import React, { Children, Component, Fragment, createElement } from 'react';
import PropTypes from 'prop-types';
import system from 'system-components';
import styled from 'styled-components';
import _reactDom from 'react-dom';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};









var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _const = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * A regular expression string matching digits
   *
   * @type {string}
   * @ignore
   */
  var digit = exports.digit = '\\d';

  /**
   * A regular expression string matching whitespace
   *
   * @type {string}
   * @ignore
   */
  var whitespace = exports.whitespace = '\\s\\uFEFF\\xA0';

  /**
   * A regular expression string matching high surrogate
   *
   * @type {string}
   * @ignore
   */
  var highSurrogate = exports.highSurrogate = '\\uD800-\\uDBFF';

  /**
   * A regular expression string matching low surrogate
   *
   * @type {string}
   * @ignore
   */
  var lowSurrogate = exports.lowSurrogate = '\\uDC00-\\uDFFF';

  /**
   * A regular expression string matching diacritical mark
   *
   * @type {string}
   * @ignore
   */
  var diacriticalMark = exports.diacriticalMark = '\\u0300-\\u036F\\u1AB0-\\u1AFF\\u1DC0-\\u1DFF\\u20D0-\\u20FF\\uFE20-\\uFE2F';

  /**
   * A regular expression to match the base character for a combining mark
   *
   * @type {string}
   * @ignore
   */
  var base = exports.base = '\\0-\\u02FF\\u0370-\\u1AAF\\u1B00-\\u1DBF\\u1E00-\\u20CF\\u2100-\\uD7FF\\uE000-\\uFE1F\\uFE30-\\uFFFF';

  /**
   * Regular expression to match combining marks
   *
   * @see http://unicode.org/faq/char_combmark.html
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_COMBINING_MARKS = exports.REGEXP_COMBINING_MARKS = new RegExp('([' + base + ']|[' + highSurrogate + '][' + lowSurrogate + ']|[' + highSurrogate + '](?![' + lowSurrogate + '])|(?:[^' + highSurrogate + ']|^)[' + lowSurrogate + '])([' + diacriticalMark + ']+)', 'g');

  /**
   * Regular expression to match surrogate pairs
   *
   * @see http://www.unicode.org/faq/utf_bom.html#utf16-2
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_SURROGATE_PAIRS = exports.REGEXP_SURROGATE_PAIRS = new RegExp('([' + highSurrogate + '])([' + lowSurrogate + '])', 'g');

  /**
   * Regular expression to match a unicode character
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_UNICODE_CHARACTER = exports.REGEXP_UNICODE_CHARACTER = new RegExp('((?:[' + base + ']|[' + highSurrogate + '][' + lowSurrogate + ']|[' + highSurrogate + '](?![' + lowSurrogate + '])|(?:[^' + highSurrogate + ']|^)[' + lowSurrogate + '])(?:[' + diacriticalMark + ']+))|\
([' + highSurrogate + '][' + lowSurrogate + '])|([\\n\\r\\u2028\\u2029])|(.)', 'g');

  /**
   * Regular expression to match whitespaces
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_WHITESPACE = exports.REGEXP_WHITESPACE = new RegExp('[' + whitespace + ']');

  /**
   * Regular expression to match whitespaces from the left side
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_TRIM_LEFT = exports.REGEXP_TRIM_LEFT = new RegExp('^[' + whitespace + ']+');

  /**
   * Regular expression to match whitespaces from the right side
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_TRIM_RIGHT = exports.REGEXP_TRIM_RIGHT = new RegExp('[' + whitespace + ']+$');

  /**
   * Regular expression to match digit characters
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_DIGIT = exports.REGEXP_DIGIT = new RegExp('^' + digit + '+$');

  /**
   * Regular expression to match regular expression special characters
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_SPECIAL_CHARACTERS = exports.REGEXP_SPECIAL_CHARACTERS = /[-[\]{}()*+!<=:?./\\^$|#,]/g;

  /**
   * Regular expression to match not latin characters
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_NON_LATIN = exports.REGEXP_NON_LATIN = /[^A-Za-z0-9]/g;

  /**
   * Regular expression to match HTML special characters.
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_HTML_SPECIAL_CHARACTERS = exports.REGEXP_HTML_SPECIAL_CHARACTERS = /[<>&"'`]/g;

  /**
   * Regular expression to match sprintf format string
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_CONVERSION_SPECIFICATION = exports.REGEXP_CONVERSION_SPECIFICATION = /(%{1,2})(?:(\d+)\$)?(\+)?([ 0]|'.{1})?(-)?(\d+)?(?:\.(\d+))?([bcdiouxXeEfgGs])?/g;

  /**
   * Regular expression to match trailing zeros in a number
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_TRAILING_ZEROS = exports.REGEXP_TRAILING_ZEROS = /\.?0+$/g;

  /**
   * Regular expression to match flags from a regular expression.
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_FLAGS = exports.REGEXP_FLAGS = /[gimuy]*$/;

  /**
   * Regular expression to match a list of tags.
   *
   * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-name
   * @type {RegExp}
   * @ignore
   */

  var REGEXP_TAG_LIST = exports.REGEXP_TAG_LIST = /<([A-Za-z0-9]+)>/g;
});

unwrapExports(_const);
var _const_1 = _const.digit;
var _const_2 = _const.whitespace;
var _const_3 = _const.highSurrogate;
var _const_4 = _const.lowSurrogate;
var _const_5 = _const.diacriticalMark;
var _const_6 = _const.base;
var _const_7 = _const.REGEXP_COMBINING_MARKS;
var _const_8 = _const.REGEXP_SURROGATE_PAIRS;
var _const_9 = _const.REGEXP_UNICODE_CHARACTER;
var _const_10 = _const.REGEXP_WHITESPACE;
var _const_11 = _const.REGEXP_TRIM_LEFT;
var _const_12 = _const.REGEXP_TRIM_RIGHT;
var _const_13 = _const.REGEXP_DIGIT;
var _const_14 = _const.REGEXP_SPECIAL_CHARACTERS;
var _const_15 = _const.REGEXP_NON_LATIN;
var _const_16 = _const.REGEXP_HTML_SPECIAL_CHARACTERS;
var _const_17 = _const.REGEXP_CONVERSION_SPECIFICATION;
var _const_18 = _const.REGEXP_TRAILING_ZEROS;
var _const_19 = _const.REGEXP_FLAGS;
var _const_20 = _const.REGEXP_TAG_LIST;

var const_extended = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.REGEXP_EXTENDED_ASCII = exports.REGEXP_ALPHA_DIGIT = exports.REGEXP_ALPHA = exports.REGEXP_LATIN_WORD = exports.REGEXP_WORD = undefined;

  /**
   * A regular expression to match the General Punctuation Unicode block
   *
   * @type {string}
   * @ignore
   */
  var generalPunctuationBlock = '\\u2000-\\u206F';

  /**
   * A regular expression to match non characters from from Basic Latin and Latin-1 Supplement Unicode blocks
   *
   * @type {string}
   * @ignore
   */
  var nonCharacter = '\\x00-\\x2F\\x3A-\\x40\\x5B-\\x60\\x7b-\\xBF\\xD7\\xF7';

  /**
   * A regular expression to match the dingbat Unicode block
   *
   * @type {string}
   * @ignore
   */
  var dingbatBlock = '\\u2700-\\u27BF';

  /**
   * A regular expression string that matches lower case letters: LATIN
   *
   * @type {string}
   * @ignore
   */
  var lowerCaseLetter = 'a-z\\xB5\\xDF-\\xF6\\xF8-\\xFF\\u0101\\u0103\\u0105\\u0107\\u0109\\u010B\\u010D\\u010F\\u0111\\u0113\\u0115\\u0117\\u0119\\u011B\\u011D\\u011F\\u0121\\u0123\\u0125\\u0127\\u0129\\u012B\\u012D\\u012F\\u0131\\u0133\\u0135\\u0137\\u0138\\u013A\\u013C\\u013E\\u0140\\u0142\\u0144\\u0146\\u0148\\u0149\\u014B\\u014D\\u014F\\u0151\\u0153\\u0155\\u0157\\u0159\\u015B\\u015D\\u015F\\u0161\\u0163\\u0165\\u0167\\u0169\\u016B\\u016D\\u016F\\u0171\\u0173\\u0175\\u0177\\u017A\\u017C\\u017E-\\u0180\\u0183\\u0185\\u0188\\u018C\\u018D\\u0192\\u0195\\u0199-\\u019B\\u019E\\u01A1\\u01A3\\u01A5\\u01A8\\u01AA\\u01AB\\u01AD\\u01B0\\u01B4\\u01B6\\u01B9\\u01BA\\u01BD-\\u01BF\\u01C6\\u01C9\\u01CC\\u01CE\\u01D0\\u01D2\\u01D4\\u01D6\\u01D8\\u01DA\\u01DC\\u01DD\\u01DF\\u01E1\\u01E3\\u01E5\\u01E7\\u01E9\\u01EB\\u01ED\\u01EF\\u01F0\\u01F3\\u01F5\\u01F9\\u01FB\\u01FD\\u01FF\\u0201\\u0203\\u0205\\u0207\\u0209\\u020B\\u020D\\u020F\\u0211\\u0213\\u0215\\u0217\\u0219\\u021B\\u021D\\u021F\\u0221\\u0223\\u0225\\u0227\\u0229\\u022B\\u022D\\u022F\\u0231\\u0233-\\u0239\\u023C\\u023F\\u0240\\u0242\\u0247\\u0249\\u024B\\u024D\\u024F';

  /**
   * A regular expression string that matches upper case letters: LATIN
   *
   * @type {string}
   * @ignore
   */
  var upperCaseLetter = '\\x41-\\x5a\\xc0-\\xd6\\xd8-\\xde\\u0100\\u0102\\u0104\\u0106\\u0108\\u010a\\u010c\\u010e\\u0110\\u0112\\u0114\\u0116\\u0118\\u011a\\u011c\\u011e\\u0120\\u0122\\u0124\\u0126\\u0128\\u012a\\u012c\\u012e\\u0130\\u0132\\u0134\\u0136\\u0139\\u013b\\u013d\\u013f\\u0141\\u0143\\u0145\\u0147\\u014a\\u014c\\u014e\\u0150\\u0152\\u0154\\u0156\\u0158\\u015a\\u015c\\u015e\\u0160\\u0162\\u0164\\u0166\\u0168\\u016a\\u016c\\u016e\\u0170\\u0172\\u0174\\u0176\\u0178\\u0179\\u017b\\u017d\\u0181\\u0182\\u0184\\u0186\\u0187\\u0189-\\u018b\\u018e-\\u0191\\u0193\\u0194\\u0196-\\u0198\\u019c\\u019d\\u019f\\u01a0\\u01a2\\u01a4\\u01a6\\u01a7\\u01a9\\u01ac\\u01ae\\u01af\\u01b1-\\u01b3\\u01b5\\u01b7\\u01b8\\u01bc\\u01c4\\u01c5\\u01c7\\u01c8\\u01ca\\u01cb\\u01cd\\u01cf\\u01d1\\u01d3\\u01d5\\u01d7\\u01d9\\u01db\\u01de\\u01e0\\u01e2\\u01e4\\u01e6\\u01e8\\u01ea\\u01ec\\u01ee\\u01f1\\u01f2\\u01f4\\u01f6-\\u01f8\\u01fa\\u01fc\\u01fe\\u0200\\u0202\\u0204\\u0206\\u0208\\u020a\\u020c\\u020e\\u0210\\u0212\\u0214\\u0216\\u0218\\u021a\\u021c\\u021e\\u0220\\u0222\\u0224\\u0226\\u0228\\u022a\\u022c\\u022e\\u0230\\u0232\\u023a\\u023b\\u023d\\u023e\\u0241\\u0243-\\u0246\\u0248\\u024a\\u024c\\u024e';

  /**
   * Regular expression to match Unicode words
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_WORD = exports.REGEXP_WORD = new RegExp('(?:[' + upperCaseLetter + '][' + _const.diacriticalMark + ']*)?(?:[' + lowerCaseLetter + '][' + _const.diacriticalMark + ']*)+|\
(?:[' + upperCaseLetter + '][' + _const.diacriticalMark + ']*)+(?![' + lowerCaseLetter + '])|\
[' + _const.digit + ']+|\
[' + dingbatBlock + ']|\
[^' + nonCharacter + generalPunctuationBlock + _const.whitespace + ']+', 'g');

  /**
   * Regular expression to match words from Basic Latin and Latin-1 Supplement blocks
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_LATIN_WORD = exports.REGEXP_LATIN_WORD = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

  /**
   * Regular expression to match alpha characters
   *
   * @see http://stackoverflow.com/a/22075070/1894471
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_ALPHA = exports.REGEXP_ALPHA = new RegExp('^(?:[' + lowerCaseLetter + upperCaseLetter + '][' + _const.diacriticalMark + ']*)+$');

  /**
   * Regular expression to match alpha and digit characters
   *
   * @see http://stackoverflow.com/a/22075070/1894471
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_ALPHA_DIGIT = exports.REGEXP_ALPHA_DIGIT = new RegExp('^((?:[' + lowerCaseLetter + upperCaseLetter + '][' + _const.diacriticalMark + ']*)|[' + _const.digit + '])+$');

  /**
   * Regular expression to match Extended ASCII characters, i.e. the first 255
   *
   * @type {RegExp}
   * @ignore
   */
  var REGEXP_EXTENDED_ASCII = exports.REGEXP_EXTENDED_ASCII = /^[\x01-\xFF]*$/;
});

unwrapExports(const_extended);
var const_extended_1 = const_extended.REGEXP_EXTENDED_ASCII;
var const_extended_2 = const_extended.REGEXP_ALPHA_DIGIT;
var const_extended_3 = const_extended.REGEXP_ALPHA;
var const_extended_4 = const_extended.REGEXP_LATIN_WORD;
var const_extended_5 = const_extended.REGEXP_WORD;

var is_nil = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isNil;
  /**
   * Checks if `value` is `null` or `undefined`
   *
   * @ignore
   * @function isNil
   * @param {*} value The object to check
   * @return {boolean} Returns `true` is `value` is `undefined` or `null`, `false` otherwise
   */
  function isNil(value) {
    return value === undefined || value === null;
  }
  module.exports = exports["default"];
});

unwrapExports(is_nil);

var coerce_to_boolean = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = coerceToBoolean;

  var _is_nil2 = _interopRequireDefault(is_nil);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  /**
   * Converts the `value` to a boolean. If `value` is `undefined` or `null`, returns `defaultValue`.
   *
   * @ignore
   * @function toBoolean
   * @param {*} value The value to convert.
   * @param {boolean} [defaultValue=false] The default value.
   * @return {boolean} Returns the coercion to boolean.
   */
  function coerceToBoolean(value) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if ((0, _is_nil2.default)(value)) {
      return defaultValue;
    }
    return Boolean(value);
  }
  module.exports = exports['default'];
});

unwrapExports(coerce_to_boolean);

var is_string = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isString;
  /**
   * Checks whether `subject` is a string primitive type.
   *
   * @function isString
   * @static
   * @since 1.0.0
   * @memberOf Query
   * @param {string} subject The value to verify.
   * @return {boolean} Returns `true` if `subject` is string primitive type or `false` otherwise.
   * @example
   * v.isString('vacation');
   * // => true
   *
   * v.isString(560);
   * // => false
   */
  function isString(subject) {
    return typeof subject === 'string';
  }
  module.exports = exports['default'];
});

unwrapExports(is_string);

var coerce_to_string = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = coerceToString;

  var _is_nil2 = _interopRequireDefault(is_nil);

  var _is_string2 = _interopRequireDefault(is_string);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  /**
   * Get the string representation of the `value`.
   * Converts the `value` to string.
   * If `value` is `null` or `undefined`, return `defaultValue`.
   *
   * @ignore
   * @function toString
   * @param {*} value             The value to convert.
   * @param {*} [defaultValue=''] The default value to return.
   * @return {string|null}        Returns the string representation of `value`. Returns `defaultValue` if `value` is
   *                              `null` or `undefined`.
   */
  function coerceToString(value) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if ((0, _is_nil2.default)(value)) {
      return defaultValue;
    }
    if ((0, _is_string2.default)(value)) {
      return value;
    }
    return String(value);
  }
  module.exports = exports['default'];
});

unwrapExports(coerce_to_string);

var capitalize_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = capitalize;

  var _coerce_to_boolean2 = _interopRequireDefault(coerce_to_boolean);

  var _coerce_to_string2 = _interopRequireDefault(coerce_to_string);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  /**
   * Converts the first character of `subject` to upper case. If `restToLower` is `true`, convert the rest of
   * `subject` to lower case.
   *
   * @function capitalize
   * @static
   * @since 1.0.0
   * @memberOf Case
   * @param  {string}  [subject='']        The string to capitalize.
   * @param  {boolean} [restToLower=false] Convert the rest of `subject` to lower case.
   * @return {string}                      Returns the capitalized string.
   * @example
   * v.capitalize('apple');
   * // => 'Apple'
   *
   * v.capitalize('aPPle', true);
   * // => 'Apple'
   */
  function capitalize(subject, restToLower) {
    var subjectString = (0, _coerce_to_string2.default)(subject);
    var restToLowerCaseBoolean = (0, _coerce_to_boolean2.default)(restToLower);
    if (subjectString === '') {
      return '';
    }
    if (restToLowerCaseBoolean) {
      subjectString = subjectString.toLowerCase();
    }
    return subjectString.substr(0, 1).toUpperCase() + subjectString.substr(1);
  }
  module.exports = exports['default'];
});

unwrapExports(capitalize_1);

var title_case = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = titleCase;

  var _capitalize2 = _interopRequireDefault(capitalize_1);

  var _coerce_to_string2 = _interopRequireDefault(coerce_to_string);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  /**
   * Converts the subject to title case.
   *
   * @function titleCase
   * @static
   * @since 1.4.0
   * @memberOf Case
   * @param  {string} [subject=''] The string to convert to title case.
   * @param  {Array}  [noSplit]    Do not split words at the specified characters.
   * @return {string}              Returns the title case string.
   * @example
   * v.titleCase('learning to fly');
   * // => 'Learning To Fly'
   *
   * v.titleCase('jean-luc is good-looking', ['-']);
   * // => 'Jean-luc Is Good-looking'
   */
  function titleCase(subject, noSplit) {
    var subjectString = (0, _coerce_to_string2.default)(subject);
    var noSplitArray = Array.isArray(noSplit) ? noSplit : [];
    var wordsRegExp = const_extended.REGEXP_EXTENDED_ASCII.test(subjectString) ? const_extended.REGEXP_LATIN_WORD : const_extended.REGEXP_WORD;
    return subjectString.replace(wordsRegExp, function (word, index) {
      var isNoSplit = index > 0 && noSplitArray.indexOf(subjectString[index - 1]) >= 0;
      return isNoSplit ? word.toLowerCase() : (0, _capitalize2.default)(word, true);
    });
  }
  module.exports = exports['default'];
});

var titleCase = unwrapExports(title_case);

var lower_case = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = lowerCase;

  var _coerce_to_string2 = _interopRequireDefault(coerce_to_string);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  /**
   * Converts the `subject` to lower case.
   *
   * @function lowerCase
   * @static
   * @since 1.0.0
   * @memberOf Case
   * @param  {string} [subject=''] The string to convert to lower case.
   * @return {string}              Returns the lower case string.
   * @example
   * v.lowerCase('Green');
   * // => 'green'
   *
   * v.lowerCase('BLUE');
   * // => 'blue'
   */
  function lowerCase(subject) {
    var subjectString = (0, _coerce_to_string2.default)(subject, '');
    return subjectString.toLowerCase();
  }
  module.exports = exports['default'];
});

var lowerCase = unwrapExports(lower_case);

function _isPlaceholder(a) {
  return a != null && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */
var always = /*#__PURE__*/_curry1(function always(val) {
  return function () {
    return val;
  };
});

/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */
var F = /*#__PURE__*/always(false);

/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
var T = /*#__PURE__*/always(true);

/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */
var add = /*#__PURE__*/_curry2(function add(a, b) {
  return Number(a) + Number(b);
});

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}

function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}

/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
  };
}

/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
var curryN = /*#__PURE__*/_curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});

/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
var addIndex = /*#__PURE__*/_curry1(function addIndex(fn) {
  return curryN(fn.length, function () {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function () {
      var result = origFn.apply(this, _concat(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a -> a) -> Number -> [a] -> [a]
 * @param {Function} fn The function to apply.
 * @param {Number} idx The index.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
 */
var adjust = /*#__PURE__*/_curry3(function adjust(fn, idx, list) {
  if (idx >= list.length || idx < -list.length) {
    return list;
  }
  var start = idx < 0 ? list.length : 0;
  var _idx = start + idx;
  var _list = _concat(list);
  _list[_idx] = fn(list[_idx]);
  return _list;
});

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
var _isArray = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}

/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
function _dispatchable(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}

function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

var _xfBase = {
  init: function init() {
    return this.xf['@@transducer/init']();
  },
  result: function result(_result) {
    return this.xf['@@transducer/result'](_result);
  }
};

/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */
var max = /*#__PURE__*/_curry2(function max(a, b) {
  return b > a ? b : a;
});

function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}

function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
  if (_isArray(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
    return false;
  }
  if (_isString(x)) {
    return false;
  }
  if (x.nodeType === 1) {
    return !!x.length;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});

var XWrap = /*#__PURE__*/function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap(fn) {
  return new XWrap(fn);
}

/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});

function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    idx += 1;
  }
  return xf['@@transducer/result'](acc);
}

function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    step = iter.next();
  }
  return xf['@@transducer/result'](acc);
}

function _methodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
}

var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

function _reduce(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = _xwrap(fn);
  }
  if (_isArrayLike(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === 'function') {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === 'function') {
    return _methodReduce(fn, acc, list, 'reduce');
  }

  throw new TypeError('reduce: list must be array or iterable');
}

var XMap = /*#__PURE__*/function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;
  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap = /*#__PURE__*/_curry2(function _xmap(f, xf) {
  return new XMap(f, xf);
});

function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var toString = Object.prototype.toString;
var _isArguments = function _isArguments() {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
};

// cover IE < 9 keys issues
var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/function () {
  return arguments.propertyIsEnumerable('length');
}();

var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var _keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
} : function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop in obj) {
    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
};
var keys = /*#__PURE__*/_curry1(_keys);

/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
var map = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys(functor));
    default:
      return _map(fn, functor);
  }
}));

/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */
var path = /*#__PURE__*/_curry2(function path(paths, obj) {
  var val = obj;
  var idx = 0;
  while (idx < paths.length) {
    if (val == null) {
      return;
    }
    val = val[paths[idx]];
    idx += 1;
  }
  return val;
});

/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */

var prop = /*#__PURE__*/_curry2(function prop(p, obj) {
  return path([p], obj);
});

/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */
var pluck = /*#__PURE__*/_curry2(function pluck(p, list) {
  return map(prop(p), list);
});

/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
var reduce = /*#__PURE__*/_curry3(_reduce);

/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */
var ap = /*#__PURE__*/_curry2(function ap(applyF, applyX) {
  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
    return applyF(x)(applyX(x));
  } :
  // else
  _reduce(function (acc, f) {
    return _concat(acc, map(f, applyX));
  }, [], applyF);
});

/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */
var append = /*#__PURE__*/_curry2(function append(el, list) {
  return _concat(list, [el]);
});

/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */

function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}

/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */
var liftN = /*#__PURE__*/_curry2(function liftN(arity, fn) {
  var lifted = curryN(arity, fn);
  return curryN(arity, function () {
    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});

/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */
var lift = /*#__PURE__*/_curry1(function lift(fn) {
  return liftN(fn.length, fn);
});

/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
var curry = /*#__PURE__*/_curry1(function curry(fn) {
  return curryN(fn.length, fn);
});

/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */
var call = /*#__PURE__*/curry(function call(fn) {
  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});

/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */
function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (_isArrayLike(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
}

function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

var preservingReduced = function preservingReduced(xf) {
  return {
    '@@transducer/init': _xfBase.init,
    '@@transducer/result': function transducerResult(result) {
      return xf['@@transducer/result'](result);
    },
    '@@transducer/step': function transducerStep(result, input) {
      var ret = xf['@@transducer/step'](result, input);
      return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
    }
  };
};

var _flatCat = function _xcat(xf) {
  var rxf = preservingReduced(xf);
  return {
    '@@transducer/init': _xfBase.init,
    '@@transducer/result': function transducerResult(result) {
      return rxf['@@transducer/result'](result);
    },
    '@@transducer/step': function transducerStep(result, input) {
      return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
    }
  };
};

var _xchain = /*#__PURE__*/_curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});

/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */
var chain = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function (x) {
      return fn(monad(x))(x);
    };
  }
  return _makeFlat(false)(map(fn, monad));
}));

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */
var type = /*#__PURE__*/_curry1(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});

/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */
var not = /*#__PURE__*/_curry1(function not(a) {
  return !a;
});

/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */
var complement = /*#__PURE__*/lift(not);

function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
function _checkForMethod(methodname, fn) {
  return function () {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}

/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
var slice = /*#__PURE__*/_curry3( /*#__PURE__*/_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));

/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
var tail = /*#__PURE__*/_curry1( /*#__PURE__*/_checkForMethod('tail', /*#__PURE__*/slice(1, Infinity)));

/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity(arguments[0].length, reduce(_pipe, arguments[0], tail(arguments)));
}

/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
var reverse = /*#__PURE__*/_curry1(function reverse(list) {
  return _isString(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});

/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe.apply(this, reverse(arguments));
}

function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}

function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}

function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */
var identical = /*#__PURE__*/_curry2(function identical(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
});

/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b = _arrayFromIterator(bIterator);

  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }

  // if *a* array contains any element that is not included in *b*
  return !_containsWith(function (b, aItem) {
    return !_containsWith(eq, aItem, b);
  }, b, a);
}

function _equals(a, b, stackA, stackB) {
  if (identical(a, b)) {
    return true;
  }

  var typeA = type(a);

  if (typeA !== type(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === (typeof b === 'undefined' ? 'undefined' : _typeof(b)) && identical(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!identical(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys(a);
  if (keysA.length !== keys(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);

  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}

/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
var equals = /*#__PURE__*/_curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});

function _indexOf(list, a, idx) {
  var inf, item;
  // Array.prototype.indexOf doesn't exist below IE9
  if (typeof list.indexOf === 'function') {
    switch (typeof a === 'undefined' ? 'undefined' : _typeof(a)) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === 'number' && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        // non-zero numbers can utilise Set
        return list.indexOf(a, idx);

      // all these types can utilise Set
      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }
    }
  }
  // anything else not covered above, defer to R.equals
  while (idx < list.length) {
    if (equals(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}

function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
}

function _quote(s) {
  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');

  return '"' + escaped.replace(/"/g, '\\"') + '"';
}

/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
var pad = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
  return d.toISOString();
} : function _toISOString(d) {
  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};

function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}

function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}

function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

var XFilter = /*#__PURE__*/function () {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;
  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

var _xfilter = /*#__PURE__*/_curry2(function _xfilter(f, xf) {
  return new XFilter(f, xf);
});

/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var filter = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['filter'], _xfilter, function (pred, filterable) {
  return _isObject(filterable) ? _reduce(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, keys(filterable)) :
  // else
  _filter(pred, filterable);
}));

/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var reject = /*#__PURE__*/_curry2(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});

function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
  };

  //  mapPairs :: (Object, [String]) -> [String]
  var mapPairs = function mapPairs(obj, keys$$1) {
    return _map(function (k) {
      return _quote(k) + ': ' + recur(obj[k]);
    }, keys$$1.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
    case '[object Array]':
      return '[' + _map(recur, x).concat(mapPairs(x, reject(function (k) {
        return (/^\d+$/.test(k)
        );
      }, keys(x)))).join(', ') + ']';
    case '[object Boolean]':
      return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
    case '[object Null]':
      return 'null';
    case '[object Number]':
      return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
    case '[object String]':
      return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
    case '[object Undefined]':
      return 'undefined';
    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();
        if (repr !== '[object Object]') {
          return repr;
        }
      }
      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
  }
}

/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
var toString$1 = /*#__PURE__*/_curry1(function toString(val) {
  return _toString(val, []);
});

/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */
var converge = /*#__PURE__*/_curry2(function converge(after, fns) {
  return curryN(reduce(max, 0, pluck('length', fns)), function () {
    var args = arguments;
    var context = this;
    return after.apply(context, _map(function (fn) {
      return fn.apply(context, args);
    }, fns));
  });
});

var XReduceBy = /*#__PURE__*/function () {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
  XReduceBy.prototype['@@transducer/result'] = function (result) {
    var key;
    for (key in this.inputs) {
      if (_has(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);
        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };
  XReduceBy.prototype['@@transducer/step'] = function (result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return XReduceBy;
}();

var _xreduceBy = /*#__PURE__*/_curryN(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
  return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});

/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */
var reduceBy = /*#__PURE__*/_curryN(4, [], /*#__PURE__*/_dispatchable([], _xreduceBy, function reduceBy(valueFn, valueAcc, keyFn, list) {
  return _reduce(function (acc, elt) {
    var key = keyFn(elt);
    acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
    return acc;
  }, {}, list);
}));

/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */
var countBy = /*#__PURE__*/reduceBy(function (acc, elem) {
  return acc + 1;
}, 0);

/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */
var dec = /*#__PURE__*/add(-1);

var XDropRepeatsWith = /*#__PURE__*/function () {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
  XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return XDropRepeatsWith;
}();

var _xdropRepeatsWith = /*#__PURE__*/_curry2(function _xdropRepeatsWith(pred, xf) {
  return new XDropRepeatsWith(pred, xf);
});

/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */
var nth = /*#__PURE__*/_curry2(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});

/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */
var last = /*#__PURE__*/nth(-1);

/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */
var dropRepeatsWith = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;
  if (len !== 0) {
    result[0] = list[0];
    while (idx < len) {
      if (!pred(last(result), list[idx])) {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
  }
  return result;
}));

/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */
var dropRepeats = /*#__PURE__*/_curry1( /*#__PURE__*/_dispatchable([], /*#__PURE__*/_xdropRepeatsWith(equals), /*#__PURE__*/dropRepeatsWith(equals)));

/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */
var flip = /*#__PURE__*/_curry1(function flip(fn) {
  return curryN(fn.length, function (a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});

/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */
var groupBy = /*#__PURE__*/_curry2( /*#__PURE__*/_checkForMethod('groupBy', /*#__PURE__*/reduceBy(function (acc, item) {
  if (acc == null) {
    acc = [];
  }
  acc.push(item);
  return acc;
}, null)));

/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */
var head = /*#__PURE__*/nth(0);

function _identity(x) {
  return x;
}

/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */
var identity = /*#__PURE__*/_curry1(_identity);

/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
var inc = /*#__PURE__*/add(1);

/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */
var indexBy = /*#__PURE__*/reduceBy(function (acc, elem) {
  return elem;
}, null);

/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */
var init = /*#__PURE__*/slice(0, -1);

var _Set = /*#__PURE__*/function () {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function (item) {
    return !hasOrAdd(item, true, this);
  };

  //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //
  _Set.prototype.has = function (item) {
    return hasOrAdd(item, false, this);
  };

  //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //
  return _Set;
}();

function hasOrAdd(item, shouldAdd, set$$1) {
  var type = typeof item === 'undefined' ? 'undefined' : _typeof(item);
  var prevSize, newSize;
  switch (type) {
    case 'string':
    case 'number':
      // distinguish between +0 and -0
      if (item === 0 && 1 / item === -Infinity) {
        if (set$$1._items['-0']) {
          return true;
        } else {
          if (shouldAdd) {
            set$$1._items['-0'] = true;
          }
          return false;
        }
      }
      // these types can all utilise the native Set
      if (set$$1._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set$$1._nativeSet.size;
          set$$1._nativeSet.add(item);
          newSize = set$$1._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set$$1._nativeSet.has(item);
        }
      } else {
        if (!(type in set$$1._items)) {
          if (shouldAdd) {
            set$$1._items[type] = {};
            set$$1._items[type][item] = true;
          }
          return false;
        } else if (item in set$$1._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set$$1._items[type][item] = true;
          }
          return false;
        }
      }

    case 'boolean':
      // set._items['boolean'] holds a two element array
      // representing [ falseExists, trueExists ]
      if (type in set$$1._items) {
        var bIdx = item ? 1 : 0;
        if (set$$1._items[type][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set$$1._items[type][bIdx] = true;
          }
          return false;
        }
      } else {
        if (shouldAdd) {
          set$$1._items[type] = item ? [false, true] : [true, false];
        }
        return false;
      }

    case 'function':
      // compare functions for reference equality
      if (set$$1._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set$$1._nativeSet.size;
          set$$1._nativeSet.add(item);
          newSize = set$$1._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set$$1._nativeSet.has(item);
        }
      } else {
        if (!(type in set$$1._items)) {
          if (shouldAdd) {
            set$$1._items[type] = [item];
          }
          return false;
        }
        if (!_contains(item, set$$1._items[type])) {
          if (shouldAdd) {
            set$$1._items[type].push(item);
          }
          return false;
        }
        return true;
      }

    case 'undefined':
      if (set$$1._items[type]) {
        return true;
      } else {
        if (shouldAdd) {
          set$$1._items[type] = true;
        }
        return false;
      }

    case 'object':
      if (item === null) {
        if (!set$$1._items['null']) {
          if (shouldAdd) {
            set$$1._items['null'] = true;
          }
          return false;
        }
        return true;
      }
    /* falls through */
    default:
      // reduce the search size of heterogeneous sets by creating buckets
      // for each type.
      type = Object.prototype.toString.call(item);
      if (!(type in set$$1._items)) {
        if (shouldAdd) {
          set$$1._items[type] = [item];
        }
        return false;
      }
      // scan through all previously applied items
      if (!_contains(item, set$$1._items[type])) {
        if (shouldAdd) {
          set$$1._items[type].push(item);
        }
        return false;
      }
      return true;
  }
}

/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */
var uniqBy = /*#__PURE__*/_curry2(function uniqBy(fn, list) {
  var set$$1 = new _Set();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set$$1.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});

/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */
var uniq = /*#__PURE__*/uniqBy(identity);

/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */
var invoker = /*#__PURE__*/_curry2(function invoker(arity, method) {
  return curryN(arity + 1, function () {
    var target = arguments[arity];
    if (target != null && _isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString$1(target) + ' does not have a method named "' + method + '"');
  });
});

/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */
var join = /*#__PURE__*/invoker(1, 'join');

/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */
var juxt = /*#__PURE__*/_curry1(function juxt(fns) {
  return converge(function () {
    return Array.prototype.slice.call(arguments, 0);
  }, fns);
});

/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */
var sum = /*#__PURE__*/reduce(add, 0);

/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
var memoizeWith = /*#__PURE__*/_curry2(function memoizeWith(mFn, fn) {
  var cache = {};
  return _arity(fn.length, function () {
    var key = mFn.apply(this, arguments);
    if (!_has(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});

/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @deprecated since v0.25.0
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
var memoize = /*#__PURE__*/memoizeWith(function () {
  return toString$1(arguments);
});

/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */
var multiply = /*#__PURE__*/_curry2(function multiply(a, b) {
  return a * b;
});

function _createPartialApplicator(concat) {
  return _curry2(function (fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}

/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */
var partialRight = /*#__PURE__*/_createPartialApplicator( /*#__PURE__*/flip(_concat));

/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */
var partition = /*#__PURE__*/juxt([filter, reject]);

/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */
var pickAll = /*#__PURE__*/_curry2(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});

/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */
var product = /*#__PURE__*/reduce(multiply, 1);

/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */
var useWith = /*#__PURE__*/_curry2(function useWith(fn, transformers) {
  return curryN(transformers.length, function () {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});

/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */
var project = /*#__PURE__*/useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity

/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      var isOdd = (acc, x) => x % 2 === 1;
 *      var xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      var ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */
var reduceWhile = /*#__PURE__*/_curryN(4, [], function _reduceWhile(pred, fn, a, list) {
  return _reduce(function (acc, x) {
    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
  }, a, list);
});

/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */
var times = /*#__PURE__*/_curry2(function times(fn, n) {
  var len = Number(n);
  var idx = 0;
  var list;

  if (len < 0 || isNaN(len)) {
    throw new RangeError('n must be a non-negative number');
  }
  list = new Array(len);
  while (idx < len) {
    list[idx] = fn(idx);
    idx += 1;
  }
  return list;
});

/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      var obj = {};
 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */
var repeat = /*#__PURE__*/_curry2(function repeat(value, n) {
  return times(always(value), n);
});

/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */
var split = /*#__PURE__*/invoker(1, 'split');

/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */
var toLower = /*#__PURE__*/invoker(0, 'toLowerCase');

/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
var toUpper = /*#__PURE__*/invoker(0, 'toUpperCase');

/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      var isOdd = (x) => x % 2 === 1;
 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */
var transduce = /*#__PURE__*/curryN(4, function transduce(xf, fn, acc, list) {
  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
});

var ws = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
var zeroWidth = '\u200B';
var hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */
var _trim = !hasProtoTrim || /*#__PURE__*/ws.trim() || ! /*#__PURE__*/zeroWidth.trim() ? function trim(str) {
  var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
  var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
  return str.replace(beginRx, '').replace(endRx, '');
} : function trim(str) {
  return str.trim();
};

/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */
var union = /*#__PURE__*/_curry2( /*#__PURE__*/compose(uniq, _concat));

/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */
var unnest = /*#__PURE__*/chain(_identity);

var formatTitle = compose(titleCase, lowerCase);
var mapIndexed = addIndex(map);
var compact = filter(identity);

var AvatarWrapper = system({
  is: "img",
  size: "3em"
});

var classCallCheck$1 = function classCallCheck$$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits$1 = function inherits$$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties$1 = function objectWithoutProperties$$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn$1 = function possibleConstructorReturn$$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
};

var taggedTemplateLiteral$1 = function taggedTemplateLiteral$$1(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

/**
 * A Component for the Offcourse Project that shows the avatar image of a
 * given user
 */

var Avatar = function (_Component) {
  inherits$1(Avatar, _Component);

  function Avatar() {
    classCallCheck$1(this, Avatar);
    return possibleConstructorReturn$1(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
  }

  createClass$1(Avatar, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          url = _props.url,
          name = _props.name;

      return React.createElement(AvatarWrapper, { src: url, alt: "avatar of " + lowerCase(name) });
    }
  }]);
  return Avatar;
}(Component);

Avatar.propTypes = {
  /**  url that refers to an avatar image */
  url: PropTypes.string,
  /** name of the person corresponding to this avatar */
  name: PropTypes.string.isRequired
};
Avatar.defaultProps = {
  url: "https://assets.offcourse.io/portraits/offcourse_2.jpg"
};

var _templateObject = taggedTemplateLiteral$1(["\n  box-sizing: border-box\n"], ["\n  box-sizing: border-box\n"]);

var BarWrapper = system({
  display: "flex",
  justifyContent: "space-between",
  position: "fixed",
  left: 0,
  right: 0,
  bg: "white",
  flexDirection: "row",
  pr: 4,
  alignItems: "center",
  height: "2rem",
  zIndex: 2
}, "top", "bottom").extend(_templateObject);

var Bar = function (_Component) {
  inherits$1(Bar, _Component);

  function Bar() {
    classCallCheck$1(this, Bar);
    return possibleConstructorReturn$1(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).apply(this, arguments));
  }

  createClass$1(Bar, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          docked = _props.docked,
          children = _props.children,
          position = _props.position;

      return React.createElement(BarWrapper, {
        top: docked === "top" ? 0 : null,
        bottom: docked === "bottom" ? 0 : null,
        position: position
      }, children);
    }
  }]);
  return Bar;
}(Component);

Bar.propTypes = {
  docked: PropTypes.oneOf(["top", "bottom"]),
  position: PropTypes.oneOf(["fixed", "absolute"])
};
Bar.defaultProps = {
  docked: "top",
  position: "fixed"
};

var constants = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var breakpoints = exports.breakpoints = ['40em', '52em', '64em'];

  var space = exports.space = [0, 4, 8, 16, 32, 64, 128, 256, 512];

  var fontSizes = exports.fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];

  exports.default = {
    breakpoints: breakpoints,
    space: space,
    fontSizes: fontSizes
  };
});

unwrapExports(constants);
var constants_1 = constants.breakpoints;
var constants_2 = constants.space;
var constants_3 = constants.fontSizes;

var util = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.complexStyle = exports.themeGet = exports.pseudoStyle = exports.responsiveStyle = exports.style = exports.cloneFunc = exports.getValue = exports.merge = exports.media = exports.dec = exports.breaks = exports.fallbackTheme = exports.mq = exports.get = exports.getWidth = exports.arr = exports.neg = exports.px = exports.num = exports.is = undefined;

  var _typeof$$1 = typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
  };

  var _extends$$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var _constants2 = _interopRequireDefault(constants);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }return obj;
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }return arr2;
    } else {
      return Array.from(arr);
    }
  }

  var propTypes = {
    responsive: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
    numberOrString: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  };

  var is = exports.is = function is(n) {
    return n !== undefined && n !== null;
  };
  var num = exports.num = function num(n) {
    return typeof n === 'number' && !isNaN(n);
  };
  var px = exports.px = function px(n) {
    return num(n) ? n + 'px' : n;
  };
  var neg = exports.neg = function neg(n) {
    return n < 0;
  };
  var arr = exports.arr = function arr(n) {
    return Array.isArray(n) ? n : [n];
  };

  var getWidth = exports.getWidth = function getWidth(n) {
    return !num(n) || n > 1 ? px(n) : n * 100 + '%';
  };
  var get$$1 = exports.get = function get$$1(obj, path, fallback) {
    return path.split('.').reduce(function (a, b) {
      return a && a[b] ? a[b] : null;
    }, obj) || fallback;
  };

  var mq = exports.mq = function mq(n) {
    return '@media screen and (min-width: ' + px(n) + ')';
  };

  var fallbackTheme = exports.fallbackTheme = function fallbackTheme(props) {
    return _extends$$1({}, _constants2.default, get$$1(props, 'theme'));
  };

  var breaks = exports.breaks = function breaks(props) {
    return [null].concat(_toConsumableArray(get$$1(props, 'theme.breakpoints', constants.breakpoints).map(mq)));
  };

  var dec = exports.dec = function dec(props) {
    return function (val) {
      return arr(props).reduce(function (acc, prop) {
        return acc[prop] = val, acc;
      }, {});
    };
  };

  var media = exports.media = function media(bp) {
    return function (d, i) {
      return is(d) ? bp[i] ? _defineProperty({}, bp[i], d) : d : null;
    };
  };

  var merge = exports.merge = function merge(a, b) {
    return Object.assign({}, a, b, Object.keys(b || {}).reduce(function (obj, key) {
      return Object.assign(obj, _defineProperty({}, key, a[key] !== null && _typeof$$1(a[key]) === 'object' ? merge(a[key], b[key]) : b[key]));
    }, {}));
  };

  var getValue = exports.getValue = function getValue(val, getter, toPx) {
    return typeof getter === 'function' ? getter(val) : toPx ? px(val) : val;
  };

  var cloneFunc = exports.cloneFunc = function cloneFunc(fn) {
    return function () {
      return fn.apply(undefined, arguments);
    };
  };

  var style = exports.style = function style(_ref2) {
    var prop = _ref2.prop,
        cssProperty = _ref2.cssProperty,
        alias = _ref2.alias,
        key = _ref2.key,
        getter = _ref2.getter,
        numberToPx = _ref2.numberToPx;

    var fn = function fn(props) {
      cssProperty = cssProperty || prop;
      var n = is(props[prop]) ? props[prop] : props[alias];
      var th = fallbackTheme(props);
      if (!is(n)) return null;
      var value = getValue(get$$1(th, [key, n].join('.'), n), getter, numberToPx);

      return _defineProperty({}, cssProperty, value);
    };
    fn.propTypes = _defineProperty({}, prop, cloneFunc(propTypes.numberOrString));
    if (alias) {
      fn.propTypes[alias] = propTypes.numberOrString;
    }
    fn.propTypes[prop].meta = {
      prop: prop,
      themeKey: key,
      styleType: 'default'
    };
    return fn;
  };

  var responsiveStyle = exports.responsiveStyle = function responsiveStyle(_ref4) {
    var prop = _ref4.prop,
        cssProperty = _ref4.cssProperty,
        alias = _ref4.alias,
        key = _ref4.key,
        getter = _ref4.getter,
        numberToPx = _ref4.numberToPx;

    var fn = function fn(props) {
      cssProperty = cssProperty || prop;
      var n = is(props[prop]) ? props[prop] : props[alias];
      if (!is(n)) return null;

      var bp = breaks(props);
      var th = fallbackTheme(props);
      var sx = function sx(n) {
        return getValue(get$$1(th, [key || prop, n].join('.'), n), getter, numberToPx);
      };

      if (!Array.isArray(n)) {
        return _defineProperty({}, cssProperty, sx(n));
      }

      var val = arr(n);
      return val.map(sx).map(dec(cssProperty)).map(media(bp)).reduce(merge, {});
    };

    // add propTypes object to returned function
    fn.propTypes = _defineProperty({}, prop, cloneFunc(propTypes.responsive));
    if (alias) {
      fn.propTypes[alias] = propTypes.responsive;
    }

    fn.propTypes[prop].meta = {
      prop: prop,
      themeKey: key,
      responsive: true,
      styleType: 'responsive'
    };

    return fn;
  };

  var pseudoStyle = exports.pseudoStyle = function pseudoStyle(_ref6) {
    var prop = _ref6.prop,
        alias = _ref6.alias,
        pseudoclass = _ref6.pseudoclass,
        _ref6$keys = _ref6.keys,
        keys = _ref6$keys === undefined ? {} : _ref6$keys,
        _ref6$getters = _ref6.getters,
        getters = _ref6$getters === undefined ? {} : _ref6$getters,
        _ref6$numberToPx = _ref6.numberToPx,
        numberToPx = _ref6$numberToPx === undefined ? {} : _ref6$numberToPx;

    var fn = function fn(props) {
      var style = props[prop] || props[alias];
      pseudoclass = pseudoclass || prop;
      var th = fallbackTheme(props);
      for (var key in style) {
        var toPx = numberToPx[key];
        if (!keys[key] && !getters[key] && !toPx) continue;
        var themeKey = [keys[key], style[key]].join('.');
        style[key] = getValue(get$$1(th, themeKey, style[key]), getters[key], toPx);
      }

      return _defineProperty({}, '&:' + pseudoclass, style);
    };
    fn.propTypes = _defineProperty({}, prop, cloneFunc(_propTypes2.default.object));

    fn.propTypes[prop].meta = {
      prop: prop,
      pseudo: true,
      styleType: 'pseudo'
    };
    return fn;
  };

  // todo: consider alternative names
  var themeGet = exports.themeGet = function themeGet(keys, fallback) {
    return function (props) {
      return get$$1(props.theme, keys, fallback);
    };
  };

  var getBooleans = function getBooleans(props) {
    var bools = [];
    for (var key in props) {
      if (props[key] !== true) continue;
      bools.push(key);
    }
    return bools;
  };

  var complexStyle = exports.complexStyle = function complexStyle(_ref8) {
    var prop = _ref8.prop,
        key = _ref8.key,
        alias = _ref8.alias;

    var fn = function fn(props) {
      var style = get$$1(props, ['theme', key, get$$1(props, prop, props[alias])].join('.'), {});
      var bools = getBooleans(props);
      bools.forEach(function (name) {
        style = _extends$$1({}, style, get$$1(props, ['theme', key, name].join('.'), {}));
      });
      return style;
    };

    fn.propTypes = _defineProperty({}, prop, _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]));

    if (alias) {
      fn.propTypes[alias] = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]);
    }

    fn.propTypes[prop].meta = {
      prop: prop,
      themeKey: key,
      complex: true,
      styleType: 'complex'
    };

    return fn;
  };
});

unwrapExports(util);
var util_1 = util.complexStyle;
var util_2 = util.themeGet;
var util_3 = util.pseudoStyle;
var util_4 = util.responsiveStyle;
var util_5 = util.style;
var util_6 = util.cloneFunc;
var util_7 = util.getValue;
var util_8 = util.merge;
var util_9 = util.media;
var util_10 = util.dec;
var util_11 = util.breaks;
var util_12 = util.fallbackTheme;
var util_13 = util.mq;
var util_14 = util.get;
var util_15 = util.getWidth;
var util_16 = util.arr;
var util_17 = util.neg;
var util_18 = util.px;
var util_19 = util.num;
var util_20 = util.is;

var space_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.space = undefined;

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;_e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }return _arr;
    }return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var _constants2 = _interopRequireDefault(constants);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }return obj;
  }

  var REG = /^[mp][trblxy]?$/;

  var space = exports.space = function space(props) {
    var keys = Object.keys(props).filter(function (key) {
      return REG.test(key);
    }).sort();
    var bp = (0, util.breaks)(props);
    var sc = (0, util.get)(props, 'theme.space', _constants2.default.space);

    return keys.map(function (key) {
      var val = props[key];
      var p = getProperties(key);

      if (!Array.isArray(val)) {
        return p.reduce(function (a, b) {
          return Object.assign(a, _defineProperty({}, b, mx(sc)(val)));
        }, {});
      }

      return (0, util.arr)(val).map(mx(sc)).map((0, util.dec)(p)).map((0, util.media)(bp)).reduce(util.merge, {});
    }).reduce(util.merge, {});
  };

  var mx = function mx(scale) {
    return function (n) {
      if (!(0, util.num)(n)) {
        return n;
      }

      var value = scale[Math.abs(n)] || Math.abs(n);
      if (!(0, util.num)(value)) {
        return (0, util.neg)(n) ? '-' + value : value;
      }

      return (0, util.px)(value * ((0, util.neg)(n) ? -1 : 1));
    };
  };

  var getProperties = function getProperties(key) {
    var _key$split = key.split(''),
        _key$split2 = _slicedToArray(_key$split, 2),
        a = _key$split2[0],
        b = _key$split2[1];

    var prop = properties[a];
    var dirs = directions[b] || [''];
    return dirs.map(function (dir) {
      return prop + dir;
    });
  };

  var properties = {
    m: 'margin',
    p: 'padding'
  };

  var directions = {
    t: ['Top'],
    r: ['Right'],
    b: ['Bottom'],
    l: ['Left'],
    x: ['Left', 'Right'],
    y: ['Top', 'Bottom']
  };

  var responsive = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]);

  space.propTypes = {
    m: responsive,
    mt: responsive,
    mr: responsive,
    mb: responsive,
    ml: responsive,
    mx: responsive,
    my: responsive,
    p: responsive,
    pt: responsive,
    pr: responsive,
    pb: responsive,
    pl: responsive,
    px: responsive,
    py: responsive
  };

  var meta = function meta(prop) {
    return {
      prop: prop,
      responsive: true,
      styleType: 'responsive',
      themeKey: 'space'
    };
  };
  Object.keys(space.propTypes).forEach(function (prop) {
    space.propTypes[prop].meta = meta(prop);
  });

  exports.default = space;
});

unwrapExports(space_1);
var space_2 = space_1.space;

var styles = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.borderWidth = exports.buttonStyle = exports.colorStyle = exports.textStyle = exports.disabled = exports.active = exports.focus = exports.hover = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = exports.backgroundRepeat = exports.backgroundPosition = exports.backgroundSize = exports.backgroundImage = exports.background = exports.boxShadow = exports.borderRadius = exports.borderColor = exports.borders = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = exports.order = exports.alignSelf = exports.justifySelf = exports.flex = exports.flexDirection = exports.flexBasis = exports.flexWrap = exports.justifyContent = exports.alignContent = exports.alignItems = exports.ratio = exports.ratioPadding = exports.size = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.display = exports.letterSpacing = exports.fontWeight = exports.lineHeight = exports.textAlign = exports.fontFamily = exports.color = exports.bgColor = exports.textColor = exports.fontSize = exports.width = exports.space = undefined;

  var _extends$$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };

  Object.defineProperty(exports, 'space', {
    enumerable: true,
    get: function get$$1() {
      return _interopRequireDefault(space_1).default;
    }
  });

  var util$$1 = _interopRequireWildcard(util);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  var width = exports.width = (0, util.responsiveStyle)({
    prop: 'width',
    alias: 'w',
    getter: util.getWidth
  });

  var fontSize = exports.fontSize = (0, util.responsiveStyle)({
    prop: 'fontSize',
    alias: 'f',
    key: 'fontSizes',
    numberToPx: true
  });

  var textColor = exports.textColor = (0, util.responsiveStyle)({
    prop: 'color',
    key: 'colors'
  });

  var bgColor = exports.bgColor = (0, util.responsiveStyle)({
    prop: 'bg',
    cssProperty: 'backgroundColor',
    key: 'colors'
  });

  var color = exports.color = function color(props) {
    return _extends$$1({}, textColor(props), bgColor(props));
  };
  color.propTypes = _extends$$1({}, textColor.propTypes, bgColor.propTypes);

  // typography
  var fontFamily = exports.fontFamily = (0, util.style)({
    prop: 'fontFamily',
    alias: 'font',
    key: 'fonts'
  });

  var textAlign = exports.textAlign = (0, util.responsiveStyle)({
    prop: 'textAlign',
    // for backwards compatibility - will cause bugs when used with alignItems
    alias: 'align'
  });

  var lineHeight = exports.lineHeight = (0, util.responsiveStyle)({
    prop: 'lineHeight',
    key: 'lineHeights'
  });

  var fontWeight = exports.fontWeight = (0, util.style)({
    prop: 'fontWeight',
    key: 'fontWeights'
  });

  var letterSpacing = exports.letterSpacing = (0, util.style)({
    prop: 'letterSpacing',
    key: 'letterSpacings',
    numberToPx: true
  });

  // layout
  var display = exports.display = (0, util.responsiveStyle)({
    prop: 'display'
  });

  var maxWidth = exports.maxWidth = (0, util.responsiveStyle)({
    prop: 'maxWidth',
    key: 'maxWidths',
    numberToPx: true
  });

  var minWidth = exports.minWidth = (0, util.responsiveStyle)({
    prop: 'minWidth',
    key: 'minWidths',
    numberToPx: true
  });

  var height = exports.height = (0, util.responsiveStyle)({
    prop: 'height',
    key: 'heights',
    numberToPx: true
  });

  var maxHeight = exports.maxHeight = (0, util.responsiveStyle)({
    prop: 'maxHeight',
    key: 'maxHeights',
    numberToPx: true
  });

  var minHeight = exports.minHeight = (0, util.responsiveStyle)({
    prop: 'minHeight',
    key: 'minHeights',
    numberToPx: true
  });

  var sizeWidth = exports.sizeWidth = (0, util.responsiveStyle)({
    prop: 'size',
    cssProperty: 'width',
    numberToPx: true
  });

  var sizeHeight = exports.sizeHeight = (0, util.responsiveStyle)({
    prop: 'size',
    cssProperty: 'height',
    numberToPx: true
  });

  var size = exports.size = function size(props) {
    return (0, util.merge)(sizeHeight(props), sizeWidth(props));
  };

  size.propTypes = _extends$$1({}, sizeWidth.propTypes, sizeHeight.propTypes);

  var ratioPadding = exports.ratioPadding = (0, util.style)({
    prop: 'ratio',
    cssProperty: 'paddingBottom',
    getter: function getter(n) {
      return n * 100 + '%';
    }
  });

  var ratio = exports.ratio = function ratio(props) {
    return props.ratio ? _extends$$1({
      height: 0
    }, ratioPadding(props)) : null;
  };
  ratio.propTypes = _extends$$1({}, ratioPadding.propTypes);

  // flexbox
  var alignItems = exports.alignItems = (0, util.responsiveStyle)({
    prop: 'alignItems',
    // for backwards compatibility - will cause bugs when used with textAlign
    alias: 'align'
  });

  var alignContent = exports.alignContent = (0, util.responsiveStyle)({
    prop: 'alignContent'
  });

  var justifyContent = exports.justifyContent = (0, util.responsiveStyle)({
    prop: 'justifyContent',
    // for backwards compatibility
    alias: 'justify'
  });

  // for backwards compatibility
  var flexWrapShim = function flexWrapShim(n) {
    return n === true ? 'wrap' : n;
  };
  var flexWrap = exports.flexWrap = (0, util.responsiveStyle)({
    prop: 'flexWrap',
    alias: 'wrap',
    getter: flexWrapShim
  });

  var flexBasis = exports.flexBasis = (0, util.responsiveStyle)({
    prop: 'flexBasis',
    getter: util.getWidth
  });

  var flexDirection = exports.flexDirection = (0, util.responsiveStyle)({
    prop: 'flexDirection'
  });

  var flex = exports.flex = (0, util.responsiveStyle)({
    prop: 'flex'
  });

  var justifySelf = exports.justifySelf = (0, util.responsiveStyle)({
    prop: 'justifySelf'
  });

  var alignSelf = exports.alignSelf = (0, util.responsiveStyle)({
    prop: 'alignSelf'
  });

  var order = exports.order = (0, util.responsiveStyle)({
    prop: 'order'
  });

  // grid
  var gridGap = exports.gridGap = (0, util.responsiveStyle)({
    prop: 'gridGap',
    numberToPx: true,
    key: 'space'
  });

  var gridColumnGap = exports.gridColumnGap = (0, util.responsiveStyle)({
    prop: 'gridColumnGap',
    numberToPx: true,
    key: 'space'
  });

  var gridRowGap = exports.gridRowGap = (0, util.responsiveStyle)({
    prop: 'gridRowGap',
    numberToPx: true,
    key: 'space'
  });

  var gridColumn = exports.gridColumn = (0, util.responsiveStyle)({
    prop: 'gridColumn'
  });

  var gridRow = exports.gridRow = (0, util.responsiveStyle)({
    prop: 'gridRow'
  });

  var gridAutoFlow = exports.gridAutoFlow = (0, util.style)({
    prop: 'gridAutoFlow'
  });

  var gridAutoColumns = exports.gridAutoColumns = (0, util.style)({
    prop: 'gridAutoColumns'
  });

  var gridAutoRows = exports.gridAutoRows = (0, util.style)({
    prop: 'gridAutoRows'
  });

  var gridTemplateColumns = exports.gridTemplateColumns = (0, util.responsiveStyle)({
    prop: 'gridTemplateColumns'
  });

  var gridTemplateRows = exports.gridTemplateRows = (0, util.responsiveStyle)({
    prop: 'gridTemplateRows'
  });

  // borders
  var getBorder = function getBorder(n) {
    return util$$1.num(n) && n > 0 ? n + 'px solid' : n;
  };

  var border = exports.border = (0, util.responsiveStyle)({
    prop: 'border',
    key: 'borders',
    getter: getBorder
  });

  var borderTop = exports.borderTop = (0, util.responsiveStyle)({
    prop: 'borderTop',
    key: 'borders',
    getter: getBorder
  });

  var borderRight = exports.borderRight = (0, util.responsiveStyle)({
    prop: 'borderRight',
    key: 'borders',
    getter: getBorder
  });

  var borderBottom = exports.borderBottom = (0, util.responsiveStyle)({
    prop: 'borderBottom',
    key: 'borders',
    getter: getBorder
  });

  var borderLeft = exports.borderLeft = (0, util.responsiveStyle)({
    prop: 'borderLeft',
    key: 'borders',
    getter: getBorder
  });

  var borders = exports.borders = function borders(props) {
    return _extends$$1({}, border(props), borderTop(props), borderRight(props), borderBottom(props), borderLeft(props));
  };
  borders.propTypes = _extends$$1({}, border.propTypes, borderTop.propTypes, borderRight.propTypes, borderBottom.propTypes, borderLeft.propTypes);

  var borderColor = exports.borderColor = (0, util.style)({
    prop: 'borderColor',
    key: 'colors'
  });

  var borderRadius = exports.borderRadius = (0, util.style)({
    prop: 'borderRadius',
    key: 'radii',
    numberToPx: true
  });

  var boxShadow = exports.boxShadow = (0, util.style)({
    prop: 'boxShadow',
    key: 'shadows'
  });

  // backgrounds
  var background = exports.background = (0, util.style)({
    prop: 'background'
  });

  var backgroundImage = exports.backgroundImage = (0, util.style)({
    prop: 'backgroundImage',
    alias: 'bgImage',
    getter: function getter(n) {
      return 'url(' + n + ')';
    }
  });

  var backgroundSize = exports.backgroundSize = (0, util.style)({
    prop: 'backgroundSize',
    alias: 'bgSize'
  });

  var backgroundPosition = exports.backgroundPosition = (0, util.style)({
    prop: 'backgroundPosition',
    alias: 'bgPosition'
  });

  var backgroundRepeat = exports.backgroundRepeat = (0, util.style)({
    prop: 'backgroundRepeat',
    alias: 'bgRepeat'
  });

  // position
  var position = exports.position = (0, util.responsiveStyle)({
    prop: 'position'
  });

  var zIndex = exports.zIndex = (0, util.style)({
    prop: 'zIndex'
  });

  var top = exports.top = (0, util.responsiveStyle)({
    prop: 'top',
    numberToPx: true
  });

  var right = exports.right = (0, util.responsiveStyle)({
    prop: 'right',
    numberToPx: true
  });

  var bottom = exports.bottom = (0, util.responsiveStyle)({
    prop: 'bottom',
    numberToPx: true
  });

  var left = exports.left = (0, util.responsiveStyle)({
    prop: 'left',
    numberToPx: true
  });

  // pseudos
  var hover = exports.hover = (0, util.pseudoStyle)({
    prop: 'hover',
    pseudoclass: 'hover',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });

  var focus = exports.focus = (0, util.pseudoStyle)({
    prop: 'focus',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });

  var active = exports.active = (0, util.pseudoStyle)({
    prop: 'active',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });

  var disabled = exports.disabled = (0, util.pseudoStyle)({
    prop: 'disabledStyle',
    pseudoclass: 'disabled',
    keys: {
      color: 'colors',
      backgroundColor: 'colors',
      borderColor: 'colors',
      boxShadow: 'shadows'
    }
  });

  var textStyle = exports.textStyle = (0, util.complexStyle)({
    prop: 'textStyle',
    key: 'textStyles'
  });

  var colorStyle = exports.colorStyle = (0, util.complexStyle)({
    prop: 'colors',
    key: 'colorStyles'
  });

  var buttonStyle = exports.buttonStyle = (0, util.complexStyle)({
    prop: 'buttonStyle',
    key: 'buttons'
  });

  // for backwards-compatibility
  // these will be removed in v3
  var __DEV__ = process.env.NODE_ENV !== 'production';

  var borderWidth = exports.borderWidth = (0, util.style)({
    prop: 'borderWidth',
    cssProperty: 'border',
    key: 'borderWidths',
    getter: function getter(v) {
      if (__DEV__) {
        console.warn('borderWidth is deprecated. Please use the `borders` utility instead');
      }
      return getBorder(v);
    }
  });
});

unwrapExports(styles);
var styles_1 = styles.borderWidth;
var styles_2 = styles.buttonStyle;
var styles_3 = styles.colorStyle;
var styles_4 = styles.textStyle;
var styles_5 = styles.disabled;
var styles_6 = styles.active;
var styles_7 = styles.focus;
var styles_8 = styles.hover;
var styles_9 = styles.left;
var styles_10 = styles.bottom;
var styles_11 = styles.right;
var styles_12 = styles.top;
var styles_13 = styles.zIndex;
var styles_14 = styles.position;
var styles_15 = styles.backgroundRepeat;
var styles_16 = styles.backgroundPosition;
var styles_17 = styles.backgroundSize;
var styles_18 = styles.backgroundImage;
var styles_19 = styles.background;
var styles_20 = styles.boxShadow;
var styles_21 = styles.borderRadius;
var styles_22 = styles.borderColor;
var styles_23 = styles.borders;
var styles_24 = styles.borderLeft;
var styles_25 = styles.borderBottom;
var styles_26 = styles.borderRight;
var styles_27 = styles.borderTop;
var styles_28 = styles.border;
var styles_29 = styles.gridTemplateRows;
var styles_30 = styles.gridTemplateColumns;
var styles_31 = styles.gridAutoRows;
var styles_32 = styles.gridAutoColumns;
var styles_33 = styles.gridAutoFlow;
var styles_34 = styles.gridRow;
var styles_35 = styles.gridColumn;
var styles_36 = styles.gridRowGap;
var styles_37 = styles.gridColumnGap;
var styles_38 = styles.gridGap;
var styles_39 = styles.order;
var styles_40 = styles.alignSelf;
var styles_41 = styles.justifySelf;
var styles_42 = styles.flex;
var styles_43 = styles.flexDirection;
var styles_44 = styles.flexBasis;
var styles_45 = styles.flexWrap;
var styles_46 = styles.justifyContent;
var styles_47 = styles.alignContent;
var styles_48 = styles.alignItems;
var styles_49 = styles.ratio;
var styles_50 = styles.ratioPadding;
var styles_51 = styles.size;
var styles_52 = styles.sizeHeight;
var styles_53 = styles.sizeWidth;
var styles_54 = styles.minHeight;
var styles_55 = styles.maxHeight;
var styles_56 = styles.height;
var styles_57 = styles.minWidth;
var styles_58 = styles.maxWidth;
var styles_59 = styles.display;
var styles_60 = styles.letterSpacing;
var styles_61 = styles.fontWeight;
var styles_62 = styles.lineHeight;
var styles_63 = styles.textAlign;
var styles_64 = styles.fontFamily;
var styles_65 = styles.color;
var styles_66 = styles.bgColor;
var styles_67 = styles.textColor;
var styles_68 = styles.fontSize;
var styles_69 = styles.width;
var styles_70 = styles.space;

var dist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.propTypes = exports.util = exports.theme = exports.themeGet = exports.complexStyle = exports.responsiveStyle = exports.pseudoStyle = exports.style = exports.borderWidth = exports.buttonStyle = exports.colorStyle = exports.textStyle = exports.disabled = exports.active = exports.focus = exports.hover = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = exports.backgroundRepeat = exports.backgroundPosition = exports.backgroundSize = exports.backgroundImage = exports.background = exports.boxShadow = exports.borderRadius = exports.borderColor = exports.borders = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = exports.order = exports.alignSelf = exports.justifySelf = exports.flexBasis = exports.flex = exports.flexDirection = exports.flexWrap = exports.justifyContent = exports.alignContent = exports.alignItems = exports.ratio = exports.size = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.display = exports.letterSpacing = exports.fontWeight = exports.lineHeight = exports.textAlign = exports.fontFamily = exports.color = exports.bgColor = exports.textColor = exports.fontSize = exports.width = exports.space = exports.styles = undefined;

  Object.defineProperty(exports, 'space', {
    enumerable: true,
    get: function get$$1() {
      return styles.space;
    }
  });
  Object.defineProperty(exports, 'width', {
    enumerable: true,
    get: function get$$1() {
      return styles.width;
    }
  });
  Object.defineProperty(exports, 'fontSize', {
    enumerable: true,
    get: function get$$1() {
      return styles.fontSize;
    }
  });
  Object.defineProperty(exports, 'textColor', {
    enumerable: true,
    get: function get$$1() {
      return styles.textColor;
    }
  });
  Object.defineProperty(exports, 'bgColor', {
    enumerable: true,
    get: function get$$1() {
      return styles.bgColor;
    }
  });
  Object.defineProperty(exports, 'color', {
    enumerable: true,
    get: function get$$1() {
      return styles.color;
    }
  });
  Object.defineProperty(exports, 'fontFamily', {
    enumerable: true,
    get: function get$$1() {
      return styles.fontFamily;
    }
  });
  Object.defineProperty(exports, 'textAlign', {
    enumerable: true,
    get: function get$$1() {
      return styles.textAlign;
    }
  });
  Object.defineProperty(exports, 'lineHeight', {
    enumerable: true,
    get: function get$$1() {
      return styles.lineHeight;
    }
  });
  Object.defineProperty(exports, 'fontWeight', {
    enumerable: true,
    get: function get$$1() {
      return styles.fontWeight;
    }
  });
  Object.defineProperty(exports, 'letterSpacing', {
    enumerable: true,
    get: function get$$1() {
      return styles.letterSpacing;
    }
  });
  Object.defineProperty(exports, 'display', {
    enumerable: true,
    get: function get$$1() {
      return styles.display;
    }
  });
  Object.defineProperty(exports, 'maxWidth', {
    enumerable: true,
    get: function get$$1() {
      return styles.maxWidth;
    }
  });
  Object.defineProperty(exports, 'minWidth', {
    enumerable: true,
    get: function get$$1() {
      return styles.minWidth;
    }
  });
  Object.defineProperty(exports, 'height', {
    enumerable: true,
    get: function get$$1() {
      return styles.height;
    }
  });
  Object.defineProperty(exports, 'maxHeight', {
    enumerable: true,
    get: function get$$1() {
      return styles.maxHeight;
    }
  });
  Object.defineProperty(exports, 'minHeight', {
    enumerable: true,
    get: function get$$1() {
      return styles.minHeight;
    }
  });
  Object.defineProperty(exports, 'size', {
    enumerable: true,
    get: function get$$1() {
      return styles.size;
    }
  });
  Object.defineProperty(exports, 'ratio', {
    enumerable: true,
    get: function get$$1() {
      return styles.ratio;
    }
  });
  Object.defineProperty(exports, 'alignItems', {
    enumerable: true,
    get: function get$$1() {
      return styles.alignItems;
    }
  });
  Object.defineProperty(exports, 'alignContent', {
    enumerable: true,
    get: function get$$1() {
      return styles.alignContent;
    }
  });
  Object.defineProperty(exports, 'justifyContent', {
    enumerable: true,
    get: function get$$1() {
      return styles.justifyContent;
    }
  });
  Object.defineProperty(exports, 'flexWrap', {
    enumerable: true,
    get: function get$$1() {
      return styles.flexWrap;
    }
  });
  Object.defineProperty(exports, 'flexDirection', {
    enumerable: true,
    get: function get$$1() {
      return styles.flexDirection;
    }
  });
  Object.defineProperty(exports, 'flex', {
    enumerable: true,
    get: function get$$1() {
      return styles.flex;
    }
  });
  Object.defineProperty(exports, 'flexBasis', {
    enumerable: true,
    get: function get$$1() {
      return styles.flexBasis;
    }
  });
  Object.defineProperty(exports, 'justifySelf', {
    enumerable: true,
    get: function get$$1() {
      return styles.justifySelf;
    }
  });
  Object.defineProperty(exports, 'alignSelf', {
    enumerable: true,
    get: function get$$1() {
      return styles.alignSelf;
    }
  });
  Object.defineProperty(exports, 'order', {
    enumerable: true,
    get: function get$$1() {
      return styles.order;
    }
  });
  Object.defineProperty(exports, 'gridGap', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridGap;
    }
  });
  Object.defineProperty(exports, 'gridColumnGap', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridColumnGap;
    }
  });
  Object.defineProperty(exports, 'gridRowGap', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridRowGap;
    }
  });
  Object.defineProperty(exports, 'gridColumn', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridColumn;
    }
  });
  Object.defineProperty(exports, 'gridRow', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridRow;
    }
  });
  Object.defineProperty(exports, 'gridAutoFlow', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridAutoFlow;
    }
  });
  Object.defineProperty(exports, 'gridAutoColumns', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridAutoColumns;
    }
  });
  Object.defineProperty(exports, 'gridAutoRows', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridAutoRows;
    }
  });
  Object.defineProperty(exports, 'gridTemplateColumns', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridTemplateColumns;
    }
  });
  Object.defineProperty(exports, 'gridTemplateRows', {
    enumerable: true,
    get: function get$$1() {
      return styles.gridTemplateRows;
    }
  });
  Object.defineProperty(exports, 'border', {
    enumerable: true,
    get: function get$$1() {
      return styles.border;
    }
  });
  Object.defineProperty(exports, 'borderTop', {
    enumerable: true,
    get: function get$$1() {
      return styles.borderTop;
    }
  });
  Object.defineProperty(exports, 'borderRight', {
    enumerable: true,
    get: function get$$1() {
      return styles.borderRight;
    }
  });
  Object.defineProperty(exports, 'borderBottom', {
    enumerable: true,
    get: function get$$1() {
      return styles.borderBottom;
    }
  });
  Object.defineProperty(exports, 'borderLeft', {
    enumerable: true,
    get: function get$$1() {
      return styles.borderLeft;
    }
  });
  Object.defineProperty(exports, 'borders', {
    enumerable: true,
    get: function get$$1() {
      return styles.borders;
    }
  });
  Object.defineProperty(exports, 'borderColor', {
    enumerable: true,
    get: function get$$1() {
      return styles.borderColor;
    }
  });
  Object.defineProperty(exports, 'borderRadius', {
    enumerable: true,
    get: function get$$1() {
      return styles.borderRadius;
    }
  });
  Object.defineProperty(exports, 'boxShadow', {
    enumerable: true,
    get: function get$$1() {
      return styles.boxShadow;
    }
  });
  Object.defineProperty(exports, 'background', {
    enumerable: true,
    get: function get$$1() {
      return styles.background;
    }
  });
  Object.defineProperty(exports, 'backgroundImage', {
    enumerable: true,
    get: function get$$1() {
      return styles.backgroundImage;
    }
  });
  Object.defineProperty(exports, 'backgroundSize', {
    enumerable: true,
    get: function get$$1() {
      return styles.backgroundSize;
    }
  });
  Object.defineProperty(exports, 'backgroundPosition', {
    enumerable: true,
    get: function get$$1() {
      return styles.backgroundPosition;
    }
  });
  Object.defineProperty(exports, 'backgroundRepeat', {
    enumerable: true,
    get: function get$$1() {
      return styles.backgroundRepeat;
    }
  });
  Object.defineProperty(exports, 'position', {
    enumerable: true,
    get: function get$$1() {
      return styles.position;
    }
  });
  Object.defineProperty(exports, 'zIndex', {
    enumerable: true,
    get: function get$$1() {
      return styles.zIndex;
    }
  });
  Object.defineProperty(exports, 'top', {
    enumerable: true,
    get: function get$$1() {
      return styles.top;
    }
  });
  Object.defineProperty(exports, 'right', {
    enumerable: true,
    get: function get$$1() {
      return styles.right;
    }
  });
  Object.defineProperty(exports, 'bottom', {
    enumerable: true,
    get: function get$$1() {
      return styles.bottom;
    }
  });
  Object.defineProperty(exports, 'left', {
    enumerable: true,
    get: function get$$1() {
      return styles.left;
    }
  });
  Object.defineProperty(exports, 'hover', {
    enumerable: true,
    get: function get$$1() {
      return styles.hover;
    }
  });
  Object.defineProperty(exports, 'focus', {
    enumerable: true,
    get: function get$$1() {
      return styles.focus;
    }
  });
  Object.defineProperty(exports, 'active', {
    enumerable: true,
    get: function get$$1() {
      return styles.active;
    }
  });
  Object.defineProperty(exports, 'disabled', {
    enumerable: true,
    get: function get$$1() {
      return styles.disabled;
    }
  });
  Object.defineProperty(exports, 'textStyle', {
    enumerable: true,
    get: function get$$1() {
      return styles.textStyle;
    }
  });
  Object.defineProperty(exports, 'colorStyle', {
    enumerable: true,
    get: function get$$1() {
      return styles.colorStyle;
    }
  });
  Object.defineProperty(exports, 'buttonStyle', {
    enumerable: true,
    get: function get$$1() {
      return styles.buttonStyle;
    }
  });
  Object.defineProperty(exports, 'borderWidth', {
    enumerable: true,
    get: function get$$1() {
      return styles.borderWidth;
    }
  });

  Object.defineProperty(exports, 'style', {
    enumerable: true,
    get: function get$$1() {
      return util.style;
    }
  });
  Object.defineProperty(exports, 'pseudoStyle', {
    enumerable: true,
    get: function get$$1() {
      return util.pseudoStyle;
    }
  });
  Object.defineProperty(exports, 'responsiveStyle', {
    enumerable: true,
    get: function get$$1() {
      return util.responsiveStyle;
    }
  });
  Object.defineProperty(exports, 'complexStyle', {
    enumerable: true,
    get: function get$$1() {
      return util.complexStyle;
    }
  });
  Object.defineProperty(exports, 'themeGet', {
    enumerable: true,
    get: function get$$1() {
      return util.themeGet;
    }
  });
  Object.defineProperty(exports, 'theme', {
    enumerable: true,
    get: function get$$1() {
      return util.themeGet;
    }
  });

  var styles$$1 = _interopRequireWildcard(styles);

  var _styles = _interopRequireWildcard(styles);

  var _util = _interopRequireWildcard(util);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  exports.styles = _styles;
  exports.util = _util;
  var propTypes = exports.propTypes = {};

  Object.keys(styles$$1).forEach(function (key) {
    propTypes[key] = styles$$1[key].propTypes;
  });

  styles$$1.propTypes = propTypes;

  exports.default = styles$$1;
});

unwrapExports(dist);
var dist_1 = dist.propTypes;
var dist_2 = dist.util;
var dist_3 = dist.theme;
var dist_4 = dist.themeGet;
var dist_5 = dist.complexStyle;
var dist_6 = dist.responsiveStyle;
var dist_7 = dist.pseudoStyle;
var dist_8 = dist.style;
var dist_9 = dist.borderWidth;
var dist_10 = dist.buttonStyle;
var dist_11 = dist.colorStyle;
var dist_12 = dist.textStyle;
var dist_13 = dist.disabled;
var dist_14 = dist.active;
var dist_15 = dist.focus;
var dist_16 = dist.hover;
var dist_17 = dist.left;
var dist_18 = dist.bottom;
var dist_19 = dist.right;
var dist_20 = dist.top;
var dist_21 = dist.zIndex;
var dist_22 = dist.position;
var dist_23 = dist.backgroundRepeat;
var dist_24 = dist.backgroundPosition;
var dist_25 = dist.backgroundSize;
var dist_26 = dist.backgroundImage;
var dist_27 = dist.background;
var dist_28 = dist.boxShadow;
var dist_29 = dist.borderRadius;
var dist_30 = dist.borderColor;
var dist_31 = dist.borders;
var dist_32 = dist.borderLeft;
var dist_33 = dist.borderBottom;
var dist_34 = dist.borderRight;
var dist_35 = dist.borderTop;
var dist_36 = dist.border;
var dist_37 = dist.gridTemplateRows;
var dist_38 = dist.gridTemplateColumns;
var dist_39 = dist.gridAutoRows;
var dist_40 = dist.gridAutoColumns;
var dist_41 = dist.gridAutoFlow;
var dist_42 = dist.gridRow;
var dist_43 = dist.gridColumn;
var dist_44 = dist.gridRowGap;
var dist_45 = dist.gridColumnGap;
var dist_46 = dist.gridGap;
var dist_47 = dist.order;
var dist_48 = dist.alignSelf;
var dist_49 = dist.justifySelf;
var dist_50 = dist.flexBasis;
var dist_51 = dist.flex;
var dist_52 = dist.flexDirection;
var dist_53 = dist.flexWrap;
var dist_54 = dist.justifyContent;
var dist_55 = dist.alignContent;
var dist_56 = dist.alignItems;
var dist_57 = dist.ratio;
var dist_58 = dist.size;
var dist_59 = dist.minHeight;
var dist_60 = dist.maxHeight;
var dist_61 = dist.height;
var dist_62 = dist.minWidth;
var dist_63 = dist.maxWidth;
var dist_64 = dist.display;
var dist_65 = dist.letterSpacing;
var dist_66 = dist.fontWeight;
var dist_67 = dist.lineHeight;
var dist_68 = dist.textAlign;
var dist_69 = dist.fontFamily;
var dist_70 = dist.color;
var dist_71 = dist.bgColor;
var dist_72 = dist.textColor;
var dist_73 = dist.fontSize;
var dist_74 = dist.width;
var dist_75 = dist.space;
var dist_76 = dist.styles;

var background = {
  default: "grayScale.3",
  disabled: "disabled",
  primary: "primary",
  positive: "positive",
  warning: "warning",
  negative: "negative"
};

var inverseBackground = {
  default: "primary",
  disabled: "disabled",
  primary: "grayScale.3",
  positive: "grayScale.3",
  warning: "grayScale.3",
  negative: "grayScale.3"
};

var textColor = {
  default: "white",
  disabled: "grayScale.1",
  negative: "white",
  primary: "black",
  warning: "black",
  positive: "black"
};

var inverseText = {
  default: "white",
  disabled: "white",
  negative: "white",
  primary: "white",
  warning: "white",
  positive: "white"
};

var ButtonWrapper = system({
  is: "button",
  display: "flex",
  alignItems: "center",
  height: "2.813rem",
  justifyContent: "center",
  m: 0,
  mt: 0,
  border: 0,
  fontSize: 1,
  lineHeight: 1,
  minWidth: "5.33333rem",
  maxWidth: "16rem",
  px: 6,
  py: 4,
  borderBottom: 2
}, function (props) {
  return {
    backgroundColor: dist_3("colors." + background[props.variant])(props),
    borderColor: dist_3("colors." + inverseBackground[props.variant])(props),
    color: dist_3("colors." + textColor[props.variant])(props),
    fontFamily: props.theme.fonts.bold,
    "&:focus": { outline: "none" },
    "&:disabled": { cursor: "default" },
    "> a": {
      color: "inherit",
      textDecoration: "inherit"
    },
    "&:hover": {
      borderColor: dist_3("colors." + background[props.variant])(props),
      color: dist_3("colors." + inverseText[props.variant])(props),
      backgroundColor: dist_3("colors." + inverseBackground[props.variant])(props)
    },
    boxSizing: "border-box",
    userSelect: "none"
  };
});

/**
 * The button component for the Offcourse project
 */

var Button = function (_Component) {
  inherits$1(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck$1(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn$1(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var onClick = _this.props.onClick;

      e.preventDefault();
      onClick();
    }, _temp), possibleConstructorReturn$1(_this, _ret);
  }

  createClass$1(Button, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          href = _props.href,
          type = _props.type,
          children = _props.children,
          onClick = _props.onClick,
          tabindex = _props.tabindex,
          variant = _props.variant,
          mt = _props.mt,
          size = _props.size,
          rest = objectWithoutProperties$1(_props, ["href", "type", "children", "onClick", "tabindex", "variant", "mt", "size"]);

      var buttonType = type || "button";
      var disabled = this.props.disabled || this.props.loading;

      var widths = {
        small: "5.33333rem",
        medium: "8rem",
        large: "16rem"
      };

      var text = formatTitle(children);

      return React.createElement(ButtonWrapper, {
        mt: mt,
        type: buttonType,
        variant: disabled ? "disabled" : variant,
        disabled: disabled,
        onClick: onClick,
        tabIndex: tabindex || 1,
        minWidth: widths[size],
        maxWidth: widths[size]
      }, href ? React.createElement("a", { href: !disabled ? href : undefined }, text) : text);
    }
  }]);
  return Button;
}(Component);

Button.propTypes = {
  /** determines if the button should be disabled */
  disabled: PropTypes.bool,
  /** determines the status of the button */
  variant: PropTypes.oneOf(["default", "primary", "positive", "warning", "negative"]),
  /** the text that is displayed on the button */
  children: PropTypes.string,
  /** code that the button should execute when clicked */
  onClick: PropTypes.func,
  /** a url that the button should link to, automatically turns the button into the basic type */
  href: PropTypes.string,
  /** only accept a type prop when type is submit */
  type: PropTypes.oneOf(["submit", "button"]),
  /** the size of the button */
  size: PropTypes.oneOf(["small", "medium", "large"])
};
Button.defaultProps = {
  variant: "default",
  size: "medium",
  disabled: false,
  type: "button"
};

var _templateObject$1 = taggedTemplateLiteral$1(["\n  section:last-child {\n    border-bottom: ", ";\n    border-color: ", ";\n\n    &:hover {\n        border-color: ", ";\n      }\n    }\n  }\n"], ["\n  section:last-child {\n    border-bottom: ", ";\n    border-color: ", ";\n\n    &:hover {\n        border-color: ", ";\n      }\n    }\n  }\n"]);

var CardWrapper = system({
  display: "block",
  width: ["18rem", "18rem", "18rem"],
  bg: "grayScale.0"
}).extend(_templateObject$1, function (_ref) {
  var theme = _ref.theme;
  return theme.borders[2];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grayScale[2];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});

var Card = function (_Component) {
  inherits$1(Card, _Component);

  function Card() {
    classCallCheck$1(this, Card);
    return possibleConstructorReturn$1(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
  }

  createClass$1(Card, [{
    key: "renderSections",
    value: function renderSections() {
      var children = this.props.children;

      return Children.map(children, function (child, index) {
        if (!child) {
          return null;
        }
        var inverse = child.props.inverse;

        return React.createElement(Section, { bg: inverse ? "grayScale.3" : "white" }, child);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(CardWrapper, null, this.renderSections());
    }
  }]);
  return Card;
}(Component);

/*!
 * Font Awesome Free 5.0.13 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER$1 = null;
var _PERFORMANCE = { mark: noop, measure: noop };

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER$1 = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {};
var _ref$userAgent = _ref.userAgent;
var userAgent = _ref$userAgent === undefined ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER$1;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';

var PRODUCTION = function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
}();

var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);

var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];

var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter'].concat(oneToTen.map(function (n) {
  return n + 'x';
})).concat(oneToTwenty.map(function (n) {
  return 'w-' + n;
}));

var classCallCheck$1$1 = function classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var toConsumableArray$1 = function toConsumableArray$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
};

var initial = WINDOW.FontAwesomeConfig || {};
var initialKeys = Object.keys(initial);

var _default = _extends$1({
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}, initial);

if (!_default.autoReplaceSvg) _default.observeMutations = false;

var config$1 = _extends$1({}, _default);

WINDOW.FontAwesomeConfig = config$1;

function update$2(newConfig) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$asNewDefault = params.asNewDefault,
      asNewDefault = _params$asNewDefault === undefined ? false : _params$asNewDefault;

  var validKeys = Object.keys(config$1);
  var ok = asNewDefault ? function (k) {
    return ~validKeys.indexOf(k) && !~initialKeys.indexOf(k);
  } : function (k) {
    return ~validKeys.indexOf(k);
  };

  Object.keys(newConfig).forEach(function (configKey) {
    if (ok(configKey)) config$1[configKey] = newConfig[configKey];
  });
}

function auto(value) {
  update$2({
    autoReplaceSvg: value,
    observeMutations: value
  });
}

var w = WINDOW || {};

if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];

var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];
var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);

  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var domready = function domready(fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
};

var d = UNITS_IN_GRID;

var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function bunker(fn) {
  try {
    fn();
  } catch (e) {
    if (!PRODUCTION) {
      throw e;
    }
  }
}

function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;

  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();
    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);

  return css;
}

var _uniqueId = 0;

function nextUniqueId() {
  _uniqueId++;

  return _uniqueId;
}

function toArray$1(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}

function classArray(node) {
  if (node.classList) {
    return toArray$1(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}

function htmlEscape(str) {
  return ('' + str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + (attributeName + '="' + htmlEscape(attributes[attributeName]) + '" ');
  }, '').trim();
}

function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + (styleName + ': ' + styles[styleName] + ';');
  }, '');
}

function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}

function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;

  var outer = {
    transform: 'translate(' + containerWidth / 2 + ' 256)'
  };
  var innerTranslate = 'translate(' + transform.x * 32 + ', ' + transform.y * 32 + ') ';
  var innerScale = 'scale(' + transform.size / 16 * (transform.flipX ? -1 : 1) + ', ' + transform.size / 16 * (transform.flipY ? -1 : 1) + ') ';
  var innerRotate = 'rotate(' + transform.rotate + ' 0 0)';
  var inner = {
    transform: innerTranslate + ' ' + innerScale + ' ' + innerRotate
  };
  var path = {
    transform: 'translate(' + iconWidth / 2 * -1 + ' -256)'
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === undefined ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === undefined ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === undefined ? false : _ref2$startCentered;

  var val = '';

  if (startCentered && IS_IE) {
    val += 'translate(' + (transform.x / d - width / 2) + 'em, ' + (transform.y / d - height / 2) + 'em) ';
  } else if (startCentered) {
    val += 'translate(calc(-50% + ' + transform.x / d + 'em), calc(-50% + ' + transform.y / d + 'em)) ';
  } else {
    val += 'translate(' + transform.x / d + 'em, ' + transform.y / d + 'em) ';
  }

  val += 'scale(' + transform.size / d * (transform.flipX ? -1 : 1) + ', ' + transform.size / d * (transform.flipY ? -1 : 1) + ') ';
  val += 'rotate(' + transform.rotate + 'deg) ';

  return val;
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

var makeIconMasking = function makeIconMasking(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;

  var trans = transformForSvg({ transform: transform, containerWidth: maskWidth, iconWidth: mainWidth });

  var maskRect = {
    tag: 'rect',
    attributes: _extends$1({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroup = {
    tag: 'g',
    attributes: _extends$1({}, trans.inner),
    children: [{ tag: 'path', attributes: _extends$1({}, mainPath.attributes, trans.path, { fill: 'black' }) }]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _extends$1({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = 'mask-' + nextUniqueId();
  var clipId = 'clip-' + nextUniqueId();
  var maskTag = {
    tag: 'mask',
    attributes: _extends$1({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{ tag: 'clipPath', attributes: { id: clipId }, children: [maskPath] }, maskTag]
  };

  children.push(defs, { tag: 'rect', attributes: _extends$1({ fill: 'currentColor', 'clip-path': 'url(#' + clipId + ')', mask: 'url(#' + maskId + ')' }, ALL_SPACE) });

  return {
    children: children,
    attributes: attributes
  };
};

var makeIconStandard = function makeIconStandard(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({ transform: transform, containerWidth: main.width, iconWidth: main.width });
    children.push({
      tag: 'g',
      attributes: _extends$1({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _extends$1({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _extends$1({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
};

var asIcon = function asIcon(_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;

    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_extends$1({}, styles, {
      'transform-origin': offset.x + transform.x / 16 + 'em ' + (offset.y + transform.y / 16) + 'em'
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
};

var asSymbol = function asSymbol(_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;

  var id = symbol === true ? prefix + '-' + config$1.familyPrefix + '-' + iconName : symbol;

  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _extends$1({}, attributes, { id: id }),
      children: children
    }]
  }];
};

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === undefined ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var widthClass = 'fa-w-' + Math.ceil(width / height * 16);
  var attrClass = [config$1.replacementClass, iconName ? config$1.familyPrefix + '-' + iconName : '', widthClass].concat(extra.classes).join(' ');

  var content = {
    children: [],
    attributes: _extends$1({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': '0 0 ' + width + ' ' + height
    })
  };

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({ tag: 'title', attributes: { id: content.attributes['aria-labelledby'] || 'title-' + nextUniqueId() }, children: [title] });

  var args = _extends$1({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    transform: transform,
    symbol: symbol,
    styles: extra.styles
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === undefined ? false : _params$watchable2;

  var attributes = _extends$1({}, extra.attributes, title ? { 'title': title } : {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _extends$1({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({ transform: transform, startCentered: true, width: width, height: height });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];

  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({ tag: 'span', attributes: { class: 'sr-only' }, children: [title] });
  }

  return val;
}

var noop$2 = function noop() {};
var p = config$1.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : { mark: noop$2, measure: noop$2 };
var preamble = 'FA "5.0.13"';

var begin = function begin(name) {
  p.mark(preamble + ' ' + name + ' begins');
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark(preamble + ' ' + name + ' ends');
  p.measure(preamble + ' ' + name, preamble + ' ' + name + ' begins', preamble + ' ' + name + ' ends');
};

var perf = { begin: begin, end: end };

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */
var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */
var reduce$2 = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

var styles$2 = namespace.styles;
var shims = namespace.shims;

var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};

var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce$2(styles$2, function (o, style, prefix) {
      o[prefix] = reduce$2(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    acc[icon[3]] = iconName;

    return acc;
  });

  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];

    acc[iconName] = iconName;

    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });

    return acc;
  });

  var hasRegular = 'far' in styles$2;

  _byOldName = reduce$2(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = { prefix: prefix, iconName: iconName };

    return acc;
  }, {});
};

build();

function byUnicode(prefix, unicode) {
  return _byUnicode[prefix][unicode];
}

function byLigature(prefix, ligature) {
  return _byLigature[prefix][ligature];
}

function byOldName(name) {
  return _byOldName[name] || { prefix: null, iconName: null };
}

var styles$1$1 = namespace.styles;

var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return { prefix: null, iconName: null, rest: [] };
};

function getCanonicalIcon(values) {
  return values.reduce(function (acc, cls) {
    var iconName = getIconName(config$1.familyPrefix, cls);

    if (styles$1$1[cls]) {
      acc.prefix = cls;
    } else if (iconName) {
      var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};

      acc.iconName = shim.iconName || iconName;
      acc.prefix = shim.prefix || acc.prefix;
    } else if (cls !== config$1.replacementClass && cls.indexOf('fa-w-') !== 0) {
      acc.rest.push(cls);
    }

    return acc;
  }, emptyCanonicalIcon());
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === undefined ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === undefined ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return '<' + tag + ' ' + joinAttributes(attributes) + '>' + children.map(toHtml).join('') + '</' + tag + '>';
  }
}

var noop$1 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;

  return typeof i2svg === 'string';
}

function getMutator() {
  if (config$1.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config$1.autoReplaceSvg];

  return mutator || mutators.replace;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];
    var newOuterHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');

    if (node.parentNode && node.outerHTML) {
      node.outerHTML = newOuterHTML + (config$1.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? '<!-- ' + node.outerHTML + ' -->' : '');
    } else if (node.parentNode) {
      var newNode = document.createElement('span');
      node.parentNode.replaceChild(newNode, node);
      newNode.outerHTML = newOuterHTML;
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];

    // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement
    if (~classArray(node).indexOf(config$1.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp(config$1.familyPrefix + '-.*');

    delete abstract[0].attributes.style;

    var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
      if (cls === config$1.replacementClass || cls.match(forSvg)) {
        acc.toSvg.push(cls);
      } else {
        acc.toNode.push(cls);
      }

      return acc;
    }, { toNode: [], toSvg: [] });

    abstract[0].attributes.class = splitClasses.toSvg.join(' ');

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute('class', splitClasses.toNode.join(' '));
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$1;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = WINDOW.requestAnimationFrame || function (op) {
      return op();
    };

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');

      mutations.map(mutator);

      mark();

      callbackFunction();
    });
  }
}

var disabled = false;

function disableObservation(operation) {
  disabled = true;
  operation();
  disabled = false;
}

var mo = null;

function observe(options) {
  if (!MUTATION_OBSERVER) return;

  var treeCallback = options.treeCallback,
      nodeCallback = options.nodeCallback,
      pseudoElementsCallback = options.pseudoElementsCallback;

  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;

    toArray$1(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config$1.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config$1.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class') {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
          if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
        } else {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });

  if (!IS_DOM) return;

  mo.observe(DOCUMENT.getElementsByTagName('body')[0], {
    childList: true, attributes: true, characterData: true, subtree: true
  });
}

function disconnect() {
  if (!mo) return;

  mo.disconnect();
}

var styleParser = function styleParser(node) {
  var style = node.getAttribute('style');

  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
};

function toHex(unicode) {
  var result = '';

  for (var i = 0; i < unicode.length; i++) {
    var hex = unicode.charCodeAt(i).toString(16);
    result += ('000' + hex).slice(-4);
  }

  return result;
}

var classParser = function classParser(node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';

  var val = getCanonicalIcon(classArray(node));

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.prefix && innerText.length > 1) {
    val.iconName = byLigature(val.prefix, node.innerText);
  } else if (val.prefix && innerText.length === 1) {
    val.iconName = byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;
        case 'shrink':
          acc.size = acc.size - rest;
          break;
        case 'left':
          acc.x = acc.x - rest;
          break;
        case 'right':
          acc.x = acc.x + rest;
          break;
        case 'up':
          acc.y = acc.y - rest;
          break;
        case 'down':
          acc.y = acc.y + rest;
          break;
        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

var transformParser = function transformParser(node) {
  return parseTransformString(node.getAttribute('data-fa-transform'));
};

var symbolParser = function symbolParser(node) {
  var symbol = node.getAttribute('data-fa-symbol');

  return symbol === null ? false : symbol === '' ? true : symbol;
};

var attributesParser = function attributesParser(node) {
  var extraAttributes = toArray$1(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});

  var title = node.getAttribute('title');

  if (config$1.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
    } else {
      extraAttributes['aria-hidden'] = 'true';
    }
  }

  return extraAttributes;
};

var maskParser = function maskParser(node) {
  var mask = node.getAttribute('data-fa-mask');

  if (!mask) {
    return emptyCanonicalIcon();
  } else {
    return getCanonicalIcon(mask.split(' ').map(function (i) {
      return i.trim();
    }));
  }
};

function parseMeta(node) {
  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraStyles = styleParser(node);
  var transform = transformParser(node);
  var symbol = symbolParser(node);
  var extraAttributes = attributesParser(node);
  var mask = maskParser(node);

  return {
    iconName: iconName,
    title: node.getAttribute('title'),
    prefix: prefix,
    transform: transform,
    symbol: symbol,
    mask: mask,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  };
}

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}

MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = { fill: 'currentColor' };
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _extends$1({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};
var OPACITY_ANIMATE = _extends$1({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});
var DOT = {
  tag: 'circle',
  attributes: _extends$1({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{ tag: 'animate', attributes: _extends$1({}, ANIMATION_BASE, { attributeName: 'r', values: '28;14;28;28;14;28;' }) }, { tag: 'animate', attributes: _extends$1({}, OPACITY_ANIMATE, { values: '1;0;1;1;0;1;' }) }]
};
var QUESTION = {
  tag: 'path',
  attributes: _extends$1({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{ tag: 'animate', attributes: _extends$1({}, OPACITY_ANIMATE, { values: '1;0;0;0;0;1;' }) }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _extends$1({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{ tag: 'animate', attributes: _extends$1({}, OPACITY_ANIMATE, { values: '0;0;1;1;0;0;' }) }]
};

var missing = { tag: 'g', children: [RING, DOT, QUESTION, EXCLAMATION] };

var styles$2$1 = namespace.styles;

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Brands)/;
var STYLE_TO_PREFIX = {
  'Solid': 'fas',
  'Regular': 'far',
  'Light': 'fal',
  'Brands': 'fab'
};

function findIcon(iconName, prefix) {
  var val = {
    found: false,
    width: 512,
    height: 512,
    icon: missing
  };

  if (iconName && prefix && styles$2$1[prefix] && styles$2$1[prefix][iconName]) {
    var icon = styles$2$1[prefix][iconName];
    var width = icon[0];
    var height = icon[1];
    var vectorData = icon.slice(4);

    val = {
      found: true,
      width: width,
      height: height,
      icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
    };
  } else if (iconName && prefix && !config$1.showMissingIcons) {
    throw new MissingIcon('Icon is missing for prefix ' + prefix + ' with icon name ' + iconName);
  }

  return val;
}

function generateSvgReplacementMutation(node, nodeMeta) {
  var iconName = nodeMeta.iconName,
      title = nodeMeta.title,
      prefix = nodeMeta.prefix,
      transform = nodeMeta.transform,
      symbol = nodeMeta.symbol,
      mask = nodeMeta.mask,
      extra = nodeMeta.extra;

  return [node, makeInlineSvgAbstract({
    icons: {
      main: findIcon(iconName, prefix),
      mask: findIcon(mask.iconName, mask.prefix)
    },
    prefix: prefix,
    iconName: iconName,
    transform: transform,
    symbol: symbol,
    mask: mask,
    title: title,
    extra: extra,
    watchable: true
  })];
}

function generateLayersText(node, nodeMeta) {
  var title = nodeMeta.title,
      transform = nodeMeta.transform,
      extra = nodeMeta.extra;

  var width = null;
  var height = null;

  if (IS_IE) {
    var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
    var boundingClientRect = node.getBoundingClientRect();
    width = boundingClientRect.width / computedFontSize;
    height = boundingClientRect.height / computedFontSize;
  }

  if (config$1.autoA11y && !title) {
    extra.attributes['aria-hidden'] = 'true';
  }

  return [node, makeLayersTextAbstract({
    content: node.innerHTML,
    width: width,
    height: height,
    transform: transform,
    title: title,
    extra: extra,
    watchable: true
  })];
}

function generateMutation(node) {
  var nodeMeta = parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return generateLayersText(node, nodeMeta);
  } else {
    return generateSvgReplacementMutation(node, nodeMeta);
  }
}

function remove$2(node) {
  if (typeof node.remove === 'function') {
    node.remove();
  } else if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;

  var end = perf.begin('searchPseudoElements');

  disableObservation(function () {
    toArray$1(root.querySelectorAll('*')).forEach(function (node) {
      [':before', ':after'].forEach(function (pos) {
        var styles = WINDOW.getComputedStyle(node, pos);
        var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
        var children = toArray$1(node.children);
        var pseudoElement = children.filter(function (c) {
          return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === pos;
        })[0];

        if (pseudoElement) {
          if (pseudoElement.nextSibling && pseudoElement.nextSibling.textContent.indexOf(DATA_FA_PSEUDO_ELEMENT) > -1) {
            remove$2(pseudoElement.nextSibling);
          }
          remove$2(pseudoElement);
          pseudoElement = null;
        }

        if (fontFamily && !pseudoElement) {
          var content = styles.getPropertyValue('content');
          var i = DOCUMENT.createElement('i');
          i.setAttribute('class', '' + STYLE_TO_PREFIX[fontFamily[1]]);
          i.setAttribute(DATA_FA_PSEUDO_ELEMENT, pos);
          i.innerText = content.length === 3 ? content.substr(1, 1) : content;
          if (pos === ':before') {
            node.insertBefore(i, node.firstChild);
          } else {
            node.appendChild(i);
          }
        }
      });
    });
  });

  end();
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!IS_DOM) return;

  var htmlClassList = DOCUMENT.documentElement.classList;
  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
  };
  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
  };
  var prefixes = Object.keys(styles$2$1);
  var prefixesDomQuery = ['.' + LAYERS_TEXT_CLASSNAME + ':not([' + DATA_FA_I2SVG + '])'].concat(prefixes.map(function (p) {
    return '.' + p + ':not([' + DATA_FA_I2SVG + '])';
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return;
  }

  var candidates = toArray$1(root.querySelectorAll(prefixesDomQuery));

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return;
  }

  var mark = perf.begin('onTree');

  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e instanceof MissingIcon) {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);

  mark();

  perform(mutations, function () {
    hclAdd('active');
    hclAdd('complete');
    hclRemove('pending');

    if (typeof callback === 'function') callback();
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var mutation = generateMutation(node);

  if (mutation) {
    perform([mutation], callback);
  }
}

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible; }\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em; }\n  .svg-inline--fa.fa-lg {\n    vertical-align: -.225em; }\n  .svg-inline--fa.fa-w-1 {\n    width: 0.0625em; }\n  .svg-inline--fa.fa-w-2 {\n    width: 0.125em; }\n  .svg-inline--fa.fa-w-3 {\n    width: 0.1875em; }\n  .svg-inline--fa.fa-w-4 {\n    width: 0.25em; }\n  .svg-inline--fa.fa-w-5 {\n    width: 0.3125em; }\n  .svg-inline--fa.fa-w-6 {\n    width: 0.375em; }\n  .svg-inline--fa.fa-w-7 {\n    width: 0.4375em; }\n  .svg-inline--fa.fa-w-8 {\n    width: 0.5em; }\n  .svg-inline--fa.fa-w-9 {\n    width: 0.5625em; }\n  .svg-inline--fa.fa-w-10 {\n    width: 0.625em; }\n  .svg-inline--fa.fa-w-11 {\n    width: 0.6875em; }\n  .svg-inline--fa.fa-w-12 {\n    width: 0.75em; }\n  .svg-inline--fa.fa-w-13 {\n    width: 0.8125em; }\n  .svg-inline--fa.fa-w-14 {\n    width: 0.875em; }\n  .svg-inline--fa.fa-w-15 {\n    width: 0.9375em; }\n  .svg-inline--fa.fa-w-16 {\n    width: 1em; }\n  .svg-inline--fa.fa-w-17 {\n    width: 1.0625em; }\n  .svg-inline--fa.fa-w-18 {\n    width: 1.125em; }\n  .svg-inline--fa.fa-w-19 {\n    width: 1.1875em; }\n  .svg-inline--fa.fa-w-20 {\n    width: 1.25em; }\n  .svg-inline--fa.fa-pull-left {\n    margin-right: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-pull-right {\n    margin-left: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-border {\n    height: 1.5em; }\n  .svg-inline--fa.fa-li {\n    width: 2em; }\n  .svg-inline--fa.fa-fw {\n    width: 1.25em; }\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em; }\n  .fa-layers svg.svg-inline--fa {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center; }\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center; }\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right; }\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left; }\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1em; }\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n";

var css = function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config$1.familyPrefix;
  var rc = config$1.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp('\\.' + dfp + '\\-', 'g');
    var rPatt = new RegExp('\\.' + drc, 'g');

    s = s.replace(dPatt, '.' + fp + '-').replace(rPatt, '.' + rc);
  }

  return s;
};

function define(prefix, icons) {
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }
    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function') {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _extends$1({}, namespace.styles[prefix] || {}, normalized);
  }

  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */
  if (prefix === 'fas') {
    define('fa', icons);
  }
}

var Library = function () {
  function Library() {
    classCallCheck$1$1(this, Library);

    this.definitions = {};
  }

  createClass$1$1(Library, [{
    key: 'add',
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});

      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _extends$1({}, _this.definitions[key] || {}, additions[key]);
        define(key, additions[key]);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: '_pullDefinitions',
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? { 0: definition } : definition;

      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;

        if (!additions[prefix]) additions[prefix] = {};

        additions[prefix][iconName] = icon;
      });

      return additions;
    }
  }]);
  return Library;
}();

function prepIcon(icon) {
  var width = icon[0];
  var height = icon[1];
  var vectorData = icon.slice(4);

  return {
    found: true,
    width: width,
    height: height,
    icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
  };
}

var _cssInserted = false;

function ensureCss() {
  if (!config$1.autoAddCss) {
    return;
  }

  if (!_cssInserted) {
    insertCss(css());
  }

  _cssInserted = true;
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });

  Object.defineProperty(val, 'html', {
    get: function get$$1() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });

  Object.defineProperty(val, 'node', {
    get: function get$$1() {
      if (!IS_DOM) return;

      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });

  return val;
}

function findIconDefinition(params) {
  var _params$prefix = params.prefix,
      prefix = _params$prefix === undefined ? 'fa' : _params$prefix,
      iconName = params.iconName;

  if (!iconName) return;

  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});

    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _extends$1({}, params, { mask: mask }));
  };
}

var library = new Library();

var noAuto = function noAuto() {
  auto(false);
  disconnect();
};

var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      ensureCss();

      var _params$node = params.node,
          node = _params$node === undefined ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === undefined ? function () {} : _params$callback;

      if (config$1.searchPseudoElements) {
        searchPseudoElements(node);
      }

      onTree(node, callback);
    }
  },

  css: css,

  insertCss: function insertCss$$1() {
    insertCss(css());
  }
};

var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};

var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === undefined ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === undefined ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === undefined ? null : _params$mask,
      _params$title = params.title,
      title = _params$title === undefined ? null : _params$title,
      _params$classes = params.classes,
      classes = _params$classes === undefined ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === undefined ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === undefined ? {} : _params$styles;

  if (!iconDefinition) return;

  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;

  return apiObject(_extends$1({ type: 'icon' }, iconDefinition), function () {
    ensureCss();

    if (config$1.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
      } else {
        attributes['aria-hidden'] = 'true';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: prepIcon(icon),
        mask: mask ? prepIcon(mask.icon) : { found: false, width: null, height: null, icon: {} }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _extends$1({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

var text = function text(content) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform2 = params.transform,
      transform = _params$transform2 === undefined ? meaninglessTransform : _params$transform2,
      _params$title2 = params.title,
      title = _params$title2 === undefined ? null : _params$title2,
      _params$classes2 = params.classes,
      classes = _params$classes2 === undefined ? [] : _params$classes2,
      _params$attributes2 = params.attributes,
      attributes = _params$attributes2 === undefined ? {} : _params$attributes2,
      _params$styles2 = params.styles,
      styles = _params$styles2 === undefined ? {} : _params$styles2;

  return apiObject({ type: 'text', content: content }, function () {
    ensureCss();

    return makeLayersTextAbstract({
      content: content,
      transform: _extends$1({}, meaninglessTransform, transform),
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: [config$1.familyPrefix + '-layers-text'].concat(toConsumableArray$1(classes))
      }
    });
  });
};

var layer = function layer(assembler) {
  return apiObject({ type: 'layer' }, function () {
    ensureCss();

    var children = [];

    assembler(function (args) {
      Array.isArray(args) ? args.map(function (a) {
        children = children.concat(a.abstract);
      }) : children = children.concat(args.abstract);
    });

    return [{
      tag: 'span',
      attributes: { class: config$1.familyPrefix + '-layers' },
      children: children
    }];
  });
};

var api$1 = {
  noAuto: noAuto,
  dom: dom,
  library: library,
  parse: parse,
  findIconDefinition: findIconDefinition,
  icon: icon,
  text: text,
  layer: layer
};

var autoReplace = function autoReplace() {
  if (IS_DOM && config$1.autoReplaceSvg) api$1.dom.i2svg({ node: DOCUMENT });
};

function bootstrap() {
  if (IS_BROWSER) {
    if (!WINDOW.FontAwesome) {
      WINDOW.FontAwesome = api$1;
    }

    domready(function () {
      if (Object.keys(namespace.styles).length > 0) {
        autoReplace();
      }

      if (config$1.observeMutations && typeof MutationObserver === 'function') {
        observe({
          treeCallback: onTree,
          nodeCallback: onNode,
          pseudoElementsCallback: searchPseudoElements
        });
      }
    });
  }

  namespace.hooks = _extends$1({}, namespace.hooks, {

    addPack: function addPack(prefix, icons) {
      namespace.styles[prefix] = _extends$1({}, namespace.styles[prefix] || {}, icons);

      build();
      autoReplace();
    },

    addShims: function addShims(shims) {
      var _namespace$shims;

      (_namespace$shims = namespace.shims).push.apply(_namespace$shims, toConsumableArray$1(shims));

      build();
      autoReplace();
    }
  });
}

Object.defineProperty(api$1, 'config', {
  get: function get$$1() {
    return config$1;
  },

  set: function set$$1(newConfig) {
    update$2(newConfig);
  }
});

if (IS_DOM) bunker(bootstrap);

var commonjsGlobal$1 = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule$1(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var humps = createCommonjsModule$1(function (module) {
  // =========
  // = humps =
  // =========
  // Underscore-to-camelCase converter (and vice versa)
  // for strings and object keys

  // humps is copyright © 2012+ Dom Christie
  // Released under the MIT license.


  (function (global) {

    var _processKeys = function _processKeys(convert, obj, options) {
      if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
        return obj;
      }

      var output,
          i = 0,
          l = 0;

      if (_isArray(obj)) {
        output = [];
        for (l = obj.length; i < l; i++) {
          output.push(_processKeys(convert, obj[i], options));
        }
      } else {
        output = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            output[convert(key, options)] = _processKeys(convert, obj[key], options);
          }
        }
      }
      return output;
    };

    // String conversion methods

    var separateWords = function separateWords(string, options) {
      options = options || {};
      var separator = options.separator || '_';
      var split = options.split || /(?=[A-Z])/;

      return string.split(split).join(separator);
    };

    var camelize = function camelize(string) {
      if (_isNumerical(string)) {
        return string;
      }
      string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : '';
      });
      // Ensure 1st char is always lowercase
      return string.substr(0, 1).toLowerCase() + string.substr(1);
    };

    var pascalize = function pascalize(string) {
      var camelized = camelize(string);
      // Ensure 1st char is always uppercase
      return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };

    var decamelize = function decamelize(string, options) {
      return separateWords(string, options).toLowerCase();
    };

    // Utilities
    // Taken from Underscore.js

    var toString = Object.prototype.toString;

    var _isFunction = function _isFunction(obj) {
      return typeof obj === 'function';
    };
    var _isObject = function _isObject(obj) {
      return obj === Object(obj);
    };
    var _isArray = function _isArray(obj) {
      return toString.call(obj) == '[object Array]';
    };
    var _isDate = function _isDate(obj) {
      return toString.call(obj) == '[object Date]';
    };
    var _isRegExp = function _isRegExp(obj) {
      return toString.call(obj) == '[object RegExp]';
    };
    var _isBoolean = function _isBoolean(obj) {
      return toString.call(obj) == '[object Boolean]';
    };

    // Performant way to determine if obj coerces to a number
    var _isNumerical = function _isNumerical(obj) {
      obj = obj - 0;
      return obj === obj;
    };

    // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback
    var _processor = function _processor(convert, options) {
      var callback = options && 'process' in options ? options.process : options;

      if (typeof callback !== 'function') {
        return convert;
      }

      return function (string, options) {
        return callback(string, convert, options);
      };
    };

    var humps = {
      camelize: camelize,
      decamelize: decamelize,
      pascalize: pascalize,
      depascalize: decamelize,
      camelizeKeys: function camelizeKeys(object, options) {
        return _processKeys(_processor(camelize, options), object);
      },
      decamelizeKeys: function decamelizeKeys(object, options) {
        return _processKeys(_processor(decamelize, options), object, options);
      },
      pascalizeKeys: function pascalizeKeys(object, options) {
        return _processKeys(_processor(pascalize, options), object);
      },
      depascalizeKeys: function depascalizeKeys() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };

    if (typeof undefined === 'function' && undefined.amd) {
      undefined(humps);
    } else if ('object' !== 'undefined' && module.exports) {
      module.exports = humps;
    } else {
      global.humps = humps;
    }
  })(commonjsGlobal$1);
});

var _typeof$1 = typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
};

var defineProperty$1 = function defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties$1$1 = function objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var toConsumableArray$2 = function toConsumableArray$2(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
};

function capitalize$1(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();

    prop.startsWith('webkit') ? acc[capitalize$1(prop)] = value : acc[prop] = value;

    return acc;
  }, {});
}

function convert(createElement$$1, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var children = (element.children || []).map(convert.bind(null, createElement$$1));

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;
      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;
      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[humps.camelize(key)] = val;
        }
    }

    return acc;
  }, { attrs: {} });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === undefined ? {} : _extraProps$style,
      remaining = objectWithoutProperties$1$1(extraProps, ['style']);

  mixins.attrs['style'] = _extends$2({}, mixins.attrs['style'], existingStyle);

  return createElement$$1.apply(undefined, [element.tag, _extends$2({}, mixins.attrs, remaining)].concat(toConsumableArray$2(children)));
}

var PRODUCTION$1 = false;

try {
  PRODUCTION$1 = process.env.NODE_ENV === 'production';
} catch (e) {}

var log = function log() {
  if (!PRODUCTION$1 && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
};

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty$1({}, key, value) : {};
}

function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-pulse': props.pulse,
    'fa-fw': props.fixedWidth,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, defineProperty$1(_classes, 'fa-' + props.size, props.size !== null), defineProperty$1(_classes, 'fa-rotate-' + props.rotation, props.rotation !== null), defineProperty$1(_classes, 'fa-pull-' + props.pull, props.pull !== null), _classes);

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

function normalizeIconArgs(icon$$1) {
  if (icon$$1 === null) {
    return null;
  }

  if ((typeof icon$$1 === 'undefined' ? 'undefined' : _typeof$1(icon$$1)) === 'object' && icon$$1.prefix && icon$$1.iconName) {
    return icon$$1;
  }

  if (Array.isArray(icon$$1) && icon$$1.length === 2) {
    return { prefix: icon$$1[0], iconName: icon$$1[1] };
  }

  if (typeof icon$$1 === 'string') {
    return { prefix: 'fas', iconName: icon$$1 };
  }
}

function FontAwesomeIcon$1(props) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className;

  var icon$$1 = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(toConsumableArray$2(classList(props)), toConsumableArray$2(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? api$1.parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));

  var renderedIcon = api$1.icon(icon$$1, _extends$2({}, classes, transform, mask, {
    symbol: symbol
  }));

  if (!renderedIcon) {
    log('Could not find icon', icon$$1);
    return null;
  }

  var abstract = renderedIcon.abstract;

  var convertCurry = convert.bind(null, React.createElement);
  var extraProps = {};

  Object.keys(props).forEach(function (key) {
    if (!FontAwesomeIcon$1.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
  });

  return convertCurry(abstract[0], extraProps);
}

FontAwesomeIcon$1.propTypes = {
  border: PropTypes.bool,

  className: PropTypes.string,

  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),

  fixedWidth: PropTypes.bool,

  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),

  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),

  listItem: PropTypes.bool,

  pull: PropTypes.oneOf(['right', 'left']),

  pulse: PropTypes.bool,

  name: PropTypes.string,

  rotation: PropTypes.oneOf([90, 180, 270]),

  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),

  spin: PropTypes.bool,

  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

FontAwesomeIcon$1.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  name: '',
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  transform: null
};

api$1.noAuto();

var faCheck = { prefix: 'fas', iconName: 'check', icon: [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"] };

var _templateObject$2 = taggedTemplateLiteral$1(["\n  grid-template-areas: \"checkbox\";\n\n  > input[type=\"checkbox\"] {\n    display: none;\n  }\n\n  > input[type=\"checkbox\"]:checked + label {\n    display: block;\n  }\n"], ["\n  grid-template-areas: \"checkbox\";\n\n  > input[type=\"checkbox\"] {\n    display: none;\n  }\n\n  > input[type=\"checkbox\"]:checked + label {\n    display: block;\n  }\n"]);

var OuterWrapper = system({
  size: "1.25rem",
  display: "grid",
  bg: "white",
  justifyContent: "center",
  alignItems: "center"
}).extend(_templateObject$2);

var _templateObject$3 = taggedTemplateLiteral$1(["\n  grid-area: checkbox;\n  box-sizing: border-box;\n"], ["\n  grid-area: checkbox;\n  box-sizing: border-box;\n"]);

var LabelWrapper = system({
  is: "label",
  size: "1rem",
  display: "none",
  bg: "white",
  color: "black",
  hover: {
    color: "black"
  }
}, "space").extend(_templateObject$3);

/**
 * Checkbox component for the offcourse project
 */

var Checkbox = function (_Component) {
  inherits$1(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck$1(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn$1(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checked: _this.props.checked
    }, _this.handleClick = function (e) {
      e.preventDefault();
      var onToggle = _this.props.onToggle;

      _this.setState(function (_ref2) {
        var checked = _ref2.checked;
        return { checked: !checked };
      }, function () {
        return onToggle(_this.state);
      });
    }, _temp), possibleConstructorReturn$1(_this, _ret);
  }

  createClass$1(Checkbox, [{
    key: "render",
    value: function render() {
      var checked = this.state.checked;

      return React.createElement(OuterWrapper, { onClick: this.handleClick }, React.createElement("input", { type: "checkbox", readOnly: true, checked: checked }), React.createElement(LabelWrapper, null, React.createElement(FontAwesomeIcon$1, { icon: faCheck })));
    }
  }]);
  return Checkbox;
}(Component);

Checkbox.propTypes = {
  /**  allows the user to directly decide if the value is checked or not */
  checked: PropTypes.bool,
  /** an optional callback that triggers when the checkbox changes its value */
  onToggle: PropTypes.func
};
Checkbox.defaultProps = {
  checked: false,
  onToggle: function onToggle() {
    return null;
  }
};

var _templateObject$4 = taggedTemplateLiteral$1(["\n"], ["\n"]);

var Container = system({
  display: "flex",
  flexDirection: "column",
  bg: "white",
  alignItems: "stretch",
  justifyContent: "flex-start",
  fontSize: 1,
  minWidth: "18rem",
  maxWidth: "40rem",
  width: "40rem",
  flex: 1,
  px: 0,
  py: 0,
  mx: 6,
  my: 6,
  opactity: 1
}).extend(_templateObject$4);

var _templateObject$5 = taggedTemplateLiteral$1(["\n"], ["\n"]);

var Group = system({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flex: 1,
  mt: 0,
  px: 0,
  pb: 0,
  pt: 0
}, "height", "color").extend(_templateObject$5);

var HeadingWrapper = system({
  m: 0,
  color: "inherit",
  lineHeight: 2,
  fontSize: 3
}, function (props) {
  return {
    fontFamily: props.theme.fonts.bold,
    userSelect: "none",
    textDecoration: "inherit",
    cursor: props.href ? "pointer" : "cursor",
    "&:hover": {
      color: props.href ? dist_3("colors.primary")(props) : dist_3("colors.black")(props)
    }
  };
});

/**
 * Heading Component for the Offcourse Project
 */

var Heading = function (_Component) {
  inherits$1(Heading, _Component);

  function Heading() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck$1(this, Heading);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn$1(this, (_ref = Heading.__proto__ || Object.getPrototypeOf(Heading)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          href = _this$props.href;

      if (onClick) {
        event.preventDefault();
        onClick({ href: href });
      }
    }, _temp), possibleConstructorReturn$1(_this, _ret);
  }

  createClass$1(Heading, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          href = _props.href,
          size = _props.size;

      return React.createElement(HeadingWrapper, {
        is: href ? "a" : "h1",
        onClick: this.handleClick,
        href: href,
        lineHeight: size === "small" ? 1 : 2,
        fontSize: size === "small" ? 2 : 3
      }, formatTitle(children));
    }
  }]);
  return Heading;
}(Component);

Heading.propTypes = {
  /** The actual text of the header */
  children: PropTypes.string.isRequired,
  /** Field that indicates the size of the header */
  size: PropTypes.oneOf(["small", "regular"]),
  /** Headings can optionally link to other documents, etc */
  href: PropTypes.string
};
Heading.defaultProps = {
  size: "regular"
};

var faBars = { prefix: 'fas', iconName: 'bars', icon: [448, 512, [], "f0c9", "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"] };

var faTimes = { prefix: 'fas', iconName: 'times', icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"] };

var faPlus = { prefix: 'fas', iconName: 'plus', icon: [448, 512, [], "f067", "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"] };

var faSort = { prefix: 'fas', iconName: 'sort', icon: [320, 512, [], "f0dc", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"] };

var faEye = { prefix: 'fas', iconName: 'eye', icon: [576, 512, [], "f06e", "M569.354 231.631C512.969 135.949 407.81 72 288 72 168.14 72 63.004 135.994 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.031 376.051 168.19 440 288 440c119.86 0 224.996-63.994 281.354-159.631a47.997 47.997 0 0 0 0-48.738zM288 392c-75.162 0-136-60.827-136-136 0-75.162 60.826-136 136-136 75.162 0 136 60.826 136 136 0 75.162-60.826 136-136 136zm104-136c0 57.438-46.562 104-104 104s-104-46.562-104-104c0-17.708 4.431-34.379 12.236-48.973l-.001.032c0 23.651 19.173 42.823 42.824 42.823s42.824-19.173 42.824-42.823c0-23.651-19.173-42.824-42.824-42.824l-.032.001C253.621 156.431 270.292 152 288 152c57.438 0 104 46.562 104 104z"] };

var faClock = { prefix: 'fas', iconName: 'clock', icon: [512, 512, [], "f017", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm57.1 350.1L224.9 294c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v137.7l63.5 46.2c5.4 3.9 6.5 11.4 2.6 16.8l-28.2 38.8c-3.9 5.3-11.4 6.5-16.8 2.6z"] };

var faRocket = { prefix: 'fas', iconName: 'rocket', icon: [512, 512, [], "f135", "M505.1 19.1C503.8 13 499 8.2 492.9 6.9 460.7 0 435.5 0 410.4 0 307.2 0 245.3 55.2 199.1 128H94.9c-18.2 0-34.8 10.3-42.9 26.5L2.6 253.3c-8 16 3.6 34.7 21.5 34.7h95.1c-5.9 12.8-11.9 25.5-18 37.7-3.1 6.2-1.9 13.6 3 18.5l63.6 63.6c4.9 4.9 12.3 6.1 18.5 3 12.2-6.1 24.9-12 37.7-17.9V488c0 17.8 18.8 29.4 34.7 21.5l98.7-49.4c16.3-8.1 26.5-24.8 26.5-42.9V312.8c72.6-46.3 128-108.4 128-211.1.1-25.2.1-50.4-6.8-82.6zM400 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"] };

var faThermometerEmpty = { prefix: 'fas', iconName: 'thermometer-empty', icon: [256, 512, [], "f2cb", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"] };

var faThermometerHalf = { prefix: 'fas', iconName: 'thermometer-half', icon: [256, 512, [], "f2c9", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"] };

var faThermometerFull = { prefix: 'fas', iconName: 'thermometer-full', icon: [256, 512, [], "f2c7", "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"] };

var faCalendarAlt = { prefix: 'fas', iconName: 'calendar-alt', icon: [448, 512, [], "f073", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm116 204c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm128 128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm128 128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40z"] };

var faFacebook = { prefix: 'fab', iconName: 'facebook', icon: [448, 512, [], "f09a", "M448 56.7v398.5c0 13.7-11.1 24.7-24.7 24.7H309.1V306.5h58.2l8.7-67.6h-67v-43.2c0-19.6 5.4-32.9 33.5-32.9h35.8v-60.5c-6.2-.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9h-58.4v67.6h58.4V480H24.7C11.1 480 0 468.9 0 455.3V56.7C0 43.1 11.1 32 24.7 32h398.5c13.7 0 24.8 11.1 24.8 24.7z"] };

var faTwitter = { prefix: 'fab', iconName: 'twitter', icon: [512, 512, [], "f099", "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"] };

var faAsterisk = { prefix: 'fas', iconName: 'asterisk', icon: [512, 512, [], "f069", "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"] };

var icons = Object.freeze({
  hamburger: faBars,
  checkmark: faCheck,
  remove: faTimes,
  add: faPlus,
  sort: faSort,
  eye: faEye,
  clock: faClock,
  rocket: faRocket,
  beginner: faThermometerEmpty,
  advanced: faThermometerHalf,
  expert: faThermometerFull,
  calendar: faCalendarAlt,
  facebook: faFacebook,
  twitter: faTwitter,
  asterisk: faAsterisk
});

var _templateObject$6 = taggedTemplateLiteral$1(["\n  box-sizing: border-box;\n"], ["\n  box-sizing: border-box;\n"]);

var IconWrapper = system({
  is: "i",
  m: 0,
  p: 0,
  border: 0,
  fontSize: 1,
  lineHeight: 1,
  color: "black",
  bg: "transparent",
  hover: {
    color: "primary"
  },
  focus: {
    outline: "none",
    color: "primary"
  }
}).extend(_templateObject$6);

/**
 * Icon Component for the Offcourse Project
 */

var Icon = function (_Component) {
  inherits$1(Icon, _Component);

  function Icon() {
    classCallCheck$1(this, Icon);
    return possibleConstructorReturn$1(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  createClass$1(Icon, [{
    key: "icon",
    value: function icon$$1() {
      var name = this.props.name;

      return icons[name];
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color,
          spin = _props.spin,
          tabIndex = _props.tabIndex,
          name = _props.name,
          href = _props.href,
          is = _props.is,
          onClick = _props.onClick;

      return React.createElement(IconWrapper, {
        is: is || href && "a" || onClick && "button",
        type: is === "button" && "button" || onClick && "button",
        color: color,
        tabIndex: tabIndex,
        onClick: onClick
      }, React.createElement(FontAwesomeIcon$1, { icon: this.icon(), size: Icon.sizes[size], spin: spin }));
    }
  }]);
  return Icon;
}(Component);

Icon.propTypes = {
  /** Name name of the icon */
  name: PropTypes.oneOf(Object.keys(icons)),
  /** Size of the icon */
  size: PropTypes.oneOf(["small", "medium", "large"]),
  /** Url that the button should link to */
  href: PropTypes.string,
  /** Indicates if the icon should be spinning */
  spin: PropTypes.bool,
  /** Callback that the button should execute when clicked */
  onClick: PropTypes.func
};
Icon.defaultProps = {
  size: "medium",
  spin: false
};
Icon.sizes = {
  small: "xs",
  medium: "lg",
  large: "2x"
};

var ItemWrapper = system({
  is: "div",
  display: "grid",
  bg: "grayScale.1",
  px: 4,
  py: 4,
  lineHeight: 1,
  fontSize: 1,
  alignItems: "center",
  justifyContent: "space-between",
  color: "black",
  hover: {
    backgroundColor: "primary",
    color: "white"
  },
  gridTemplateColumns: "1fr"
}, function (props) {
  return {
    boxSizing: "border-box",
    textDecoration: "inherit",
    fontFamily: props.theme.fonts.bold,
    userSelect: "none"
  };
});

var Item = function (_Component) {
  inherits$1(Item, _Component);

  function Item() {
    classCallCheck$1(this, Item);
    return possibleConstructorReturn$1(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
  }

  createClass$1(Item, [{
    key: "renderChildren",
    value: function renderChildren() {
      var _props = this.props,
          href = _props.href,
          children = _props.children;

      return href ? React.createElement(Item.Link, { href: href }, children) : children;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          is = _props2.is,
          href = _props2.href,
          gridTemplateColumns = _props2.gridTemplateColumns;

      return React.createElement(ItemWrapper, { is: is, gridTemplateColumns: gridTemplateColumns }, this.renderChildren());
    }
  }]);
  return Item;
}(Component);

Item.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element]))]).isRequired
};

Item.Link = function (_ref) {
  var href = _ref.href,
      children = _ref.children;
  return React.createElement(Link, { basic: true, href: href }, children);
};

Item.Content = function (_ref2) {
  var children = _ref2.children;
  return React.createElement(Label, null, children);
};

var _templateObject$7 = taggedTemplateLiteral$1(["\n  ::placeholder {\n    color: ", ";\n  }\n\n  ::selection {\n    background: ", ";\n    color: white;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  ::placeholder {\n    color: ", ";\n  }\n\n  ::selection {\n    background: ", ";\n    color: white;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]);

var BaseWrapper = system({
  is: "input",
  bg: "grayScale.1",
  color: "text",
  p: 0,
  px: 6,
  m: 0,
  border: 0,
  fontSize: 1,
  lineHeight: 1,
  justifyContent: "center",
  alignContent: "center",
  width: "100%"
}, function (props) {
  return {
    fontFamily: props.theme.fonts.bold,
    boxSizing: "border-box"
  };
}).extend(_templateObject$7, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.mediumGray;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});

var _templateObject$8 = taggedTemplateLiteral$1([""], [""]);

var InputWrapper = BaseWrapper.extend(_templateObject$8);

var _templateObject$9 = taggedTemplateLiteral$1(["\n  box-sizing: \"border-box\";\n  grid-template-areas: \"input\";\n  .icons, button {\n    padding: 0;\n    background-color: rgba(255, 255, 255, 0);\n    color: ", ";\n    grid-area: input;\n    justify-self: end;\n    z-index: 1;\n  }\n"], ["\n  box-sizing: \"border-box\";\n  grid-template-areas: \"input\";\n  .icons, button {\n    padding: 0;\n    background-color: rgba(255, 255, 255, 0);\n    color: ", ";\n    grid-area: input;\n    justify-self: end;\n    z-index: 1;\n  }\n"]);

var OuterWrapper$1 = system({
  display: "flex",
  flex: 1,
  alignItems: "center",
  pb: 4,
  pt: 4,
  m: 0,
  border: 0,
  borderColor: "negative",
  bg: "grayScale.1"
}).extend(_templateObject$9, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grayScale[2];
});

var _templateObject$10 = taggedTemplateLiteral$1(["\n  height: 10rem;\n  resize: none;\n"], ["\n  height: 10rem;\n  resize: none;\n"]);

var TextAreaWrapper = BaseWrapper.extend(_templateObject$10);

var Input = function (_Component) {
  inherits$1(Input, _Component);

  function Input() {
    classCallCheck$1(this, Input);
    return possibleConstructorReturn$1(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  createClass$1(Input, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          mb = _props.mb,
          pt = _props.pt,
          pb = _props.pb,
          variant = _props.variant,
          children = _props.children,
          hasErrors = _props.hasErrors,
          name = _props.name,
          value = _props.value,
          placeholder = _props.placeholder,
          onChange = _props.onChange,
          type = _props.type,
          onBlur = _props.onBlur;

      return React.createElement(OuterWrapper$1, { border: hasErrors ? 2 : 0, pb: pb, pt: pt, mb: mb }, variant === "textarea" ? React.createElement(TextAreaWrapper, {
        is: "textarea",
        rows: "4",
        name: name,
        value: value,
        placeholder: placeholder,
        onChange: onChange,
        onBlur: onBlur
      }) : React.createElement(InputWrapper, {
        name: name,
        type: type,
        value: value,
        placeholder: formatTitle(placeholder),
        onChange: onChange,
        onBlur: onBlur,
        fontSize: variant === "small" ? 1 : 3,
        lineHeight: variant === "small" ? 1 : 3
      }), children && React.createElement(Group, { px: 6, alignItems: "flex-end" }, children));
    }
  }]);
  return Input;
}(Component);

Input.propTypes = {
  /** name of the input */
  name: PropTypes.string.isRequired,
  /** value of the input, if you set this, onChange is required*/
  value: PropTypes.string,
  /** callback that is triggered when the field changes its value */
  onChange: PropTypes.func,
  /** placeholder for absent value */
  placeholder: PropTypes.string,
  /** callback that is triggered when the field loses focus */
  onBlur: PropTypes.func,
  /** property that indicates if the field has erors */
  hasErrors: PropTypes.bool,
  /** property that changes the visual representation of the field */
  variant: PropTypes.oneOf(["default", "textarea", "small"])
};

Input.defaultProps = {
  variant: "default"
};

var LabelWrapper$2 = system({
  is: "div",
  p: 0,
  color: "black",
  m: 0
}, function (props) {
  return {
    fontFamily: props.theme.fonts.bold,
    fontWeight: 700,
    display: props.is === "span" ? "inline-block" : "block",
    userSelect: "none"
  };
});

var Label = function (_Component) {
  inherits$1(Label, _Component);

  function Label() {
    classCallCheck$1(this, Label);
    return possibleConstructorReturn$1(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  createClass$1(Label, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          color = _props.color,
          children = _props.children,
          px = _props.px,
          pt = _props.pt,
          pb = _props.pb,
          is = _props.is;

      var label = formatTitle(children);
      return React.createElement(LabelWrapper$2, { color: color, is: is, pt: pt, pb: pb, px: px }, label);
    }
  }]);
  return Label;
}(Component);

Label.propTypes = {
  /** The actual text of the label */
  children: PropTypes.string.isRequired
};

var _templateObject$11 = taggedTemplateLiteral$1(["\n  user-select: none;\n  font-family: ", ";\n  box-sizing: border-box;\n  text-decoration: inherit;\n"], ["\n  user-select: none;\n  font-family: ", ";\n  box-sizing: border-box;\n  text-decoration: inherit;\n"]);

var LinkWrapper = system({
  is: "a",
  alignSelf: "flex-start",
  lineHeight: 0,
  borderBottom: 2,
  pb: 0,
  color: "black",
  fontSize: 1,
  m: 0,
  mr: 0,
  mb: 0,
  focus: {
    outline: "none"
  }
}, function (props) {
  return {
    borderColor: props.disabled ? dist_3("colors.disabled")(props) : dist_3("colors.black")(props),
    cursor: props.disabled ? "default" : "pointer",
    "&:hover": {
      color: props.disabled ? dist_3("colors.disabled")(props) : dist_3("colors.black")(props),
      borderColor: props.disabled ? dist_3("colors.disabled")(props) : dist_3("colors.primary")(props)
    }
  };
}).extend(_templateObject$11, function (_ref) {
  var theme$$1 = _ref.theme;
  return theme$$1.fonts.bold;
});

/**
 * The link component for the Offcourse project
 */

var Link = function (_Component) {
  inherits$1(Link, _Component);

  function Link() {
    classCallCheck$1(this, Link);
    return possibleConstructorReturn$1(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  createClass$1(Link, [{
    key: "color",
    value: function color() {
      var _props = this.props,
          active = _props.active,
          disabled = _props.disabled;

      if (disabled) {
        return "disabled";
      }
      if (active) {
        return "primary";
      }
      return "black";
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          active = _props2.active,
          basic = _props2.basic,
          href = _props2.href,
          children = _props2.children,
          onClick = _props2.onClick,
          disabled = _props2.disabled;

      return React.createElement(LinkWrapper, {
        color: this.color(),
        borderBottom: basic ? 0 : 2,
        onClick: !disabled ? onClick : function () {},
        href: !disabled ? href : undefined,
        disabled: disabled
      }, formatTitle(children));
    }
  }]);
  return Link;
}(Component);

Link.propTypes = {
  /** determines if the link should only have basic styling*/
  basic: PropTypes.bool,
  /** determines if the link is in an active state*/
  active: PropTypes.bool,
  /** determines if the link should be disabled */
  disabled: PropTypes.bool,
  /** the text that is displayed on the link */
  children: PropTypes.string,
  /** code that the link should execute when clicked */
  onClick: PropTypes.func,
  /** a url that the link should link to, automatically turns the link into the basic type */
  href: PropTypes.string
};

Link.defaultProps = {
  disabled: false,
  type: "link"
};

var Loading = function (_Component) {
  inherits$1(Loading, _Component);

  function Loading() {
    classCallCheck$1(this, Loading);
    return possibleConstructorReturn$1(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
  }

  createClass$1(Loading, [{
    key: "render",
    value: function render() {
      var size = this.props.size;

      return React.createElement(Icon, { name: "asterisk", size: size, spin: true });
    }
  }]);
  return Loading;
}(Component);

Loading.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"])
};

Loading.defaultProps = {
  size: "lg"
};

var LogoWrapper = system({
  is: "div",
  bg: "black",
  hover: { backgroundColor: "primary" }
}, function (props) {
  return {
    height: props.theme.logo.dimensions.height * props.multiply + "rem",
    width: props.theme.logo.dimensions.width * props.multiply + "rem",
    background: "url(" + props.theme.logo.svg + ") no-repeat top left",
    backgroundColor: "" + props.theme.logo.background,
    backgroundSize: "contain",
    boxSizing: "border-box"
  };
});

/**
 * The logo component for the Offcourse project
 */
var sizes = {
  small: 2,
  medium: 4,
  large: 6
};

var Logo = function (_Component) {
  inherits$1(Logo, _Component);

  function Logo() {
    classCallCheck$1(this, Logo);
    return possibleConstructorReturn$1(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
  }

  createClass$1(Logo, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          size = _props.size,
          onClick = _props.onClick;

      return React.createElement(LogoWrapper, { onClick: onClick, multiply: sizes[size] });
    }
  }]);
  return Logo;
}(Component);

Logo.defaultProps = {
  size: "small"
};

Logo.propTypes = {
  /** code that the logo should execute when clicked */
  onClick: PropTypes.func
};

var _templateObject$12 = taggedTemplateLiteral$1(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  width: 100%;\n"]);
var _templateObject2 = taggedTemplateLiteral$1(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-content: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-content: stretch;\n"]);
var _templateObject3 = taggedTemplateLiteral$1(["\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n"], ["\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n"]);

var MasonryWrapper = styled.div(_templateObject$12);

var ColumnWrapper = styled.div(_templateObject2);

var ItemWrapper$2 = styled.div(_templateObject3);

var reduceIndexed = addIndex(reduce);

var Masonry = function (_React$Component) {
  inherits$1(Masonry, _React$Component);

  function Masonry() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck$1(this, Masonry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn$1(this, (_ref = Masonry.__proto__ || Object.getPrototypeOf(Masonry)).call.apply(_ref, [this].concat(args))), _this), _this.state = { numberOfColumns: 1 }, _this.onResize = function () {
      var numberOfColumns = _this.state.numberOfColumns;

      var proposal = _this.getColumns(_this.masonry.offsetWidth);
      if (proposal !== numberOfColumns) {
        _this.setState({ numberOfColumns: proposal });
      }
    }, _temp), possibleConstructorReturn$1(_this, _ret);
  }

  createClass$1(Masonry, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onResize();
      window.addEventListener("resize", this.onResize);
    }
  }, {
    key: "getColumns",
    value: function getColumns(containerWidth) {
      var breakpoints = this.props.breakpoints;

      return reduceWhile(function (_, breakpoint) {
        return breakpoint < containerWidth;
      }, inc, 1, breakpoints);
    }
  }, {
    key: "prepareGrid",
    value: function prepareGrid() {
      var children = this.props.children;
      var numberOfColumns = this.state.numberOfColumns;

      return reduceIndexed(function (acc, child, index) {
        return adjust(append(child), index % numberOfColumns, acc);
      }, repeat([], numberOfColumns), children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(MasonryWrapper, {
        innerRef: function innerRef(el) {
          _this2.masonry = el;
        }
      }, this.prepareGrid().map(function (col, ci) {
        return React.createElement(ColumnWrapper, { key: ci }, col.map(function (child, i) {
          return React.createElement(ItemWrapper$2, { key: i }, child);
        }));
      }));
    }
  }]);
  return Masonry;
}(React.Component);

Masonry.propTypes = {
  breakpoints: PropTypes.arrayOf(PropTypes.number)
};
Masonry.defaultProps = {
  breakpoints: []
};

var _templateObject$13 = taggedTemplateLiteral$1(["\n  span::after {\n    content: \": \";\n    white-space: pre;\n  }\n"], ["\n  span::after {\n    content: \": \";\n    white-space: pre;\n  }\n"]);

var MessageWrapper = system({
  display: "flex",
  flex: 1,
  px: 0,
  py: 0
}, "color", function (props) {
  return {
    fontFamily: props.theme.fonts.base,
    userSelect: "none"
  };
}).extend(_templateObject$13);

var background$1 = {
  default: "grayScale.3",
  info: "primary",
  warning: "warning",
  success: "positive",
  error: "negative"
};

var textColor$1 = {
  default: "white",
  error: "white",
  info: "white",
  warning: "text",
  success: "text"
};

var Message = function (_Component) {
  inherits$1(Message, _Component);

  function Message() {
    classCallCheck$1(this, Message);
    return possibleConstructorReturn$1(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
  }

  createClass$1(Message, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          px = _props.px,
          basic = _props.basic,
          variant = _props.variant;

      return React.createElement(MessageWrapper, {
        px: basic ? 0 : px,
        py: basic ? 0 : 4,
        bg: basic ? null : background$1[variant],
        color: basic ? background$1[variant] : textColor$1[variant]
      }, variant !== "default" && React.createElement(Label, { is: "span" }, variant), formatTitle(children));
    }
  }]);
  return Message;
}(Component);

Message.propTypes = {
  children: PropTypes.string.isRequired,
  basic: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "error", "info", "success", "warning"])
};

Message.defaultProps = {
  px: 6,
  variant: "default"
};

var _templateObject$14 = taggedTemplateLiteral$1(["\n  transition: all .5s ease-in-out;\n  > * {\n    opacity: ", ";\n    transition: all .5s ease-in-out;\n  }\n"], ["\n  transition: all .5s ease-in-out;\n  > * {\n    opacity: ", ";\n    transition: all .5s ease-in-out;\n  }\n"]);

var OverlayWrapper = system({
  bg: "grayScale.4",
  display: "flex",
  position: "fixed",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}).extend(_templateObject$14, function (props) {
  return props.zIndex === 999 ? 0.9 : 0;
});

var Overlay = function (_Component) {
  inherits$1(Overlay, _Component);

  function Overlay() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck$1(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn$1(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyPress = function (e) {
      var keyCode = e.keyCode;
      var close = _this.props.close;

      if (keyCode === 27) {
        close();
      }
    }, _temp), possibleConstructorReturn$1(_this, _ret);
  }

  createClass$1(Overlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.handleKeyPress);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyPress);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isOpen = _props.isOpen,
          close = _props.close;

      var bg = isOpen ? "rgba(61, 61, 61, 0.9)" : "rgba(61,61,61,0)";
      return React.createElement(OverlayWrapper, { bg: bg, zIndex: isOpen ? 999 : -1 }, children);
    }
  }]);
  return Overlay;
}(Component);

Overlay.propTypes = {
  /** flag that decides if the overlay is open or closed */
  isOpen: PropTypes.bool.isRequired
};
Overlay.defaultProps = {
  isOpen: true,
  close: function close() {
    return null;
  }
};

var SectionWrapper = system({
  is: "section",
  px: 6,
  py: 6,
  borderBottom: 1,
  borderColor: "grayScale.1"
}, "alignItems", "justifyContent", "flexDirection", "display", "color");

/**
 * Generic Section component for the Offcourse project
 */

var Section = function (_Component) {
  inherits$1(Section, _Component);

  function Section() {
    classCallCheck$1(this, Section);
    return possibleConstructorReturn$1(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
  }

  createClass$1(Section, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = objectWithoutProperties$1(_props, ["children"]);

      return React.createElement(SectionWrapper, rest, children);
    }
  }]);
  return Section;
}(Component);

var _templateObject$15 = taggedTemplateLiteral$1(["\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  font-family: ", ";\n  text-decoration: inherit;\n"], ["\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  font-family: ", ";\n  text-decoration: inherit;\n"]);

var TagWrapper = system({
  display: "inline-block",
  color: "black",
  bg: "grayScale.1",
  py: 0,
  px: 4,
  hover: {
    backgroundColor: "primary",
    color: "white"
  }
}).extend(_templateObject$15, function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.bold;
});

/**
 * The Tag component for the Offcourse project
 */

var Tag = function (_Component) {
  inherits$1(Tag, _Component);

  function Tag() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck$1(this, Tag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn$1(this, (_ref = Tag.__proto__ || Object.getPrototypeOf(Tag)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          children = _this$props.children,
          href = _this$props.href;

      if (onClick) {
        event.preventDefault();
        onClick({ tag: children });
      }
    }, _temp), possibleConstructorReturn$1(_this, _ret);
  }

  createClass$1(Tag, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          href = _props.href;

      return React.createElement(TagWrapper, { onClick: this.handleClick, href: href }, React.createElement(Text, { size: "small" }, formatTitle(children)));
    }
  }]);
  return Tag;
}(Component);

Tag.propTypes = {
  /** the text that is displayed on the tag */
  children: PropTypes.string.isRequired,
  /** a url that the tag links to */
  href: PropTypes.string,
  /** a on click callback handler */
  onClick: PropTypes.func
};

var TextWrapper = system({
  is: "p",
  m: 0,
  p: 0,
  fontSize: 1,
  lineHeight: 1
});

var Text = function (_Component) {
  inherits$1(Text, _Component);

  function Text() {
    classCallCheck$1(this, Text);
    return possibleConstructorReturn$1(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }

  createClass$1(Text, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          size = _props.size,
          children = _props.children;

      var textSize = size === "small" ? 0 : 1;
      return React.createElement(TextWrapper, { fontSize: textSize, lineHeight: textSize }, children);
    }
  }]);
  return Text;
}(Component);

Text.propTypes = {
  /** Field that indicates the size of the text */
  size: PropTypes.oneOf(["small", "regular"])
};

Text.defaultProps = {
  size: "regular"
};

function unwrapExports$1(x){return x&&x.__esModule&&Object.prototype.hasOwnProperty.call(x,'default')?x['default']:x;}function createCommonjsModule$1$1(fn,module){return module={exports:{}}, fn(module,module.exports), module.exports;}var _const$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});/**
 * A regular expression string matching digits
 *
 * @type {string}
 * @ignore
 */var digit=exports.digit='\\d';/**
 * A regular expression string matching whitespace
 *
 * @type {string}
 * @ignore
 */var whitespace=exports.whitespace='\\s\\uFEFF\\xA0';/**
 * A regular expression string matching high surrogate
 *
 * @type {string}
 * @ignore
 */var highSurrogate=exports.highSurrogate='\\uD800-\\uDBFF';/**
 * A regular expression string matching low surrogate
 *
 * @type {string}
 * @ignore
 */var lowSurrogate=exports.lowSurrogate='\\uDC00-\\uDFFF';/**
 * A regular expression string matching diacritical mark
 *
 * @type {string}
 * @ignore
 */var diacriticalMark=exports.diacriticalMark='\\u0300-\\u036F\\u1AB0-\\u1AFF\\u1DC0-\\u1DFF\\u20D0-\\u20FF\\uFE20-\\uFE2F';/**
 * A regular expression to match the base character for a combining mark
 *
 * @type {string}
 * @ignore
 */var base=exports.base='\\0-\\u02FF\\u0370-\\u1AAF\\u1B00-\\u1DBF\\u1E00-\\u20CF\\u2100-\\uD7FF\\uE000-\\uFE1F\\uFE30-\\uFFFF';/**
 * Regular expression to match combining marks
 *
 * @see http://unicode.org/faq/char_combmark.html
 * @type {RegExp}
 * @ignore
 */var REGEXP_COMBINING_MARKS=exports.REGEXP_COMBINING_MARKS=new RegExp('(['+base+']|['+highSurrogate+']['+lowSurrogate+']|['+highSurrogate+'](?!['+lowSurrogate+'])|(?:[^'+highSurrogate+']|^)['+lowSurrogate+'])(['+diacriticalMark+']+)','g');/**
 * Regular expression to match surrogate pairs
 *
 * @see http://www.unicode.org/faq/utf_bom.html#utf16-2
 * @type {RegExp}
 * @ignore
 */var REGEXP_SURROGATE_PAIRS=exports.REGEXP_SURROGATE_PAIRS=new RegExp('(['+highSurrogate+'])(['+lowSurrogate+'])','g');/**
 * Regular expression to match a unicode character
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_UNICODE_CHARACTER=exports.REGEXP_UNICODE_CHARACTER=new RegExp('((?:['+base+']|['+highSurrogate+']['+lowSurrogate+']|['+highSurrogate+'](?!['+lowSurrogate+'])|(?:[^'+highSurrogate+']|^)['+lowSurrogate+'])(?:['+diacriticalMark+']+))|\
(['+highSurrogate+']['+lowSurrogate+'])|([\\n\\r\\u2028\\u2029])|(.)','g');/**
 * Regular expression to match whitespaces
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_WHITESPACE=exports.REGEXP_WHITESPACE=new RegExp('['+whitespace+']');/**
 * Regular expression to match whitespaces from the left side
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_TRIM_LEFT=exports.REGEXP_TRIM_LEFT=new RegExp('^['+whitespace+']+');/**
 * Regular expression to match whitespaces from the right side
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_TRIM_RIGHT=exports.REGEXP_TRIM_RIGHT=new RegExp('['+whitespace+']+$');/**
 * Regular expression to match digit characters
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_DIGIT=exports.REGEXP_DIGIT=new RegExp('^'+digit+'+$');/**
 * Regular expression to match regular expression special characters
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_SPECIAL_CHARACTERS=exports.REGEXP_SPECIAL_CHARACTERS=/[-[\]{}()*+!<=:?./\\^$|#,]/g;/**
 * Regular expression to match not latin characters
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_NON_LATIN=exports.REGEXP_NON_LATIN=/[^A-Za-z0-9]/g;/**
 * Regular expression to match HTML special characters.
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_HTML_SPECIAL_CHARACTERS=exports.REGEXP_HTML_SPECIAL_CHARACTERS=/[<>&"'`]/g;/**
 * Regular expression to match sprintf format string
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_CONVERSION_SPECIFICATION=exports.REGEXP_CONVERSION_SPECIFICATION=/(%{1,2})(?:(\d+)\$)?(\+)?([ 0]|'.{1})?(-)?(\d+)?(?:\.(\d+))?([bcdiouxXeEfgGs])?/g;/**
 * Regular expression to match trailing zeros in a number
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_TRAILING_ZEROS=exports.REGEXP_TRAILING_ZEROS=/\.?0+$/g;/**
 * Regular expression to match flags from a regular expression.
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_FLAGS=exports.REGEXP_FLAGS=/[gimuy]*$/;/**
 * Regular expression to match a list of tags.
 *
 * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-name
 * @type {RegExp}
 * @ignore
 */var REGEXP_TAG_LIST=exports.REGEXP_TAG_LIST=/<([A-Za-z0-9]+)>/g;});unwrapExports$1(_const$1);var _const_1$1=_const$1.digit;var _const_2$1=_const$1.whitespace;var _const_3$1=_const$1.highSurrogate;var _const_4$1=_const$1.lowSurrogate;var _const_5$1=_const$1.diacriticalMark;var _const_6$1=_const$1.base;var _const_7$1=_const$1.REGEXP_COMBINING_MARKS;var _const_8$1=_const$1.REGEXP_SURROGATE_PAIRS;var _const_9$1=_const$1.REGEXP_UNICODE_CHARACTER;var _const_10$1=_const$1.REGEXP_WHITESPACE;var _const_11$1=_const$1.REGEXP_TRIM_LEFT;var _const_12$1=_const$1.REGEXP_TRIM_RIGHT;var _const_13$1=_const$1.REGEXP_DIGIT;var _const_14$1=_const$1.REGEXP_SPECIAL_CHARACTERS;var _const_15$1=_const$1.REGEXP_NON_LATIN;var _const_16$1=_const$1.REGEXP_HTML_SPECIAL_CHARACTERS;var _const_17$1=_const$1.REGEXP_CONVERSION_SPECIFICATION;var _const_18$1=_const$1.REGEXP_TRAILING_ZEROS;var _const_19$1=_const$1.REGEXP_FLAGS;var _const_20$1=_const$1.REGEXP_TAG_LIST;var const_extended$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.REGEXP_EXTENDED_ASCII=exports.REGEXP_ALPHA_DIGIT=exports.REGEXP_ALPHA=exports.REGEXP_LATIN_WORD=exports.REGEXP_WORD=undefined;/**
 * A regular expression to match the General Punctuation Unicode block
 *
 * @type {string}
 * @ignore
 */var generalPunctuationBlock='\\u2000-\\u206F';/**
 * A regular expression to match non characters from from Basic Latin and Latin-1 Supplement Unicode blocks
 *
 * @type {string}
 * @ignore
 */var nonCharacter='\\x00-\\x2F\\x3A-\\x40\\x5B-\\x60\\x7b-\\xBF\\xD7\\xF7';/**
 * A regular expression to match the dingbat Unicode block
 *
 * @type {string}
 * @ignore
 */var dingbatBlock='\\u2700-\\u27BF';/**
 * A regular expression string that matches lower case letters: LATIN
 *
 * @type {string}
 * @ignore
 */var lowerCaseLetter='a-z\\xB5\\xDF-\\xF6\\xF8-\\xFF\\u0101\\u0103\\u0105\\u0107\\u0109\\u010B\\u010D\\u010F\\u0111\\u0113\\u0115\\u0117\\u0119\\u011B\\u011D\\u011F\\u0121\\u0123\\u0125\\u0127\\u0129\\u012B\\u012D\\u012F\\u0131\\u0133\\u0135\\u0137\\u0138\\u013A\\u013C\\u013E\\u0140\\u0142\\u0144\\u0146\\u0148\\u0149\\u014B\\u014D\\u014F\\u0151\\u0153\\u0155\\u0157\\u0159\\u015B\\u015D\\u015F\\u0161\\u0163\\u0165\\u0167\\u0169\\u016B\\u016D\\u016F\\u0171\\u0173\\u0175\\u0177\\u017A\\u017C\\u017E-\\u0180\\u0183\\u0185\\u0188\\u018C\\u018D\\u0192\\u0195\\u0199-\\u019B\\u019E\\u01A1\\u01A3\\u01A5\\u01A8\\u01AA\\u01AB\\u01AD\\u01B0\\u01B4\\u01B6\\u01B9\\u01BA\\u01BD-\\u01BF\\u01C6\\u01C9\\u01CC\\u01CE\\u01D0\\u01D2\\u01D4\\u01D6\\u01D8\\u01DA\\u01DC\\u01DD\\u01DF\\u01E1\\u01E3\\u01E5\\u01E7\\u01E9\\u01EB\\u01ED\\u01EF\\u01F0\\u01F3\\u01F5\\u01F9\\u01FB\\u01FD\\u01FF\\u0201\\u0203\\u0205\\u0207\\u0209\\u020B\\u020D\\u020F\\u0211\\u0213\\u0215\\u0217\\u0219\\u021B\\u021D\\u021F\\u0221\\u0223\\u0225\\u0227\\u0229\\u022B\\u022D\\u022F\\u0231\\u0233-\\u0239\\u023C\\u023F\\u0240\\u0242\\u0247\\u0249\\u024B\\u024D\\u024F';/**
 * A regular expression string that matches upper case letters: LATIN
 *
 * @type {string}
 * @ignore
 */var upperCaseLetter='\\x41-\\x5a\\xc0-\\xd6\\xd8-\\xde\\u0100\\u0102\\u0104\\u0106\\u0108\\u010a\\u010c\\u010e\\u0110\\u0112\\u0114\\u0116\\u0118\\u011a\\u011c\\u011e\\u0120\\u0122\\u0124\\u0126\\u0128\\u012a\\u012c\\u012e\\u0130\\u0132\\u0134\\u0136\\u0139\\u013b\\u013d\\u013f\\u0141\\u0143\\u0145\\u0147\\u014a\\u014c\\u014e\\u0150\\u0152\\u0154\\u0156\\u0158\\u015a\\u015c\\u015e\\u0160\\u0162\\u0164\\u0166\\u0168\\u016a\\u016c\\u016e\\u0170\\u0172\\u0174\\u0176\\u0178\\u0179\\u017b\\u017d\\u0181\\u0182\\u0184\\u0186\\u0187\\u0189-\\u018b\\u018e-\\u0191\\u0193\\u0194\\u0196-\\u0198\\u019c\\u019d\\u019f\\u01a0\\u01a2\\u01a4\\u01a6\\u01a7\\u01a9\\u01ac\\u01ae\\u01af\\u01b1-\\u01b3\\u01b5\\u01b7\\u01b8\\u01bc\\u01c4\\u01c5\\u01c7\\u01c8\\u01ca\\u01cb\\u01cd\\u01cf\\u01d1\\u01d3\\u01d5\\u01d7\\u01d9\\u01db\\u01de\\u01e0\\u01e2\\u01e4\\u01e6\\u01e8\\u01ea\\u01ec\\u01ee\\u01f1\\u01f2\\u01f4\\u01f6-\\u01f8\\u01fa\\u01fc\\u01fe\\u0200\\u0202\\u0204\\u0206\\u0208\\u020a\\u020c\\u020e\\u0210\\u0212\\u0214\\u0216\\u0218\\u021a\\u021c\\u021e\\u0220\\u0222\\u0224\\u0226\\u0228\\u022a\\u022c\\u022e\\u0230\\u0232\\u023a\\u023b\\u023d\\u023e\\u0241\\u0243-\\u0246\\u0248\\u024a\\u024c\\u024e';/**
 * Regular expression to match Unicode words
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_WORD=exports.REGEXP_WORD=new RegExp('(?:['+upperCaseLetter+']['+_const$1.diacriticalMark+']*)?(?:['+lowerCaseLetter+']['+_const$1.diacriticalMark+']*)+|\
(?:['+upperCaseLetter+']['+_const$1.diacriticalMark+']*)+(?!['+lowerCaseLetter+'])|\
['+_const$1.digit+']+|\
['+dingbatBlock+']|\
[^'+nonCharacter+generalPunctuationBlock+_const$1.whitespace+']+','g');/**
 * Regular expression to match words from Basic Latin and Latin-1 Supplement blocks
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_LATIN_WORD=exports.REGEXP_LATIN_WORD=/[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;/**
 * Regular expression to match alpha characters
 *
 * @see http://stackoverflow.com/a/22075070/1894471
 * @type {RegExp}
 * @ignore
 */var REGEXP_ALPHA=exports.REGEXP_ALPHA=new RegExp('^(?:['+lowerCaseLetter+upperCaseLetter+']['+_const$1.diacriticalMark+']*)+$');/**
 * Regular expression to match alpha and digit characters
 *
 * @see http://stackoverflow.com/a/22075070/1894471
 * @type {RegExp}
 * @ignore
 */var REGEXP_ALPHA_DIGIT=exports.REGEXP_ALPHA_DIGIT=new RegExp('^((?:['+lowerCaseLetter+upperCaseLetter+']['+_const$1.diacriticalMark+']*)|['+_const$1.digit+'])+$');/**
 * Regular expression to match Extended ASCII characters, i.e. the first 255
 *
 * @type {RegExp}
 * @ignore
 */var REGEXP_EXTENDED_ASCII=exports.REGEXP_EXTENDED_ASCII=/^[\x01-\xFF]*$/;});unwrapExports$1(const_extended$1);var const_extended_1$1=const_extended$1.REGEXP_EXTENDED_ASCII;var const_extended_2$1=const_extended$1.REGEXP_ALPHA_DIGIT;var const_extended_3$1=const_extended$1.REGEXP_ALPHA;var const_extended_4$1=const_extended$1.REGEXP_LATIN_WORD;var const_extended_5$1=const_extended$1.REGEXP_WORD;var is_nil$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=isNil;/**
 * Checks if `value` is `null` or `undefined`
 *
 * @ignore
 * @function isNil
 * @param {*} value The object to check
 * @return {boolean} Returns `true` is `value` is `undefined` or `null`, `false` otherwise
 */function isNil(value){return value===undefined||value===null;}module.exports=exports["default"];});unwrapExports$1(is_nil$1);var coerce_to_boolean$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=coerceToBoolean;var _is_nil2=_interopRequireDefault(is_nil$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Converts the `value` to a boolean. If `value` is `undefined` or `null`, returns `defaultValue`.
 *
 * @ignore
 * @function toBoolean
 * @param {*} value The value to convert.
 * @param {boolean} [defaultValue=false] The default value.
 * @return {boolean} Returns the coercion to boolean.
 */function coerceToBoolean(value){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if((0, _is_nil2.default)(value)){return defaultValue;}return Boolean(value);}module.exports=exports['default'];});unwrapExports$1(coerce_to_boolean$1);var is_string$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=isString;/**
 * Checks whether `subject` is a string primitive type.
 *
 * @function isString
 * @static
 * @since 1.0.0
 * @memberOf Query
 * @param {string} subject The value to verify.
 * @return {boolean} Returns `true` if `subject` is string primitive type or `false` otherwise.
 * @example
 * v.isString('vacation');
 * // => true
 *
 * v.isString(560);
 * // => false
 */function isString(subject){return typeof subject==='string';}module.exports=exports['default'];});unwrapExports$1(is_string$1);var coerce_to_string$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=coerceToString;var _is_nil2=_interopRequireDefault(is_nil$1);var _is_string2=_interopRequireDefault(is_string$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Get the string representation of the `value`.
 * Converts the `value` to string.
 * If `value` is `null` or `undefined`, return `defaultValue`.
 *
 * @ignore
 * @function toString
 * @param {*} value             The value to convert.
 * @param {*} [defaultValue=''] The default value to return.
 * @return {string|null}        Returns the string representation of `value`. Returns `defaultValue` if `value` is
 *                              `null` or `undefined`.
 */function coerceToString(value){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';if((0, _is_nil2.default)(value)){return defaultValue;}if((0, _is_string2.default)(value)){return value;}return String(value);}module.exports=exports['default'];});unwrapExports$1(coerce_to_string$1);var capitalize_1$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=capitalize;var _coerce_to_boolean2=_interopRequireDefault(coerce_to_boolean$1);var _coerce_to_string2=_interopRequireDefault(coerce_to_string$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Converts the first character of `subject` to upper case. If `restToLower` is `true`, convert the rest of
 * `subject` to lower case.
 *
 * @function capitalize
 * @static
 * @since 1.0.0
 * @memberOf Case
 * @param  {string}  [subject='']        The string to capitalize.
 * @param  {boolean} [restToLower=false] Convert the rest of `subject` to lower case.
 * @return {string}                      Returns the capitalized string.
 * @example
 * v.capitalize('apple');
 * // => 'Apple'
 *
 * v.capitalize('aPPle', true);
 * // => 'Apple'
 */function capitalize(subject,restToLower){var subjectString=(0, _coerce_to_string2.default)(subject);var restToLowerCaseBoolean=(0, _coerce_to_boolean2.default)(restToLower);if(subjectString===''){return'';}if(restToLowerCaseBoolean){subjectString=subjectString.toLowerCase();}return subjectString.substr(0,1).toUpperCase()+subjectString.substr(1);}module.exports=exports['default'];});unwrapExports$1(capitalize_1$1);var title_case$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=titleCase;var _capitalize2=_interopRequireDefault(capitalize_1$1);var _coerce_to_string2=_interopRequireDefault(coerce_to_string$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Converts the subject to title case.
 *
 * @function titleCase
 * @static
 * @since 1.4.0
 * @memberOf Case
 * @param  {string} [subject=''] The string to convert to title case.
 * @param  {Array}  [noSplit]    Do not split words at the specified characters.
 * @return {string}              Returns the title case string.
 * @example
 * v.titleCase('learning to fly');
 * // => 'Learning To Fly'
 *
 * v.titleCase('jean-luc is good-looking', ['-']);
 * // => 'Jean-luc Is Good-looking'
 */function titleCase(subject,noSplit){var subjectString=(0, _coerce_to_string2.default)(subject);var noSplitArray=Array.isArray(noSplit)?noSplit:[];var wordsRegExp=const_extended$1.REGEXP_EXTENDED_ASCII.test(subjectString)?const_extended$1.REGEXP_LATIN_WORD:const_extended$1.REGEXP_WORD;return subjectString.replace(wordsRegExp,function(word,index){var isNoSplit=index>0&&noSplitArray.indexOf(subjectString[index-1])>=0;return isNoSplit?word.toLowerCase():(0, _capitalize2.default)(word,true);});}module.exports=exports['default'];});var titleCase$1=unwrapExports$1(title_case$1);var lower_case$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=lowerCase;var _coerce_to_string2=_interopRequireDefault(coerce_to_string$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Converts the `subject` to lower case.
 *
 * @function lowerCase
 * @static
 * @since 1.0.0
 * @memberOf Case
 * @param  {string} [subject=''] The string to convert to lower case.
 * @return {string}              Returns the lower case string.
 * @example
 * v.lowerCase('Green');
 * // => 'green'
 *
 * v.lowerCase('BLUE');
 * // => 'blue'
 */function lowerCase(subject){var subjectString=(0, _coerce_to_string2.default)(subject,'');return subjectString.toLowerCase();}module.exports=exports['default'];});var lowerCase$1=unwrapExports$1(lower_case$1);function _isPlaceholder$1(a){return a!=null&&(typeof a==='undefined'?'undefined':_typeof(a))==='object'&&a['@@functional/placeholder']===true;}/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curry1$1(fn){return function f1(a){if(arguments.length===0||_isPlaceholder$1(a)){return f1;}else{return fn.apply(this,arguments);}};}/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */var always$1=/*#__PURE__*/_curry1$1(function always(val){return function(){return val;};});/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */var F$1=/*#__PURE__*/always$1(false);/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */var T$1=/*#__PURE__*/always$1(true);/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 *//**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curry2$1(fn){return function f2(a,b){switch(arguments.length){case 0:return f2;case 1:return _isPlaceholder$1(a)?f2:_curry1$1(function(_b){return fn(a,_b);});default:return _isPlaceholder$1(a)&&_isPlaceholder$1(b)?f2:_isPlaceholder$1(a)?_curry1$1(function(_a){return fn(_a,b);}):_isPlaceholder$1(b)?_curry1$1(function(_b){return fn(a,_b);}):fn(a,b);}};}/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */var add$1=/*#__PURE__*/_curry2$1(function add(a,b){return Number(a)+Number(b);});/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */function _concat$1(set1,set2){set1=set1||[];set2=set2||[];var idx;var len1=set1.length;var len2=set2.length;var result=[];idx=0;while(idx<len1){result[result.length]=set1[idx];idx+=1;}idx=0;while(idx<len2){result[result.length]=set2[idx];idx+=1;}return result;}function _arity$1(n,fn){/* eslint-disable no-unused-vars */switch(n){case 0:return function(){return fn.apply(this,arguments);};case 1:return function(a0){return fn.apply(this,arguments);};case 2:return function(a0,a1){return fn.apply(this,arguments);};case 3:return function(a0,a1,a2){return fn.apply(this,arguments);};case 4:return function(a0,a1,a2,a3){return fn.apply(this,arguments);};case 5:return function(a0,a1,a2,a3,a4){return fn.apply(this,arguments);};case 6:return function(a0,a1,a2,a3,a4,a5){return fn.apply(this,arguments);};case 7:return function(a0,a1,a2,a3,a4,a5,a6){return fn.apply(this,arguments);};case 8:return function(a0,a1,a2,a3,a4,a5,a6,a7){return fn.apply(this,arguments);};case 9:return function(a0,a1,a2,a3,a4,a5,a6,a7,a8){return fn.apply(this,arguments);};case 10:return function(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9){return fn.apply(this,arguments);};default:throw new Error('First argument to _arity must be a non-negative integer no greater than ten');}}/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curryN$1(length,received,fn){return function(){var combined=[];var argsIdx=0;var left=length;var combinedIdx=0;while(combinedIdx<received.length||argsIdx<arguments.length){var result;if(combinedIdx<received.length&&(!_isPlaceholder$1(received[combinedIdx])||argsIdx>=arguments.length)){result=received[combinedIdx];}else{result=arguments[argsIdx];argsIdx+=1;}combined[combinedIdx]=result;if(!_isPlaceholder$1(result)){left-=1;}combinedIdx+=1;}return left<=0?fn.apply(this,combined):_arity$1(left,_curryN$1(length,combined,fn));};}/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */var curryN$1=/*#__PURE__*/_curry2$1(function curryN(length,fn){if(length===1){return _curry1$1(fn);}return _arity$1(length,_curryN$1(length,[],fn));});/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */var addIndex$1=/*#__PURE__*/_curry1$1(function addIndex(fn){return curryN$1(fn.length,function(){var idx=0;var origFn=arguments[0];var list=arguments[arguments.length-1];var args=Array.prototype.slice.call(arguments,0);args[0]=function(){var result=origFn.apply(this,_concat$1(arguments,[idx,list]));idx+=1;return result;};return fn.apply(this,args);});});/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curry3$1(fn){return function f3(a,b,c){switch(arguments.length){case 0:return f3;case 1:return _isPlaceholder$1(a)?f3:_curry2$1(function(_b,_c){return fn(a,_b,_c);});case 2:return _isPlaceholder$1(a)&&_isPlaceholder$1(b)?f3:_isPlaceholder$1(a)?_curry2$1(function(_a,_c){return fn(_a,b,_c);}):_isPlaceholder$1(b)?_curry2$1(function(_b,_c){return fn(a,_b,_c);}):_curry1$1(function(_c){return fn(a,b,_c);});default:return _isPlaceholder$1(a)&&_isPlaceholder$1(b)&&_isPlaceholder$1(c)?f3:_isPlaceholder$1(a)&&_isPlaceholder$1(b)?_curry2$1(function(_a,_b){return fn(_a,_b,c);}):_isPlaceholder$1(a)&&_isPlaceholder$1(c)?_curry2$1(function(_a,_c){return fn(_a,b,_c);}):_isPlaceholder$1(b)&&_isPlaceholder$1(c)?_curry2$1(function(_b,_c){return fn(a,_b,_c);}):_isPlaceholder$1(a)?_curry1$1(function(_a){return fn(_a,b,c);}):_isPlaceholder$1(b)?_curry1$1(function(_b){return fn(a,_b,c);}):_isPlaceholder$1(c)?_curry1$1(function(_c){return fn(a,b,_c);}):fn(a,b,c);}};}/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */var _isArray$1=Array.isArray||function _isArray(val){return val!=null&&val.length>=0&&Object.prototype.toString.call(val)==='[object Array]';};function _isTransformer$1(obj){return typeof obj['@@transducer/step']==='function';}/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */function _dispatchable$1(methodNames,xf,fn){return function(){if(arguments.length===0){return fn();}var args=Array.prototype.slice.call(arguments,0);var obj=args.pop();if(!_isArray$1(obj)){var idx=0;while(idx<methodNames.length){if(typeof obj[methodNames[idx]]==='function'){return obj[methodNames[idx]].apply(obj,args);}idx+=1;}if(_isTransformer$1(obj)){var transducer=xf.apply(null,args);return transducer(obj);}}return fn.apply(this,arguments);};}var _xfBase$1={init:function init(){return this.xf['@@transducer/init']();},result:function result(_result2){return this.xf['@@transducer/result'](_result2);}};/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */var max$1=/*#__PURE__*/_curry2$1(function max(a,b){return b>a?b:a;});function _map$1(fn,functor){var idx=0;var len=functor.length;var result=Array(len);while(idx<len){result[idx]=fn(functor[idx]);idx+=1;}return result;}function _isString$1(x){return Object.prototype.toString.call(x)==='[object String]';}/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */var _isArrayLike$1=/*#__PURE__*/_curry1$1(function isArrayLike(x){if(_isArray$1(x)){return true;}if(!x){return false;}if((typeof x==='undefined'?'undefined':_typeof(x))!=='object'){return false;}if(_isString$1(x)){return false;}if(x.nodeType===1){return!!x.length;}if(x.length===0){return true;}if(x.length>0){return x.hasOwnProperty(0)&&x.hasOwnProperty(x.length-1);}return false;});var XWrap$1=/*#__PURE__*/function(){function XWrap(fn){this.f=fn;}XWrap.prototype['@@transducer/init']=function(){throw new Error('init not implemented on XWrap');};XWrap.prototype['@@transducer/result']=function(acc){return acc;};XWrap.prototype['@@transducer/step']=function(acc,x){return this.f(acc,x);};return XWrap;}();function _xwrap$1(fn){return new XWrap$1(fn);}/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */var bind$1=/*#__PURE__*/_curry2$1(function bind(fn,thisObj){return _arity$1(fn.length,function(){return fn.apply(thisObj,arguments);});});function _arrayReduce$1(xf,acc,list){var idx=0;var len=list.length;while(idx<len){acc=xf['@@transducer/step'](acc,list[idx]);if(acc&&acc['@@transducer/reduced']){acc=acc['@@transducer/value'];break;}idx+=1;}return xf['@@transducer/result'](acc);}function _iterableReduce$1(xf,acc,iter){var step=iter.next();while(!step.done){acc=xf['@@transducer/step'](acc,step.value);if(acc&&acc['@@transducer/reduced']){acc=acc['@@transducer/value'];break;}step=iter.next();}return xf['@@transducer/result'](acc);}function _methodReduce$1(xf,acc,obj,methodName){return xf['@@transducer/result'](obj[methodName](bind$1(xf['@@transducer/step'],xf),acc));}var symIterator$1=typeof Symbol!=='undefined'?Symbol.iterator:'@@iterator';function _reduce$1(fn,acc,list){if(typeof fn==='function'){fn=_xwrap$1(fn);}if(_isArrayLike$1(list)){return _arrayReduce$1(fn,acc,list);}if(typeof list['fantasy-land/reduce']==='function'){return _methodReduce$1(fn,acc,list,'fantasy-land/reduce');}if(list[symIterator$1]!=null){return _iterableReduce$1(fn,acc,list[symIterator$1]());}if(typeof list.next==='function'){return _iterableReduce$1(fn,acc,list);}if(typeof list.reduce==='function'){return _methodReduce$1(fn,acc,list,'reduce');}throw new TypeError('reduce: list must be array or iterable');}var XMap$1=/*#__PURE__*/function(){function XMap(f,xf){this.xf=xf;this.f=f;}XMap.prototype['@@transducer/init']=_xfBase$1.init;XMap.prototype['@@transducer/result']=_xfBase$1.result;XMap.prototype['@@transducer/step']=function(result,input){return this.xf['@@transducer/step'](result,this.f(input));};return XMap;}();var _xmap$1=/*#__PURE__*/_curry2$1(function _xmap(f,xf){return new XMap$1(f,xf);});function _has$1(prop,obj){return Object.prototype.hasOwnProperty.call(obj,prop);}var toString$1$1=Object.prototype.toString;var _isArguments$1=function _isArguments(){return toString$1$1.call(arguments)==='[object Arguments]'?function _isArguments(x){return toString$1$1.call(x)==='[object Arguments]';}:function _isArguments(x){return _has$1('callee',x);};};// cover IE < 9 keys issues
var hasEnumBug$1=!/*#__PURE__*/{toString:null}.propertyIsEnumerable('toString');var nonEnumerableProps$1=['constructor','valueOf','isPrototypeOf','toString','propertyIsEnumerable','hasOwnProperty','toLocaleString'];// Safari bug
var hasArgsEnumBug$1=/*#__PURE__*/function(){return arguments.propertyIsEnumerable('length');}();var contains$1=function contains(list,item){var idx=0;while(idx<list.length){if(list[idx]===item){return true;}idx+=1;}return false;};/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */var _keys$1=typeof Object.keys==='function'&&!hasArgsEnumBug$1?function keys(obj){return Object(obj)!==obj?[]:Object.keys(obj);}:function keys(obj){if(Object(obj)!==obj){return[];}var prop,nIdx;var ks=[];var checkArgsLength=hasArgsEnumBug$1&&_isArguments$1(obj);for(prop in obj){if(_has$1(prop,obj)&&(!checkArgsLength||prop!=='length')){ks[ks.length]=prop;}}if(hasEnumBug$1){nIdx=nonEnumerableProps$1.length-1;while(nIdx>=0){prop=nonEnumerableProps$1[nIdx];if(_has$1(prop,obj)&&!contains$1(ks,prop)){ks[ks.length]=prop;}nIdx-=1;}}return ks;};var keys$1=/*#__PURE__*/_curry1$1(_keys$1);/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */var map$1=/*#__PURE__*/_curry2$1(/*#__PURE__*/_dispatchable$1(['fantasy-land/map','map'],_xmap$1,function map(fn,functor){switch(Object.prototype.toString.call(functor)){case'[object Function]':return curryN$1(functor.length,function(){return fn.call(this,functor.apply(this,arguments));});case'[object Object]':return _reduce$1(function(acc,key){acc[key]=fn(functor[key]);return acc;},{},keys$1(functor));default:return _map$1(fn,functor);}}));/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */var path$1=/*#__PURE__*/_curry2$1(function path(paths,obj){var val=obj;var idx=0;while(idx<paths.length){if(val==null){return;}val=val[paths[idx]];idx+=1;}return val;});/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */var prop$1=/*#__PURE__*/_curry2$1(function prop(p,obj){return path$1([p],obj);});/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */var pluck$1=/*#__PURE__*/_curry2$1(function pluck(p,list){return map$1(prop$1(p),list);});/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */var reduce$1=/*#__PURE__*/_curry3$1(_reduce$1);/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */var ap$1=/*#__PURE__*/_curry2$1(function ap(applyF,applyX){return typeof applyX['fantasy-land/ap']==='function'?applyX['fantasy-land/ap'](applyF):typeof applyF.ap==='function'?applyF.ap(applyX):typeof applyF==='function'?function(x){return applyF(x)(applyX(x));}:// else
_reduce$1(function(acc,f){return _concat$1(acc,map$1(f,applyX));},[],applyF);});/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */var values=/*#__PURE__*/_curry1$1(function values(obj){var props=keys$1(obj);var len=props.length;var vals=[];var idx=0;while(idx<len){vals[idx]=obj[props[idx]];idx+=1;}return vals;});/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */function _isFunction$1(x){return Object.prototype.toString.call(x)==='[object Function]';}/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */var liftN$1=/*#__PURE__*/_curry2$1(function liftN(arity,fn){var lifted=curryN$1(arity,fn);return curryN$1(arity,function(){return _reduce$1(ap$1,map$1(lifted,arguments[0]),Array.prototype.slice.call(arguments,1));});});/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */var lift$1=/*#__PURE__*/_curry1$1(function lift(fn){return liftN$1(fn.length,fn);});/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */var curry$1=/*#__PURE__*/_curry1$1(function curry(fn){return curryN$1(fn.length,fn);});/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */var call$1=/*#__PURE__*/curry$1(function call(fn){return fn.apply(this,Array.prototype.slice.call(arguments,1));});/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */function _makeFlat$1(recursive){return function flatt(list){var value,jlen,j;var result=[];var idx=0;var ilen=list.length;while(idx<ilen){if(_isArrayLike$1(list[idx])){value=recursive?flatt(list[idx]):list[idx];j=0;jlen=value.length;while(j<jlen){result[result.length]=value[j];j+=1;}}else{result[result.length]=list[idx];}idx+=1;}return result;};}function _forceReduced$1(x){return{'@@transducer/value':x,'@@transducer/reduced':true};}var preservingReduced$1=function preservingReduced(xf){return{'@@transducer/init':_xfBase$1.init,'@@transducer/result':function transducerResult(result){return xf['@@transducer/result'](result);},'@@transducer/step':function transducerStep(result,input){var ret=xf['@@transducer/step'](result,input);return ret['@@transducer/reduced']?_forceReduced$1(ret):ret;}};};var _flatCat$1=function _xcat(xf){var rxf=preservingReduced$1(xf);return{'@@transducer/init':_xfBase$1.init,'@@transducer/result':function transducerResult(result){return rxf['@@transducer/result'](result);},'@@transducer/step':function transducerStep(result,input){return!_isArrayLike$1(input)?_reduce$1(rxf,result,[input]):_reduce$1(rxf,result,input);}};};var _xchain$1=/*#__PURE__*/_curry2$1(function _xchain(f,xf){return map$1(f,_flatCat$1(xf));});/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */var chain$1=/*#__PURE__*/_curry2$1(/*#__PURE__*/_dispatchable$1(['fantasy-land/chain','chain'],_xchain$1,function chain(fn,monad){if(typeof monad==='function'){return function(x){return fn(monad(x))(x);};}return _makeFlat$1(false)(map$1(fn,monad));}));/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */var type$1=/*#__PURE__*/_curry1$1(function type(val){return val===null?'Null':val===undefined?'Undefined':Object.prototype.toString.call(val).slice(8,-1);});/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */var not$1=/*#__PURE__*/_curry1$1(function not(a){return!a;});/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */var complement$1=/*#__PURE__*/lift$1(not$1);function _pipe$1(f,g){return function(){return g.call(this,f.apply(this,arguments));};}/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */function _checkForMethod$1(methodname,fn){return function(){var length=arguments.length;if(length===0){return fn();}var obj=arguments[length-1];return _isArray$1(obj)||typeof obj[methodname]!=='function'?fn.apply(this,arguments):obj[methodname].apply(obj,Array.prototype.slice.call(arguments,0,length-1));};}/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */var slice$1=/*#__PURE__*/_curry3$1(/*#__PURE__*/_checkForMethod$1('slice',function slice(fromIndex,toIndex,list){return Array.prototype.slice.call(list,fromIndex,toIndex);}));/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */var tail$1=/*#__PURE__*/_curry1$1(/*#__PURE__*/_checkForMethod$1('tail',/*#__PURE__*/slice$1(1,Infinity)));/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */function pipe$1(){if(arguments.length===0){throw new Error('pipe requires at least one argument');}return _arity$1(arguments[0].length,reduce$1(_pipe$1,arguments[0],tail$1(arguments)));}/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */var reverse$1=/*#__PURE__*/_curry1$1(function reverse(list){return _isString$1(list)?list.split('').reverse().join(''):Array.prototype.slice.call(list,0).reverse();});/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */function compose$1(){if(arguments.length===0){throw new Error('compose requires at least one argument');}return pipe$1.apply(this,reverse$1(arguments));}function _arrayFromIterator$1(iter){var list=[];var next;while(!(next=iter.next()).done){list.push(next.value);}return list;}function _containsWith$1(pred,x,list){var idx=0;var len=list.length;while(idx<len){if(pred(x,list[idx])){return true;}idx+=1;}return false;}function _functionName$1(f){// String(x => x) evaluates to "x => x", so the pattern may not match.
var match=String(f).match(/^function (\w*)/);return match==null?'':match[1];}/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */var identical$1=/*#__PURE__*/_curry2$1(function identical(a,b){// SameValue algorithm
if(a===b){// Steps 1-5, 7-10
// Steps 6.b-6.e: +0 != -0
return a!==0||1/a===1/b;}else{// Step 6.a: NaN == NaN
return a!==a&&b!==b;}});/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */function _uniqContentEquals$1(aIterator,bIterator,stackA,stackB){var a=_arrayFromIterator$1(aIterator);var b=_arrayFromIterator$1(bIterator);function eq(_a,_b){return _equals$1(_a,_b,stackA.slice(),stackB.slice());}// if *a* array contains any element that is not included in *b*
return!_containsWith$1(function(b,aItem){return!_containsWith$1(eq,aItem,b);},b,a);}function _equals$1(a,b,stackA,stackB){if(identical$1(a,b)){return true;}var typeA=type$1(a);if(typeA!==type$1(b)){return false;}if(a==null||b==null){return false;}if(typeof a['fantasy-land/equals']==='function'||typeof b['fantasy-land/equals']==='function'){return typeof a['fantasy-land/equals']==='function'&&a['fantasy-land/equals'](b)&&typeof b['fantasy-land/equals']==='function'&&b['fantasy-land/equals'](a);}if(typeof a.equals==='function'||typeof b.equals==='function'){return typeof a.equals==='function'&&a.equals(b)&&typeof b.equals==='function'&&b.equals(a);}switch(typeA){case'Arguments':case'Array':case'Object':if(typeof a.constructor==='function'&&_functionName$1(a.constructor)==='Promise'){return a===b;}break;case'Boolean':case'Number':case'String':if(!((typeof a==='undefined'?'undefined':_typeof(a))===(typeof b==='undefined'?'undefined':_typeof(b))&&identical$1(a.valueOf(),b.valueOf()))){return false;}break;case'Date':if(!identical$1(a.valueOf(),b.valueOf())){return false;}break;case'Error':return a.name===b.name&&a.message===b.message;case'RegExp':if(!(a.source===b.source&&a.global===b.global&&a.ignoreCase===b.ignoreCase&&a.multiline===b.multiline&&a.sticky===b.sticky&&a.unicode===b.unicode)){return false;}break;}var idx=stackA.length-1;while(idx>=0){if(stackA[idx]===a){return stackB[idx]===b;}idx-=1;}switch(typeA){case'Map':if(a.size!==b.size){return false;}return _uniqContentEquals$1(a.entries(),b.entries(),stackA.concat([a]),stackB.concat([b]));case'Set':if(a.size!==b.size){return false;}return _uniqContentEquals$1(a.values(),b.values(),stackA.concat([a]),stackB.concat([b]));case'Arguments':case'Array':case'Object':case'Boolean':case'Number':case'String':case'Date':case'Error':case'RegExp':case'Int8Array':case'Uint8Array':case'Uint8ClampedArray':case'Int16Array':case'Uint16Array':case'Int32Array':case'Uint32Array':case'Float32Array':case'Float64Array':case'ArrayBuffer':break;default:// Values of other types are only equal if identical.
return false;}var keysA=keys$1(a);if(keysA.length!==keys$1(b).length){return false;}var extendedStackA=stackA.concat([a]);var extendedStackB=stackB.concat([b]);idx=keysA.length-1;while(idx>=0){var key=keysA[idx];if(!(_has$1(key,b)&&_equals$1(b[key],a[key],extendedStackA,extendedStackB))){return false;}idx-=1;}return true;}/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */var equals$1=/*#__PURE__*/_curry2$1(function equals(a,b){return _equals$1(a,b,[],[]);});function _indexOf$1(list,a,idx){var inf,item;// Array.prototype.indexOf doesn't exist below IE9
if(typeof list.indexOf==='function'){switch(typeof a==='undefined'?'undefined':_typeof(a)){case'number':if(a===0){// manually crawl the list to distinguish between +0 and -0
inf=1/a;while(idx<list.length){item=list[idx];if(item===0&&1/item===inf){return idx;}idx+=1;}return-1;}else if(a!==a){// NaN
while(idx<list.length){item=list[idx];if(typeof item==='number'&&item!==item){return idx;}idx+=1;}return-1;}// non-zero numbers can utilise Set
return list.indexOf(a,idx);// all these types can utilise Set
case'string':case'boolean':case'function':case'undefined':return list.indexOf(a,idx);case'object':if(a===null){// null can utilise Set
return list.indexOf(a,idx);}}}// anything else not covered above, defer to R.equals
while(idx<list.length){if(equals$1(list[idx],a)){return idx;}idx+=1;}return-1;}function _contains$1(a,list){return _indexOf$1(list,a,0)>=0;}function _quote$1(s){var escaped=s.replace(/\\/g,'\\\\').replace(/[\b]/g,'\\b')// \b matches word boundary; [\b] matches backspace
.replace(/\f/g,'\\f').replace(/\n/g,'\\n').replace(/\r/g,'\\r').replace(/\t/g,'\\t').replace(/\v/g,'\\v').replace(/\0/g,'\\0');return'"'+escaped.replace(/"/g,'\\"')+'"';}/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */var pad$1=function pad(n){return(n<10?'0':'')+n;};var _toISOString$1=typeof Date.prototype.toISOString==='function'?function _toISOString(d){return d.toISOString();}:function _toISOString(d){return d.getUTCFullYear()+'-'+pad$1(d.getUTCMonth()+1)+'-'+pad$1(d.getUTCDate())+'T'+pad$1(d.getUTCHours())+':'+pad$1(d.getUTCMinutes())+':'+pad$1(d.getUTCSeconds())+'.'+(d.getUTCMilliseconds()/1000).toFixed(3).slice(2,5)+'Z';};function _complement$1(f){return function(){return!f.apply(this,arguments);};}function _filter$1(fn,list){var idx=0;var len=list.length;var result=[];while(idx<len){if(fn(list[idx])){result[result.length]=list[idx];}idx+=1;}return result;}function _isObject$1(x){return Object.prototype.toString.call(x)==='[object Object]';}var XFilter$1=/*#__PURE__*/function(){function XFilter(f,xf){this.xf=xf;this.f=f;}XFilter.prototype['@@transducer/init']=_xfBase$1.init;XFilter.prototype['@@transducer/result']=_xfBase$1.result;XFilter.prototype['@@transducer/step']=function(result,input){return this.f(input)?this.xf['@@transducer/step'](result,input):result;};return XFilter;}();var _xfilter$1=/*#__PURE__*/_curry2$1(function _xfilter(f,xf){return new XFilter$1(f,xf);});/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */var filter$1=/*#__PURE__*/_curry2$1(/*#__PURE__*/_dispatchable$1(['filter'],_xfilter$1,function(pred,filterable){return _isObject$1(filterable)?_reduce$1(function(acc,key){if(pred(filterable[key])){acc[key]=filterable[key];}return acc;},{},keys$1(filterable)):// else
_filter$1(pred,filterable);}));/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */var reject$1=/*#__PURE__*/_curry2$1(function reject(pred,filterable){return filter$1(_complement$1(pred),filterable);});function _toString$1(x,seen){var recur=function recur(y){var xs=seen.concat([x]);return _contains$1(y,xs)?'<Circular>':_toString$1(y,xs);};//  mapPairs :: (Object, [String]) -> [String]
var mapPairs=function mapPairs(obj,keys$$1){return _map$1(function(k){return _quote$1(k)+': '+recur(obj[k]);},keys$$1.slice().sort());};switch(Object.prototype.toString.call(x)){case'[object Arguments]':return'(function() { return arguments; }('+_map$1(recur,x).join(', ')+'))';case'[object Array]':return'['+_map$1(recur,x).concat(mapPairs(x,reject$1(function(k){return /^\d+$/.test(k);},keys$1(x)))).join(', ')+']';case'[object Boolean]':return(typeof x==='undefined'?'undefined':_typeof(x))==='object'?'new Boolean('+recur(x.valueOf())+')':x.toString();case'[object Date]':return'new Date('+(isNaN(x.valueOf())?recur(NaN):_quote$1(_toISOString$1(x)))+')';case'[object Null]':return'null';case'[object Number]':return(typeof x==='undefined'?'undefined':_typeof(x))==='object'?'new Number('+recur(x.valueOf())+')':1/x===-Infinity?'-0':x.toString(10);case'[object String]':return(typeof x==='undefined'?'undefined':_typeof(x))==='object'?'new String('+recur(x.valueOf())+')':_quote$1(x);case'[object Undefined]':return'undefined';default:if(typeof x.toString==='function'){var repr=x.toString();if(repr!=='[object Object]'){return repr;}}return'{'+mapPairs(x,keys$1(x)).join(', ')+'}';}}/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */var toString$1$2=/*#__PURE__*/_curry1$1(function toString(val){return _toString$1(val,[]);});/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 */var contains$1$1=/*#__PURE__*/_curry2$1(_contains$1);/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */var converge$1=/*#__PURE__*/_curry2$1(function converge(after,fns){return curryN$1(reduce$1(max$1,0,pluck$1('length',fns)),function(){var args=arguments;var context=this;return after.apply(context,_map$1(function(fn){return fn.apply(context,args);},fns));});});var XReduceBy$1=/*#__PURE__*/function(){function XReduceBy(valueFn,valueAcc,keyFn,xf){this.valueFn=valueFn;this.valueAcc=valueAcc;this.keyFn=keyFn;this.xf=xf;this.inputs={};}XReduceBy.prototype['@@transducer/init']=_xfBase$1.init;XReduceBy.prototype['@@transducer/result']=function(result){var key;for(key in this.inputs){if(_has$1(key,this.inputs)){result=this.xf['@@transducer/step'](result,this.inputs[key]);if(result['@@transducer/reduced']){result=result['@@transducer/value'];break;}}}this.inputs=null;return this.xf['@@transducer/result'](result);};XReduceBy.prototype['@@transducer/step']=function(result,input){var key=this.keyFn(input);this.inputs[key]=this.inputs[key]||[key,this.valueAcc];this.inputs[key][1]=this.valueFn(this.inputs[key][1],input);return result;};return XReduceBy;}();var _xreduceBy$1=/*#__PURE__*/_curryN$1(4,[],function _xreduceBy(valueFn,valueAcc,keyFn,xf){return new XReduceBy$1(valueFn,valueAcc,keyFn,xf);});/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */var reduceBy$1=/*#__PURE__*/_curryN$1(4,[],/*#__PURE__*/_dispatchable$1([],_xreduceBy$1,function reduceBy(valueFn,valueAcc,keyFn,list){return _reduce$1(function(acc,elt){var key=keyFn(elt);acc[key]=valueFn(_has$1(key,acc)?acc[key]:valueAcc,elt);return acc;},{},list);}));/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */var countBy$1=/*#__PURE__*/reduceBy$1(function(acc,elem){return acc+1;},0);/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */var dec$1=/*#__PURE__*/add$1(-1);var XDropRepeatsWith$1=/*#__PURE__*/function(){function XDropRepeatsWith(pred,xf){this.xf=xf;this.pred=pred;this.lastValue=undefined;this.seenFirstValue=false;}XDropRepeatsWith.prototype['@@transducer/init']=_xfBase$1.init;XDropRepeatsWith.prototype['@@transducer/result']=_xfBase$1.result;XDropRepeatsWith.prototype['@@transducer/step']=function(result,input){var sameAsLast=false;if(!this.seenFirstValue){this.seenFirstValue=true;}else if(this.pred(this.lastValue,input)){sameAsLast=true;}this.lastValue=input;return sameAsLast?result:this.xf['@@transducer/step'](result,input);};return XDropRepeatsWith;}();var _xdropRepeatsWith$1=/*#__PURE__*/_curry2$1(function _xdropRepeatsWith(pred,xf){return new XDropRepeatsWith$1(pred,xf);});/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */var nth$1=/*#__PURE__*/_curry2$1(function nth(offset,list){var idx=offset<0?list.length+offset:offset;return _isString$1(list)?list.charAt(idx):list[idx];});/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */var last$1=/*#__PURE__*/nth$1(-1);/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */var dropRepeatsWith$1=/*#__PURE__*/_curry2$1(/*#__PURE__*/_dispatchable$1([],_xdropRepeatsWith$1,function dropRepeatsWith(pred,list){var result=[];var idx=1;var len=list.length;if(len!==0){result[0]=list[0];while(idx<len){if(!pred(last$1(result),list[idx])){result[result.length]=list[idx];}idx+=1;}}return result;}));/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */var dropRepeats$1=/*#__PURE__*/_curry1$1(/*#__PURE__*/_dispatchable$1([],/*#__PURE__*/_xdropRepeatsWith$1(equals$1),/*#__PURE__*/dropRepeatsWith$1(equals$1)));/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */var empty=/*#__PURE__*/_curry1$1(function empty(x){return x!=null&&typeof x['fantasy-land/empty']==='function'?x['fantasy-land/empty']():x!=null&&x.constructor!=null&&typeof x.constructor['fantasy-land/empty']==='function'?x.constructor['fantasy-land/empty']():x!=null&&typeof x.empty==='function'?x.empty():x!=null&&x.constructor!=null&&typeof x.constructor.empty==='function'?x.constructor.empty():_isArray$1(x)?[]:_isString$1(x)?'':_isObject$1(x)?{}:_isArguments$1(x)?function(){return arguments;}():// else
void 0;});/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */var flip$1=/*#__PURE__*/_curry1$1(function flip(fn){return curryN$1(fn.length,function(a,b){var args=Array.prototype.slice.call(arguments,0);args[0]=b;args[1]=a;return fn.apply(this,args);});});/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */var groupBy$1=/*#__PURE__*/_curry2$1(/*#__PURE__*/_checkForMethod$1('groupBy',/*#__PURE__*/reduceBy$1(function(acc,item){if(acc==null){acc=[];}acc.push(item);return acc;},null)));/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */var gte=/*#__PURE__*/_curry2$1(function gte(a,b){return a>=b;});/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */var head$1=/*#__PURE__*/nth$1(0);function _identity$1(x){return x;}/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */var identity$1=/*#__PURE__*/_curry1$1(_identity$1);/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */var inc$1=/*#__PURE__*/add$1(1);/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */var indexBy$1=/*#__PURE__*/reduceBy$1(function(acc,elem){return elem;},null);/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */var init$1=/*#__PURE__*/slice$1(0,-1);var _Set$1=/*#__PURE__*/function(){function _Set(){/* globals Set */this._nativeSet=typeof Set==='function'?new Set():null;this._items={};}// until we figure out why jsdoc chokes on this
// @param item The item to add to the Set
// @returns {boolean} true if the item did not exist prior, otherwise false
//
_Set.prototype.add=function(item){return!hasOrAdd$1(item,true,this);};//
// @param item The item to check for existence in the Set
// @returns {boolean} true if the item exists in the Set, otherwise false
//
_Set.prototype.has=function(item){return hasOrAdd$1(item,false,this);};//
// Combines the logic for checking whether an item is a member of the set and
// for adding a new item to the set.
//
// @param item       The item to check or add to the Set instance.
// @param shouldAdd  If true, the item will be added to the set if it doesn't
//                   already exist.
// @param set        The set instance to check or add to.
// @return {boolean} true if the item already existed, otherwise false.
//
return _Set;}();function hasOrAdd$1(item,shouldAdd,set$$1){var type=typeof item==='undefined'?'undefined':_typeof(item);var prevSize,newSize;switch(type){case'string':case'number':// distinguish between +0 and -0
if(item===0&&1/item===-Infinity){if(set$$1._items['-0']){return true;}else{if(shouldAdd){set$$1._items['-0']=true;}return false;}}// these types can all utilise the native Set
if(set$$1._nativeSet!==null){if(shouldAdd){prevSize=set$$1._nativeSet.size;set$$1._nativeSet.add(item);newSize=set$$1._nativeSet.size;return newSize===prevSize;}else{return set$$1._nativeSet.has(item);}}else{if(!(type in set$$1._items)){if(shouldAdd){set$$1._items[type]={};set$$1._items[type][item]=true;}return false;}else if(item in set$$1._items[type]){return true;}else{if(shouldAdd){set$$1._items[type][item]=true;}return false;}}case'boolean':// set._items['boolean'] holds a two element array
// representing [ falseExists, trueExists ]
if(type in set$$1._items){var bIdx=item?1:0;if(set$$1._items[type][bIdx]){return true;}else{if(shouldAdd){set$$1._items[type][bIdx]=true;}return false;}}else{if(shouldAdd){set$$1._items[type]=item?[false,true]:[true,false];}return false;}case'function':// compare functions for reference equality
if(set$$1._nativeSet!==null){if(shouldAdd){prevSize=set$$1._nativeSet.size;set$$1._nativeSet.add(item);newSize=set$$1._nativeSet.size;return newSize===prevSize;}else{return set$$1._nativeSet.has(item);}}else{if(!(type in set$$1._items)){if(shouldAdd){set$$1._items[type]=[item];}return false;}if(!_contains$1(item,set$$1._items[type])){if(shouldAdd){set$$1._items[type].push(item);}return false;}return true;}case'undefined':if(set$$1._items[type]){return true;}else{if(shouldAdd){set$$1._items[type]=true;}return false;}case'object':if(item===null){if(!set$$1._items['null']){if(shouldAdd){set$$1._items['null']=true;}return false;}return true;}/* falls through */default:// reduce the search size of heterogeneous sets by creating buckets
// for each type.
type=Object.prototype.toString.call(item);if(!(type in set$$1._items)){if(shouldAdd){set$$1._items[type]=[item];}return false;}// scan through all previously applied items
if(!_contains$1(item,set$$1._items[type])){if(shouldAdd){set$$1._items[type].push(item);}return false;}return true;}}/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */var uniqBy$1=/*#__PURE__*/_curry2$1(function uniqBy(fn,list){var set$$1=new _Set$1();var result=[];var idx=0;var appliedItem,item;while(idx<list.length){item=list[idx];appliedItem=fn(item);if(set$$1.add(appliedItem)){result.push(item);}idx+=1;}return result;});/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */var uniq$1=/*#__PURE__*/uniqBy$1(identity$1);/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */var invoker$1=/*#__PURE__*/_curry2$1(function invoker(arity,method){return curryN$1(arity+1,function(){var target=arguments[arity];if(target!=null&&_isFunction$1(target[method])){return target[method].apply(target,Array.prototype.slice.call(arguments,0,arity));}throw new TypeError(toString$1$2(target)+' does not have a method named "'+method+'"');});});/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */var isEmpty=/*#__PURE__*/_curry1$1(function isEmpty(x){return x!=null&&equals$1(x,empty(x));});/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */var join$1=/*#__PURE__*/invoker$1(1,'join');/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */var juxt$1=/*#__PURE__*/_curry1$1(function juxt(fns){return converge$1(function(){return Array.prototype.slice.call(arguments,0);},fns);});/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */var sum$1=/*#__PURE__*/reduce$1(add$1,0);/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */var memoizeWith$1=/*#__PURE__*/_curry2$1(function memoizeWith(mFn,fn){var cache={};return _arity$1(fn.length,function(){var key=mFn.apply(this,arguments);if(!_has$1(key,cache)){cache[key]=fn.apply(this,arguments);}return cache[key];});});/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @deprecated since v0.25.0
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */var memoize$1=/*#__PURE__*/memoizeWith$1(function(){return toString$1$2(arguments);});/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */var multiply$1=/*#__PURE__*/_curry2$1(function multiply(a,b){return a*b;});function _createPartialApplicator$1(concat){return _curry2$1(function(fn,args){return _arity$1(Math.max(0,fn.length-args.length),function(){return fn.apply(this,concat(args,arguments));});});}/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight
 * @example
 *
 *      var multiply2 = (a, b) => a * b;
 *      var double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var sayHello = R.partial(greet, ['Hello']);
 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */var partial=/*#__PURE__*/_createPartialApplicator$1(_concat$1);/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */var partialRight$1=/*#__PURE__*/_createPartialApplicator$1(/*#__PURE__*/flip$1(_concat$1));/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */var partition$1=/*#__PURE__*/juxt$1([filter$1,reject$1]);/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */var pickAll$1=/*#__PURE__*/_curry2$1(function pickAll(names,obj){var result={};var idx=0;var len=names.length;while(idx<len){var name=names[idx];result[name]=obj[name];idx+=1;}return result;});/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */var product$1=/*#__PURE__*/reduce$1(multiply$1,1);/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */var useWith$1=/*#__PURE__*/_curry2$1(function useWith(fn,transformers){return curryN$1(transformers.length,function(){var args=[];var idx=0;while(idx<transformers.length){args.push(transformers[idx].call(this,arguments[idx]));idx+=1;}return fn.apply(this,args.concat(Array.prototype.slice.call(arguments,transformers.length)));});});/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */var project$1=/*#__PURE__*/useWith$1(_map$1,[pickAll$1,identity$1]);// passing `identity` gives correct arity
/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */var propSatisfies=/*#__PURE__*/_curry3$1(function propSatisfies(pred,name,obj){return pred(obj[name]);});/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */var split$1=/*#__PURE__*/invoker$1(1,'split');/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */var toLower$1=/*#__PURE__*/invoker$1(0,'toLowerCase');/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */var toUpper$1=/*#__PURE__*/invoker$1(0,'toUpperCase');/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      var isOdd = (x) => x % 2 === 1;
 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */var transduce$1=/*#__PURE__*/curryN$1(4,function transduce(xf,fn,acc,list){return _reduce$1(xf(typeof fn==='function'?_xwrap$1(fn):fn),acc,list);});var ws$1='\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003'+'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028'+'\u2029\uFEFF';var zeroWidth$1='\u200B';var hasProtoTrim$1=typeof String.prototype.trim==='function';/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */var _trim$1=!hasProtoTrim$1||/*#__PURE__*/ws$1.trim()||!/*#__PURE__*/zeroWidth$1.trim()?function trim(str){var beginRx=new RegExp('^['+ws$1+']['+ws$1+']*');var endRx=new RegExp('['+ws$1+']['+ws$1+']*$');return str.replace(beginRx,'').replace(endRx,'');}:function trim(str){return str.trim();};/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */var union$1=/*#__PURE__*/_curry2$1(/*#__PURE__*/compose$1(uniq$1,_concat$1));/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */var unnest$1=/*#__PURE__*/chain$1(_identity$1);/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *//**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */var NODE_ENV=process.env.NODE_ENV;var invariant=function invariant(condition,format,a,b,c,d,e,f){if(NODE_ENV!=='production'){if(format===undefined){throw new Error('invariant requires an error message argument');}}if(!condition){var error;if(format===undefined){error=new Error('Minified exception occurred; use the non-minified dev environment '+'for the full error message and additional helpful warnings.');}else{var args=[a,b,c,d,e,f];var argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++];}));error.name='Invariant Violation';}error.framesToPop=1;// we don't care about invariant's own frame
throw error;}};var invariant_1=invariant;var utils=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.vendorPrefix=exports.events=undefined;exports.arrayMove=arrayMove;exports.omit=omit;exports.closest=closest;exports.limit=limit;exports.getElementMargin=getElementMargin;exports.provideDisplayName=provideDisplayName;exports.getPosition=getPosition;exports.isTouchEvent=isTouchEvent;exports.getEdgeOffset=getEdgeOffset;exports.getLockPixelOffset=getLockPixelOffset;var _invariant2=_interopRequireDefault(invariant_1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function arrayMove(arr,previousIndex,newIndex){var array=arr.slice(0);if(newIndex>=array.length){var k=newIndex-array.length;while(k--+1){array.push(undefined);}}array.splice(newIndex,0,array.splice(previousIndex,1)[0]);return array;}function omit(obj){for(var _len=arguments.length,keysToOmit=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){keysToOmit[_key-1]=arguments[_key];}return Object.keys(obj).reduce(function(acc,key){if(keysToOmit.indexOf(key)===-1)acc[key]=obj[key];return acc;},{});}var events=exports.events={start:['touchstart','mousedown'],move:['touchmove','mousemove'],end:['touchend','touchcancel','mouseup']};var vendorPrefix=exports.vendorPrefix=function(){if(typeof window==='undefined'||typeof document==='undefined')return'';// server environment
// fix for:
//    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
//    window.getComputedStyle() returns null inside an iframe with display: none
// in this case return an array with a fake mozilla style in it.
var styles=window.getComputedStyle(document.documentElement,'')||['-moz-hidden-iframe'];var pre=(Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/)||styles.OLink===''&&['','o'])[1];switch(pre){case'ms':return'ms';default:return pre&&pre.length?pre[0].toUpperCase()+pre.substr(1):'';}}();function closest(el,fn){while(el){if(fn(el))return el;el=el.parentNode;}}function limit(min,max,value){if(value<min){return min;}if(value>max){return max;}return value;}function getCSSPixelValue(stringValue){if(stringValue.substr(-2)==='px'){return parseFloat(stringValue);}return 0;}function getElementMargin(element){var style=window.getComputedStyle(element);return{top:getCSSPixelValue(style.marginTop),right:getCSSPixelValue(style.marginRight),bottom:getCSSPixelValue(style.marginBottom),left:getCSSPixelValue(style.marginLeft)};}function provideDisplayName(prefix,Component$$1){var componentName=Component$$1.displayName||Component$$1.name;return componentName?prefix+'('+componentName+')':prefix;}function getPosition(event){if(event.touches&&event.touches.length){return{x:event.touches[0].pageX,y:event.touches[0].pageY};}else if(event.changedTouches&&event.changedTouches.length){return{x:event.changedTouches[0].pageX,y:event.changedTouches[0].pageY};}else{return{x:event.pageX,y:event.pageY};}}function isTouchEvent(event){return event.touches&&event.touches.length||event.changedTouches&&event.changedTouches.length;}function getEdgeOffset(node,parent){var offset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{top:0,left:0};// Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
if(node){var nodeOffset={top:offset.top+node.offsetTop,left:offset.left+node.offsetLeft};if(node.parentNode!==parent){return getEdgeOffset(node.parentNode,parent,nodeOffset);}else{return nodeOffset;}}}function getLockPixelOffset(_ref){var lockOffset=_ref.lockOffset,width=_ref.width,height=_ref.height;var offsetX=lockOffset;var offsetY=lockOffset;var unit='px';if(typeof lockOffset==='string'){var match=/^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);(0, _invariant2.default)(match!==null,'lockOffset value should be a number or a string of a '+'number followed by "px" or "%". Given %s',lockOffset);offsetX=offsetY=parseFloat(lockOffset);unit=match[1];}(0, _invariant2.default)(isFinite(offsetX)&&isFinite(offsetY),'lockOffset value should be a finite. Given %s',lockOffset);if(unit==='%'){offsetX=offsetX*width/100;offsetY=offsetY*height/100;}return{x:offsetX,y:offsetY};}});unwrapExports$1(utils);var utils_1=utils.vendorPrefix;var utils_2=utils.events;var utils_3=utils.arrayMove;var utils_4=utils.omit;var utils_5=utils.closest;var utils_6=utils.limit;var utils_7=utils.getElementMargin;var utils_8=utils.provideDisplayName;var utils_9=utils.getPosition;var utils_10=utils.isTouchEvent;var utils_11=utils.getEdgeOffset;var utils_12=utils.getLockPixelOffset;var Manager_1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Manager=function(){function Manager(){_classCallCheck(this,Manager);this.refs={};}_createClass(Manager,[{key:"add",value:function add(collection,ref){if(!this.refs[collection]){this.refs[collection]=[];}this.refs[collection].push(ref);}},{key:"remove",value:function remove(collection,ref){var index=this.getIndex(collection,ref);if(index!==-1){this.refs[collection].splice(index,1);}}},{key:"isActive",value:function isActive(){return this.active;}},{key:"getActive",value:function getActive(){var _this=this;return this.refs[this.active.collection].find(// eslint-disable-next-line eqeqeq
function(_ref){var node=_ref.node;return node.sortableInfo.index==_this.active.index;});}},{key:"getIndex",value:function getIndex(collection,ref){return this.refs[collection].indexOf(ref);}},{key:"getOrderedRefs",value:function getOrderedRefs(){var collection=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.active.collection;return this.refs[collection].sort(sortByIndex);}}]);return Manager;}();exports.default=Manager;function sortByIndex(_ref2,_ref3){var index1=_ref2.node.sortableInfo.index;var index2=_ref3.node.sortableInfo.index;return index1-index2;}});unwrapExports$1(Manager_1);var SortableContainer=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _extends$$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=sortableContainer;var _react2=_interopRequireDefault(React);var _propTypes2=_interopRequireDefault(PropTypes);var _invariant2=_interopRequireDefault(invariant_1);var _Manager2=_interopRequireDefault(Manager_1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent){var _class,_temp;var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{withRef:false};return _temp=_class=function(_Component){_inherits(_class,_Component);function _class(props){_classCallCheck(this,_class);var _this=_possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).call(this,props));_this.handleStart=function(event){var _this$props=_this.props,distance=_this$props.distance,shouldCancelStart=_this$props.shouldCancelStart;if(event.button===2||shouldCancelStart(event)){return false;}_this._touched=true;_this._pos=(0, utils.getPosition)(event);var node=(0, utils.closest)(event.target,function(el){return el.sortableInfo!=null;});if(node&&node.sortableInfo&&_this.nodeIsChild(node)&&!_this.state.sorting){var useDragHandle=_this.props.useDragHandle;var _node$sortableInfo=node.sortableInfo,index=_node$sortableInfo.index,collection=_node$sortableInfo.collection;if(useDragHandle&&!(0, utils.closest)(event.target,function(el){return el.sortableHandle!=null;}))return;_this.manager.active={index:index,collection:collection};/*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */if(!(0, utils.isTouchEvent)(event)&&event.target.tagName.toLowerCase()==='a'){event.preventDefault();}if(!distance){if(_this.props.pressDelay===0){_this.handlePress(event);}else{_this.pressTimer=setTimeout(function(){return _this.handlePress(event);},_this.props.pressDelay);}}}};_this.nodeIsChild=function(node){return node.sortableInfo.manager===_this.manager;};_this.handleMove=function(event){var _this$props2=_this.props,distance=_this$props2.distance,pressThreshold=_this$props2.pressThreshold;if(!_this.state.sorting&&_this._touched){var position=(0, utils.getPosition)(event);var delta=_this._delta={x:_this._pos.x-position.x,y:_this._pos.y-position.y};var combinedDelta=Math.abs(delta.x)+Math.abs(delta.y);if(!distance&&(!pressThreshold||pressThreshold&&combinedDelta>=pressThreshold)){clearTimeout(_this.cancelTimer);_this.cancelTimer=setTimeout(_this.cancel,0);}else if(distance&&combinedDelta>=distance&&_this.manager.isActive()){_this.handlePress(event);}}};_this.handleEnd=function(){var distance=_this.props.distance;_this._touched=false;if(!distance){_this.cancel();}};_this.cancel=function(){if(!_this.state.sorting){clearTimeout(_this.pressTimer);_this.manager.active=null;}};_this.handlePress=function(event){var active=_this.manager.getActive();if(active){var _this$props3=_this.props,axis=_this$props3.axis,getHelperDimensions=_this$props3.getHelperDimensions,helperClass=_this$props3.helperClass,hideSortableGhost=_this$props3.hideSortableGhost,onSortStart=_this$props3.onSortStart,useWindowAsScrollContainer=_this$props3.useWindowAsScrollContainer;var node=active.node,collection=active.collection;var index=node.sortableInfo.index;var margin=(0, utils.getElementMargin)(node);var containerBoundingRect=_this.container.getBoundingClientRect();var dimensions=getHelperDimensions({index:index,node:node,collection:collection});_this.node=node;_this.margin=margin;_this.width=dimensions.width;_this.height=dimensions.height;_this.marginOffset={x:_this.margin.left+_this.margin.right,y:Math.max(_this.margin.top,_this.margin.bottom)};_this.boundingClientRect=node.getBoundingClientRect();_this.containerBoundingRect=containerBoundingRect;_this.index=index;_this.newIndex=index;_this.axis={x:axis.indexOf('x')>=0,y:axis.indexOf('y')>=0};_this.offsetEdge=(0, utils.getEdgeOffset)(node,_this.container);_this.initialOffset=(0, utils.getPosition)(event);_this.initialScroll={top:_this.container.scrollTop,left:_this.container.scrollLeft};_this.initialWindowScroll={top:window.pageYOffset,left:window.pageXOffset};var fields=node.querySelectorAll('input, textarea, select');var clonedNode=node.cloneNode(true);var clonedFields=[].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select')));// Convert NodeList to Array
clonedFields.forEach(function(field,index){if(field.type!=='file'&&fields[index]){field.value=fields[index].value;}});_this.helper=_this.document.body.appendChild(clonedNode);_this.helper.style.position='fixed';_this.helper.style.top=_this.boundingClientRect.top-margin.top+'px';_this.helper.style.left=_this.boundingClientRect.left-margin.left+'px';_this.helper.style.width=_this.width+'px';_this.helper.style.height=_this.height+'px';_this.helper.style.boxSizing='border-box';_this.helper.style.pointerEvents='none';if(hideSortableGhost){_this.sortableGhost=node;node.style.visibility='hidden';node.style.opacity=0;}_this.minTranslate={};_this.maxTranslate={};if(_this.axis.x){_this.minTranslate.x=(useWindowAsScrollContainer?0:containerBoundingRect.left)-_this.boundingClientRect.left-_this.width/2;_this.maxTranslate.x=(useWindowAsScrollContainer?_this.contentWindow.innerWidth:containerBoundingRect.left+containerBoundingRect.width)-_this.boundingClientRect.left-_this.width/2;}if(_this.axis.y){_this.minTranslate.y=(useWindowAsScrollContainer?0:containerBoundingRect.top)-_this.boundingClientRect.top-_this.height/2;_this.maxTranslate.y=(useWindowAsScrollContainer?_this.contentWindow.innerHeight:containerBoundingRect.top+containerBoundingRect.height)-_this.boundingClientRect.top-_this.height/2;}if(helperClass){var _this$helper$classLis;(_this$helper$classLis=_this.helper.classList).add.apply(_this$helper$classLis,_toConsumableArray(helperClass.split(' ')));}_this.listenerNode=event.touches?node:_this.contentWindow;utils.events.move.forEach(function(eventName){return _this.listenerNode.addEventListener(eventName,_this.handleSortMove,false);});utils.events.end.forEach(function(eventName){return _this.listenerNode.addEventListener(eventName,_this.handleSortEnd,false);});_this.setState({sorting:true,sortingIndex:index});if(onSortStart){onSortStart({node:node,index:index,collection:collection},event);}}};_this.handleSortMove=function(event){var onSortMove=_this.props.onSortMove;event.preventDefault();// Prevent scrolling on mobile
_this.updatePosition(event);_this.animateNodes();_this.autoscroll();if(onSortMove){onSortMove(event);}};_this.handleSortEnd=function(event){var _this$props4=_this.props,hideSortableGhost=_this$props4.hideSortableGhost,onSortEnd=_this$props4.onSortEnd;var collection=_this.manager.active.collection;// Remove the event listeners if the node is still in the DOM
if(_this.listenerNode){utils.events.move.forEach(function(eventName){return _this.listenerNode.removeEventListener(eventName,_this.handleSortMove);});utils.events.end.forEach(function(eventName){return _this.listenerNode.removeEventListener(eventName,_this.handleSortEnd);});}// Remove the helper from the DOM
_this.helper.parentNode.removeChild(_this.helper);if(hideSortableGhost&&_this.sortableGhost){_this.sortableGhost.style.visibility='';_this.sortableGhost.style.opacity='';}var nodes=_this.manager.refs[collection];for(var i=0,len=nodes.length;i<len;i++){var node=nodes[i];var el=node.node;// Clear the cached offsetTop / offsetLeft value
node.edgeOffset=null;// Remove the transforms / transitions
el.style[utils.vendorPrefix+'Transform']='';el.style[utils.vendorPrefix+'TransitionDuration']='';}// Stop autoscroll
clearInterval(_this.autoscrollInterval);_this.autoscrollInterval=null;// Update state
_this.manager.active=null;_this.setState({sorting:false,sortingIndex:null});if(typeof onSortEnd==='function'){onSortEnd({oldIndex:_this.index,newIndex:_this.newIndex,collection:collection},event);}_this._touched=false;};_this.autoscroll=function(){var translate=_this.translate;var direction={x:0,y:0};var speed={x:1,y:1};var acceleration={x:10,y:10};if(translate.y>=_this.maxTranslate.y-_this.height/2){direction.y=1;// Scroll Down
speed.y=acceleration.y*Math.abs((_this.maxTranslate.y-_this.height/2-translate.y)/_this.height);}else if(translate.x>=_this.maxTranslate.x-_this.width/2){direction.x=1;// Scroll Right
speed.x=acceleration.x*Math.abs((_this.maxTranslate.x-_this.width/2-translate.x)/_this.width);}else if(translate.y<=_this.minTranslate.y+_this.height/2){direction.y=-1;// Scroll Up
speed.y=acceleration.y*Math.abs((translate.y-_this.height/2-_this.minTranslate.y)/_this.height);}else if(translate.x<=_this.minTranslate.x+_this.width/2){direction.x=-1;// Scroll Left
speed.x=acceleration.x*Math.abs((translate.x-_this.width/2-_this.minTranslate.x)/_this.width);}if(_this.autoscrollInterval){clearInterval(_this.autoscrollInterval);_this.autoscrollInterval=null;_this.isAutoScrolling=false;}if(direction.x!==0||direction.y!==0){_this.autoscrollInterval=setInterval(function(){_this.isAutoScrolling=true;var offset={left:1*speed.x*direction.x,top:1*speed.y*direction.y};_this.scrollContainer.scrollTop+=offset.top;_this.scrollContainer.scrollLeft+=offset.left;_this.translate.x+=offset.left;_this.translate.y+=offset.top;_this.animateNodes();},5);}};_this.manager=new _Manager2.default();_this.events={start:_this.handleStart,move:_this.handleMove,end:_this.handleEnd};(0, _invariant2.default)(!(props.distance&&props.pressDelay),'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');_this.state={};return _this;}_createClass(_class,[{key:'getChildContext',value:function getChildContext(){return{manager:this.manager};}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var useWindowAsScrollContainer=this.props.useWindowAsScrollContainer;/*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */var container=this.getContainer();Promise.resolve(container).then(function(containerNode){_this2.container=containerNode;_this2.document=_this2.container.ownerDocument||document;var contentWindow=_this2.props.contentWindow||_this2.document.defaultView||window;_this2.contentWindow=typeof contentWindow==='function'?contentWindow():contentWindow;_this2.scrollContainer=useWindowAsScrollContainer?_this2.document.scrollingElement||_this2.document.documentElement:_this2.container;var _loop=function _loop(key){if(_this2.events.hasOwnProperty(key)){utils.events[key].forEach(function(eventName){return _this2.container.addEventListener(eventName,_this2.events[key],false);});}};for(var key in _this2.events){_loop(key);}});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this3=this;if(this.container){var _loop2=function _loop2(key){if(_this3.events.hasOwnProperty(key)){utils.events[key].forEach(function(eventName){return _this3.container.removeEventListener(eventName,_this3.events[key]);});}};for(var key in this.events){_loop2(key);}}}},{key:'getLockPixelOffsets',value:function getLockPixelOffsets(){var width=this.width,height=this.height;var lockOffset=this.props.lockOffset;var offsets=Array.isArray(lockOffset)?lockOffset:[lockOffset,lockOffset];(0, _invariant2.default)(offsets.length===2,'lockOffset prop of SortableContainer should be a single '+'value or an array of exactly two values. Given %s',lockOffset);var _offsets=_slicedToArray(offsets,2),minLockOffset=_offsets[0],maxLockOffset=_offsets[1];return[(0, utils.getLockPixelOffset)({lockOffset:minLockOffset,width:width,height:height}),(0, utils.getLockPixelOffset)({lockOffset:maxLockOffset,width:width,height:height})];}},{key:'updatePosition',value:function updatePosition(event){var _props=this.props,lockAxis=_props.lockAxis,lockToContainerEdges=_props.lockToContainerEdges;var offset=(0, utils.getPosition)(event);var translate={x:offset.x-this.initialOffset.x,y:offset.y-this.initialOffset.y};// Adjust for window scroll
translate.y-=window.pageYOffset-this.initialWindowScroll.top;translate.x-=window.pageXOffset-this.initialWindowScroll.left;this.translate=translate;if(lockToContainerEdges){var _getLockPixelOffsets=this.getLockPixelOffsets(),_getLockPixelOffsets2=_slicedToArray(_getLockPixelOffsets,2),minLockOffset=_getLockPixelOffsets2[0],maxLockOffset=_getLockPixelOffsets2[1];var minOffset={x:this.width/2-minLockOffset.x,y:this.height/2-minLockOffset.y};var maxOffset={x:this.width/2-maxLockOffset.x,y:this.height/2-maxLockOffset.y};translate.x=(0, utils.limit)(this.minTranslate.x+minOffset.x,this.maxTranslate.x-maxOffset.x,translate.x);translate.y=(0, utils.limit)(this.minTranslate.y+minOffset.y,this.maxTranslate.y-maxOffset.y,translate.y);}if(lockAxis==='x'){translate.y=0;}else if(lockAxis==='y'){translate.x=0;}this.helper.style[utils.vendorPrefix+'Transform']='translate3d('+translate.x+'px,'+translate.y+'px, 0)';}},{key:'animateNodes',value:function animateNodes(){var _props2=this.props,transitionDuration=_props2.transitionDuration,hideSortableGhost=_props2.hideSortableGhost,onSortOver=_props2.onSortOver;var nodes=this.manager.getOrderedRefs();var containerScrollDelta={left:this.container.scrollLeft-this.initialScroll.left,top:this.container.scrollTop-this.initialScroll.top};var sortingOffset={left:this.offsetEdge.left+this.translate.x+containerScrollDelta.left,top:this.offsetEdge.top+this.translate.y+containerScrollDelta.top};var windowScrollDelta={top:window.pageYOffset-this.initialWindowScroll.top,left:window.pageXOffset-this.initialWindowScroll.left};var prevIndex=this.newIndex;this.newIndex=null;for(var i=0,len=nodes.length;i<len;i++){var node=nodes[i].node;var index=node.sortableInfo.index;var width=node.offsetWidth;var height=node.offsetHeight;var offset={width:this.width>width?width/2:this.width/2,height:this.height>height?height/2:this.height/2};var translate={x:0,y:0};var edgeOffset=nodes[i].edgeOffset;// If we haven't cached the node's offsetTop / offsetLeft value
if(!edgeOffset){nodes[i].edgeOffset=edgeOffset=(0, utils.getEdgeOffset)(node,this.container);}// Get a reference to the next and previous node
var nextNode=i<nodes.length-1&&nodes[i+1];var prevNode=i>0&&nodes[i-1];// Also cache the next node's edge offset if needed.
// We need this for calculating the animation in a grid setup
if(nextNode&&!nextNode.edgeOffset){nextNode.edgeOffset=(0, utils.getEdgeOffset)(nextNode.node,this.container);}// If the node is the one we're currently animating, skip it
if(index===this.index){if(hideSortableGhost){/*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */this.sortableGhost=node;node.style.visibility='hidden';node.style.opacity=0;}continue;}if(transitionDuration){node.style[utils.vendorPrefix+'TransitionDuration']=transitionDuration+'ms';}if(this.axis.x){if(this.axis.y){// Calculations for a grid setup
if(index<this.index&&(sortingOffset.left+windowScrollDelta.left-offset.width<=edgeOffset.left&&sortingOffset.top+windowScrollDelta.top<=edgeOffset.top+offset.height||sortingOffset.top+windowScrollDelta.top+offset.height<=edgeOffset.top)){// If the current node is to the left on the same row, or above the node that's being dragged
// then move it to the right
translate.x=this.width+this.marginOffset.x;if(edgeOffset.left+translate.x>this.containerBoundingRect.width-offset.width){// If it moves passed the right bounds, then animate it to the first position of the next row.
// We just use the offset of the next node to calculate where to move, because that node's original position
// is exactly where we want to go
translate.x=nextNode.edgeOffset.left-edgeOffset.left;translate.y=nextNode.edgeOffset.top-edgeOffset.top;}if(this.newIndex===null){this.newIndex=index;}}else if(index>this.index&&(sortingOffset.left+windowScrollDelta.left+offset.width>=edgeOffset.left&&sortingOffset.top+windowScrollDelta.top+offset.height>=edgeOffset.top||sortingOffset.top+windowScrollDelta.top+offset.height>=edgeOffset.top+height)){// If the current node is to the right on the same row, or below the node that's being dragged
// then move it to the left
translate.x=-(this.width+this.marginOffset.x);if(edgeOffset.left+translate.x<this.containerBoundingRect.left+offset.width){// If it moves passed the left bounds, then animate it to the last position of the previous row.
// We just use the offset of the previous node to calculate where to move, because that node's original position
// is exactly where we want to go
translate.x=prevNode.edgeOffset.left-edgeOffset.left;translate.y=prevNode.edgeOffset.top-edgeOffset.top;}this.newIndex=index;}}else{if(index>this.index&&sortingOffset.left+windowScrollDelta.left+offset.width>=edgeOffset.left){translate.x=-(this.width+this.marginOffset.x);this.newIndex=index;}else if(index<this.index&&sortingOffset.left+windowScrollDelta.left<=edgeOffset.left+offset.width){translate.x=this.width+this.marginOffset.x;if(this.newIndex==null){this.newIndex=index;}}}}else if(this.axis.y){if(index>this.index&&sortingOffset.top+windowScrollDelta.top+offset.height>=edgeOffset.top){translate.y=-(this.height+this.marginOffset.y);this.newIndex=index;}else if(index<this.index&&sortingOffset.top+windowScrollDelta.top<=edgeOffset.top+offset.height){translate.y=this.height+this.marginOffset.y;if(this.newIndex==null){this.newIndex=index;}}}node.style[utils.vendorPrefix+'Transform']='translate3d('+translate.x+'px,'+translate.y+'px,0)';}if(this.newIndex==null){this.newIndex=this.index;}if(onSortOver&&this.newIndex!==prevIndex){onSortOver({newIndex:this.newIndex,oldIndex:prevIndex,index:this.index,collection:this.manager.active.collection});}}},{key:'getWrappedInstance',value:function getWrappedInstance(){(0, _invariant2.default)(config.withRef,'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');return this.refs.wrappedInstance;}},{key:'getContainer',value:function getContainer(){var getContainer=this.props.getContainer;if(typeof getContainer!=='function'){return(0, _reactDom.findDOMNode)(this);}return getContainer(config.withRef?this.getWrappedInstance():undefined);}},{key:'render',value:function render(){var ref=config.withRef?'wrappedInstance':null;return _react2.default.createElement(WrappedComponent,_extends$$1({ref:ref},(0, utils.omit)(this.props,'contentWindow','useWindowAsScrollContainer','distance','helperClass','hideSortableGhost','transitionDuration','useDragHandle','pressDelay','pressThreshold','shouldCancelStart','onSortStart','onSortMove','onSortEnd','axis','lockAxis','lockOffset','lockToContainerEdges','getContainer','getHelperDimensions')));}}]);return _class;}(React.Component), _class.displayName=(0, utils.provideDisplayName)('sortableList',WrappedComponent), _class.defaultProps={axis:'y',transitionDuration:300,pressDelay:0,pressThreshold:5,distance:0,useWindowAsScrollContainer:false,hideSortableGhost:true,shouldCancelStart:function shouldCancelStart(e){// Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
var disabledElements=['input','textarea','select','option','button'];if(disabledElements.indexOf(e.target.tagName.toLowerCase())!==-1){return true;// Return true to cancel sorting
}},lockToContainerEdges:false,lockOffset:'50%',getHelperDimensions:function getHelperDimensions(_ref){var node=_ref.node;return{width:node.offsetWidth,height:node.offsetHeight};}}, _class.propTypes={axis:_propTypes2.default.oneOf(['x','y','xy']),distance:_propTypes2.default.number,lockAxis:_propTypes2.default.string,helperClass:_propTypes2.default.string,transitionDuration:_propTypes2.default.number,contentWindow:_propTypes2.default.any,onSortStart:_propTypes2.default.func,onSortMove:_propTypes2.default.func,onSortOver:_propTypes2.default.func,onSortEnd:_propTypes2.default.func,shouldCancelStart:_propTypes2.default.func,pressDelay:_propTypes2.default.number,useDragHandle:_propTypes2.default.bool,useWindowAsScrollContainer:_propTypes2.default.bool,hideSortableGhost:_propTypes2.default.bool,lockToContainerEdges:_propTypes2.default.bool,lockOffset:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]))]),getContainer:_propTypes2.default.func,getHelperDimensions:_propTypes2.default.func}, _class.childContextTypes={manager:_propTypes2.default.object.isRequired}, _temp;}});unwrapExports$1(SortableContainer);var SortableElement=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _extends$$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=sortableElement;var _react2=_interopRequireDefault(React);var _propTypes2=_interopRequireDefault(PropTypes);var _invariant2=_interopRequireDefault(invariant_1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent){var _class,_temp;var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{withRef:false};return _temp=_class=function(_Component){_inherits(_class,_Component);function _class(){_classCallCheck(this,_class);return _possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).apply(this,arguments));}_createClass(_class,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,collection=_props.collection,disabled=_props.disabled,index=_props.index;if(!disabled){this.setDraggable(collection,index);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.index!==nextProps.index&&this.node){this.node.sortableInfo.index=nextProps.index;}if(this.props.disabled!==nextProps.disabled){var collection=nextProps.collection,disabled=nextProps.disabled,index=nextProps.index;if(disabled){this.removeDraggable(collection);}else{this.setDraggable(collection,index);}}else if(this.props.collection!==nextProps.collection){this.removeDraggable(this.props.collection);this.setDraggable(nextProps.collection,nextProps.index);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _props2=this.props,collection=_props2.collection,disabled=_props2.disabled;if(!disabled)this.removeDraggable(collection);}},{key:'setDraggable',value:function setDraggable(collection,index){var node=this.node=(0, _reactDom.findDOMNode)(this);node.sortableInfo={index:index,collection:collection,manager:this.context.manager};this.ref={node:node};this.context.manager.add(collection,this.ref);}},{key:'removeDraggable',value:function removeDraggable(collection){this.context.manager.remove(collection,this.ref);}},{key:'getWrappedInstance',value:function getWrappedInstance(){(0, _invariant2.default)(config.withRef,'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');return this.refs.wrappedInstance;}},{key:'render',value:function render(){var ref=config.withRef?'wrappedInstance':null;return _react2.default.createElement(WrappedComponent,_extends$$1({ref:ref},(0, utils.omit)(this.props,'collection','disabled','index')));}}]);return _class;}(React.Component), _class.displayName=(0, utils.provideDisplayName)('sortableElement',WrappedComponent), _class.contextTypes={manager:_propTypes2.default.object.isRequired}, _class.propTypes={index:_propTypes2.default.number.isRequired,collection:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]),disabled:_propTypes2.default.bool}, _class.defaultProps={collection:0}, _temp;}});unwrapExports$1(SortableElement);var SortableHandle=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _extends$$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=sortableHandle;var _react2=_interopRequireDefault(React);var _invariant2=_interopRequireDefault(invariant_1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent){var _class,_temp;var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{withRef:false};return _temp=_class=function(_Component){_inherits(_class,_Component);function _class(){_classCallCheck(this,_class);return _possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).apply(this,arguments));}_createClass(_class,[{key:'componentDidMount',value:function componentDidMount(){var node=(0, _reactDom.findDOMNode)(this);node.sortableHandle=true;}},{key:'getWrappedInstance',value:function getWrappedInstance(){(0, _invariant2.default)(config.withRef,'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');return this.refs.wrappedInstance;}},{key:'render',value:function render(){var ref=config.withRef?'wrappedInstance':null;return _react2.default.createElement(WrappedComponent,_extends$$1({ref:ref},this.props));}}]);return _class;}(React.Component), _class.displayName=(0, utils.provideDisplayName)('sortableHandle',WrappedComponent), _temp;}});unwrapExports$1(SortableHandle);var commonjs=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.arrayMove=exports.sortableHandle=exports.sortableElement=exports.sortableContainer=exports.SortableHandle=exports.SortableElement=exports.SortableContainer=undefined;Object.defineProperty(exports,'arrayMove',{enumerable:true,get:function get$$1(){return utils.arrayMove;}});var _SortableContainer3=_interopRequireDefault(SortableContainer);var _SortableElement3=_interopRequireDefault(SortableElement);var _SortableHandle3=_interopRequireDefault(SortableHandle);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.SortableContainer=_SortableContainer3.default;exports.SortableElement=_SortableElement3.default;exports.SortableHandle=_SortableHandle3.default;exports.sortableContainer=_SortableContainer3.default;exports.sortableElement=_SortableElement3.default;exports.sortableHandle=_SortableHandle3.default;});unwrapExports$1(commonjs);var commonjs_1=commonjs.arrayMove;var commonjs_2=commonjs.sortableHandle;var commonjs_3=commonjs.sortableElement;var commonjs_4=commonjs.sortableContainer;var commonjs_5=commonjs.SortableHandle;var commonjs_6=commonjs.SortableElement;var commonjs_7=commonjs.SortableContainer;var formatTitle$1=compose$1(titleCase$1,lowerCase$1);var mapIndexed$1=addIndex$1(map$1);var compact$1=filter$1(identity$1);var move=commonjs_1;var _typeof$1$1=typeof Symbol==="function"&&_typeof(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof(obj);};var classCallCheck$2=function classCallCheck$$1(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}};var createClass$2=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends$1$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var inherits$2=function inherits$$1(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;};var possibleConstructorReturn$2=function possibleConstructorReturn$$1(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof(call))==="object"||typeof call==="function")?call:self;};var taggedTemplateLiteral$2=function taggedTemplateLiteral$$1(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));};function unwrapExports$1$1(x){return x&&x.__esModule&&Object.prototype.hasOwnProperty.call(x,'default')?x['default']:x;}function createCommonjsModule$1$2(fn,module){return module={exports:{}}, fn(module,module.exports), module.exports;}var _const$3=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});/**
   * A regular expression string matching digits
   *
   * @type {string}
   * @ignore
   */var digit=exports.digit='\\d';/**
   * A regular expression string matching whitespace
   *
   * @type {string}
   * @ignore
   */var whitespace=exports.whitespace='\\s\\uFEFF\\xA0';/**
   * A regular expression string matching high surrogate
   *
   * @type {string}
   * @ignore
   */var highSurrogate=exports.highSurrogate='\\uD800-\\uDBFF';/**
   * A regular expression string matching low surrogate
   *
   * @type {string}
   * @ignore
   */var lowSurrogate=exports.lowSurrogate='\\uDC00-\\uDFFF';/**
   * A regular expression string matching diacritical mark
   *
   * @type {string}
   * @ignore
   */var diacriticalMark=exports.diacriticalMark='\\u0300-\\u036F\\u1AB0-\\u1AFF\\u1DC0-\\u1DFF\\u20D0-\\u20FF\\uFE20-\\uFE2F';/**
   * A regular expression to match the base character for a combining mark
   *
   * @type {string}
   * @ignore
   */var base=exports.base='\\0-\\u02FF\\u0370-\\u1AAF\\u1B00-\\u1DBF\\u1E00-\\u20CF\\u2100-\\uD7FF\\uE000-\\uFE1F\\uFE30-\\uFFFF';/**
   * Regular expression to match combining marks
   *
   * @see http://unicode.org/faq/char_combmark.html
   * @type {RegExp}
   * @ignore
   */var REGEXP_COMBINING_MARKS=exports.REGEXP_COMBINING_MARKS=new RegExp('(['+base+']|['+highSurrogate+']['+lowSurrogate+']|['+highSurrogate+'](?!['+lowSurrogate+'])|(?:[^'+highSurrogate+']|^)['+lowSurrogate+'])(['+diacriticalMark+']+)','g');/**
   * Regular expression to match surrogate pairs
   *
   * @see http://www.unicode.org/faq/utf_bom.html#utf16-2
   * @type {RegExp}
   * @ignore
   */var REGEXP_SURROGATE_PAIRS=exports.REGEXP_SURROGATE_PAIRS=new RegExp('(['+highSurrogate+'])(['+lowSurrogate+'])','g');/**
   * Regular expression to match a unicode character
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_UNICODE_CHARACTER=exports.REGEXP_UNICODE_CHARACTER=new RegExp('((?:['+base+']|['+highSurrogate+']['+lowSurrogate+']|['+highSurrogate+'](?!['+lowSurrogate+'])|(?:[^'+highSurrogate+']|^)['+lowSurrogate+'])(?:['+diacriticalMark+']+))|\
(['+highSurrogate+']['+lowSurrogate+'])|([\\n\\r\\u2028\\u2029])|(.)','g');/**
   * Regular expression to match whitespaces
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_WHITESPACE=exports.REGEXP_WHITESPACE=new RegExp('['+whitespace+']');/**
   * Regular expression to match whitespaces from the left side
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_TRIM_LEFT=exports.REGEXP_TRIM_LEFT=new RegExp('^['+whitespace+']+');/**
   * Regular expression to match whitespaces from the right side
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_TRIM_RIGHT=exports.REGEXP_TRIM_RIGHT=new RegExp('['+whitespace+']+$');/**
   * Regular expression to match digit characters
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_DIGIT=exports.REGEXP_DIGIT=new RegExp('^'+digit+'+$');/**
   * Regular expression to match regular expression special characters
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_SPECIAL_CHARACTERS=exports.REGEXP_SPECIAL_CHARACTERS=/[-[\]{}()*+!<=:?./\\^$|#,]/g;/**
   * Regular expression to match not latin characters
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_NON_LATIN=exports.REGEXP_NON_LATIN=/[^A-Za-z0-9]/g;/**
   * Regular expression to match HTML special characters.
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_HTML_SPECIAL_CHARACTERS=exports.REGEXP_HTML_SPECIAL_CHARACTERS=/[<>&"'`]/g;/**
   * Regular expression to match sprintf format string
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_CONVERSION_SPECIFICATION=exports.REGEXP_CONVERSION_SPECIFICATION=/(%{1,2})(?:(\d+)\$)?(\+)?([ 0]|'.{1})?(-)?(\d+)?(?:\.(\d+))?([bcdiouxXeEfgGs])?/g;/**
   * Regular expression to match trailing zeros in a number
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_TRAILING_ZEROS=exports.REGEXP_TRAILING_ZEROS=/\.?0+$/g;/**
   * Regular expression to match flags from a regular expression.
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_FLAGS=exports.REGEXP_FLAGS=/[gimuy]*$/;/**
   * Regular expression to match a list of tags.
   *
   * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-name
   * @type {RegExp}
   * @ignore
   */var REGEXP_TAG_LIST=exports.REGEXP_TAG_LIST=/<([A-Za-z0-9]+)>/g;});unwrapExports$1$1(_const$3);var _const_1$1$1=_const$3.digit;var _const_2$1$1=_const$3.whitespace;var _const_3$1$1=_const$3.highSurrogate;var _const_4$1$1=_const$3.lowSurrogate;var _const_5$1$1=_const$3.diacriticalMark;var _const_6$1$1=_const$3.base;var _const_7$1$1=_const$3.REGEXP_COMBINING_MARKS;var _const_8$1$1=_const$3.REGEXP_SURROGATE_PAIRS;var _const_9$1$1=_const$3.REGEXP_UNICODE_CHARACTER;var _const_10$1$1=_const$3.REGEXP_WHITESPACE;var _const_11$1$1=_const$3.REGEXP_TRIM_LEFT;var _const_12$1$1=_const$3.REGEXP_TRIM_RIGHT;var _const_13$1$1=_const$3.REGEXP_DIGIT;var _const_14$1$1=_const$3.REGEXP_SPECIAL_CHARACTERS;var _const_15$1$1=_const$3.REGEXP_NON_LATIN;var _const_16$1$1=_const$3.REGEXP_HTML_SPECIAL_CHARACTERS;var _const_17$1$1=_const$3.REGEXP_CONVERSION_SPECIFICATION;var _const_18$1$1=_const$3.REGEXP_TRAILING_ZEROS;var _const_19$1$1=_const$3.REGEXP_FLAGS;var _const_20$1$1=_const$3.REGEXP_TAG_LIST;var const_extended$2=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.REGEXP_EXTENDED_ASCII=exports.REGEXP_ALPHA_DIGIT=exports.REGEXP_ALPHA=exports.REGEXP_LATIN_WORD=exports.REGEXP_WORD=undefined;/**
   * A regular expression to match the General Punctuation Unicode block
   *
   * @type {string}
   * @ignore
   */var generalPunctuationBlock='\\u2000-\\u206F';/**
   * A regular expression to match non characters from from Basic Latin and Latin-1 Supplement Unicode blocks
   *
   * @type {string}
   * @ignore
   */var nonCharacter='\\x00-\\x2F\\x3A-\\x40\\x5B-\\x60\\x7b-\\xBF\\xD7\\xF7';/**
   * A regular expression to match the dingbat Unicode block
   *
   * @type {string}
   * @ignore
   */var dingbatBlock='\\u2700-\\u27BF';/**
   * A regular expression string that matches lower case letters: LATIN
   *
   * @type {string}
   * @ignore
   */var lowerCaseLetter='a-z\\xB5\\xDF-\\xF6\\xF8-\\xFF\\u0101\\u0103\\u0105\\u0107\\u0109\\u010B\\u010D\\u010F\\u0111\\u0113\\u0115\\u0117\\u0119\\u011B\\u011D\\u011F\\u0121\\u0123\\u0125\\u0127\\u0129\\u012B\\u012D\\u012F\\u0131\\u0133\\u0135\\u0137\\u0138\\u013A\\u013C\\u013E\\u0140\\u0142\\u0144\\u0146\\u0148\\u0149\\u014B\\u014D\\u014F\\u0151\\u0153\\u0155\\u0157\\u0159\\u015B\\u015D\\u015F\\u0161\\u0163\\u0165\\u0167\\u0169\\u016B\\u016D\\u016F\\u0171\\u0173\\u0175\\u0177\\u017A\\u017C\\u017E-\\u0180\\u0183\\u0185\\u0188\\u018C\\u018D\\u0192\\u0195\\u0199-\\u019B\\u019E\\u01A1\\u01A3\\u01A5\\u01A8\\u01AA\\u01AB\\u01AD\\u01B0\\u01B4\\u01B6\\u01B9\\u01BA\\u01BD-\\u01BF\\u01C6\\u01C9\\u01CC\\u01CE\\u01D0\\u01D2\\u01D4\\u01D6\\u01D8\\u01DA\\u01DC\\u01DD\\u01DF\\u01E1\\u01E3\\u01E5\\u01E7\\u01E9\\u01EB\\u01ED\\u01EF\\u01F0\\u01F3\\u01F5\\u01F9\\u01FB\\u01FD\\u01FF\\u0201\\u0203\\u0205\\u0207\\u0209\\u020B\\u020D\\u020F\\u0211\\u0213\\u0215\\u0217\\u0219\\u021B\\u021D\\u021F\\u0221\\u0223\\u0225\\u0227\\u0229\\u022B\\u022D\\u022F\\u0231\\u0233-\\u0239\\u023C\\u023F\\u0240\\u0242\\u0247\\u0249\\u024B\\u024D\\u024F';/**
   * A regular expression string that matches upper case letters: LATIN
   *
   * @type {string}
   * @ignore
   */var upperCaseLetter='\\x41-\\x5a\\xc0-\\xd6\\xd8-\\xde\\u0100\\u0102\\u0104\\u0106\\u0108\\u010a\\u010c\\u010e\\u0110\\u0112\\u0114\\u0116\\u0118\\u011a\\u011c\\u011e\\u0120\\u0122\\u0124\\u0126\\u0128\\u012a\\u012c\\u012e\\u0130\\u0132\\u0134\\u0136\\u0139\\u013b\\u013d\\u013f\\u0141\\u0143\\u0145\\u0147\\u014a\\u014c\\u014e\\u0150\\u0152\\u0154\\u0156\\u0158\\u015a\\u015c\\u015e\\u0160\\u0162\\u0164\\u0166\\u0168\\u016a\\u016c\\u016e\\u0170\\u0172\\u0174\\u0176\\u0178\\u0179\\u017b\\u017d\\u0181\\u0182\\u0184\\u0186\\u0187\\u0189-\\u018b\\u018e-\\u0191\\u0193\\u0194\\u0196-\\u0198\\u019c\\u019d\\u019f\\u01a0\\u01a2\\u01a4\\u01a6\\u01a7\\u01a9\\u01ac\\u01ae\\u01af\\u01b1-\\u01b3\\u01b5\\u01b7\\u01b8\\u01bc\\u01c4\\u01c5\\u01c7\\u01c8\\u01ca\\u01cb\\u01cd\\u01cf\\u01d1\\u01d3\\u01d5\\u01d7\\u01d9\\u01db\\u01de\\u01e0\\u01e2\\u01e4\\u01e6\\u01e8\\u01ea\\u01ec\\u01ee\\u01f1\\u01f2\\u01f4\\u01f6-\\u01f8\\u01fa\\u01fc\\u01fe\\u0200\\u0202\\u0204\\u0206\\u0208\\u020a\\u020c\\u020e\\u0210\\u0212\\u0214\\u0216\\u0218\\u021a\\u021c\\u021e\\u0220\\u0222\\u0224\\u0226\\u0228\\u022a\\u022c\\u022e\\u0230\\u0232\\u023a\\u023b\\u023d\\u023e\\u0241\\u0243-\\u0246\\u0248\\u024a\\u024c\\u024e';/**
   * Regular expression to match Unicode words
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_WORD=exports.REGEXP_WORD=new RegExp('(?:['+upperCaseLetter+']['+_const$3.diacriticalMark+']*)?(?:['+lowerCaseLetter+']['+_const$3.diacriticalMark+']*)+|\
(?:['+upperCaseLetter+']['+_const$3.diacriticalMark+']*)+(?!['+lowerCaseLetter+'])|\
['+_const$3.digit+']+|\
['+dingbatBlock+']|\
[^'+nonCharacter+generalPunctuationBlock+_const$3.whitespace+']+','g');/**
   * Regular expression to match words from Basic Latin and Latin-1 Supplement blocks
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_LATIN_WORD=exports.REGEXP_LATIN_WORD=/[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;/**
   * Regular expression to match alpha characters
   *
   * @see http://stackoverflow.com/a/22075070/1894471
   * @type {RegExp}
   * @ignore
   */var REGEXP_ALPHA=exports.REGEXP_ALPHA=new RegExp('^(?:['+lowerCaseLetter+upperCaseLetter+']['+_const$3.diacriticalMark+']*)+$');/**
   * Regular expression to match alpha and digit characters
   *
   * @see http://stackoverflow.com/a/22075070/1894471
   * @type {RegExp}
   * @ignore
   */var REGEXP_ALPHA_DIGIT=exports.REGEXP_ALPHA_DIGIT=new RegExp('^((?:['+lowerCaseLetter+upperCaseLetter+']['+_const$3.diacriticalMark+']*)|['+_const$3.digit+'])+$');/**
   * Regular expression to match Extended ASCII characters, i.e. the first 255
   *
   * @type {RegExp}
   * @ignore
   */var REGEXP_EXTENDED_ASCII=exports.REGEXP_EXTENDED_ASCII=/^[\x01-\xFF]*$/;});unwrapExports$1$1(const_extended$2);var const_extended_1$1$1=const_extended$2.REGEXP_EXTENDED_ASCII;var const_extended_2$1$1=const_extended$2.REGEXP_ALPHA_DIGIT;var const_extended_3$1$1=const_extended$2.REGEXP_ALPHA;var const_extended_4$1$1=const_extended$2.REGEXP_LATIN_WORD;var const_extended_5$1$1=const_extended$2.REGEXP_WORD;var is_nil$2=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=isNil;/**
   * Checks if `value` is `null` or `undefined`
   *
   * @ignore
   * @function isNil
   * @param {*} value The object to check
   * @return {boolean} Returns `true` is `value` is `undefined` or `null`, `false` otherwise
   */function isNil(value){return value===undefined||value===null;}module.exports=exports["default"];});unwrapExports$1$1(is_nil$2);var coerce_to_boolean$2=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=coerceToBoolean;var _is_nil2=_interopRequireDefault(is_nil$2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
   * Converts the `value` to a boolean. If `value` is `undefined` or `null`, returns `defaultValue`.
   *
   * @ignore
   * @function toBoolean
   * @param {*} value The value to convert.
   * @param {boolean} [defaultValue=false] The default value.
   * @return {boolean} Returns the coercion to boolean.
   */function coerceToBoolean(value){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if((0, _is_nil2.default)(value)){return defaultValue;}return Boolean(value);}module.exports=exports['default'];});unwrapExports$1$1(coerce_to_boolean$2);var is_string$2=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=isString;/**
   * Checks whether `subject` is a string primitive type.
   *
   * @function isString
   * @static
   * @since 1.0.0
   * @memberOf Query
   * @param {string} subject The value to verify.
   * @return {boolean} Returns `true` if `subject` is string primitive type or `false` otherwise.
   * @example
   * v.isString('vacation');
   * // => true
   *
   * v.isString(560);
   * // => false
   */function isString(subject){return typeof subject==='string';}module.exports=exports['default'];});unwrapExports$1$1(is_string$2);var coerce_to_string$2=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=coerceToString;var _is_nil2=_interopRequireDefault(is_nil$2);var _is_string2=_interopRequireDefault(is_string$2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
   * Get the string representation of the `value`.
   * Converts the `value` to string.
   * If `value` is `null` or `undefined`, return `defaultValue`.
   *
   * @ignore
   * @function toString
   * @param {*} value             The value to convert.
   * @param {*} [defaultValue=''] The default value to return.
   * @return {string|null}        Returns the string representation of `value`. Returns `defaultValue` if `value` is
   *                              `null` or `undefined`.
   */function coerceToString(value){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';if((0, _is_nil2.default)(value)){return defaultValue;}if((0, _is_string2.default)(value)){return value;}return String(value);}module.exports=exports['default'];});unwrapExports$1$1(coerce_to_string$2);var capitalize_1$1$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=capitalize;var _coerce_to_boolean2=_interopRequireDefault(coerce_to_boolean$2);var _coerce_to_string2=_interopRequireDefault(coerce_to_string$2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
   * Converts the first character of `subject` to upper case. If `restToLower` is `true`, convert the rest of
   * `subject` to lower case.
   *
   * @function capitalize
   * @static
   * @since 1.0.0
   * @memberOf Case
   * @param  {string}  [subject='']        The string to capitalize.
   * @param  {boolean} [restToLower=false] Convert the rest of `subject` to lower case.
   * @return {string}                      Returns the capitalized string.
   * @example
   * v.capitalize('apple');
   * // => 'Apple'
   *
   * v.capitalize('aPPle', true);
   * // => 'Apple'
   */function capitalize(subject,restToLower){var subjectString=(0, _coerce_to_string2.default)(subject);var restToLowerCaseBoolean=(0, _coerce_to_boolean2.default)(restToLower);if(subjectString===''){return'';}if(restToLowerCaseBoolean){subjectString=subjectString.toLowerCase();}return subjectString.substr(0,1).toUpperCase()+subjectString.substr(1);}module.exports=exports['default'];});unwrapExports$1$1(capitalize_1$1$1);var title_case$1$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=titleCase;var _capitalize2=_interopRequireDefault(capitalize_1$1$1);var _coerce_to_string2=_interopRequireDefault(coerce_to_string$2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
   * Converts the subject to title case.
   *
   * @function titleCase
   * @static
   * @since 1.4.0
   * @memberOf Case
   * @param  {string} [subject=''] The string to convert to title case.
   * @param  {Array}  [noSplit]    Do not split words at the specified characters.
   * @return {string}              Returns the title case string.
   * @example
   * v.titleCase('learning to fly');
   * // => 'Learning To Fly'
   *
   * v.titleCase('jean-luc is good-looking', ['-']);
   * // => 'Jean-luc Is Good-looking'
   */function titleCase(subject,noSplit){var subjectString=(0, _coerce_to_string2.default)(subject);var noSplitArray=Array.isArray(noSplit)?noSplit:[];var wordsRegExp=const_extended$2.REGEXP_EXTENDED_ASCII.test(subjectString)?const_extended$2.REGEXP_LATIN_WORD:const_extended$2.REGEXP_WORD;return subjectString.replace(wordsRegExp,function(word,index){var isNoSplit=index>0&&noSplitArray.indexOf(subjectString[index-1])>=0;return isNoSplit?word.toLowerCase():(0, _capitalize2.default)(word,true);});}module.exports=exports['default'];});var titleCase$1$1=unwrapExports$1$1(title_case$1$1);var lower_case$1$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.default=lowerCase;var _coerce_to_string2=_interopRequireDefault(coerce_to_string$2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
   * Converts the `subject` to lower case.
   *
   * @function lowerCase
   * @static
   * @since 1.0.0
   * @memberOf Case
   * @param  {string} [subject=''] The string to convert to lower case.
   * @return {string}              Returns the lower case string.
   * @example
   * v.lowerCase('Green');
   * // => 'green'
   *
   * v.lowerCase('BLUE');
   * // => 'blue'
   */function lowerCase(subject){var subjectString=(0, _coerce_to_string2.default)(subject,'');return subjectString.toLowerCase();}module.exports=exports['default'];});var lowerCase$1$1=unwrapExports$1$1(lower_case$1$1);function _isPlaceholder$1$1(a){return a!=null&&(typeof a==='undefined'?'undefined':_typeof$1$1(a))==='object'&&a['@@functional/placeholder']===true;}/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curry1$1$1(fn){return function f1(a){if(arguments.length===0||_isPlaceholder$1$1(a)){return f1;}else{return fn.apply(this,arguments);}};}/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */var always$2=/*#__PURE__*/_curry1$1$1(function always(val){return function(){return val;};});/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */var F$2=/*#__PURE__*/always$2(false);/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */var T$2=/*#__PURE__*/always$2(true);/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 *//**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curry2$1$1(fn){return function f2(a,b){switch(arguments.length){case 0:return f2;case 1:return _isPlaceholder$1$1(a)?f2:_curry1$1$1(function(_b){return fn(a,_b);});default:return _isPlaceholder$1$1(a)&&_isPlaceholder$1$1(b)?f2:_isPlaceholder$1$1(a)?_curry1$1$1(function(_a){return fn(_a,b);}):_isPlaceholder$1$1(b)?_curry1$1$1(function(_b){return fn(a,_b);}):fn(a,b);}};}/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */var add$2=/*#__PURE__*/_curry2$1$1(function add(a,b){return Number(a)+Number(b);});/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */function _concat$1$1(set1,set2){set1=set1||[];set2=set2||[];var idx;var len1=set1.length;var len2=set2.length;var result=[];idx=0;while(idx<len1){result[result.length]=set1[idx];idx+=1;}idx=0;while(idx<len2){result[result.length]=set2[idx];idx+=1;}return result;}function _arity$1$1(n,fn){/* eslint-disable no-unused-vars */switch(n){case 0:return function(){return fn.apply(this,arguments);};case 1:return function(a0){return fn.apply(this,arguments);};case 2:return function(a0,a1){return fn.apply(this,arguments);};case 3:return function(a0,a1,a2){return fn.apply(this,arguments);};case 4:return function(a0,a1,a2,a3){return fn.apply(this,arguments);};case 5:return function(a0,a1,a2,a3,a4){return fn.apply(this,arguments);};case 6:return function(a0,a1,a2,a3,a4,a5){return fn.apply(this,arguments);};case 7:return function(a0,a1,a2,a3,a4,a5,a6){return fn.apply(this,arguments);};case 8:return function(a0,a1,a2,a3,a4,a5,a6,a7){return fn.apply(this,arguments);};case 9:return function(a0,a1,a2,a3,a4,a5,a6,a7,a8){return fn.apply(this,arguments);};case 10:return function(a0,a1,a2,a3,a4,a5,a6,a7,a8,a9){return fn.apply(this,arguments);};default:throw new Error('First argument to _arity must be a non-negative integer no greater than ten');}}/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curryN$1$1(length,received,fn){return function(){var combined=[];var argsIdx=0;var left=length;var combinedIdx=0;while(combinedIdx<received.length||argsIdx<arguments.length){var result;if(combinedIdx<received.length&&(!_isPlaceholder$1$1(received[combinedIdx])||argsIdx>=arguments.length)){result=received[combinedIdx];}else{result=arguments[argsIdx];argsIdx+=1;}combined[combinedIdx]=result;if(!_isPlaceholder$1$1(result)){left-=1;}combinedIdx+=1;}return left<=0?fn.apply(this,combined):_arity$1$1(left,_curryN$1$1(length,combined,fn));};}/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */var curryN$2=/*#__PURE__*/_curry2$1$1(function curryN(length,fn){if(length===1){return _curry1$1$1(fn);}return _arity$1$1(length,_curryN$1$1(length,[],fn));});/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */var addIndex$2=/*#__PURE__*/_curry1$1$1(function addIndex(fn){return curryN$2(fn.length,function(){var idx=0;var origFn=arguments[0];var list=arguments[arguments.length-1];var args=Array.prototype.slice.call(arguments,0);args[0]=function(){var result=origFn.apply(this,_concat$1$1(arguments,[idx,list]));idx+=1;return result;};return fn.apply(this,args);});});/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */function _curry3$1$1(fn){return function f3(a,b,c){switch(arguments.length){case 0:return f3;case 1:return _isPlaceholder$1$1(a)?f3:_curry2$1$1(function(_b,_c){return fn(a,_b,_c);});case 2:return _isPlaceholder$1$1(a)&&_isPlaceholder$1$1(b)?f3:_isPlaceholder$1$1(a)?_curry2$1$1(function(_a,_c){return fn(_a,b,_c);}):_isPlaceholder$1$1(b)?_curry2$1$1(function(_b,_c){return fn(a,_b,_c);}):_curry1$1$1(function(_c){return fn(a,b,_c);});default:return _isPlaceholder$1$1(a)&&_isPlaceholder$1$1(b)&&_isPlaceholder$1$1(c)?f3:_isPlaceholder$1$1(a)&&_isPlaceholder$1$1(b)?_curry2$1$1(function(_a,_b){return fn(_a,_b,c);}):_isPlaceholder$1$1(a)&&_isPlaceholder$1$1(c)?_curry2$1$1(function(_a,_c){return fn(_a,b,_c);}):_isPlaceholder$1$1(b)&&_isPlaceholder$1$1(c)?_curry2$1$1(function(_b,_c){return fn(a,_b,_c);}):_isPlaceholder$1$1(a)?_curry1$1$1(function(_a){return fn(_a,b,c);}):_isPlaceholder$1$1(b)?_curry1$1$1(function(_b){return fn(a,_b,c);}):_isPlaceholder$1$1(c)?_curry1$1$1(function(_c){return fn(a,b,_c);}):fn(a,b,c);}};}/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a -> a) -> Number -> [a] -> [a]
 * @param {Function} fn The function to apply.
 * @param {Number} idx The index.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
 */var adjust$2=/*#__PURE__*/_curry3$1$1(function adjust(fn,idx,list){if(idx>=list.length||idx<-list.length){return list;}var start=idx<0?list.length:0;var _idx=start+idx;var _list=_concat$1$1(list);_list[_idx]=fn(list[_idx]);return _list;});/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */var _isArray$1$1=Array.isArray||function _isArray(val){return val!=null&&val.length>=0&&Object.prototype.toString.call(val)==='[object Array]';};function _isTransformer$1$1(obj){return typeof obj['@@transducer/step']==='function';}/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */function _dispatchable$1$1(methodNames,xf,fn){return function(){if(arguments.length===0){return fn();}var args=Array.prototype.slice.call(arguments,0);var obj=args.pop();if(!_isArray$1$1(obj)){var idx=0;while(idx<methodNames.length){if(typeof obj[methodNames[idx]]==='function'){return obj[methodNames[idx]].apply(obj,args);}idx+=1;}if(_isTransformer$1$1(obj)){var transducer=xf.apply(null,args);return transducer(obj);}}return fn.apply(this,arguments);};}function _reduced$1(x){return x&&x['@@transducer/reduced']?x:{'@@transducer/value':x,'@@transducer/reduced':true};}var _xfBase$1$1={init:function init(){return this.xf['@@transducer/init']();},result:function result(_result){return this.xf['@@transducer/result'](_result);}};/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */var max$2=/*#__PURE__*/_curry2$1$1(function max(a,b){return b>a?b:a;});function _map$1$1(fn,functor){var idx=0;var len=functor.length;var result=Array(len);while(idx<len){result[idx]=fn(functor[idx]);idx+=1;}return result;}function _isString$1$1(x){return Object.prototype.toString.call(x)==='[object String]';}/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */var _isArrayLike$2=/*#__PURE__*/_curry1$1$1(function isArrayLike(x){if(_isArray$1$1(x)){return true;}if(!x){return false;}if((typeof x==='undefined'?'undefined':_typeof$1$1(x))!=='object'){return false;}if(_isString$1$1(x)){return false;}if(x.nodeType===1){return!!x.length;}if(x.length===0){return true;}if(x.length>0){return x.hasOwnProperty(0)&&x.hasOwnProperty(x.length-1);}return false;});var XWrap$1$1=/*#__PURE__*/function(){function XWrap(fn){this.f=fn;}XWrap.prototype['@@transducer/init']=function(){throw new Error('init not implemented on XWrap');};XWrap.prototype['@@transducer/result']=function(acc){return acc;};XWrap.prototype['@@transducer/step']=function(acc,x){return this.f(acc,x);};return XWrap;}();function _xwrap$1$1(fn){return new XWrap$1$1(fn);}/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */var bind$2=/*#__PURE__*/_curry2$1$1(function bind(fn,thisObj){return _arity$1$1(fn.length,function(){return fn.apply(thisObj,arguments);});});function _arrayReduce$1$1(xf,acc,list){var idx=0;var len=list.length;while(idx<len){acc=xf['@@transducer/step'](acc,list[idx]);if(acc&&acc['@@transducer/reduced']){acc=acc['@@transducer/value'];break;}idx+=1;}return xf['@@transducer/result'](acc);}function _iterableReduce$1$1(xf,acc,iter){var step=iter.next();while(!step.done){acc=xf['@@transducer/step'](acc,step.value);if(acc&&acc['@@transducer/reduced']){acc=acc['@@transducer/value'];break;}step=iter.next();}return xf['@@transducer/result'](acc);}function _methodReduce$1$1(xf,acc,obj,methodName){return xf['@@transducer/result'](obj[methodName](bind$2(xf['@@transducer/step'],xf),acc));}var symIterator$1$1=typeof Symbol!=='undefined'?Symbol.iterator:'@@iterator';function _reduce$1$1(fn,acc,list){if(typeof fn==='function'){fn=_xwrap$1$1(fn);}if(_isArrayLike$2(list)){return _arrayReduce$1$1(fn,acc,list);}if(typeof list['fantasy-land/reduce']==='function'){return _methodReduce$1$1(fn,acc,list,'fantasy-land/reduce');}if(list[symIterator$1$1]!=null){return _iterableReduce$1$1(fn,acc,list[symIterator$1$1]());}if(typeof list.next==='function'){return _iterableReduce$1$1(fn,acc,list);}if(typeof list.reduce==='function'){return _methodReduce$1$1(fn,acc,list,'reduce');}throw new TypeError('reduce: list must be array or iterable');}var XMap$1$1=/*#__PURE__*/function(){function XMap(f,xf){this.xf=xf;this.f=f;}XMap.prototype['@@transducer/init']=_xfBase$1$1.init;XMap.prototype['@@transducer/result']=_xfBase$1$1.result;XMap.prototype['@@transducer/step']=function(result,input){return this.xf['@@transducer/step'](result,this.f(input));};return XMap;}();var _xmap$2=/*#__PURE__*/_curry2$1$1(function _xmap(f,xf){return new XMap$1$1(f,xf);});function _has$1$1(prop,obj){return Object.prototype.hasOwnProperty.call(obj,prop);}var toString$3=Object.prototype.toString;var _isArguments$2=function _isArguments(){return toString$3.call(arguments)==='[object Arguments]'?function _isArguments(x){return toString$3.call(x)==='[object Arguments]';}:function _isArguments(x){return _has$1$1('callee',x);};};// cover IE < 9 keys issues
var hasEnumBug$1$1=!/*#__PURE__*/{toString:null}.propertyIsEnumerable('toString');var nonEnumerableProps$1$1=['constructor','valueOf','isPrototypeOf','toString','propertyIsEnumerable','hasOwnProperty','toLocaleString'];// Safari bug
var hasArgsEnumBug$1$1=/*#__PURE__*/function(){return arguments.propertyIsEnumerable('length');}();var contains$3=function contains(list,item){var idx=0;while(idx<list.length){if(list[idx]===item){return true;}idx+=1;}return false;};/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */var _keys$1$1=typeof Object.keys==='function'&&!hasArgsEnumBug$1$1?function keys(obj){return Object(obj)!==obj?[]:Object.keys(obj);}:function keys(obj){if(Object(obj)!==obj){return[];}var prop,nIdx;var ks=[];var checkArgsLength=hasArgsEnumBug$1$1&&_isArguments$2(obj);for(prop in obj){if(_has$1$1(prop,obj)&&(!checkArgsLength||prop!=='length')){ks[ks.length]=prop;}}if(hasEnumBug$1$1){nIdx=nonEnumerableProps$1$1.length-1;while(nIdx>=0){prop=nonEnumerableProps$1$1[nIdx];if(_has$1$1(prop,obj)&&!contains$3(ks,prop)){ks[ks.length]=prop;}nIdx-=1;}}return ks;};var keys$2=/*#__PURE__*/_curry1$1$1(_keys$1$1);/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */var map$2=/*#__PURE__*/_curry2$1$1(/*#__PURE__*/_dispatchable$1$1(['fantasy-land/map','map'],_xmap$2,function map(fn,functor){switch(Object.prototype.toString.call(functor)){case'[object Function]':return curryN$2(functor.length,function(){return fn.call(this,functor.apply(this,arguments));});case'[object Object]':return _reduce$1$1(function(acc,key){acc[key]=fn(functor[key]);return acc;},{},keys$2(functor));default:return _map$1$1(fn,functor);}}));/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */var path$2=/*#__PURE__*/_curry2$1$1(function path(paths,obj){var val=obj;var idx=0;while(idx<paths.length){if(val==null){return;}val=val[paths[idx]];idx+=1;}return val;});/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */var prop$2=/*#__PURE__*/_curry2$1$1(function prop(p,obj){return path$2([p],obj);});/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */var pluck$2=/*#__PURE__*/_curry2$1$1(function pluck(p,list){return map$2(prop$2(p),list);});/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */var reduce$2$1=/*#__PURE__*/_curry3$1$1(_reduce$1$1);/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */var ap$2=/*#__PURE__*/_curry2$1$1(function ap(applyF,applyX){return typeof applyX['fantasy-land/ap']==='function'?applyX['fantasy-land/ap'](applyF):typeof applyF.ap==='function'?applyF.ap(applyX):typeof applyF==='function'?function(x){return applyF(x)(applyX(x));}:// else
_reduce$1$1(function(acc,f){return _concat$1$1(acc,map$2(f,applyX));},[],applyF);});/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */var append$2=/*#__PURE__*/_curry2$1$1(function append(el,list){return _concat$1$1(list,[el]);});/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */function _isFunction$1$1(x){return Object.prototype.toString.call(x)==='[object Function]';}/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */var liftN$2=/*#__PURE__*/_curry2$1$1(function liftN(arity,fn){var lifted=curryN$2(arity,fn);return curryN$2(arity,function(){return _reduce$1$1(ap$2,map$2(lifted,arguments[0]),Array.prototype.slice.call(arguments,1));});});/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */var lift$2=/*#__PURE__*/_curry1$1$1(function lift(fn){return liftN$2(fn.length,fn);});/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */var curry$2=/*#__PURE__*/_curry1$1$1(function curry(fn){return curryN$2(fn.length,fn);});/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */var call$2=/*#__PURE__*/curry$2(function call(fn){return fn.apply(this,Array.prototype.slice.call(arguments,1));});/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */function _makeFlat$1$1(recursive){return function flatt(list){var value,jlen,j;var result=[];var idx=0;var ilen=list.length;while(idx<ilen){if(_isArrayLike$2(list[idx])){value=recursive?flatt(list[idx]):list[idx];j=0;jlen=value.length;while(j<jlen){result[result.length]=value[j];j+=1;}}else{result[result.length]=list[idx];}idx+=1;}return result;};}function _forceReduced$1$1(x){return{'@@transducer/value':x,'@@transducer/reduced':true};}var preservingReduced$1$1=function preservingReduced(xf){return{'@@transducer/init':_xfBase$1$1.init,'@@transducer/result':function transducerResult(result){return xf['@@transducer/result'](result);},'@@transducer/step':function transducerStep(result,input){var ret=xf['@@transducer/step'](result,input);return ret['@@transducer/reduced']?_forceReduced$1$1(ret):ret;}};};var _flatCat$2=function _xcat(xf){var rxf=preservingReduced$1$1(xf);return{'@@transducer/init':_xfBase$1$1.init,'@@transducer/result':function transducerResult(result){return rxf['@@transducer/result'](result);},'@@transducer/step':function transducerStep(result,input){return!_isArrayLike$2(input)?_reduce$1$1(rxf,result,[input]):_reduce$1$1(rxf,result,input);}};};var _xchain$2=/*#__PURE__*/_curry2$1$1(function _xchain(f,xf){return map$2(f,_flatCat$2(xf));});/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */var chain$2=/*#__PURE__*/_curry2$1$1(/*#__PURE__*/_dispatchable$1$1(['fantasy-land/chain','chain'],_xchain$2,function chain(fn,monad){if(typeof monad==='function'){return function(x){return fn(monad(x))(x);};}return _makeFlat$1$1(false)(map$2(fn,monad));}));/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */var type$2=/*#__PURE__*/_curry1$1$1(function type(val){return val===null?'Null':val===undefined?'Undefined':Object.prototype.toString.call(val).slice(8,-1);});/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */var not$2=/*#__PURE__*/_curry1$1$1(function not(a){return!a;});/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */var complement$2=/*#__PURE__*/lift$2(not$2);function _pipe$1$1(f,g){return function(){return g.call(this,f.apply(this,arguments));};}/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */function _checkForMethod$1$1(methodname,fn){return function(){var length=arguments.length;if(length===0){return fn();}var obj=arguments[length-1];return _isArray$1$1(obj)||typeof obj[methodname]!=='function'?fn.apply(this,arguments):obj[methodname].apply(obj,Array.prototype.slice.call(arguments,0,length-1));};}/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */var slice$2=/*#__PURE__*/_curry3$1$1(/*#__PURE__*/_checkForMethod$1$1('slice',function slice(fromIndex,toIndex,list){return Array.prototype.slice.call(list,fromIndex,toIndex);}));/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */var tail$2=/*#__PURE__*/_curry1$1$1(/*#__PURE__*/_checkForMethod$1$1('tail',/*#__PURE__*/slice$2(1,Infinity)));/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */function pipe$1$1(){if(arguments.length===0){throw new Error('pipe requires at least one argument');}return _arity$1$1(arguments[0].length,reduce$2$1(_pipe$1$1,arguments[0],tail$2(arguments)));}/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */var reverse$2=/*#__PURE__*/_curry1$1$1(function reverse(list){return _isString$1$1(list)?list.split('').reverse().join(''):Array.prototype.slice.call(list,0).reverse();});/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */function compose$1$1(){if(arguments.length===0){throw new Error('compose requires at least one argument');}return pipe$1$1.apply(this,reverse$2(arguments));}function _arrayFromIterator$1$1(iter){var list=[];var next;while(!(next=iter.next()).done){list.push(next.value);}return list;}function _containsWith$1$1(pred,x,list){var idx=0;var len=list.length;while(idx<len){if(pred(x,list[idx])){return true;}idx+=1;}return false;}function _functionName$1$1(f){// String(x => x) evaluates to "x => x", so the pattern may not match.
var match=String(f).match(/^function (\w*)/);return match==null?'':match[1];}/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */var identical$2=/*#__PURE__*/_curry2$1$1(function identical(a,b){// SameValue algorithm
if(a===b){// Steps 1-5, 7-10
// Steps 6.b-6.e: +0 != -0
return a!==0||1/a===1/b;}else{// Step 6.a: NaN == NaN
return a!==a&&b!==b;}});/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */function _uniqContentEquals$1$1(aIterator,bIterator,stackA,stackB){var a=_arrayFromIterator$1$1(aIterator);var b=_arrayFromIterator$1$1(bIterator);function eq(_a,_b){return _equals$1$1(_a,_b,stackA.slice(),stackB.slice());}// if *a* array contains any element that is not included in *b*
return!_containsWith$1$1(function(b,aItem){return!_containsWith$1$1(eq,aItem,b);},b,a);}function _equals$1$1(a,b,stackA,stackB){if(identical$2(a,b)){return true;}var typeA=type$2(a);if(typeA!==type$2(b)){return false;}if(a==null||b==null){return false;}if(typeof a['fantasy-land/equals']==='function'||typeof b['fantasy-land/equals']==='function'){return typeof a['fantasy-land/equals']==='function'&&a['fantasy-land/equals'](b)&&typeof b['fantasy-land/equals']==='function'&&b['fantasy-land/equals'](a);}if(typeof a.equals==='function'||typeof b.equals==='function'){return typeof a.equals==='function'&&a.equals(b)&&typeof b.equals==='function'&&b.equals(a);}switch(typeA){case'Arguments':case'Array':case'Object':if(typeof a.constructor==='function'&&_functionName$1$1(a.constructor)==='Promise'){return a===b;}break;case'Boolean':case'Number':case'String':if(!((typeof a==='undefined'?'undefined':_typeof$1$1(a))===(typeof b==='undefined'?'undefined':_typeof$1$1(b))&&identical$2(a.valueOf(),b.valueOf()))){return false;}break;case'Date':if(!identical$2(a.valueOf(),b.valueOf())){return false;}break;case'Error':return a.name===b.name&&a.message===b.message;case'RegExp':if(!(a.source===b.source&&a.global===b.global&&a.ignoreCase===b.ignoreCase&&a.multiline===b.multiline&&a.sticky===b.sticky&&a.unicode===b.unicode)){return false;}break;}var idx=stackA.length-1;while(idx>=0){if(stackA[idx]===a){return stackB[idx]===b;}idx-=1;}switch(typeA){case'Map':if(a.size!==b.size){return false;}return _uniqContentEquals$1$1(a.entries(),b.entries(),stackA.concat([a]),stackB.concat([b]));case'Set':if(a.size!==b.size){return false;}return _uniqContentEquals$1$1(a.values(),b.values(),stackA.concat([a]),stackB.concat([b]));case'Arguments':case'Array':case'Object':case'Boolean':case'Number':case'String':case'Date':case'Error':case'RegExp':case'Int8Array':case'Uint8Array':case'Uint8ClampedArray':case'Int16Array':case'Uint16Array':case'Int32Array':case'Uint32Array':case'Float32Array':case'Float64Array':case'ArrayBuffer':break;default:// Values of other types are only equal if identical.
return false;}var keysA=keys$2(a);if(keysA.length!==keys$2(b).length){return false;}var extendedStackA=stackA.concat([a]);var extendedStackB=stackB.concat([b]);idx=keysA.length-1;while(idx>=0){var key=keysA[idx];if(!(_has$1$1(key,b)&&_equals$1$1(b[key],a[key],extendedStackA,extendedStackB))){return false;}idx-=1;}return true;}/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */var equals$2=/*#__PURE__*/_curry2$1$1(function equals(a,b){return _equals$1$1(a,b,[],[]);});function _indexOf$1$1(list,a,idx){var inf,item;// Array.prototype.indexOf doesn't exist below IE9
if(typeof list.indexOf==='function'){switch(typeof a==='undefined'?'undefined':_typeof$1$1(a)){case'number':if(a===0){// manually crawl the list to distinguish between +0 and -0
inf=1/a;while(idx<list.length){item=list[idx];if(item===0&&1/item===inf){return idx;}idx+=1;}return-1;}else if(a!==a){// NaN
while(idx<list.length){item=list[idx];if(typeof item==='number'&&item!==item){return idx;}idx+=1;}return-1;}// non-zero numbers can utilise Set
return list.indexOf(a,idx);// all these types can utilise Set
case'string':case'boolean':case'function':case'undefined':return list.indexOf(a,idx);case'object':if(a===null){// null can utilise Set
return list.indexOf(a,idx);}}}// anything else not covered above, defer to R.equals
while(idx<list.length){if(equals$2(list[idx],a)){return idx;}idx+=1;}return-1;}function _contains$1$1(a,list){return _indexOf$1$1(list,a,0)>=0;}function _quote$1$1(s){var escaped=s.replace(/\\/g,'\\\\').replace(/[\b]/g,'\\b')// \b matches word boundary; [\b] matches backspace
.replace(/\f/g,'\\f').replace(/\n/g,'\\n').replace(/\r/g,'\\r').replace(/\t/g,'\\t').replace(/\v/g,'\\v').replace(/\0/g,'\\0');return'"'+escaped.replace(/"/g,'\\"')+'"';}/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */var pad$1$1=function pad(n){return(n<10?'0':'')+n;};var _toISOString$2=typeof Date.prototype.toISOString==='function'?function _toISOString(d){return d.toISOString();}:function _toISOString(d){return d.getUTCFullYear()+'-'+pad$1$1(d.getUTCMonth()+1)+'-'+pad$1$1(d.getUTCDate())+'T'+pad$1$1(d.getUTCHours())+':'+pad$1$1(d.getUTCMinutes())+':'+pad$1$1(d.getUTCSeconds())+'.'+(d.getUTCMilliseconds()/1000).toFixed(3).slice(2,5)+'Z';};function _complement$1$1(f){return function(){return!f.apply(this,arguments);};}function _filter$1$1(fn,list){var idx=0;var len=list.length;var result=[];while(idx<len){if(fn(list[idx])){result[result.length]=list[idx];}idx+=1;}return result;}function _isObject$1$1(x){return Object.prototype.toString.call(x)==='[object Object]';}var XFilter$1$1=/*#__PURE__*/function(){function XFilter(f,xf){this.xf=xf;this.f=f;}XFilter.prototype['@@transducer/init']=_xfBase$1$1.init;XFilter.prototype['@@transducer/result']=_xfBase$1$1.result;XFilter.prototype['@@transducer/step']=function(result,input){return this.f(input)?this.xf['@@transducer/step'](result,input):result;};return XFilter;}();var _xfilter$2=/*#__PURE__*/_curry2$1$1(function _xfilter(f,xf){return new XFilter$1$1(f,xf);});/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */var filter$2=/*#__PURE__*/_curry2$1$1(/*#__PURE__*/_dispatchable$1$1(['filter'],_xfilter$2,function(pred,filterable){return _isObject$1$1(filterable)?_reduce$1$1(function(acc,key){if(pred(filterable[key])){acc[key]=filterable[key];}return acc;},{},keys$2(filterable)):// else
_filter$1$1(pred,filterable);}));/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */var reject$2=/*#__PURE__*/_curry2$1$1(function reject(pred,filterable){return filter$2(_complement$1$1(pred),filterable);});function _toString$1$1(x,seen){var recur=function recur(y){var xs=seen.concat([x]);return _contains$1$1(y,xs)?'<Circular>':_toString$1$1(y,xs);};//  mapPairs :: (Object, [String]) -> [String]
var mapPairs=function mapPairs(obj,keys$$1){return _map$1$1(function(k){return _quote$1$1(k)+': '+recur(obj[k]);},keys$$1.slice().sort());};switch(Object.prototype.toString.call(x)){case'[object Arguments]':return'(function() { return arguments; }('+_map$1$1(recur,x).join(', ')+'))';case'[object Array]':return'['+_map$1$1(recur,x).concat(mapPairs(x,reject$2(function(k){return /^\d+$/.test(k);},keys$2(x)))).join(', ')+']';case'[object Boolean]':return(typeof x==='undefined'?'undefined':_typeof$1$1(x))==='object'?'new Boolean('+recur(x.valueOf())+')':x.toString();case'[object Date]':return'new Date('+(isNaN(x.valueOf())?recur(NaN):_quote$1$1(_toISOString$2(x)))+')';case'[object Null]':return'null';case'[object Number]':return(typeof x==='undefined'?'undefined':_typeof$1$1(x))==='object'?'new Number('+recur(x.valueOf())+')':1/x===-Infinity?'-0':x.toString(10);case'[object String]':return(typeof x==='undefined'?'undefined':_typeof$1$1(x))==='object'?'new String('+recur(x.valueOf())+')':_quote$1$1(x);case'[object Undefined]':return'undefined';default:if(typeof x.toString==='function'){var repr=x.toString();if(repr!=='[object Object]'){return repr;}}return'{'+mapPairs(x,keys$2(x)).join(', ')+'}';}}/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */var toString$1$1$1=/*#__PURE__*/_curry1$1$1(function toString(val){return _toString$1$1(val,[]);});/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */var converge$2=/*#__PURE__*/_curry2$1$1(function converge(after,fns){return curryN$2(reduce$2$1(max$2,0,pluck$2('length',fns)),function(){var args=arguments;var context=this;return after.apply(context,_map$1$1(function(fn){return fn.apply(context,args);},fns));});});var XReduceBy$1$1=/*#__PURE__*/function(){function XReduceBy(valueFn,valueAcc,keyFn,xf){this.valueFn=valueFn;this.valueAcc=valueAcc;this.keyFn=keyFn;this.xf=xf;this.inputs={};}XReduceBy.prototype['@@transducer/init']=_xfBase$1$1.init;XReduceBy.prototype['@@transducer/result']=function(result){var key;for(key in this.inputs){if(_has$1$1(key,this.inputs)){result=this.xf['@@transducer/step'](result,this.inputs[key]);if(result['@@transducer/reduced']){result=result['@@transducer/value'];break;}}}this.inputs=null;return this.xf['@@transducer/result'](result);};XReduceBy.prototype['@@transducer/step']=function(result,input){var key=this.keyFn(input);this.inputs[key]=this.inputs[key]||[key,this.valueAcc];this.inputs[key][1]=this.valueFn(this.inputs[key][1],input);return result;};return XReduceBy;}();var _xreduceBy$2=/*#__PURE__*/_curryN$1$1(4,[],function _xreduceBy(valueFn,valueAcc,keyFn,xf){return new XReduceBy$1$1(valueFn,valueAcc,keyFn,xf);});/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */var reduceBy$2=/*#__PURE__*/_curryN$1$1(4,[],/*#__PURE__*/_dispatchable$1$1([],_xreduceBy$2,function reduceBy(valueFn,valueAcc,keyFn,list){return _reduce$1$1(function(acc,elt){var key=keyFn(elt);acc[key]=valueFn(_has$1$1(key,acc)?acc[key]:valueAcc,elt);return acc;},{},list);}));/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */var countBy$2=/*#__PURE__*/reduceBy$2(function(acc,elem){return acc+1;},0);/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */var dec$2=/*#__PURE__*/add$2(-1);var XDropRepeatsWith$1$1=/*#__PURE__*/function(){function XDropRepeatsWith(pred,xf){this.xf=xf;this.pred=pred;this.lastValue=undefined;this.seenFirstValue=false;}XDropRepeatsWith.prototype['@@transducer/init']=_xfBase$1$1.init;XDropRepeatsWith.prototype['@@transducer/result']=_xfBase$1$1.result;XDropRepeatsWith.prototype['@@transducer/step']=function(result,input){var sameAsLast=false;if(!this.seenFirstValue){this.seenFirstValue=true;}else if(this.pred(this.lastValue,input)){sameAsLast=true;}this.lastValue=input;return sameAsLast?result:this.xf['@@transducer/step'](result,input);};return XDropRepeatsWith;}();var _xdropRepeatsWith$2=/*#__PURE__*/_curry2$1$1(function _xdropRepeatsWith(pred,xf){return new XDropRepeatsWith$1$1(pred,xf);});/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */var nth$2=/*#__PURE__*/_curry2$1$1(function nth(offset,list){var idx=offset<0?list.length+offset:offset;return _isString$1$1(list)?list.charAt(idx):list[idx];});/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */var last$2=/*#__PURE__*/nth$2(-1);/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */var dropRepeatsWith$2=/*#__PURE__*/_curry2$1$1(/*#__PURE__*/_dispatchable$1$1([],_xdropRepeatsWith$2,function dropRepeatsWith(pred,list){var result=[];var idx=1;var len=list.length;if(len!==0){result[0]=list[0];while(idx<len){if(!pred(last$2(result),list[idx])){result[result.length]=list[idx];}idx+=1;}}return result;}));/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */var dropRepeats$2=/*#__PURE__*/_curry1$1$1(/*#__PURE__*/_dispatchable$1$1([],/*#__PURE__*/_xdropRepeatsWith$2(equals$2),/*#__PURE__*/dropRepeatsWith$2(equals$2)));/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */var flip$2=/*#__PURE__*/_curry1$1$1(function flip(fn){return curryN$2(fn.length,function(a,b){var args=Array.prototype.slice.call(arguments,0);args[0]=b;args[1]=a;return fn.apply(this,args);});});/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */var groupBy$2=/*#__PURE__*/_curry2$1$1(/*#__PURE__*/_checkForMethod$1$1('groupBy',/*#__PURE__*/reduceBy$2(function(acc,item){if(acc==null){acc=[];}acc.push(item);return acc;},null)));/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */var head$2=/*#__PURE__*/nth$2(0);function _identity$1$1(x){return x;}/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */var identity$2=/*#__PURE__*/_curry1$1$1(_identity$1$1);/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */var inc$2=/*#__PURE__*/add$2(1);/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */var indexBy$2=/*#__PURE__*/reduceBy$2(function(acc,elem){return elem;},null);/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */var init$2=/*#__PURE__*/slice$2(0,-1);var _Set$2=/*#__PURE__*/function(){function _Set(){/* globals Set */this._nativeSet=typeof Set==='function'?new Set():null;this._items={};}// until we figure out why jsdoc chokes on this
// @param item The item to add to the Set
// @returns {boolean} true if the item did not exist prior, otherwise false
//
_Set.prototype.add=function(item){return!hasOrAdd$1$1(item,true,this);};//
// @param item The item to check for existence in the Set
// @returns {boolean} true if the item exists in the Set, otherwise false
//
_Set.prototype.has=function(item){return hasOrAdd$1$1(item,false,this);};//
// Combines the logic for checking whether an item is a member of the set and
// for adding a new item to the set.
//
// @param item       The item to check or add to the Set instance.
// @param shouldAdd  If true, the item will be added to the set if it doesn't
//                   already exist.
// @param set        The set instance to check or add to.
// @return {boolean} true if the item already existed, otherwise false.
//
return _Set;}();function hasOrAdd$1$1(item,shouldAdd,set$$1){var type=typeof item==='undefined'?'undefined':_typeof$1$1(item);var prevSize,newSize;switch(type){case'string':case'number':// distinguish between +0 and -0
if(item===0&&1/item===-Infinity){if(set$$1._items['-0']){return true;}else{if(shouldAdd){set$$1._items['-0']=true;}return false;}}// these types can all utilise the native Set
if(set$$1._nativeSet!==null){if(shouldAdd){prevSize=set$$1._nativeSet.size;set$$1._nativeSet.add(item);newSize=set$$1._nativeSet.size;return newSize===prevSize;}else{return set$$1._nativeSet.has(item);}}else{if(!(type in set$$1._items)){if(shouldAdd){set$$1._items[type]={};set$$1._items[type][item]=true;}return false;}else if(item in set$$1._items[type]){return true;}else{if(shouldAdd){set$$1._items[type][item]=true;}return false;}}case'boolean':// set._items['boolean'] holds a two element array
// representing [ falseExists, trueExists ]
if(type in set$$1._items){var bIdx=item?1:0;if(set$$1._items[type][bIdx]){return true;}else{if(shouldAdd){set$$1._items[type][bIdx]=true;}return false;}}else{if(shouldAdd){set$$1._items[type]=item?[false,true]:[true,false];}return false;}case'function':// compare functions for reference equality
if(set$$1._nativeSet!==null){if(shouldAdd){prevSize=set$$1._nativeSet.size;set$$1._nativeSet.add(item);newSize=set$$1._nativeSet.size;return newSize===prevSize;}else{return set$$1._nativeSet.has(item);}}else{if(!(type in set$$1._items)){if(shouldAdd){set$$1._items[type]=[item];}return false;}if(!_contains$1$1(item,set$$1._items[type])){if(shouldAdd){set$$1._items[type].push(item);}return false;}return true;}case'undefined':if(set$$1._items[type]){return true;}else{if(shouldAdd){set$$1._items[type]=true;}return false;}case'object':if(item===null){if(!set$$1._items['null']){if(shouldAdd){set$$1._items['null']=true;}return false;}return true;}/* falls through */default:// reduce the search size of heterogeneous sets by creating buckets
// for each type.
type=Object.prototype.toString.call(item);if(!(type in set$$1._items)){if(shouldAdd){set$$1._items[type]=[item];}return false;}// scan through all previously applied items
if(!_contains$1$1(item,set$$1._items[type])){if(shouldAdd){set$$1._items[type].push(item);}return false;}return true;}}/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */var uniqBy$2=/*#__PURE__*/_curry2$1$1(function uniqBy(fn,list){var set$$1=new _Set$2();var result=[];var idx=0;var appliedItem,item;while(idx<list.length){item=list[idx];appliedItem=fn(item);if(set$$1.add(appliedItem)){result.push(item);}idx+=1;}return result;});/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */var uniq$2=/*#__PURE__*/uniqBy$2(identity$2);/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */var invoker$2=/*#__PURE__*/_curry2$1$1(function invoker(arity,method){return curryN$2(arity+1,function(){var target=arguments[arity];if(target!=null&&_isFunction$1$1(target[method])){return target[method].apply(target,Array.prototype.slice.call(arguments,0,arity));}throw new TypeError(toString$1$1$1(target)+' does not have a method named "'+method+'"');});});/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */var join$2=/*#__PURE__*/invoker$2(1,'join');/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */var juxt$2=/*#__PURE__*/_curry1$1$1(function juxt(fns){return converge$2(function(){return Array.prototype.slice.call(arguments,0);},fns);});/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */var sum$2=/*#__PURE__*/reduce$2$1(add$2,0);/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */var memoizeWith$2=/*#__PURE__*/_curry2$1$1(function memoizeWith(mFn,fn){var cache={};return _arity$1$1(fn.length,function(){var key=mFn.apply(this,arguments);if(!_has$1$1(key,cache)){cache[key]=fn.apply(this,arguments);}return cache[key];});});/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @deprecated since v0.25.0
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */var memoize$2=/*#__PURE__*/memoizeWith$2(function(){return toString$1$1$1(arguments);});/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */var multiply$2=/*#__PURE__*/_curry2$1$1(function multiply(a,b){return a*b;});function _createPartialApplicator$1$1(concat){return _curry2$1$1(function(fn,args){return _arity$1$1(Math.max(0,fn.length-args.length),function(){return fn.apply(this,concat(args,arguments));});});}/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */var partialRight$2=/*#__PURE__*/_createPartialApplicator$1$1(/*#__PURE__*/flip$2(_concat$1$1));/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */var partition$2=/*#__PURE__*/juxt$2([filter$2,reject$2]);/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */var pickAll$2=/*#__PURE__*/_curry2$1$1(function pickAll(names,obj){var result={};var idx=0;var len=names.length;while(idx<len){var name=names[idx];result[name]=obj[name];idx+=1;}return result;});/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */var product$2=/*#__PURE__*/reduce$2$1(multiply$2,1);/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */var useWith$2=/*#__PURE__*/_curry2$1$1(function useWith(fn,transformers){return curryN$2(transformers.length,function(){var args=[];var idx=0;while(idx<transformers.length){args.push(transformers[idx].call(this,arguments[idx]));idx+=1;}return fn.apply(this,args.concat(Array.prototype.slice.call(arguments,transformers.length)));});});/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */var project$2=/*#__PURE__*/useWith$2(_map$1$1,[pickAll$2,identity$2]);// passing `identity` gives correct arity
/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      var isOdd = (acc, x) => x % 2 === 1;
 *      var xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      var ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */var reduceWhile$2=/*#__PURE__*/_curryN$1$1(4,[],function _reduceWhile(pred,fn,a,list){return _reduce$1$1(function(acc,x){return pred(acc,x)?fn(acc,x):_reduced$1(acc);},a,list);});/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */var times$2=/*#__PURE__*/_curry2$1$1(function times(fn,n){var len=Number(n);var idx=0;var list;if(len<0||isNaN(len)){throw new RangeError('n must be a non-negative number');}list=new Array(len);while(idx<len){list[idx]=fn(idx);idx+=1;}return list;});/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      var obj = {};
 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */var repeat$2=/*#__PURE__*/_curry2$1$1(function repeat(value,n){return times$2(always$2(value),n);});/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */var split$2=/*#__PURE__*/invoker$2(1,'split');/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */var toLower$2=/*#__PURE__*/invoker$2(0,'toLowerCase');/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */var toUpper$2=/*#__PURE__*/invoker$2(0,'toUpperCase');/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      var isOdd = (x) => x % 2 === 1;
 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */var transduce$2=/*#__PURE__*/curryN$2(4,function transduce(xf,fn,acc,list){return _reduce$1$1(xf(typeof fn==='function'?_xwrap$1$1(fn):fn),acc,list);});var ws$1$1='\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003'+'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028'+'\u2029\uFEFF';var zeroWidth$1$1='\u200B';var hasProtoTrim$1$1=typeof String.prototype.trim==='function';/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */var _trim$1$1=!hasProtoTrim$1$1||/*#__PURE__*/ws$1$1.trim()||!/*#__PURE__*/zeroWidth$1$1.trim()?function trim(str){var beginRx=new RegExp('^['+ws$1$1+']['+ws$1$1+']*');var endRx=new RegExp('['+ws$1$1+']['+ws$1$1+']*$');return str.replace(beginRx,'').replace(endRx,'');}:function trim(str){return str.trim();};/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */var union$2=/*#__PURE__*/_curry2$1$1(/*#__PURE__*/compose$1$1(uniq$2,_concat$1$1));/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */var unnest$2=/*#__PURE__*/chain$2(_identity$1$1);var formatTitle$1$1=compose$1$1(titleCase$1$1,lowerCase$1$1);var mapIndexed$1$1=addIndex$2(map$2);var compact$1$1=filter$2(identity$2);var AvatarWrapper$1=system({is:"img",size:"3em"});var classCallCheck$1$2=function classCallCheck$$1(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}};var createClass$1$2=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var inherits$1$1=function inherits$$1(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof$1$1(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;};var objectWithoutProperties$1$2=function objectWithoutProperties$$1(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;};var possibleConstructorReturn$1$1=function possibleConstructorReturn$$1(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof$1$1(call))==="object"||typeof call==="function")?call:self;};var taggedTemplateLiteral$1$1=function taggedTemplateLiteral$$1(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));};/**
 * A Component for the Offcourse Project that shows the avatar image of a
 * given user
 */var Avatar$1=function(_Component){inherits$1$1(Avatar,_Component);function Avatar(){classCallCheck$1$2(this,Avatar);return possibleConstructorReturn$1$1(this,(Avatar.__proto__||Object.getPrototypeOf(Avatar)).apply(this,arguments));}createClass$1$2(Avatar,[{key:"render",value:function render(){var _props=this.props,url=_props.url,name=_props.name;return React.createElement(AvatarWrapper$1,{src:url,alt:"avatar of "+lowerCase$1$1(name)});}}]);return Avatar;}(Component);Avatar$1.propTypes={/**  url that refers to an avatar image */url:PropTypes.string,/** name of the person corresponding to this avatar */name:PropTypes.string.isRequired};Avatar$1.defaultProps={url:"https://assets.offcourse.io/portraits/offcourse_2.jpg"};var _templateObject$1$1=taggedTemplateLiteral$1$1(["\n  box-sizing: border-box\n"],["\n  box-sizing: border-box\n"]);var BarWrapper$1=system({display:"flex",justifyContent:"space-between",position:"fixed",left:0,right:0,bg:"white",flexDirection:"row",pr:4,alignItems:"center",height:"2rem",zIndex:2},"top","bottom").extend(_templateObject$1$1);var Bar$1=function(_Component){inherits$1$1(Bar,_Component);function Bar(){classCallCheck$1$2(this,Bar);return possibleConstructorReturn$1$1(this,(Bar.__proto__||Object.getPrototypeOf(Bar)).apply(this,arguments));}createClass$1$2(Bar,[{key:"render",value:function render(){var _props=this.props,docked=_props.docked,children=_props.children,position=_props.position;return React.createElement(BarWrapper$1,{top:docked==="top"?0:null,bottom:docked==="bottom"?0:null,position:position},children);}}]);return Bar;}(Component);Bar$1.propTypes={docked:PropTypes.oneOf(["top","bottom"]),position:PropTypes.oneOf(["fixed","absolute"])};Bar$1.defaultProps={docked:"top",position:"fixed"};var constants$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var breakpoints=exports.breakpoints=['40em','52em','64em'];var space=exports.space=[0,4,8,16,32,64,128,256,512];var fontSizes=exports.fontSizes=[12,14,16,20,24,32,48,64,72];exports.default={breakpoints:breakpoints,space:space,fontSizes:fontSizes};});unwrapExports$1$1(constants$1);var constants_1$1=constants$1.breakpoints;var constants_2$1=constants$1.space;var constants_3$1=constants$1.fontSizes;var util$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.complexStyle=exports.themeGet=exports.pseudoStyle=exports.responsiveStyle=exports.style=exports.cloneFunc=exports.getValue=exports.merge=exports.media=exports.dec=exports.breaks=exports.fallbackTheme=exports.mq=exports.get=exports.getWidth=exports.arr=exports.neg=exports.px=exports.num=exports.is=undefined;var _typeof$$1=typeof Symbol==="function"&&_typeof$1$1(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof$1$1(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof$1$1(obj);};var _extends$$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _propTypes2=_interopRequireDefault(PropTypes);var _constants2=_interopRequireDefault(constants$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var propTypes={responsive:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string,_propTypes2.default.array]),numberOrString:_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string])};var is=exports.is=function is(n){return n!==undefined&&n!==null;};var num=exports.num=function num(n){return typeof n==='number'&&!isNaN(n);};var px=exports.px=function px(n){return num(n)?n+'px':n;};var neg=exports.neg=function neg(n){return n<0;};var arr=exports.arr=function arr(n){return Array.isArray(n)?n:[n];};var getWidth=exports.getWidth=function getWidth(n){return!num(n)||n>1?px(n):n*100+'%';};var get$$1=exports.get=function get$$1(obj,path,fallback){return path.split('.').reduce(function(a,b){return a&&a[b]?a[b]:null;},obj)||fallback;};var mq=exports.mq=function mq(n){return'@media screen and (min-width: '+px(n)+')';};var fallbackTheme=exports.fallbackTheme=function fallbackTheme(props){return _extends$$1({},_constants2.default,get$$1(props,'theme'));};var breaks=exports.breaks=function breaks(props){return[null].concat(_toConsumableArray(get$$1(props,'theme.breakpoints',constants$1.breakpoints).map(mq)));};var dec=exports.dec=function dec(props){return function(val){return arr(props).reduce(function(acc,prop){return acc[prop]=val, acc;},{});};};var media=exports.media=function media(bp){return function(d,i){return is(d)?bp[i]?_defineProperty({},bp[i],d):d:null;};};var merge=exports.merge=function merge(a,b){return Object.assign({},a,b,Object.keys(b||{}).reduce(function(obj,key){return Object.assign(obj,_defineProperty({},key,a[key]!==null&&_typeof$$1(a[key])==='object'?merge(a[key],b[key]):b[key]));},{}));};var getValue=exports.getValue=function getValue(val,getter,toPx){return typeof getter==='function'?getter(val):toPx?px(val):val;};var cloneFunc=exports.cloneFunc=function cloneFunc(fn){return function(){return fn.apply(undefined,arguments);};};var style=exports.style=function style(_ref2){var prop=_ref2.prop,cssProperty=_ref2.cssProperty,alias=_ref2.alias,key=_ref2.key,getter=_ref2.getter,numberToPx=_ref2.numberToPx;var fn=function fn(props){cssProperty=cssProperty||prop;var n=is(props[prop])?props[prop]:props[alias];var th=fallbackTheme(props);if(!is(n))return null;var value=getValue(get$$1(th,[key,n].join('.'),n),getter,numberToPx);return _defineProperty({},cssProperty,value);};fn.propTypes=_defineProperty({},prop,cloneFunc(propTypes.numberOrString));if(alias){fn.propTypes[alias]=propTypes.numberOrString;}fn.propTypes[prop].meta={prop:prop,themeKey:key,styleType:'default'};return fn;};var responsiveStyle=exports.responsiveStyle=function responsiveStyle(_ref4){var prop=_ref4.prop,cssProperty=_ref4.cssProperty,alias=_ref4.alias,key=_ref4.key,getter=_ref4.getter,numberToPx=_ref4.numberToPx;var fn=function fn(props){cssProperty=cssProperty||prop;var n=is(props[prop])?props[prop]:props[alias];if(!is(n))return null;var bp=breaks(props);var th=fallbackTheme(props);var sx=function sx(n){return getValue(get$$1(th,[key||prop,n].join('.'),n),getter,numberToPx);};if(!Array.isArray(n)){return _defineProperty({},cssProperty,sx(n));}var val=arr(n);return val.map(sx).map(dec(cssProperty)).map(media(bp)).reduce(merge,{});};// add propTypes object to returned function
fn.propTypes=_defineProperty({},prop,cloneFunc(propTypes.responsive));if(alias){fn.propTypes[alias]=propTypes.responsive;}fn.propTypes[prop].meta={prop:prop,themeKey:key,responsive:true,styleType:'responsive'};return fn;};var pseudoStyle=exports.pseudoStyle=function pseudoStyle(_ref6){var prop=_ref6.prop,alias=_ref6.alias,pseudoclass=_ref6.pseudoclass,_ref6$keys=_ref6.keys,keys=_ref6$keys===undefined?{}:_ref6$keys,_ref6$getters=_ref6.getters,getters=_ref6$getters===undefined?{}:_ref6$getters,_ref6$numberToPx=_ref6.numberToPx,numberToPx=_ref6$numberToPx===undefined?{}:_ref6$numberToPx;var fn=function fn(props){var style=props[prop]||props[alias];pseudoclass=pseudoclass||prop;var th=fallbackTheme(props);for(var key in style){var toPx=numberToPx[key];if(!keys[key]&&!getters[key]&&!toPx)continue;var themeKey=[keys[key],style[key]].join('.');style[key]=getValue(get$$1(th,themeKey,style[key]),getters[key],toPx);}return _defineProperty({},'&:'+pseudoclass,style);};fn.propTypes=_defineProperty({},prop,cloneFunc(_propTypes2.default.object));fn.propTypes[prop].meta={prop:prop,pseudo:true,styleType:'pseudo'};return fn;};// todo: consider alternative names
var themeGet=exports.themeGet=function themeGet(keys,fallback){return function(props){return get$$1(props.theme,keys,fallback);};};var getBooleans=function getBooleans(props){var bools=[];for(var key in props){if(props[key]!==true)continue;bools.push(key);}return bools;};var complexStyle=exports.complexStyle=function complexStyle(_ref8){var prop=_ref8.prop,key=_ref8.key,alias=_ref8.alias;var fn=function fn(props){var style=get$$1(props,['theme',key,get$$1(props,prop,props[alias])].join('.'),{});var bools=getBooleans(props);bools.forEach(function(name){style=_extends$$1({},style,get$$1(props,['theme',key,name].join('.'),{}));});return style;};fn.propTypes=_defineProperty({},prop,_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]));if(alias){fn.propTypes[alias]=_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string]);}fn.propTypes[prop].meta={prop:prop,themeKey:key,complex:true,styleType:'complex'};return fn;};});unwrapExports$1$1(util$1);var util_1$1=util$1.complexStyle;var util_2$1=util$1.themeGet;var util_3$1=util$1.pseudoStyle;var util_4$1=util$1.responsiveStyle;var util_5$1=util$1.style;var util_6$1=util$1.cloneFunc;var util_7$1=util$1.getValue;var util_8$1=util$1.merge;var util_9$1=util$1.media;var util_10$1=util$1.dec;var util_11$1=util$1.breaks;var util_12$1=util$1.fallbackTheme;var util_13$1=util$1.mq;var util_14$1=util$1.get;var util_15$1=util$1.getWidth;var util_16$1=util$1.arr;var util_17$1=util$1.neg;var util_18$1=util$1.px;var util_19$1=util$1.num;var util_20$1=util$1.is;var space_1$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.space=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _propTypes2=_interopRequireDefault(PropTypes);var _constants2=_interopRequireDefault(constants$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REG=/^[mp][trblxy]?$/;var space=exports.space=function space(props){var keys=Object.keys(props).filter(function(key){return REG.test(key);}).sort();var bp=(0, util$1.breaks)(props);var sc=(0, util$1.get)(props,'theme.space',_constants2.default.space);return keys.map(function(key){var val=props[key];var p=getProperties(key);if(!Array.isArray(val)){return p.reduce(function(a,b){return Object.assign(a,_defineProperty({},b,mx(sc)(val)));},{});}return(0, util$1.arr)(val).map(mx(sc)).map((0, util$1.dec)(p)).map((0, util$1.media)(bp)).reduce(util$1.merge,{});}).reduce(util$1.merge,{});};var mx=function mx(scale){return function(n){if(!(0, util$1.num)(n)){return n;}var value=scale[Math.abs(n)]||Math.abs(n);if(!(0, util$1.num)(value)){return(0, util$1.neg)(n)?'-'+value:value;}return(0, util$1.px)(value*((0, util$1.neg)(n)?-1:1));};};var getProperties=function getProperties(key){var _key$split=key.split(''),_key$split2=_slicedToArray(_key$split,2),a=_key$split2[0],b=_key$split2[1];var prop=properties[a];var dirs=directions[b]||[''];return dirs.map(function(dir){return prop+dir;});};var properties={m:'margin',p:'padding'};var directions={t:['Top'],r:['Right'],b:['Bottom'],l:['Left'],x:['Left','Right'],y:['Top','Bottom']};var responsive=_propTypes2.default.oneOfType([_propTypes2.default.number,_propTypes2.default.string,_propTypes2.default.array]);space.propTypes={m:responsive,mt:responsive,mr:responsive,mb:responsive,ml:responsive,mx:responsive,my:responsive,p:responsive,pt:responsive,pr:responsive,pb:responsive,pl:responsive,px:responsive,py:responsive};var meta=function meta(prop){return{prop:prop,responsive:true,styleType:'responsive',themeKey:'space'};};Object.keys(space.propTypes).forEach(function(prop){space.propTypes[prop].meta=meta(prop);});exports.default=space;});unwrapExports$1$1(space_1$1);var space_2$1=space_1$1.space;var styles$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.borderWidth=exports.buttonStyle=exports.colorStyle=exports.textStyle=exports.disabled=exports.active=exports.focus=exports.hover=exports.left=exports.bottom=exports.right=exports.top=exports.zIndex=exports.position=exports.backgroundRepeat=exports.backgroundPosition=exports.backgroundSize=exports.backgroundImage=exports.background=exports.boxShadow=exports.borderRadius=exports.borderColor=exports.borders=exports.borderLeft=exports.borderBottom=exports.borderRight=exports.borderTop=exports.border=exports.gridTemplateRows=exports.gridTemplateColumns=exports.gridAutoRows=exports.gridAutoColumns=exports.gridAutoFlow=exports.gridRow=exports.gridColumn=exports.gridRowGap=exports.gridColumnGap=exports.gridGap=exports.order=exports.alignSelf=exports.justifySelf=exports.flex=exports.flexDirection=exports.flexBasis=exports.flexWrap=exports.justifyContent=exports.alignContent=exports.alignItems=exports.ratio=exports.ratioPadding=exports.size=exports.sizeHeight=exports.sizeWidth=exports.minHeight=exports.maxHeight=exports.height=exports.minWidth=exports.maxWidth=exports.display=exports.letterSpacing=exports.fontWeight=exports.lineHeight=exports.textAlign=exports.fontFamily=exports.color=exports.bgColor=exports.textColor=exports.fontSize=exports.width=exports.space=undefined;var _extends$$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};Object.defineProperty(exports,'space',{enumerable:true,get:function get$$1(){return _interopRequireDefault(space_1$1).default;}});var util$$1=_interopRequireWildcard(util$1);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var width=exports.width=(0, util$1.responsiveStyle)({prop:'width',alias:'w',getter:util$1.getWidth});var fontSize=exports.fontSize=(0, util$1.responsiveStyle)({prop:'fontSize',alias:'f',key:'fontSizes',numberToPx:true});var textColor=exports.textColor=(0, util$1.responsiveStyle)({prop:'color',key:'colors'});var bgColor=exports.bgColor=(0, util$1.responsiveStyle)({prop:'bg',cssProperty:'backgroundColor',key:'colors'});var color=exports.color=function color(props){return _extends$$1({},textColor(props),bgColor(props));};color.propTypes=_extends$$1({},textColor.propTypes,bgColor.propTypes);// typography
var fontFamily=exports.fontFamily=(0, util$1.style)({prop:'fontFamily',alias:'font',key:'fonts'});var textAlign=exports.textAlign=(0, util$1.responsiveStyle)({prop:'textAlign',// for backwards compatibility - will cause bugs when used with alignItems
alias:'align'});var lineHeight=exports.lineHeight=(0, util$1.responsiveStyle)({prop:'lineHeight',key:'lineHeights'});var fontWeight=exports.fontWeight=(0, util$1.style)({prop:'fontWeight',key:'fontWeights'});var letterSpacing=exports.letterSpacing=(0, util$1.style)({prop:'letterSpacing',key:'letterSpacings',numberToPx:true});// layout
var display=exports.display=(0, util$1.responsiveStyle)({prop:'display'});var maxWidth=exports.maxWidth=(0, util$1.responsiveStyle)({prop:'maxWidth',key:'maxWidths',numberToPx:true});var minWidth=exports.minWidth=(0, util$1.responsiveStyle)({prop:'minWidth',key:'minWidths',numberToPx:true});var height=exports.height=(0, util$1.responsiveStyle)({prop:'height',key:'heights',numberToPx:true});var maxHeight=exports.maxHeight=(0, util$1.responsiveStyle)({prop:'maxHeight',key:'maxHeights',numberToPx:true});var minHeight=exports.minHeight=(0, util$1.responsiveStyle)({prop:'minHeight',key:'minHeights',numberToPx:true});var sizeWidth=exports.sizeWidth=(0, util$1.responsiveStyle)({prop:'size',cssProperty:'width',numberToPx:true});var sizeHeight=exports.sizeHeight=(0, util$1.responsiveStyle)({prop:'size',cssProperty:'height',numberToPx:true});var size=exports.size=function size(props){return(0, util$1.merge)(sizeHeight(props),sizeWidth(props));};size.propTypes=_extends$$1({},sizeWidth.propTypes,sizeHeight.propTypes);var ratioPadding=exports.ratioPadding=(0, util$1.style)({prop:'ratio',cssProperty:'paddingBottom',getter:function getter(n){return n*100+'%';}});var ratio=exports.ratio=function ratio(props){return props.ratio?_extends$$1({height:0},ratioPadding(props)):null;};ratio.propTypes=_extends$$1({},ratioPadding.propTypes);// flexbox
var alignItems=exports.alignItems=(0, util$1.responsiveStyle)({prop:'alignItems',// for backwards compatibility - will cause bugs when used with textAlign
alias:'align'});var alignContent=exports.alignContent=(0, util$1.responsiveStyle)({prop:'alignContent'});var justifyContent=exports.justifyContent=(0, util$1.responsiveStyle)({prop:'justifyContent',// for backwards compatibility
alias:'justify'});// for backwards compatibility
var flexWrapShim=function flexWrapShim(n){return n===true?'wrap':n;};var flexWrap=exports.flexWrap=(0, util$1.responsiveStyle)({prop:'flexWrap',alias:'wrap',getter:flexWrapShim});var flexBasis=exports.flexBasis=(0, util$1.responsiveStyle)({prop:'flexBasis',getter:util$1.getWidth});var flexDirection=exports.flexDirection=(0, util$1.responsiveStyle)({prop:'flexDirection'});var flex=exports.flex=(0, util$1.responsiveStyle)({prop:'flex'});var justifySelf=exports.justifySelf=(0, util$1.responsiveStyle)({prop:'justifySelf'});var alignSelf=exports.alignSelf=(0, util$1.responsiveStyle)({prop:'alignSelf'});var order=exports.order=(0, util$1.responsiveStyle)({prop:'order'});// grid
var gridGap=exports.gridGap=(0, util$1.responsiveStyle)({prop:'gridGap',numberToPx:true,key:'space'});var gridColumnGap=exports.gridColumnGap=(0, util$1.responsiveStyle)({prop:'gridColumnGap',numberToPx:true,key:'space'});var gridRowGap=exports.gridRowGap=(0, util$1.responsiveStyle)({prop:'gridRowGap',numberToPx:true,key:'space'});var gridColumn=exports.gridColumn=(0, util$1.responsiveStyle)({prop:'gridColumn'});var gridRow=exports.gridRow=(0, util$1.responsiveStyle)({prop:'gridRow'});var gridAutoFlow=exports.gridAutoFlow=(0, util$1.style)({prop:'gridAutoFlow'});var gridAutoColumns=exports.gridAutoColumns=(0, util$1.style)({prop:'gridAutoColumns'});var gridAutoRows=exports.gridAutoRows=(0, util$1.style)({prop:'gridAutoRows'});var gridTemplateColumns=exports.gridTemplateColumns=(0, util$1.responsiveStyle)({prop:'gridTemplateColumns'});var gridTemplateRows=exports.gridTemplateRows=(0, util$1.responsiveStyle)({prop:'gridTemplateRows'});// borders
var getBorder=function getBorder(n){return util$$1.num(n)&&n>0?n+'px solid':n;};var border=exports.border=(0, util$1.responsiveStyle)({prop:'border',key:'borders',getter:getBorder});var borderTop=exports.borderTop=(0, util$1.responsiveStyle)({prop:'borderTop',key:'borders',getter:getBorder});var borderRight=exports.borderRight=(0, util$1.responsiveStyle)({prop:'borderRight',key:'borders',getter:getBorder});var borderBottom=exports.borderBottom=(0, util$1.responsiveStyle)({prop:'borderBottom',key:'borders',getter:getBorder});var borderLeft=exports.borderLeft=(0, util$1.responsiveStyle)({prop:'borderLeft',key:'borders',getter:getBorder});var borders=exports.borders=function borders(props){return _extends$$1({},border(props),borderTop(props),borderRight(props),borderBottom(props),borderLeft(props));};borders.propTypes=_extends$$1({},border.propTypes,borderTop.propTypes,borderRight.propTypes,borderBottom.propTypes,borderLeft.propTypes);var borderColor=exports.borderColor=(0, util$1.style)({prop:'borderColor',key:'colors'});var borderRadius=exports.borderRadius=(0, util$1.style)({prop:'borderRadius',key:'radii',numberToPx:true});var boxShadow=exports.boxShadow=(0, util$1.style)({prop:'boxShadow',key:'shadows'});// backgrounds
var background=exports.background=(0, util$1.style)({prop:'background'});var backgroundImage=exports.backgroundImage=(0, util$1.style)({prop:'backgroundImage',alias:'bgImage',getter:function getter(n){return'url('+n+')';}});var backgroundSize=exports.backgroundSize=(0, util$1.style)({prop:'backgroundSize',alias:'bgSize'});var backgroundPosition=exports.backgroundPosition=(0, util$1.style)({prop:'backgroundPosition',alias:'bgPosition'});var backgroundRepeat=exports.backgroundRepeat=(0, util$1.style)({prop:'backgroundRepeat',alias:'bgRepeat'});// position
var position=exports.position=(0, util$1.responsiveStyle)({prop:'position'});var zIndex=exports.zIndex=(0, util$1.style)({prop:'zIndex'});var top=exports.top=(0, util$1.responsiveStyle)({prop:'top',numberToPx:true});var right=exports.right=(0, util$1.responsiveStyle)({prop:'right',numberToPx:true});var bottom=exports.bottom=(0, util$1.responsiveStyle)({prop:'bottom',numberToPx:true});var left=exports.left=(0, util$1.responsiveStyle)({prop:'left',numberToPx:true});// pseudos
var hover=exports.hover=(0, util$1.pseudoStyle)({prop:'hover',pseudoclass:'hover',keys:{color:'colors',backgroundColor:'colors',borderColor:'colors',boxShadow:'shadows'}});var focus=exports.focus=(0, util$1.pseudoStyle)({prop:'focus',keys:{color:'colors',backgroundColor:'colors',borderColor:'colors',boxShadow:'shadows'}});var active=exports.active=(0, util$1.pseudoStyle)({prop:'active',keys:{color:'colors',backgroundColor:'colors',borderColor:'colors',boxShadow:'shadows'}});var disabled=exports.disabled=(0, util$1.pseudoStyle)({prop:'disabledStyle',pseudoclass:'disabled',keys:{color:'colors',backgroundColor:'colors',borderColor:'colors',boxShadow:'shadows'}});var textStyle=exports.textStyle=(0, util$1.complexStyle)({prop:'textStyle',key:'textStyles'});var colorStyle=exports.colorStyle=(0, util$1.complexStyle)({prop:'colors',key:'colorStyles'});var buttonStyle=exports.buttonStyle=(0, util$1.complexStyle)({prop:'buttonStyle',key:'buttons'});// for backwards-compatibility
// these will be removed in v3
var __DEV__=process.env.NODE_ENV!=='production';var borderWidth=exports.borderWidth=(0, util$1.style)({prop:'borderWidth',cssProperty:'border',key:'borderWidths',getter:function getter(v){if(__DEV__){console.warn('borderWidth is deprecated. Please use the `borders` utility instead');}return getBorder(v);}});});unwrapExports$1$1(styles$1);var styles_1$1=styles$1.borderWidth;var styles_2$1=styles$1.buttonStyle;var styles_3$1=styles$1.colorStyle;var styles_4$1=styles$1.textStyle;var styles_5$1=styles$1.disabled;var styles_6$1=styles$1.active;var styles_7$1=styles$1.focus;var styles_8$1=styles$1.hover;var styles_9$1=styles$1.left;var styles_10$1=styles$1.bottom;var styles_11$1=styles$1.right;var styles_12$1=styles$1.top;var styles_13$1=styles$1.zIndex;var styles_14$1=styles$1.position;var styles_15$1=styles$1.backgroundRepeat;var styles_16$1=styles$1.backgroundPosition;var styles_17$1=styles$1.backgroundSize;var styles_18$1=styles$1.backgroundImage;var styles_19$1=styles$1.background;var styles_20$1=styles$1.boxShadow;var styles_21$1=styles$1.borderRadius;var styles_22$1=styles$1.borderColor;var styles_23$1=styles$1.borders;var styles_24$1=styles$1.borderLeft;var styles_25$1=styles$1.borderBottom;var styles_26$1=styles$1.borderRight;var styles_27$1=styles$1.borderTop;var styles_28$1=styles$1.border;var styles_29$1=styles$1.gridTemplateRows;var styles_30$1=styles$1.gridTemplateColumns;var styles_31$1=styles$1.gridAutoRows;var styles_32$1=styles$1.gridAutoColumns;var styles_33$1=styles$1.gridAutoFlow;var styles_34$1=styles$1.gridRow;var styles_35$1=styles$1.gridColumn;var styles_36$1=styles$1.gridRowGap;var styles_37$1=styles$1.gridColumnGap;var styles_38$1=styles$1.gridGap;var styles_39$1=styles$1.order;var styles_40$1=styles$1.alignSelf;var styles_41$1=styles$1.justifySelf;var styles_42$1=styles$1.flex;var styles_43$1=styles$1.flexDirection;var styles_44$1=styles$1.flexBasis;var styles_45$1=styles$1.flexWrap;var styles_46$1=styles$1.justifyContent;var styles_47$1=styles$1.alignContent;var styles_48$1=styles$1.alignItems;var styles_49$1=styles$1.ratio;var styles_50$1=styles$1.ratioPadding;var styles_51$1=styles$1.size;var styles_52$1=styles$1.sizeHeight;var styles_53$1=styles$1.sizeWidth;var styles_54$1=styles$1.minHeight;var styles_55$1=styles$1.maxHeight;var styles_56$1=styles$1.height;var styles_57$1=styles$1.minWidth;var styles_58$1=styles$1.maxWidth;var styles_59$1=styles$1.display;var styles_60$1=styles$1.letterSpacing;var styles_61$1=styles$1.fontWeight;var styles_62$1=styles$1.lineHeight;var styles_63$1=styles$1.textAlign;var styles_64$1=styles$1.fontFamily;var styles_65$1=styles$1.color;var styles_66$1=styles$1.bgColor;var styles_67$1=styles$1.textColor;var styles_68$1=styles$1.fontSize;var styles_69$1=styles$1.width;var styles_70$1=styles$1.space;var dist$1=createCommonjsModule$1$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.propTypes=exports.util=exports.theme=exports.themeGet=exports.complexStyle=exports.responsiveStyle=exports.pseudoStyle=exports.style=exports.borderWidth=exports.buttonStyle=exports.colorStyle=exports.textStyle=exports.disabled=exports.active=exports.focus=exports.hover=exports.left=exports.bottom=exports.right=exports.top=exports.zIndex=exports.position=exports.backgroundRepeat=exports.backgroundPosition=exports.backgroundSize=exports.backgroundImage=exports.background=exports.boxShadow=exports.borderRadius=exports.borderColor=exports.borders=exports.borderLeft=exports.borderBottom=exports.borderRight=exports.borderTop=exports.border=exports.gridTemplateRows=exports.gridTemplateColumns=exports.gridAutoRows=exports.gridAutoColumns=exports.gridAutoFlow=exports.gridRow=exports.gridColumn=exports.gridRowGap=exports.gridColumnGap=exports.gridGap=exports.order=exports.alignSelf=exports.justifySelf=exports.flexBasis=exports.flex=exports.flexDirection=exports.flexWrap=exports.justifyContent=exports.alignContent=exports.alignItems=exports.ratio=exports.size=exports.minHeight=exports.maxHeight=exports.height=exports.minWidth=exports.maxWidth=exports.display=exports.letterSpacing=exports.fontWeight=exports.lineHeight=exports.textAlign=exports.fontFamily=exports.color=exports.bgColor=exports.textColor=exports.fontSize=exports.width=exports.space=exports.styles=undefined;Object.defineProperty(exports,'space',{enumerable:true,get:function get$$1(){return styles$1.space;}});Object.defineProperty(exports,'width',{enumerable:true,get:function get$$1(){return styles$1.width;}});Object.defineProperty(exports,'fontSize',{enumerable:true,get:function get$$1(){return styles$1.fontSize;}});Object.defineProperty(exports,'textColor',{enumerable:true,get:function get$$1(){return styles$1.textColor;}});Object.defineProperty(exports,'bgColor',{enumerable:true,get:function get$$1(){return styles$1.bgColor;}});Object.defineProperty(exports,'color',{enumerable:true,get:function get$$1(){return styles$1.color;}});Object.defineProperty(exports,'fontFamily',{enumerable:true,get:function get$$1(){return styles$1.fontFamily;}});Object.defineProperty(exports,'textAlign',{enumerable:true,get:function get$$1(){return styles$1.textAlign;}});Object.defineProperty(exports,'lineHeight',{enumerable:true,get:function get$$1(){return styles$1.lineHeight;}});Object.defineProperty(exports,'fontWeight',{enumerable:true,get:function get$$1(){return styles$1.fontWeight;}});Object.defineProperty(exports,'letterSpacing',{enumerable:true,get:function get$$1(){return styles$1.letterSpacing;}});Object.defineProperty(exports,'display',{enumerable:true,get:function get$$1(){return styles$1.display;}});Object.defineProperty(exports,'maxWidth',{enumerable:true,get:function get$$1(){return styles$1.maxWidth;}});Object.defineProperty(exports,'minWidth',{enumerable:true,get:function get$$1(){return styles$1.minWidth;}});Object.defineProperty(exports,'height',{enumerable:true,get:function get$$1(){return styles$1.height;}});Object.defineProperty(exports,'maxHeight',{enumerable:true,get:function get$$1(){return styles$1.maxHeight;}});Object.defineProperty(exports,'minHeight',{enumerable:true,get:function get$$1(){return styles$1.minHeight;}});Object.defineProperty(exports,'size',{enumerable:true,get:function get$$1(){return styles$1.size;}});Object.defineProperty(exports,'ratio',{enumerable:true,get:function get$$1(){return styles$1.ratio;}});Object.defineProperty(exports,'alignItems',{enumerable:true,get:function get$$1(){return styles$1.alignItems;}});Object.defineProperty(exports,'alignContent',{enumerable:true,get:function get$$1(){return styles$1.alignContent;}});Object.defineProperty(exports,'justifyContent',{enumerable:true,get:function get$$1(){return styles$1.justifyContent;}});Object.defineProperty(exports,'flexWrap',{enumerable:true,get:function get$$1(){return styles$1.flexWrap;}});Object.defineProperty(exports,'flexDirection',{enumerable:true,get:function get$$1(){return styles$1.flexDirection;}});Object.defineProperty(exports,'flex',{enumerable:true,get:function get$$1(){return styles$1.flex;}});Object.defineProperty(exports,'flexBasis',{enumerable:true,get:function get$$1(){return styles$1.flexBasis;}});Object.defineProperty(exports,'justifySelf',{enumerable:true,get:function get$$1(){return styles$1.justifySelf;}});Object.defineProperty(exports,'alignSelf',{enumerable:true,get:function get$$1(){return styles$1.alignSelf;}});Object.defineProperty(exports,'order',{enumerable:true,get:function get$$1(){return styles$1.order;}});Object.defineProperty(exports,'gridGap',{enumerable:true,get:function get$$1(){return styles$1.gridGap;}});Object.defineProperty(exports,'gridColumnGap',{enumerable:true,get:function get$$1(){return styles$1.gridColumnGap;}});Object.defineProperty(exports,'gridRowGap',{enumerable:true,get:function get$$1(){return styles$1.gridRowGap;}});Object.defineProperty(exports,'gridColumn',{enumerable:true,get:function get$$1(){return styles$1.gridColumn;}});Object.defineProperty(exports,'gridRow',{enumerable:true,get:function get$$1(){return styles$1.gridRow;}});Object.defineProperty(exports,'gridAutoFlow',{enumerable:true,get:function get$$1(){return styles$1.gridAutoFlow;}});Object.defineProperty(exports,'gridAutoColumns',{enumerable:true,get:function get$$1(){return styles$1.gridAutoColumns;}});Object.defineProperty(exports,'gridAutoRows',{enumerable:true,get:function get$$1(){return styles$1.gridAutoRows;}});Object.defineProperty(exports,'gridTemplateColumns',{enumerable:true,get:function get$$1(){return styles$1.gridTemplateColumns;}});Object.defineProperty(exports,'gridTemplateRows',{enumerable:true,get:function get$$1(){return styles$1.gridTemplateRows;}});Object.defineProperty(exports,'border',{enumerable:true,get:function get$$1(){return styles$1.border;}});Object.defineProperty(exports,'borderTop',{enumerable:true,get:function get$$1(){return styles$1.borderTop;}});Object.defineProperty(exports,'borderRight',{enumerable:true,get:function get$$1(){return styles$1.borderRight;}});Object.defineProperty(exports,'borderBottom',{enumerable:true,get:function get$$1(){return styles$1.borderBottom;}});Object.defineProperty(exports,'borderLeft',{enumerable:true,get:function get$$1(){return styles$1.borderLeft;}});Object.defineProperty(exports,'borders',{enumerable:true,get:function get$$1(){return styles$1.borders;}});Object.defineProperty(exports,'borderColor',{enumerable:true,get:function get$$1(){return styles$1.borderColor;}});Object.defineProperty(exports,'borderRadius',{enumerable:true,get:function get$$1(){return styles$1.borderRadius;}});Object.defineProperty(exports,'boxShadow',{enumerable:true,get:function get$$1(){return styles$1.boxShadow;}});Object.defineProperty(exports,'background',{enumerable:true,get:function get$$1(){return styles$1.background;}});Object.defineProperty(exports,'backgroundImage',{enumerable:true,get:function get$$1(){return styles$1.backgroundImage;}});Object.defineProperty(exports,'backgroundSize',{enumerable:true,get:function get$$1(){return styles$1.backgroundSize;}});Object.defineProperty(exports,'backgroundPosition',{enumerable:true,get:function get$$1(){return styles$1.backgroundPosition;}});Object.defineProperty(exports,'backgroundRepeat',{enumerable:true,get:function get$$1(){return styles$1.backgroundRepeat;}});Object.defineProperty(exports,'position',{enumerable:true,get:function get$$1(){return styles$1.position;}});Object.defineProperty(exports,'zIndex',{enumerable:true,get:function get$$1(){return styles$1.zIndex;}});Object.defineProperty(exports,'top',{enumerable:true,get:function get$$1(){return styles$1.top;}});Object.defineProperty(exports,'right',{enumerable:true,get:function get$$1(){return styles$1.right;}});Object.defineProperty(exports,'bottom',{enumerable:true,get:function get$$1(){return styles$1.bottom;}});Object.defineProperty(exports,'left',{enumerable:true,get:function get$$1(){return styles$1.left;}});Object.defineProperty(exports,'hover',{enumerable:true,get:function get$$1(){return styles$1.hover;}});Object.defineProperty(exports,'focus',{enumerable:true,get:function get$$1(){return styles$1.focus;}});Object.defineProperty(exports,'active',{enumerable:true,get:function get$$1(){return styles$1.active;}});Object.defineProperty(exports,'disabled',{enumerable:true,get:function get$$1(){return styles$1.disabled;}});Object.defineProperty(exports,'textStyle',{enumerable:true,get:function get$$1(){return styles$1.textStyle;}});Object.defineProperty(exports,'colorStyle',{enumerable:true,get:function get$$1(){return styles$1.colorStyle;}});Object.defineProperty(exports,'buttonStyle',{enumerable:true,get:function get$$1(){return styles$1.buttonStyle;}});Object.defineProperty(exports,'borderWidth',{enumerable:true,get:function get$$1(){return styles$1.borderWidth;}});Object.defineProperty(exports,'style',{enumerable:true,get:function get$$1(){return util$1.style;}});Object.defineProperty(exports,'pseudoStyle',{enumerable:true,get:function get$$1(){return util$1.pseudoStyle;}});Object.defineProperty(exports,'responsiveStyle',{enumerable:true,get:function get$$1(){return util$1.responsiveStyle;}});Object.defineProperty(exports,'complexStyle',{enumerable:true,get:function get$$1(){return util$1.complexStyle;}});Object.defineProperty(exports,'themeGet',{enumerable:true,get:function get$$1(){return util$1.themeGet;}});Object.defineProperty(exports,'theme',{enumerable:true,get:function get$$1(){return util$1.themeGet;}});var styles$$1=_interopRequireWildcard(styles$1);var _styles=_interopRequireWildcard(styles$1);var _util=_interopRequireWildcard(util$1);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}exports.styles=_styles;exports.util=_util;var propTypes=exports.propTypes={};Object.keys(styles$$1).forEach(function(key){propTypes[key]=styles$$1[key].propTypes;});styles$$1.propTypes=propTypes;exports.default=styles$$1;});unwrapExports$1$1(dist$1);var dist_1$1=dist$1.propTypes;var dist_2$1=dist$1.util;var dist_3$1=dist$1.theme;var dist_4$1=dist$1.themeGet;var dist_5$1=dist$1.complexStyle;var dist_6$1=dist$1.responsiveStyle;var dist_7$1=dist$1.pseudoStyle;var dist_8$1=dist$1.style;var dist_9$1=dist$1.borderWidth;var dist_10$1=dist$1.buttonStyle;var dist_11$1=dist$1.colorStyle;var dist_12$1=dist$1.textStyle;var dist_13$1=dist$1.disabled;var dist_14$1=dist$1.active;var dist_15$1=dist$1.focus;var dist_16$1=dist$1.hover;var dist_17$1=dist$1.left;var dist_18$1=dist$1.bottom;var dist_19$1=dist$1.right;var dist_20$1=dist$1.top;var dist_21$1=dist$1.zIndex;var dist_22$1=dist$1.position;var dist_23$1=dist$1.backgroundRepeat;var dist_24$1=dist$1.backgroundPosition;var dist_25$1=dist$1.backgroundSize;var dist_26$1=dist$1.backgroundImage;var dist_27$1=dist$1.background;var dist_28$1=dist$1.boxShadow;var dist_29$1=dist$1.borderRadius;var dist_30$1=dist$1.borderColor;var dist_31$1=dist$1.borders;var dist_32$1=dist$1.borderLeft;var dist_33$1=dist$1.borderBottom;var dist_34$1=dist$1.borderRight;var dist_35$1=dist$1.borderTop;var dist_36$1=dist$1.border;var dist_37$1=dist$1.gridTemplateRows;var dist_38$1=dist$1.gridTemplateColumns;var dist_39$1=dist$1.gridAutoRows;var dist_40$1=dist$1.gridAutoColumns;var dist_41$1=dist$1.gridAutoFlow;var dist_42$1=dist$1.gridRow;var dist_43$1=dist$1.gridColumn;var dist_44$1=dist$1.gridRowGap;var dist_45$1=dist$1.gridColumnGap;var dist_46$1=dist$1.gridGap;var dist_47$1=dist$1.order;var dist_48$1=dist$1.alignSelf;var dist_49$1=dist$1.justifySelf;var dist_50$1=dist$1.flexBasis;var dist_51$1=dist$1.flex;var dist_52$1=dist$1.flexDirection;var dist_53$1=dist$1.flexWrap;var dist_54$1=dist$1.justifyContent;var dist_55$1=dist$1.alignContent;var dist_56$1=dist$1.alignItems;var dist_57$1=dist$1.ratio;var dist_58$1=dist$1.size;var dist_59$1=dist$1.minHeight;var dist_60$1=dist$1.maxHeight;var dist_61$1=dist$1.height;var dist_62$1=dist$1.minWidth;var dist_63$1=dist$1.maxWidth;var dist_64$1=dist$1.display;var dist_65$1=dist$1.letterSpacing;var dist_66$1=dist$1.fontWeight;var dist_67$1=dist$1.lineHeight;var dist_68$1=dist$1.textAlign;var dist_69$1=dist$1.fontFamily;var dist_70$1=dist$1.color;var dist_71$1=dist$1.bgColor;var dist_72$1=dist$1.textColor;var dist_73$1=dist$1.fontSize;var dist_74$1=dist$1.width;var dist_75$1=dist$1.space;var dist_76$1=dist$1.styles;var background$1$1={default:"grayScale.3",disabled:"disabled",primary:"primary",positive:"positive",warning:"warning",negative:"negative"};var inverseBackground$1={default:"primary",disabled:"disabled",primary:"grayScale.3",positive:"grayScale.3",warning:"grayScale.3",negative:"grayScale.3"};var textColor$1$1={default:"white",disabled:"grayScale.1",negative:"white",primary:"black",warning:"black",positive:"black"};var inverseText$1={default:"white",disabled:"white",negative:"white",primary:"white",warning:"white",positive:"white"};var ButtonWrapper$1=system({is:"button",display:"flex",alignItems:"center",height:"2.813rem",justifyContent:"center",m:0,mt:0,border:0,fontSize:1,lineHeight:1,minWidth:"5.33333rem",maxWidth:"16rem",px:6,py:4,borderBottom:2},function(props){return{backgroundColor:dist_3$1("colors."+background$1$1[props.variant])(props),borderColor:dist_3$1("colors."+inverseBackground$1[props.variant])(props),color:dist_3$1("colors."+textColor$1$1[props.variant])(props),fontFamily:props.theme.fonts.bold,"&:focus":{outline:"none"},"&:disabled":{cursor:"default"},"> a":{color:"inherit",textDecoration:"inherit"},"&:hover":{borderColor:dist_3$1("colors."+background$1$1[props.variant])(props),color:dist_3$1("colors."+inverseText$1[props.variant])(props),backgroundColor:dist_3$1("colors."+inverseBackground$1[props.variant])(props)},boxSizing:"border-box",userSelect:"none"};});/**
 * The button component for the Offcourse project
 */var Button$1=function(_Component){inherits$1$1(Button,_Component);function Button(){var _ref;var _temp,_this,_ret;classCallCheck$1$2(this,Button);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$1$1(this,(_ref=Button.__proto__||Object.getPrototypeOf(Button)).call.apply(_ref,[this].concat(args))), _this), _this.handleClick=function(e){var onClick=_this.props.onClick;e.preventDefault();onClick();}, _temp), possibleConstructorReturn$1$1(_this,_ret);}createClass$1$2(Button,[{key:"render",value:function render(){var _props=this.props,href=_props.href,type=_props.type,children=_props.children,onClick=_props.onClick,tabindex=_props.tabindex,variant=_props.variant,mt=_props.mt,size=_props.size,rest=objectWithoutProperties$1$2(_props,["href","type","children","onClick","tabindex","variant","mt","size"]);var buttonType=type||"button";var disabled=this.props.disabled||this.props.loading;var widths={small:"5.33333rem",medium:"8rem",large:"16rem"};var text=formatTitle$1$1(children);return React.createElement(ButtonWrapper$1,{mt:mt,type:buttonType,variant:disabled?"disabled":variant,disabled:disabled,onClick:onClick,tabIndex:tabindex||1,minWidth:widths[size],maxWidth:widths[size]},href?React.createElement("a",{href:!disabled?href:undefined},text):text);}}]);return Button;}(Component);Button$1.propTypes={/** determines if the button should be disabled */disabled:PropTypes.bool,/** determines the status of the button */variant:PropTypes.oneOf(["default","primary","positive","warning","negative"]),/** the text that is displayed on the button */children:PropTypes.string,/** code that the button should execute when clicked */onClick:PropTypes.func,/** a url that the button should link to, automatically turns the button into the basic type */href:PropTypes.string,/** only accept a type prop when type is submit */type:PropTypes.oneOf(["submit","button"]),/** the size of the button */size:PropTypes.oneOf(["small","medium","large"])};Button$1.defaultProps={variant:"default",size:"medium",disabled:false,type:"button"};var _templateObject$1$2=taggedTemplateLiteral$1$1(["\n  section:last-child {\n    border-bottom: ",";\n    border-color: ",";\n\n    &:hover {\n        border-color: ",";\n      }\n    }\n  }\n"],["\n  section:last-child {\n    border-bottom: ",";\n    border-color: ",";\n\n    &:hover {\n        border-color: ",";\n      }\n    }\n  }\n"]);var CardWrapper$1=system({display:"block",width:["18rem","18rem","18rem"],bg:"grayScale.0"}).extend(_templateObject$1$2,function(_ref){var theme=_ref.theme;return theme.borders[2];},function(_ref2){var theme=_ref2.theme;return theme.colors.grayScale[2];},function(_ref3){var theme=_ref3.theme;return theme.colors.primary;});var Card$1=function(_Component){inherits$1$1(Card,_Component);function Card(){classCallCheck$1$2(this,Card);return possibleConstructorReturn$1$1(this,(Card.__proto__||Object.getPrototypeOf(Card)).apply(this,arguments));}createClass$1$2(Card,[{key:"renderSections",value:function renderSections(){var children=this.props.children;return Children.map(children,function(child,index){if(!child){return null;}var inverse=child.props.inverse;return React.createElement(Section$1,{bg:inverse?"grayScale.3":"white"},child);});}},{key:"render",value:function render(){return React.createElement(CardWrapper$1,null,this.renderSections());}}]);return Card;}(Component);/*!
 * Font Awesome Free 5.0.13 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */var noop$1$1=function noop(){};var _WINDOW$1={};var _DOCUMENT$1={};var _MUTATION_OBSERVER$1$1=null;var _PERFORMANCE$1={mark:noop$1$1,measure:noop$1$1};try{if(typeof window!=='undefined')_WINDOW$1=window;if(typeof document!=='undefined')_DOCUMENT$1=document;if(typeof MutationObserver!=='undefined')_MUTATION_OBSERVER$1$1=MutationObserver;if(typeof performance!=='undefined')_PERFORMANCE$1=performance;}catch(e){}var _ref$1=_WINDOW$1.navigator||{};var _ref$userAgent$1=_ref$1.userAgent;var userAgent$1=_ref$userAgent$1===undefined?'':_ref$userAgent$1;var WINDOW$1=_WINDOW$1;var DOCUMENT$1=_DOCUMENT$1;var MUTATION_OBSERVER$1=_MUTATION_OBSERVER$1$1;var PERFORMANCE$1=_PERFORMANCE$1;var IS_BROWSER$1=!!WINDOW$1.document;var IS_DOM$1=!!DOCUMENT$1.documentElement&&!!DOCUMENT$1.head&&typeof DOCUMENT$1.addEventListener==='function'&&typeof DOCUMENT$1.createElement==='function';var IS_IE$1=~userAgent$1.indexOf('MSIE')||~userAgent$1.indexOf('Trident/');var NAMESPACE_IDENTIFIER$1='___FONT_AWESOME___';var UNITS_IN_GRID$1=16;var DEFAULT_FAMILY_PREFIX$1='fa';var DEFAULT_REPLACEMENT_CLASS$1='svg-inline--fa';var DATA_FA_I2SVG$1='data-fa-i2svg';var DATA_FA_PSEUDO_ELEMENT$1='data-fa-pseudo-element';var HTML_CLASS_I2SVG_BASE_CLASS$1='fontawesome-i2svg';var PRODUCTION$1$1=function(){try{return process.env.NODE_ENV==='production';}catch(e){return false;}}();var oneToTen$1=[1,2,3,4,5,6,7,8,9,10];var oneToTwenty$1=oneToTen$1.concat([11,12,13,14,15,16,17,18,19,20]);var ATTRIBUTES_WATCHED_FOR_MUTATION$1=['class','data-prefix','data-icon','data-fa-transform','data-fa-mask'];var RESERVED_CLASSES$1=['xs','sm','lg','fw','ul','li','border','pull-left','pull-right','spin','pulse','rotate-90','rotate-180','rotate-270','flip-horizontal','flip-vertical','stack','stack-1x','stack-2x','inverse','layers','layers-text','layers-counter'].concat(oneToTen$1.map(function(n){return n+'x';})).concat(oneToTwenty$1.map(function(n){return'w-'+n;}));var classCallCheck$1$1$1=function classCallCheck$1(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}};var createClass$1$1$1=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends$1$2=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var toConsumableArray$1$1=function toConsumableArray$1(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}};var initial$1=WINDOW$1.FontAwesomeConfig||{};var initialKeys$1=Object.keys(initial$1);var _default$1=_extends$1$2({familyPrefix:DEFAULT_FAMILY_PREFIX$1,replacementClass:DEFAULT_REPLACEMENT_CLASS$1,autoReplaceSvg:true,autoAddCss:true,autoA11y:true,searchPseudoElements:false,observeMutations:true,keepOriginalSource:true,measurePerformance:false,showMissingIcons:true},initial$1);if(!_default$1.autoReplaceSvg)_default$1.observeMutations=false;var config$1$1=_extends$1$2({},_default$1);WINDOW$1.FontAwesomeConfig=config$1$1;function update$2$1(newConfig){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _params$asNewDefault=params.asNewDefault,asNewDefault=_params$asNewDefault===undefined?false:_params$asNewDefault;var validKeys=Object.keys(config$1$1);var ok=asNewDefault?function(k){return~validKeys.indexOf(k)&&!~initialKeys$1.indexOf(k);}:function(k){return~validKeys.indexOf(k);};Object.keys(newConfig).forEach(function(configKey){if(ok(configKey))config$1$1[configKey]=newConfig[configKey];});}function auto$1(value){update$2$1({autoReplaceSvg:value,observeMutations:value});}var w$1=WINDOW$1||{};if(!w$1[NAMESPACE_IDENTIFIER$1])w$1[NAMESPACE_IDENTIFIER$1]={};if(!w$1[NAMESPACE_IDENTIFIER$1].styles)w$1[NAMESPACE_IDENTIFIER$1].styles={};if(!w$1[NAMESPACE_IDENTIFIER$1].hooks)w$1[NAMESPACE_IDENTIFIER$1].hooks={};if(!w$1[NAMESPACE_IDENTIFIER$1].shims)w$1[NAMESPACE_IDENTIFIER$1].shims=[];var namespace$1=w$1[NAMESPACE_IDENTIFIER$1];var functions$1=[];var listener$1=function listener(){DOCUMENT$1.removeEventListener('DOMContentLoaded',listener);loaded$1=1;functions$1.map(function(fn){return fn();});};var loaded$1=false;if(IS_DOM$1){loaded$1=(DOCUMENT$1.documentElement.doScroll?/^loaded|^c/:/^loaded|^i|^c/).test(DOCUMENT$1.readyState);if(!loaded$1)DOCUMENT$1.addEventListener('DOMContentLoaded',listener$1);}var domready$1=function domready(fn){if(!IS_DOM$1)return;loaded$1?setTimeout(fn,0):functions$1.push(fn);};var d$1=UNITS_IN_GRID$1;var meaninglessTransform$1={size:16,x:0,y:0,rotate:0,flipX:false,flipY:false};function isReserved$1(name){return~RESERVED_CLASSES$1.indexOf(name);}function bunker$1(fn){try{fn();}catch(e){if(!PRODUCTION$1$1){throw e;}}}function insertCss$1(css){if(!css||!IS_DOM$1){return;}var style=DOCUMENT$1.createElement('style');style.setAttribute('type','text/css');style.innerHTML=css;var headChildren=DOCUMENT$1.head.childNodes;var beforeChild=null;for(var i=headChildren.length-1;i>-1;i--){var child=headChildren[i];var tagName=(child.tagName||'').toUpperCase();if(['STYLE','LINK'].indexOf(tagName)>-1){beforeChild=child;}}DOCUMENT$1.head.insertBefore(style,beforeChild);return css;}var _uniqueId$1=0;function nextUniqueId$1(){_uniqueId$1++;return _uniqueId$1;}function toArray$1$1(obj){var array=[];for(var i=(obj||[]).length>>>0;i--;){array[i]=obj[i];}return array;}function classArray$1(node){if(node.classList){return toArray$1$1(node.classList);}else{return(node.getAttribute('class')||'').split(' ').filter(function(i){return i;});}}function getIconName$1(familyPrefix,cls){var parts=cls.split('-');var prefix=parts[0];var iconName=parts.slice(1).join('-');if(prefix===familyPrefix&&iconName!==''&&!isReserved$1(iconName)){return iconName;}else{return null;}}function htmlEscape$1(str){return(''+str).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}function joinAttributes$1(attributes){return Object.keys(attributes||{}).reduce(function(acc,attributeName){return acc+(attributeName+'="'+htmlEscape$1(attributes[attributeName])+'" ');},'').trim();}function joinStyles$1(styles){return Object.keys(styles||{}).reduce(function(acc,styleName){return acc+(styleName+': '+styles[styleName]+';');},'');}function transformIsMeaningful$1(transform){return transform.size!==meaninglessTransform$1.size||transform.x!==meaninglessTransform$1.x||transform.y!==meaninglessTransform$1.y||transform.rotate!==meaninglessTransform$1.rotate||transform.flipX||transform.flipY;}function transformForSvg$1(_ref){var transform=_ref.transform,containerWidth=_ref.containerWidth,iconWidth=_ref.iconWidth;var outer={transform:'translate('+containerWidth/2+' 256)'};var innerTranslate='translate('+transform.x*32+', '+transform.y*32+') ';var innerScale='scale('+transform.size/16*(transform.flipX?-1:1)+', '+transform.size/16*(transform.flipY?-1:1)+') ';var innerRotate='rotate('+transform.rotate+' 0 0)';var inner={transform:innerTranslate+' '+innerScale+' '+innerRotate};var path={transform:'translate('+iconWidth/2*-1+' -256)'};return{outer:outer,inner:inner,path:path};}function transformForCss$1(_ref2){var transform=_ref2.transform,_ref2$width=_ref2.width,width=_ref2$width===undefined?UNITS_IN_GRID$1:_ref2$width,_ref2$height=_ref2.height,height=_ref2$height===undefined?UNITS_IN_GRID$1:_ref2$height,_ref2$startCentered=_ref2.startCentered,startCentered=_ref2$startCentered===undefined?false:_ref2$startCentered;var val='';if(startCentered&&IS_IE$1){val+='translate('+(transform.x/d$1-width/2)+'em, '+(transform.y/d$1-height/2)+'em) ';}else if(startCentered){val+='translate(calc(-50% + '+transform.x/d$1+'em), calc(-50% + '+transform.y/d$1+'em)) ';}else{val+='translate('+transform.x/d$1+'em, '+transform.y/d$1+'em) ';}val+='scale('+transform.size/d$1*(transform.flipX?-1:1)+', '+transform.size/d$1*(transform.flipY?-1:1)+') ';val+='rotate('+transform.rotate+'deg) ';return val;}var ALL_SPACE$1={x:0,y:0,width:'100%',height:'100%'};var makeIconMasking$1=function makeIconMasking(_ref){var children=_ref.children,attributes=_ref.attributes,main=_ref.main,mask=_ref.mask,transform=_ref.transform;var mainWidth=main.width,mainPath=main.icon;var maskWidth=mask.width,maskPath=mask.icon;var trans=transformForSvg$1({transform:transform,containerWidth:maskWidth,iconWidth:mainWidth});var maskRect={tag:'rect',attributes:_extends$1$2({},ALL_SPACE$1,{fill:'white'})};var maskInnerGroup={tag:'g',attributes:_extends$1$2({},trans.inner),children:[{tag:'path',attributes:_extends$1$2({},mainPath.attributes,trans.path,{fill:'black'})}]};var maskOuterGroup={tag:'g',attributes:_extends$1$2({},trans.outer),children:[maskInnerGroup]};var maskId='mask-'+nextUniqueId$1();var clipId='clip-'+nextUniqueId$1();var maskTag={tag:'mask',attributes:_extends$1$2({},ALL_SPACE$1,{id:maskId,maskUnits:'userSpaceOnUse',maskContentUnits:'userSpaceOnUse'}),children:[maskRect,maskOuterGroup]};var defs={tag:'defs',children:[{tag:'clipPath',attributes:{id:clipId},children:[maskPath]},maskTag]};children.push(defs,{tag:'rect',attributes:_extends$1$2({fill:'currentColor','clip-path':'url(#'+clipId+')',mask:'url(#'+maskId+')'},ALL_SPACE$1)});return{children:children,attributes:attributes};};var makeIconStandard$1=function makeIconStandard(_ref){var children=_ref.children,attributes=_ref.attributes,main=_ref.main,transform=_ref.transform,styles=_ref.styles;var styleString=joinStyles$1(styles);if(styleString.length>0){attributes['style']=styleString;}if(transformIsMeaningful$1(transform)){var trans=transformForSvg$1({transform:transform,containerWidth:main.width,iconWidth:main.width});children.push({tag:'g',attributes:_extends$1$2({},trans.outer),children:[{tag:'g',attributes:_extends$1$2({},trans.inner),children:[{tag:main.icon.tag,children:main.icon.children,attributes:_extends$1$2({},main.icon.attributes,trans.path)}]}]});}else{children.push(main.icon);}return{children:children,attributes:attributes};};var asIcon$1=function asIcon(_ref){var children=_ref.children,main=_ref.main,mask=_ref.mask,attributes=_ref.attributes,styles=_ref.styles,transform=_ref.transform;if(transformIsMeaningful$1(transform)&&main.found&&!mask.found){var width=main.width,height=main.height;var offset={x:width/height/2,y:0.5};attributes['style']=joinStyles$1(_extends$1$2({},styles,{'transform-origin':offset.x+transform.x/16+'em '+(offset.y+transform.y/16)+'em'}));}return[{tag:'svg',attributes:attributes,children:children}];};var asSymbol$1=function asSymbol(_ref){var prefix=_ref.prefix,iconName=_ref.iconName,children=_ref.children,attributes=_ref.attributes,symbol=_ref.symbol;var id=symbol===true?prefix+'-'+config$1$1.familyPrefix+'-'+iconName:symbol;return[{tag:'svg',attributes:{style:'display: none;'},children:[{tag:'symbol',attributes:_extends$1$2({},attributes,{id:id}),children:children}]}];};function makeInlineSvgAbstract$1(params){var _params$icons=params.icons,main=_params$icons.main,mask=_params$icons.mask,prefix=params.prefix,iconName=params.iconName,transform=params.transform,symbol=params.symbol,title=params.title,extra=params.extra,_params$watchable=params.watchable,watchable=_params$watchable===undefined?false:_params$watchable;var _ref=mask.found?mask:main,width=_ref.width,height=_ref.height;var widthClass='fa-w-'+Math.ceil(width/height*16);var attrClass=[config$1$1.replacementClass,iconName?config$1$1.familyPrefix+'-'+iconName:'',widthClass].concat(extra.classes).join(' ');var content={children:[],attributes:_extends$1$2({},extra.attributes,{'data-prefix':prefix,'data-icon':iconName,'class':attrClass,'role':'img','xmlns':'http://www.w3.org/2000/svg','viewBox':'0 0 '+width+' '+height})};if(watchable){content.attributes[DATA_FA_I2SVG$1]='';}if(title)content.children.push({tag:'title',attributes:{id:content.attributes['aria-labelledby']||'title-'+nextUniqueId$1()},children:[title]});var args=_extends$1$2({},content,{prefix:prefix,iconName:iconName,main:main,mask:mask,transform:transform,symbol:symbol,styles:extra.styles});var _ref2=mask.found&&main.found?makeIconMasking$1(args):makeIconStandard$1(args),children=_ref2.children,attributes=_ref2.attributes;args.children=children;args.attributes=attributes;if(symbol){return asSymbol$1(args);}else{return asIcon$1(args);}}function makeLayersTextAbstract$1(params){var content=params.content,width=params.width,height=params.height,transform=params.transform,title=params.title,extra=params.extra,_params$watchable2=params.watchable,watchable=_params$watchable2===undefined?false:_params$watchable2;var attributes=_extends$1$2({},extra.attributes,title?{'title':title}:{},{'class':extra.classes.join(' ')});if(watchable){attributes[DATA_FA_I2SVG$1]='';}var styles=_extends$1$2({},extra.styles);if(transformIsMeaningful$1(transform)){styles['transform']=transformForCss$1({transform:transform,startCentered:true,width:width,height:height});styles['-webkit-transform']=styles['transform'];}var styleString=joinStyles$1(styles);if(styleString.length>0){attributes['style']=styleString;}var val=[];val.push({tag:'span',attributes:attributes,children:[content]});if(title){val.push({tag:'span',attributes:{class:'sr-only'},children:[title]});}return val;}var noop$2$1=function noop(){};var p$1=config$1$1.measurePerformance&&PERFORMANCE$1&&PERFORMANCE$1.mark&&PERFORMANCE$1.measure?PERFORMANCE$1:{mark:noop$2$1,measure:noop$2$1};var preamble$1='FA "5.0.13"';var begin$1=function begin(name){p$1.mark(preamble$1+' '+name+' begins');return function(){return end$1(name);};};var end$1=function end(name){p$1.mark(preamble$1+' '+name+' ends');p$1.measure(preamble$1+' '+name,preamble$1+' '+name+' begins',preamble$1+' '+name+' ends');};var perf$1={begin:begin$1,end:end$1};/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */var bindInternal4$1=function bindInternal4(func,thisContext){return function(a,b,c,d){return func.call(thisContext,a,b,c,d);};};/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */var reduce$2$1$1=function fastReduceObject(subject,fn,initialValue,thisContext){var keys=Object.keys(subject),length=keys.length,iterator=thisContext!==undefined?bindInternal4$1(fn,thisContext):fn,i,key,result;if(initialValue===undefined){i=1;result=subject[keys[0]];}else{i=0;result=initialValue;}for(;i<length;i++){key=keys[i];result=iterator(result,subject[key],key,subject);}return result;};var styles$2$1$1=namespace$1.styles;var shims$1=namespace$1.shims;var _byUnicode$1={};var _byLigature$1={};var _byOldName$1={};var build$1=function build(){var lookup=function lookup(reducer){return reduce$2$1$1(styles$2$1$1,function(o,style,prefix){o[prefix]=reduce$2$1$1(style,reducer,{});return o;},{});};_byUnicode$1=lookup(function(acc,icon,iconName){acc[icon[3]]=iconName;return acc;});_byLigature$1=lookup(function(acc,icon,iconName){var ligatures=icon[2];acc[iconName]=iconName;ligatures.forEach(function(ligature){acc[ligature]=iconName;});return acc;});var hasRegular='far'in styles$2$1$1;_byOldName$1=reduce$2$1$1(shims$1,function(acc,shim){var oldName=shim[0];var prefix=shim[1];var iconName=shim[2];if(prefix==='far'&&!hasRegular){prefix='fas';}acc[oldName]={prefix:prefix,iconName:iconName};return acc;},{});};build$1();function byUnicode$1(prefix,unicode){return _byUnicode$1[prefix][unicode];}function byLigature$1(prefix,ligature){return _byLigature$1[prefix][ligature];}function byOldName$1(name){return _byOldName$1[name]||{prefix:null,iconName:null};}var styles$1$1$1=namespace$1.styles;var emptyCanonicalIcon$1=function emptyCanonicalIcon(){return{prefix:null,iconName:null,rest:[]};};function getCanonicalIcon$1(values){return values.reduce(function(acc,cls){var iconName=getIconName$1(config$1$1.familyPrefix,cls);if(styles$1$1$1[cls]){acc.prefix=cls;}else if(iconName){var shim=acc.prefix==='fa'?byOldName$1(iconName):{};acc.iconName=shim.iconName||iconName;acc.prefix=shim.prefix||acc.prefix;}else if(cls!==config$1$1.replacementClass&&cls.indexOf('fa-w-')!==0){acc.rest.push(cls);}return acc;},emptyCanonicalIcon$1());}function iconFromMapping$1(mapping,prefix,iconName){if(mapping&&mapping[prefix]&&mapping[prefix][iconName]){return{prefix:prefix,iconName:iconName,icon:mapping[prefix][iconName]};}}function toHtml$1(abstractNodes){var tag=abstractNodes.tag,_abstractNodes$attrib=abstractNodes.attributes,attributes=_abstractNodes$attrib===undefined?{}:_abstractNodes$attrib,_abstractNodes$childr=abstractNodes.children,children=_abstractNodes$childr===undefined?[]:_abstractNodes$childr;if(typeof abstractNodes==='string'){return htmlEscape$1(abstractNodes);}else{return'<'+tag+' '+joinAttributes$1(attributes)+'>'+children.map(toHtml$1).join('')+'</'+tag+'>';}}var noop$1$2=function noop(){};function isWatched$1(node){var i2svg=node.getAttribute?node.getAttribute(DATA_FA_I2SVG$1):null;return typeof i2svg==='string';}function getMutator$1(){if(config$1$1.autoReplaceSvg===true){return mutators$1.replace;}var mutator=mutators$1[config$1$1.autoReplaceSvg];return mutator||mutators$1.replace;}var mutators$1={replace:function replace(mutation){var node=mutation[0];var abstract=mutation[1];var newOuterHTML=abstract.map(function(a){return toHtml$1(a);}).join('\n');if(node.parentNode&&node.outerHTML){node.outerHTML=newOuterHTML+(config$1$1.keepOriginalSource&&node.tagName.toLowerCase()!=='svg'?'<!-- '+node.outerHTML+' -->':'');}else if(node.parentNode){var newNode=document.createElement('span');node.parentNode.replaceChild(newNode,node);newNode.outerHTML=newOuterHTML;}},nest:function nest(mutation){var node=mutation[0];var abstract=mutation[1];// If we already have a replaced node we do not want to continue nesting within it.
// Short-circuit to the standard replacement
if(~classArray$1(node).indexOf(config$1$1.replacementClass)){return mutators$1.replace(mutation);}var forSvg=new RegExp(config$1$1.familyPrefix+'-.*');delete abstract[0].attributes.style;var splitClasses=abstract[0].attributes.class.split(' ').reduce(function(acc,cls){if(cls===config$1$1.replacementClass||cls.match(forSvg)){acc.toSvg.push(cls);}else{acc.toNode.push(cls);}return acc;},{toNode:[],toSvg:[]});abstract[0].attributes.class=splitClasses.toSvg.join(' ');var newInnerHTML=abstract.map(function(a){return toHtml$1(a);}).join('\n');node.setAttribute('class',splitClasses.toNode.join(' '));node.setAttribute(DATA_FA_I2SVG$1,'');node.innerHTML=newInnerHTML;}};function perform$1(mutations,callback){var callbackFunction=typeof callback==='function'?callback:noop$1$2;if(mutations.length===0){callbackFunction();}else{var frame=WINDOW$1.requestAnimationFrame||function(op){return op();};frame(function(){var mutator=getMutator$1();var mark=perf$1.begin('mutate');mutations.map(mutator);mark();callbackFunction();});}}var disabled$1=false;function disableObservation$1(operation){disabled$1=true;operation();disabled$1=false;}var mo$1=null;function observe$1(options){if(!MUTATION_OBSERVER$1)return;var treeCallback=options.treeCallback,nodeCallback=options.nodeCallback,pseudoElementsCallback=options.pseudoElementsCallback;mo$1=new MUTATION_OBSERVER$1(function(objects){if(disabled$1)return;toArray$1$1(objects).forEach(function(mutationRecord){if(mutationRecord.type==='childList'&&mutationRecord.addedNodes.length>0&&!isWatched$1(mutationRecord.addedNodes[0])){if(config$1$1.searchPseudoElements){pseudoElementsCallback(mutationRecord.target);}treeCallback(mutationRecord.target);}if(mutationRecord.type==='attributes'&&mutationRecord.target.parentNode&&config$1$1.searchPseudoElements){pseudoElementsCallback(mutationRecord.target.parentNode);}if(mutationRecord.type==='attributes'&&isWatched$1(mutationRecord.target)&&~ATTRIBUTES_WATCHED_FOR_MUTATION$1.indexOf(mutationRecord.attributeName)){if(mutationRecord.attributeName==='class'){var _getCanonicalIcon=getCanonicalIcon$1(classArray$1(mutationRecord.target)),prefix=_getCanonicalIcon.prefix,iconName=_getCanonicalIcon.iconName;if(prefix)mutationRecord.target.setAttribute('data-prefix',prefix);if(iconName)mutationRecord.target.setAttribute('data-icon',iconName);}else{nodeCallback(mutationRecord.target);}}});});if(!IS_DOM$1)return;mo$1.observe(DOCUMENT$1.getElementsByTagName('body')[0],{childList:true,attributes:true,characterData:true,subtree:true});}function disconnect$1(){if(!mo$1)return;mo$1.disconnect();}var styleParser$1=function styleParser(node){var style=node.getAttribute('style');var val=[];if(style){val=style.split(';').reduce(function(acc,style){var styles=style.split(':');var prop=styles[0];var value=styles.slice(1);if(prop&&value.length>0){acc[prop]=value.join(':').trim();}return acc;},{});}return val;};function toHex$1(unicode){var result='';for(var i=0;i<unicode.length;i++){var hex=unicode.charCodeAt(i).toString(16);result+=('000'+hex).slice(-4);}return result;}var classParser$1=function classParser(node){var existingPrefix=node.getAttribute('data-prefix');var existingIconName=node.getAttribute('data-icon');var innerText=node.innerText!==undefined?node.innerText.trim():'';var val=getCanonicalIcon$1(classArray$1(node));if(existingPrefix&&existingIconName){val.prefix=existingPrefix;val.iconName=existingIconName;}if(val.prefix&&innerText.length>1){val.iconName=byLigature$1(val.prefix,node.innerText);}else if(val.prefix&&innerText.length===1){val.iconName=byUnicode$1(val.prefix,toHex$1(node.innerText));}return val;};var parseTransformString$1=function parseTransformString(transformString){var transform={size:16,x:0,y:0,flipX:false,flipY:false,rotate:0};if(!transformString){return transform;}else{return transformString.toLowerCase().split(' ').reduce(function(acc,n){var parts=n.toLowerCase().split('-');var first=parts[0];var rest=parts.slice(1).join('-');if(first&&rest==='h'){acc.flipX=true;return acc;}if(first&&rest==='v'){acc.flipY=true;return acc;}rest=parseFloat(rest);if(isNaN(rest)){return acc;}switch(first){case'grow':acc.size=acc.size+rest;break;case'shrink':acc.size=acc.size-rest;break;case'left':acc.x=acc.x-rest;break;case'right':acc.x=acc.x+rest;break;case'up':acc.y=acc.y-rest;break;case'down':acc.y=acc.y+rest;break;case'rotate':acc.rotate=acc.rotate+rest;break;}return acc;},transform);}};var transformParser$1=function transformParser(node){return parseTransformString$1(node.getAttribute('data-fa-transform'));};var symbolParser$1=function symbolParser(node){var symbol=node.getAttribute('data-fa-symbol');return symbol===null?false:symbol===''?true:symbol;};var attributesParser$1=function attributesParser(node){var extraAttributes=toArray$1$1(node.attributes).reduce(function(acc,attr){if(acc.name!=='class'&&acc.name!=='style'){acc[attr.name]=attr.value;}return acc;},{});var title=node.getAttribute('title');if(config$1$1.autoA11y){if(title){extraAttributes['aria-labelledby']=config$1$1.replacementClass+'-title-'+nextUniqueId$1();}else{extraAttributes['aria-hidden']='true';}}return extraAttributes;};var maskParser$1=function maskParser(node){var mask=node.getAttribute('data-fa-mask');if(!mask){return emptyCanonicalIcon$1();}else{return getCanonicalIcon$1(mask.split(' ').map(function(i){return i.trim();}));}};function parseMeta$1(node){var _classParser=classParser$1(node),iconName=_classParser.iconName,prefix=_classParser.prefix,extraClasses=_classParser.rest;var extraStyles=styleParser$1(node);var transform=transformParser$1(node);var symbol=symbolParser$1(node);var extraAttributes=attributesParser$1(node);var mask=maskParser$1(node);return{iconName:iconName,title:node.getAttribute('title'),prefix:prefix,transform:transform,symbol:symbol,mask:mask,extra:{classes:extraClasses,styles:extraStyles,attributes:extraAttributes}};}function MissingIcon$1(error){this.name='MissingIcon';this.message=error||'Icon unavailable';this.stack=new Error().stack;}MissingIcon$1.prototype=Object.create(Error.prototype);MissingIcon$1.prototype.constructor=MissingIcon$1;var FILL$1={fill:'currentColor'};var ANIMATION_BASE$1={attributeType:'XML',repeatCount:'indefinite',dur:'2s'};var RING$1={tag:'path',attributes:_extends$1$2({},FILL$1,{d:'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'})};var OPACITY_ANIMATE$1=_extends$1$2({},ANIMATION_BASE$1,{attributeName:'opacity'});var DOT$1={tag:'circle',attributes:_extends$1$2({},FILL$1,{cx:'256',cy:'364',r:'28'}),children:[{tag:'animate',attributes:_extends$1$2({},ANIMATION_BASE$1,{attributeName:'r',values:'28;14;28;28;14;28;'})},{tag:'animate',attributes:_extends$1$2({},OPACITY_ANIMATE$1,{values:'1;0;1;1;0;1;'})}]};var QUESTION$1={tag:'path',attributes:_extends$1$2({},FILL$1,{opacity:'1',d:'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'}),children:[{tag:'animate',attributes:_extends$1$2({},OPACITY_ANIMATE$1,{values:'1;0;0;0;0;1;'})}]};var EXCLAMATION$1={tag:'path',attributes:_extends$1$2({},FILL$1,{opacity:'0',d:'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'}),children:[{tag:'animate',attributes:_extends$1$2({},OPACITY_ANIMATE$1,{values:'0;0;1;1;0;0;'})}]};var missing$1={tag:'g',children:[RING$1,DOT$1,QUESTION$1,EXCLAMATION$1]};var styles$2$1$2=namespace$1.styles;var LAYERS_TEXT_CLASSNAME$1='fa-layers-text';var FONT_FAMILY_PATTERN$1=/Font Awesome 5 (Solid|Regular|Light|Brands)/;var STYLE_TO_PREFIX$1={'Solid':'fas','Regular':'far','Light':'fal','Brands':'fab'};function findIcon$1(iconName,prefix){var val={found:false,width:512,height:512,icon:missing$1};if(iconName&&prefix&&styles$2$1$2[prefix]&&styles$2$1$2[prefix][iconName]){var icon=styles$2$1$2[prefix][iconName];var width=icon[0];var height=icon[1];var vectorData=icon.slice(4);val={found:true,width:width,height:height,icon:{tag:'path',attributes:{fill:'currentColor',d:vectorData[0]}}};}else if(iconName&&prefix&&!config$1$1.showMissingIcons){throw new MissingIcon$1('Icon is missing for prefix '+prefix+' with icon name '+iconName);}return val;}function generateSvgReplacementMutation$1(node,nodeMeta){var iconName=nodeMeta.iconName,title=nodeMeta.title,prefix=nodeMeta.prefix,transform=nodeMeta.transform,symbol=nodeMeta.symbol,mask=nodeMeta.mask,extra=nodeMeta.extra;return[node,makeInlineSvgAbstract$1({icons:{main:findIcon$1(iconName,prefix),mask:findIcon$1(mask.iconName,mask.prefix)},prefix:prefix,iconName:iconName,transform:transform,symbol:symbol,mask:mask,title:title,extra:extra,watchable:true})];}function generateLayersText$1(node,nodeMeta){var title=nodeMeta.title,transform=nodeMeta.transform,extra=nodeMeta.extra;var width=null;var height=null;if(IS_IE$1){var computedFontSize=parseInt(getComputedStyle(node).fontSize,10);var boundingClientRect=node.getBoundingClientRect();width=boundingClientRect.width/computedFontSize;height=boundingClientRect.height/computedFontSize;}if(config$1$1.autoA11y&&!title){extra.attributes['aria-hidden']='true';}return[node,makeLayersTextAbstract$1({content:node.innerHTML,width:width,height:height,transform:transform,title:title,extra:extra,watchable:true})];}function generateMutation$1(node){var nodeMeta=parseMeta$1(node);if(~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME$1)){return generateLayersText$1(node,nodeMeta);}else{return generateSvgReplacementMutation$1(node,nodeMeta);}}function remove$2$1(node){if(typeof node.remove==='function'){node.remove();}else if(node&&node.parentNode){node.parentNode.removeChild(node);}}function searchPseudoElements$1(root){if(!IS_DOM$1)return;var end=perf$1.begin('searchPseudoElements');disableObservation$1(function(){toArray$1$1(root.querySelectorAll('*')).forEach(function(node){[':before',':after'].forEach(function(pos){var styles=WINDOW$1.getComputedStyle(node,pos);var fontFamily=styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN$1);var children=toArray$1$1(node.children);var pseudoElement=children.filter(function(c){return c.getAttribute(DATA_FA_PSEUDO_ELEMENT$1)===pos;})[0];if(pseudoElement){if(pseudoElement.nextSibling&&pseudoElement.nextSibling.textContent.indexOf(DATA_FA_PSEUDO_ELEMENT$1)>-1){remove$2$1(pseudoElement.nextSibling);}remove$2$1(pseudoElement);pseudoElement=null;}if(fontFamily&&!pseudoElement){var content=styles.getPropertyValue('content');var i=DOCUMENT$1.createElement('i');i.setAttribute('class',''+STYLE_TO_PREFIX$1[fontFamily[1]]);i.setAttribute(DATA_FA_PSEUDO_ELEMENT$1,pos);i.innerText=content.length===3?content.substr(1,1):content;if(pos===':before'){node.insertBefore(i,node.firstChild);}else{node.appendChild(i);}}});});});end();}function onTree$1(root){var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;if(!IS_DOM$1)return;var htmlClassList=DOCUMENT$1.documentElement.classList;var hclAdd=function hclAdd(suffix){return htmlClassList.add(HTML_CLASS_I2SVG_BASE_CLASS$1+'-'+suffix);};var hclRemove=function hclRemove(suffix){return htmlClassList.remove(HTML_CLASS_I2SVG_BASE_CLASS$1+'-'+suffix);};var prefixes=Object.keys(styles$2$1$2);var prefixesDomQuery=['.'+LAYERS_TEXT_CLASSNAME$1+':not(['+DATA_FA_I2SVG$1+'])'].concat(prefixes.map(function(p){return'.'+p+':not(['+DATA_FA_I2SVG$1+'])';})).join(', ');if(prefixesDomQuery.length===0){return;}var candidates=toArray$1$1(root.querySelectorAll(prefixesDomQuery));if(candidates.length>0){hclAdd('pending');hclRemove('complete');}else{return;}var mark=perf$1.begin('onTree');var mutations=candidates.reduce(function(acc,node){try{var mutation=generateMutation$1(node);if(mutation){acc.push(mutation);}}catch(e){if(!PRODUCTION$1$1){if(e instanceof MissingIcon$1){console.error(e);}}}return acc;},[]);mark();perform$1(mutations,function(){hclAdd('active');hclAdd('complete');hclRemove('pending');if(typeof callback==='function')callback();});}function onNode$1(node){var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var mutation=generateMutation$1(node);if(mutation){perform$1([mutation],callback);}}var baseStyles$1="svg:not(:root).svg-inline--fa {\n  overflow: visible; }\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em; }\n  .svg-inline--fa.fa-lg {\n    vertical-align: -.225em; }\n  .svg-inline--fa.fa-w-1 {\n    width: 0.0625em; }\n  .svg-inline--fa.fa-w-2 {\n    width: 0.125em; }\n  .svg-inline--fa.fa-w-3 {\n    width: 0.1875em; }\n  .svg-inline--fa.fa-w-4 {\n    width: 0.25em; }\n  .svg-inline--fa.fa-w-5 {\n    width: 0.3125em; }\n  .svg-inline--fa.fa-w-6 {\n    width: 0.375em; }\n  .svg-inline--fa.fa-w-7 {\n    width: 0.4375em; }\n  .svg-inline--fa.fa-w-8 {\n    width: 0.5em; }\n  .svg-inline--fa.fa-w-9 {\n    width: 0.5625em; }\n  .svg-inline--fa.fa-w-10 {\n    width: 0.625em; }\n  .svg-inline--fa.fa-w-11 {\n    width: 0.6875em; }\n  .svg-inline--fa.fa-w-12 {\n    width: 0.75em; }\n  .svg-inline--fa.fa-w-13 {\n    width: 0.8125em; }\n  .svg-inline--fa.fa-w-14 {\n    width: 0.875em; }\n  .svg-inline--fa.fa-w-15 {\n    width: 0.9375em; }\n  .svg-inline--fa.fa-w-16 {\n    width: 1em; }\n  .svg-inline--fa.fa-w-17 {\n    width: 1.0625em; }\n  .svg-inline--fa.fa-w-18 {\n    width: 1.125em; }\n  .svg-inline--fa.fa-w-19 {\n    width: 1.1875em; }\n  .svg-inline--fa.fa-w-20 {\n    width: 1.25em; }\n  .svg-inline--fa.fa-pull-left {\n    margin-right: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-pull-right {\n    margin-left: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-border {\n    height: 1.5em; }\n  .svg-inline--fa.fa-li {\n    width: 2em; }\n  .svg-inline--fa.fa-fw {\n    width: 1.25em; }\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em; }\n  .fa-layers svg.svg-inline--fa {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center; }\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center; }\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right; }\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left; }\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1em; }\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n";var css$1=function css(){var dfp=DEFAULT_FAMILY_PREFIX$1;var drc=DEFAULT_REPLACEMENT_CLASS$1;var fp=config$1$1.familyPrefix;var rc=config$1$1.replacementClass;var s=baseStyles$1;if(fp!==dfp||rc!==drc){var dPatt=new RegExp('\\.'+dfp+'\\-','g');var rPatt=new RegExp('\\.'+drc,'g');s=s.replace(dPatt,'.'+fp+'-').replace(rPatt,'.'+rc);}return s;};function define$1(prefix,icons){var normalized=Object.keys(icons).reduce(function(acc,iconName){var icon=icons[iconName];var expanded=!!icon.icon;if(expanded){acc[icon.iconName]=icon.icon;}else{acc[iconName]=icon;}return acc;},{});if(typeof namespace$1.hooks.addPack==='function'){namespace$1.hooks.addPack(prefix,normalized);}else{namespace$1.styles[prefix]=_extends$1$2({},namespace$1.styles[prefix]||{},normalized);}/**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */if(prefix==='fas'){define$1('fa',icons);}}var Library$1=function(){function Library(){classCallCheck$1$1$1(this,Library);this.definitions={};}createClass$1$1$1(Library,[{key:'add',value:function add(){var _this=this;for(var _len=arguments.length,definitions=Array(_len),_key=0;_key<_len;_key++){definitions[_key]=arguments[_key];}var additions=definitions.reduce(this._pullDefinitions,{});Object.keys(additions).forEach(function(key){_this.definitions[key]=_extends$1$2({},_this.definitions[key]||{},additions[key]);define$1(key,additions[key]);});}},{key:'reset',value:function reset(){this.definitions={};}},{key:'_pullDefinitions',value:function _pullDefinitions(additions,definition){var normalized=definition.prefix&&definition.iconName&&definition.icon?{0:definition}:definition;Object.keys(normalized).map(function(key){var _normalized$key=normalized[key],prefix=_normalized$key.prefix,iconName=_normalized$key.iconName,icon=_normalized$key.icon;if(!additions[prefix])additions[prefix]={};additions[prefix][iconName]=icon;});return additions;}}]);return Library;}();function prepIcon$1(icon){var width=icon[0];var height=icon[1];var vectorData=icon.slice(4);return{found:true,width:width,height:height,icon:{tag:'path',attributes:{fill:'currentColor',d:vectorData[0]}}};}var _cssInserted$1=false;function ensureCss$1(){if(!config$1$1.autoAddCss){return;}if(!_cssInserted$1){insertCss$1(css$1());}_cssInserted$1=true;}function apiObject$1(val,abstractCreator){Object.defineProperty(val,'abstract',{get:abstractCreator});Object.defineProperty(val,'html',{get:function get$$1(){return val.abstract.map(function(a){return toHtml$1(a);});}});Object.defineProperty(val,'node',{get:function get$$1(){if(!IS_DOM$1)return;var container=DOCUMENT$1.createElement('div');container.innerHTML=val.html;return container.children;}});return val;}function findIconDefinition$1(params){var _params$prefix=params.prefix,prefix=_params$prefix===undefined?'fa':_params$prefix,iconName=params.iconName;if(!iconName)return;return iconFromMapping$1(library$1.definitions,prefix,iconName)||iconFromMapping$1(namespace$1.styles,prefix,iconName);}function resolveIcons$1(next){return function(maybeIconDefinition){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var iconDefinition=(maybeIconDefinition||{}).icon?maybeIconDefinition:findIconDefinition$1(maybeIconDefinition||{});var mask=params.mask;if(mask){mask=(mask||{}).icon?mask:findIconDefinition$1(mask||{});}return next(iconDefinition,_extends$1$2({},params,{mask:mask}));};}var library$1=new Library$1();var noAuto$1=function noAuto(){auto$1(false);disconnect$1();};var dom$1={i2svg:function i2svg(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(IS_DOM$1){ensureCss$1();var _params$node=params.node,node=_params$node===undefined?DOCUMENT$1:_params$node,_params$callback=params.callback,callback=_params$callback===undefined?function(){}:_params$callback;if(config$1$1.searchPseudoElements){searchPseudoElements$1(node);}onTree$1(node,callback);}},css:css$1,insertCss:function insertCss$$1(){insertCss$1(css$1());}};var parse$1={transform:function transform(transformString){return parseTransformString$1(transformString);}};var icon$1=resolveIcons$1(function(iconDefinition){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _params$transform=params.transform,transform=_params$transform===undefined?meaninglessTransform$1:_params$transform,_params$symbol=params.symbol,symbol=_params$symbol===undefined?false:_params$symbol,_params$mask=params.mask,mask=_params$mask===undefined?null:_params$mask,_params$title=params.title,title=_params$title===undefined?null:_params$title,_params$classes=params.classes,classes=_params$classes===undefined?[]:_params$classes,_params$attributes=params.attributes,attributes=_params$attributes===undefined?{}:_params$attributes,_params$styles=params.styles,styles=_params$styles===undefined?{}:_params$styles;if(!iconDefinition)return;var prefix=iconDefinition.prefix,iconName=iconDefinition.iconName,icon=iconDefinition.icon;return apiObject$1(_extends$1$2({type:'icon'},iconDefinition),function(){ensureCss$1();if(config$1$1.autoA11y){if(title){attributes['aria-labelledby']=config$1$1.replacementClass+'-title-'+nextUniqueId$1();}else{attributes['aria-hidden']='true';}}return makeInlineSvgAbstract$1({icons:{main:prepIcon$1(icon),mask:mask?prepIcon$1(mask.icon):{found:false,width:null,height:null,icon:{}}},prefix:prefix,iconName:iconName,transform:_extends$1$2({},meaninglessTransform$1,transform),symbol:symbol,title:title,extra:{attributes:attributes,styles:styles,classes:classes}});});});var text$1=function text(content){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _params$transform2=params.transform,transform=_params$transform2===undefined?meaninglessTransform$1:_params$transform2,_params$title2=params.title,title=_params$title2===undefined?null:_params$title2,_params$classes2=params.classes,classes=_params$classes2===undefined?[]:_params$classes2,_params$attributes2=params.attributes,attributes=_params$attributes2===undefined?{}:_params$attributes2,_params$styles2=params.styles,styles=_params$styles2===undefined?{}:_params$styles2;return apiObject$1({type:'text',content:content},function(){ensureCss$1();return makeLayersTextAbstract$1({content:content,transform:_extends$1$2({},meaninglessTransform$1,transform),title:title,extra:{attributes:attributes,styles:styles,classes:[config$1$1.familyPrefix+'-layers-text'].concat(toConsumableArray$1$1(classes))}});});};var layer$1=function layer(assembler){return apiObject$1({type:'layer'},function(){ensureCss$1();var children=[];assembler(function(args){Array.isArray(args)?args.map(function(a){children=children.concat(a.abstract);}):children=children.concat(args.abstract);});return[{tag:'span',attributes:{class:config$1$1.familyPrefix+'-layers'},children:children}];});};var api$1$1={noAuto:noAuto$1,dom:dom$1,library:library$1,parse:parse$1,findIconDefinition:findIconDefinition$1,icon:icon$1,text:text$1,layer:layer$1};var autoReplace$1=function autoReplace(){if(IS_DOM$1&&config$1$1.autoReplaceSvg)api$1$1.dom.i2svg({node:DOCUMENT$1});};function bootstrap$1(){if(IS_BROWSER$1){if(!WINDOW$1.FontAwesome){WINDOW$1.FontAwesome=api$1$1;}domready$1(function(){if(Object.keys(namespace$1.styles).length>0){autoReplace$1();}if(config$1$1.observeMutations&&typeof MutationObserver==='function'){observe$1({treeCallback:onTree$1,nodeCallback:onNode$1,pseudoElementsCallback:searchPseudoElements$1});}});}namespace$1.hooks=_extends$1$2({},namespace$1.hooks,{addPack:function addPack(prefix,icons){namespace$1.styles[prefix]=_extends$1$2({},namespace$1.styles[prefix]||{},icons);build$1();autoReplace$1();},addShims:function addShims(shims){var _namespace$shims;(_namespace$shims=namespace$1.shims).push.apply(_namespace$shims,toConsumableArray$1$1(shims));build$1();autoReplace$1();}});}Object.defineProperty(api$1$1,'config',{get:function get$$1(){return config$1$1;},set:function set$$1(newConfig){update$2$1(newConfig);}});if(IS_DOM$1)bunker$1(bootstrap$1);var commonjsGlobal$1$1=typeof window!=='undefined'?window:typeof global!=='undefined'?global:typeof self!=='undefined'?self:{};function createCommonjsModule$1$1$1(fn,module){return module={exports:{}}, fn(module,module.exports), module.exports;}var humps$1=createCommonjsModule$1$1$1(function(module){// =========
// = humps =
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
(function(global){var _processKeys=function _processKeys(convert,obj,options){if(!_isObject(obj)||_isDate(obj)||_isRegExp(obj)||_isBoolean(obj)||_isFunction(obj)){return obj;}var output,i=0,l=0;if(_isArray(obj)){output=[];for(l=obj.length;i<l;i++){output.push(_processKeys(convert,obj[i],options));}}else{output={};for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){output[convert(key,options)]=_processKeys(convert,obj[key],options);}}}return output;};// String conversion methods
var separateWords=function separateWords(string,options){options=options||{};var separator=options.separator||'_';var split=options.split||/(?=[A-Z])/;return string.split(split).join(separator);};var camelize=function camelize(string){if(_isNumerical(string)){return string;}string=string.replace(/[\-_\s]+(.)?/g,function(match,chr){return chr?chr.toUpperCase():'';});// Ensure 1st char is always lowercase
return string.substr(0,1).toLowerCase()+string.substr(1);};var pascalize=function pascalize(string){var camelized=camelize(string);// Ensure 1st char is always uppercase
return camelized.substr(0,1).toUpperCase()+camelized.substr(1);};var decamelize=function decamelize(string,options){return separateWords(string,options).toLowerCase();};// Utilities
// Taken from Underscore.js
var toString=Object.prototype.toString;var _isFunction=function _isFunction(obj){return typeof obj==='function';};var _isObject=function _isObject(obj){return obj===Object(obj);};var _isArray=function _isArray(obj){return toString.call(obj)=='[object Array]';};var _isDate=function _isDate(obj){return toString.call(obj)=='[object Date]';};var _isRegExp=function _isRegExp(obj){return toString.call(obj)=='[object RegExp]';};var _isBoolean=function _isBoolean(obj){return toString.call(obj)=='[object Boolean]';};// Performant way to determine if obj coerces to a number
var _isNumerical=function _isNumerical(obj){obj=obj-0;return obj===obj;};// Sets up function which handles processing keys
// allowing the convert function to be modified by a callback
var _processor=function _processor(convert,options){var callback=options&&'process'in options?options.process:options;if(typeof callback!=='function'){return convert;}return function(string,options){return callback(string,convert,options);};};var humps={camelize:camelize,decamelize:decamelize,pascalize:pascalize,depascalize:decamelize,camelizeKeys:function camelizeKeys(object,options){return _processKeys(_processor(camelize,options),object);},decamelizeKeys:function decamelizeKeys(object,options){return _processKeys(_processor(decamelize,options),object,options);},pascalizeKeys:function pascalizeKeys(object,options){return _processKeys(_processor(pascalize,options),object);},depascalizeKeys:function depascalizeKeys(){return this.decamelizeKeys.apply(this,arguments);}};if(typeof undefined==='function'&&undefined.amd){undefined(humps);}else if('object'!=='undefined'&&module.exports){module.exports=humps;}else{global.humps=humps;}})(commonjsGlobal$1$1);});var _typeof$1$2=typeof Symbol==="function"&&_typeof$1$1(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof$1$1(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof$1$1(obj);};var defineProperty$1$1=function defineProperty$1(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;};var _extends$2$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var objectWithoutProperties$1$1$1=function objectWithoutProperties$1(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;};var toConsumableArray$2$1=function toConsumableArray$2(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}};function capitalize$1$1(val){return val.charAt(0).toUpperCase()+val.slice(1);}function styleToObject$1(style){return style.split(';').map(function(s){return s.trim();}).filter(function(s){return s;}).reduce(function(acc,pair){var i=pair.indexOf(':');var prop=humps$1.camelize(pair.slice(0,i));var value=pair.slice(i+1).trim();prop.startsWith('webkit')?acc[capitalize$1$1(prop)]=value:acc[prop]=value;return acc;},{});}function convert$1(createElement$$1,element){var extraProps=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var children=(element.children||[]).map(convert$1.bind(null,createElement$$1));var mixins=Object.keys(element.attributes||{}).reduce(function(acc,key){var val=element.attributes[key];switch(key){case'class':acc.attrs['className']=val;delete element.attributes['class'];break;case'style':acc.attrs['style']=styleToObject$1(val);break;default:if(key.indexOf('aria-')===0||key.indexOf('data-')===0){acc.attrs[key.toLowerCase()]=val;}else{acc.attrs[humps$1.camelize(key)]=val;}}return acc;},{attrs:{}});var _extraProps$style=extraProps.style,existingStyle=_extraProps$style===undefined?{}:_extraProps$style,remaining=objectWithoutProperties$1$1$1(extraProps,['style']);mixins.attrs['style']=_extends$2$1({},mixins.attrs['style'],existingStyle);return createElement$$1.apply(undefined,[element.tag,_extends$2$1({},mixins.attrs,remaining)].concat(toConsumableArray$2$1(children)));}var PRODUCTION$1$2=false;try{PRODUCTION$1$2=process.env.NODE_ENV==='production';}catch(e){}var log$1=function log(){if(!PRODUCTION$1$2&&console&&typeof console.error==='function'){var _console;(_console=console).error.apply(_console,arguments);}};function objectWithKey$1(key,value){return Array.isArray(value)&&value.length>0||!Array.isArray(value)&&value?defineProperty$1$1({},key,value):{};}function classList$1(props){var _classes;var classes=(_classes={'fa-spin':props.spin,'fa-pulse':props.pulse,'fa-fw':props.fixedWidth,'fa-border':props.border,'fa-li':props.listItem,'fa-flip-horizontal':props.flip==='horizontal'||props.flip==='both','fa-flip-vertical':props.flip==='vertical'||props.flip==='both'}, defineProperty$1$1(_classes,'fa-'+props.size,props.size!==null), defineProperty$1$1(_classes,'fa-rotate-'+props.rotation,props.rotation!==null), defineProperty$1$1(_classes,'fa-pull-'+props.pull,props.pull!==null), _classes);return Object.keys(classes).map(function(key){return classes[key]?key:null;}).filter(function(key){return key;});}function normalizeIconArgs$1(icon$$1){if(icon$$1===null){return null;}if((typeof icon$$1==='undefined'?'undefined':_typeof$1$2(icon$$1))==='object'&&icon$$1.prefix&&icon$$1.iconName){return icon$$1;}if(Array.isArray(icon$$1)&&icon$$1.length===2){return{prefix:icon$$1[0],iconName:icon$$1[1]};}if(typeof icon$$1==='string'){return{prefix:'fas',iconName:icon$$1};}}function FontAwesomeIcon$1$1(props){var iconArgs=props.icon,maskArgs=props.mask,symbol=props.symbol,className=props.className;var icon$$1=normalizeIconArgs$1(iconArgs);var classes=objectWithKey$1('classes',[].concat(toConsumableArray$2$1(classList$1(props)),toConsumableArray$2$1(className.split(' '))));var transform=objectWithKey$1('transform',typeof props.transform==='string'?api$1$1.parse.transform(props.transform):props.transform);var mask=objectWithKey$1('mask',normalizeIconArgs$1(maskArgs));var renderedIcon=api$1$1.icon(icon$$1,_extends$2$1({},classes,transform,mask,{symbol:symbol}));if(!renderedIcon){log$1('Could not find icon',icon$$1);return null;}var abstract=renderedIcon.abstract;var convertCurry=convert$1.bind(null,React.createElement);var extraProps={};Object.keys(props).forEach(function(key){if(!FontAwesomeIcon$1$1.defaultProps.hasOwnProperty(key))extraProps[key]=props[key];});return convertCurry(abstract[0],extraProps);}FontAwesomeIcon$1$1.propTypes={border:PropTypes.bool,className:PropTypes.string,mask:PropTypes.oneOfType([PropTypes.object,PropTypes.array,PropTypes.string]),fixedWidth:PropTypes.bool,flip:PropTypes.oneOf(['horizontal','vertical','both']),icon:PropTypes.oneOfType([PropTypes.object,PropTypes.array,PropTypes.string]),listItem:PropTypes.bool,pull:PropTypes.oneOf(['right','left']),pulse:PropTypes.bool,name:PropTypes.string,rotation:PropTypes.oneOf([90,180,270]),size:PropTypes.oneOf(['lg','xs','sm','1x','2x','3x','4x','5x','6x','7x','8x','9x','10x']),spin:PropTypes.bool,symbol:PropTypes.oneOfType([PropTypes.bool,PropTypes.string]),transform:PropTypes.oneOfType([PropTypes.string,PropTypes.object])};FontAwesomeIcon$1$1.defaultProps={border:false,className:'',mask:null,fixedWidth:false,flip:null,icon:null,listItem:false,pull:null,pulse:false,name:'',rotation:null,size:null,spin:false,symbol:false,transform:null};api$1$1.noAuto();var faCheck$1={prefix:'fas',iconName:'check',icon:[512,512,[],"f00c","M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"]};var _templateObject$2$1=taggedTemplateLiteral$1$1(["\n  grid-template-areas: \"checkbox\";\n\n  > input[type=\"checkbox\"] {\n    display: none;\n  }\n\n  > input[type=\"checkbox\"]:checked + label {\n    display: block;\n  }\n"],["\n  grid-template-areas: \"checkbox\";\n\n  > input[type=\"checkbox\"] {\n    display: none;\n  }\n\n  > input[type=\"checkbox\"]:checked + label {\n    display: block;\n  }\n"]);var OuterWrapper$1$1=system({size:"1.25rem",display:"grid",bg:"white",justifyContent:"center",alignItems:"center"}).extend(_templateObject$2$1);var _templateObject$3$1=taggedTemplateLiteral$1$1(["\n  grid-area: checkbox;\n  box-sizing: border-box;\n"],["\n  grid-area: checkbox;\n  box-sizing: border-box;\n"]);var LabelWrapper$1=system({is:"label",size:"1rem",display:"none",bg:"white",color:"black",hover:{color:"black"}},"space").extend(_templateObject$3$1);/**
 * Checkbox component for the offcourse project
 */var Checkbox$1=function(_Component){inherits$1$1(Checkbox,_Component);function Checkbox(){var _ref;var _temp,_this,_ret;classCallCheck$1$2(this,Checkbox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$1$1(this,(_ref=Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).call.apply(_ref,[this].concat(args))), _this), _this.state={checked:_this.props.checked}, _this.handleClick=function(e){e.preventDefault();var onToggle=_this.props.onToggle;_this.setState(function(_ref2){var checked=_ref2.checked;return{checked:!checked};},function(){return onToggle(_this.state);});}, _temp), possibleConstructorReturn$1$1(_this,_ret);}createClass$1$2(Checkbox,[{key:"render",value:function render(){var checked=this.state.checked;return React.createElement(OuterWrapper$1$1,{onClick:this.handleClick},React.createElement("input",{type:"checkbox",readOnly:true,checked:checked}),React.createElement(LabelWrapper$1,null,React.createElement(FontAwesomeIcon$1$1,{icon:faCheck$1})));}}]);return Checkbox;}(Component);Checkbox$1.propTypes={/**  allows the user to directly decide if the value is checked or not */checked:PropTypes.bool,/** an optional callback that triggers when the checkbox changes its value */onToggle:PropTypes.func};Checkbox$1.defaultProps={checked:false,onToggle:function onToggle(){return null;}};var _templateObject$4$1=taggedTemplateLiteral$1$1(["\n"],["\n"]);var Container$1=system({display:"flex",flexDirection:"column",bg:"white",alignItems:"stretch",justifyContent:"flex-start",fontSize:1,minWidth:"18rem",maxWidth:"40rem",width:"40rem",flex:1,px:0,py:0,mx:6,my:6,opactity:1}).extend(_templateObject$4$1);var _templateObject$5$1=taggedTemplateLiteral$1$1(["\n"],["\n"]);var Group$1=system({display:"flex",flexDirection:"column",alignItems:"flex-start",justifyContent:"flex-start",flex:1,mt:0,px:0,pb:0,pt:0},"height","color").extend(_templateObject$5$1);var HeadingWrapper$1=system({m:0,color:"inherit",lineHeight:2,fontSize:3},function(props){return{fontFamily:props.theme.fonts.bold,userSelect:"none",textDecoration:"inherit",cursor:props.href?"pointer":"cursor","&:hover":{color:props.href?dist_3$1("colors.primary")(props):dist_3$1("colors.black")(props)}};});/**
 * Heading Component for the Offcourse Project
 */var Heading$1=function(_Component){inherits$1$1(Heading,_Component);function Heading(){var _ref;var _temp,_this,_ret;classCallCheck$1$2(this,Heading);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$1$1(this,(_ref=Heading.__proto__||Object.getPrototypeOf(Heading)).call.apply(_ref,[this].concat(args))), _this), _this.handleClick=function(event){var _this$props=_this.props,onClick=_this$props.onClick,href=_this$props.href;if(onClick){event.preventDefault();onClick({href:href});}}, _temp), possibleConstructorReturn$1$1(_this,_ret);}createClass$1$2(Heading,[{key:"render",value:function render(){var _props=this.props,children=_props.children,href=_props.href,size=_props.size;return React.createElement(HeadingWrapper$1,{is:href?"a":"h1",onClick:this.handleClick,href:href,lineHeight:size==="small"?1:2,fontSize:size==="small"?2:3},formatTitle$1$1(children));}}]);return Heading;}(Component);Heading$1.propTypes={/** The actual text of the header */children:PropTypes.string.isRequired,/** Field that indicates the size of the header */size:PropTypes.oneOf(["small","regular"]),/** Headings can optionally link to other documents, etc */href:PropTypes.string};Heading$1.defaultProps={size:"regular"};var faBars$1={prefix:'fas',iconName:'bars',icon:[448,512,[],"f0c9","M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"]};var faTimes$1={prefix:'fas',iconName:'times',icon:[352,512,[],"f00d","M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]};var faPlus$1={prefix:'fas',iconName:'plus',icon:[448,512,[],"f067","M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]};var faSort$1={prefix:'fas',iconName:'sort',icon:[320,512,[],"f0dc","M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"]};var faEye$1={prefix:'fas',iconName:'eye',icon:[576,512,[],"f06e","M569.354 231.631C512.969 135.949 407.81 72 288 72 168.14 72 63.004 135.994 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.031 376.051 168.19 440 288 440c119.86 0 224.996-63.994 281.354-159.631a47.997 47.997 0 0 0 0-48.738zM288 392c-75.162 0-136-60.827-136-136 0-75.162 60.826-136 136-136 75.162 0 136 60.826 136 136 0 75.162-60.826 136-136 136zm104-136c0 57.438-46.562 104-104 104s-104-46.562-104-104c0-17.708 4.431-34.379 12.236-48.973l-.001.032c0 23.651 19.173 42.823 42.824 42.823s42.824-19.173 42.824-42.823c0-23.651-19.173-42.824-42.824-42.824l-.032.001C253.621 156.431 270.292 152 288 152c57.438 0 104 46.562 104 104z"]};var faClock$1={prefix:'fas',iconName:'clock',icon:[512,512,[],"f017","M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm57.1 350.1L224.9 294c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v137.7l63.5 46.2c5.4 3.9 6.5 11.4 2.6 16.8l-28.2 38.8c-3.9 5.3-11.4 6.5-16.8 2.6z"]};var faRocket$1={prefix:'fas',iconName:'rocket',icon:[512,512,[],"f135","M505.1 19.1C503.8 13 499 8.2 492.9 6.9 460.7 0 435.5 0 410.4 0 307.2 0 245.3 55.2 199.1 128H94.9c-18.2 0-34.8 10.3-42.9 26.5L2.6 253.3c-8 16 3.6 34.7 21.5 34.7h95.1c-5.9 12.8-11.9 25.5-18 37.7-3.1 6.2-1.9 13.6 3 18.5l63.6 63.6c4.9 4.9 12.3 6.1 18.5 3 12.2-6.1 24.9-12 37.7-17.9V488c0 17.8 18.8 29.4 34.7 21.5l98.7-49.4c16.3-8.1 26.5-24.8 26.5-42.9V312.8c72.6-46.3 128-108.4 128-211.1.1-25.2.1-50.4-6.8-82.6zM400 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]};var faThermometerEmpty$1={prefix:'fas',iconName:'thermometer-empty',icon:[256,512,[],"f2cb","M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]};var faThermometerHalf$1={prefix:'fas',iconName:'thermometer-half',icon:[256,512,[],"f2c9","M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]};var faThermometerFull$1={prefix:'fas',iconName:'thermometer-full',icon:[256,512,[],"f2c7","M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"]};var faCalendarAlt$1={prefix:'fas',iconName:'calendar-alt',icon:[448,512,[],"f073","M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm116 204c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm128 128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm128 128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40z"]};var faFacebook$1={prefix:'fab',iconName:'facebook',icon:[448,512,[],"f09a","M448 56.7v398.5c0 13.7-11.1 24.7-24.7 24.7H309.1V306.5h58.2l8.7-67.6h-67v-43.2c0-19.6 5.4-32.9 33.5-32.9h35.8v-60.5c-6.2-.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9h-58.4v67.6h58.4V480H24.7C11.1 480 0 468.9 0 455.3V56.7C0 43.1 11.1 32 24.7 32h398.5c13.7 0 24.8 11.1 24.8 24.7z"]};var faTwitter$1={prefix:'fab',iconName:'twitter',icon:[512,512,[],"f099","M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"]};var faAsterisk$1={prefix:'fas',iconName:'asterisk',icon:[512,512,[],"f069","M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"]};var icons$1=Object.freeze({hamburger:faBars$1,checkmark:faCheck$1,remove:faTimes$1,add:faPlus$1,sort:faSort$1,eye:faEye$1,clock:faClock$1,rocket:faRocket$1,beginner:faThermometerEmpty$1,advanced:faThermometerHalf$1,expert:faThermometerFull$1,calendar:faCalendarAlt$1,facebook:faFacebook$1,twitter:faTwitter$1,asterisk:faAsterisk$1});var _templateObject$6$1=taggedTemplateLiteral$1$1(["\n  box-sizing: border-box;\n"],["\n  box-sizing: border-box;\n"]);var IconWrapper$1=system({is:"i",m:0,p:0,border:0,fontSize:1,lineHeight:1,color:"black",bg:"transparent",hover:{color:"primary"},focus:{outline:"none",color:"primary"}}).extend(_templateObject$6$1);/**
 * Icon Component for the Offcourse Project
 */var Icon$1=function(_Component){inherits$1$1(Icon,_Component);function Icon(){classCallCheck$1$2(this,Icon);return possibleConstructorReturn$1$1(this,(Icon.__proto__||Object.getPrototypeOf(Icon)).apply(this,arguments));}createClass$1$2(Icon,[{key:"icon",value:function icon$$1(){var name=this.props.name;return icons$1[name];}},{key:"render",value:function render(){var _props=this.props,size=_props.size,color=_props.color,spin=_props.spin,tabIndex=_props.tabIndex,name=_props.name,href=_props.href,is=_props.is,onClick=_props.onClick;return React.createElement(IconWrapper$1,{is:is||href&&"a"||onClick&&"button",type:is==="button"&&"button"||onClick&&"button",color:color,tabIndex:tabIndex,onClick:onClick},React.createElement(FontAwesomeIcon$1$1,{icon:this.icon(),size:Icon.sizes[size],spin:spin}));}}]);return Icon;}(Component);Icon$1.propTypes={/** Name name of the icon */name:PropTypes.oneOf(Object.keys(icons$1)),/** Size of the icon */size:PropTypes.oneOf(["small","medium","large"]),/** Url that the button should link to */href:PropTypes.string,/** Indicates if the icon should be spinning */spin:PropTypes.bool,/** Callback that the button should execute when clicked */onClick:PropTypes.func};Icon$1.defaultProps={size:"medium",spin:false};Icon$1.sizes={small:"xs",medium:"lg",large:"2x"};var ItemWrapper$1=system({is:"div",display:"grid",bg:"grayScale.1",px:4,py:4,lineHeight:1,fontSize:1,alignItems:"center",justifyContent:"space-between",color:"black",hover:{backgroundColor:"primary",color:"white"},gridTemplateColumns:"1fr"},function(props){return{boxSizing:"border-box",textDecoration:"inherit",fontFamily:props.theme.fonts.bold,userSelect:"none"};});var Item$1=function(_Component){inherits$1$1(Item,_Component);function Item(){classCallCheck$1$2(this,Item);return possibleConstructorReturn$1$1(this,(Item.__proto__||Object.getPrototypeOf(Item)).apply(this,arguments));}createClass$1$2(Item,[{key:"renderChildren",value:function renderChildren(){var _props=this.props,href=_props.href,children=_props.children;return href?React.createElement(Item.Link,{href:href},children):children;}},{key:"render",value:function render(){var _props2=this.props,children=_props2.children,is=_props2.is,href=_props2.href,gridTemplateColumns=_props2.gridTemplateColumns;return React.createElement(ItemWrapper$1,{is:is,gridTemplateColumns:gridTemplateColumns},this.renderChildren());}}]);return Item;}(Component);Item$1.propTypes={children:PropTypes.oneOfType([PropTypes.string,PropTypes.element,PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string,PropTypes.element]))]).isRequired};Item$1.Link=function(_ref){var href=_ref.href,children=_ref.children;return React.createElement(Link$1,{basic:true,href:href},children);};Item$1.Content=function(_ref2){var children=_ref2.children;return React.createElement(Label$1,null,children);};var _templateObject$7$1=taggedTemplateLiteral$1$1(["\n  ::placeholder {\n    color: ",";\n  }\n\n  ::selection {\n    background: ",";\n    color: white;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"],["\n  ::placeholder {\n    color: ",";\n  }\n\n  ::selection {\n    background: ",";\n    color: white;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]);var BaseWrapper$1=system({is:"input",bg:"grayScale.1",color:"text",p:0,px:6,m:0,border:0,fontSize:1,lineHeight:1,justifyContent:"center",alignContent:"center",width:"100%"},function(props){return{fontFamily:props.theme.fonts.bold,boxSizing:"border-box"};}).extend(_templateObject$7$1,function(_ref){var theme=_ref.theme;return theme.colors.mediumGray;},function(_ref2){var theme=_ref2.theme;return theme.colors.primary;});var _templateObject$8$1=taggedTemplateLiteral$1$1([""],[""]);var InputWrapper$1=BaseWrapper$1.extend(_templateObject$8$1);var _templateObject$9$1=taggedTemplateLiteral$1$1(["\n  box-sizing: \"border-box\";\n  grid-template-areas: \"input\";\n  .icons, button {\n    padding: 0;\n    background-color: rgba(255, 255, 255, 0);\n    color: ",";\n    grid-area: input;\n    justify-self: end;\n    z-index: 1;\n  }\n"],["\n  box-sizing: \"border-box\";\n  grid-template-areas: \"input\";\n  .icons, button {\n    padding: 0;\n    background-color: rgba(255, 255, 255, 0);\n    color: ",";\n    grid-area: input;\n    justify-self: end;\n    z-index: 1;\n  }\n"]);var OuterWrapper$1$2=system({display:"flex",flex:1,alignItems:"center",pb:4,pt:4,m:0,border:0,borderColor:"negative",bg:"grayScale.1"}).extend(_templateObject$9$1,function(_ref){var theme=_ref.theme;return theme.colors.grayScale[2];});var _templateObject$10$1=taggedTemplateLiteral$1$1(["\n  height: 10rem;\n  resize: none;\n"],["\n  height: 10rem;\n  resize: none;\n"]);var TextAreaWrapper$1=BaseWrapper$1.extend(_templateObject$10$1);var Input$1=function(_Component){inherits$1$1(Input,_Component);function Input(){classCallCheck$1$2(this,Input);return possibleConstructorReturn$1$1(this,(Input.__proto__||Object.getPrototypeOf(Input)).apply(this,arguments));}createClass$1$2(Input,[{key:"render",value:function render(){var _props=this.props,mb=_props.mb,pt=_props.pt,pb=_props.pb,variant=_props.variant,children=_props.children,hasErrors=_props.hasErrors,name=_props.name,value=_props.value,placeholder=_props.placeholder,onChange=_props.onChange,type=_props.type,onBlur=_props.onBlur;return React.createElement(OuterWrapper$1$2,{border:hasErrors?2:0,pb:pb,pt:pt,mb:mb},variant==="textarea"?React.createElement(TextAreaWrapper$1,{is:"textarea",rows:"4",name:name,value:value,placeholder:placeholder,onChange:onChange,onBlur:onBlur}):React.createElement(InputWrapper$1,{name:name,type:type,value:value,placeholder:formatTitle$1$1(placeholder),onChange:onChange,onBlur:onBlur,fontSize:variant==="small"?1:3,lineHeight:variant==="small"?1:3}),children&&React.createElement(Group$1,{px:6,alignItems:"flex-end"},children));}}]);return Input;}(Component);Input$1.propTypes={/** name of the input */name:PropTypes.string.isRequired,/** value of the input, if you set this, onChange is required*/value:PropTypes.string,/** callback that is triggered when the field changes its value */onChange:PropTypes.func,/** placeholder for absent value */placeholder:PropTypes.string,/** callback that is triggered when the field loses focus */onBlur:PropTypes.func,/** property that indicates if the field has erors */hasErrors:PropTypes.bool,/** property that changes the visual representation of the field */variant:PropTypes.oneOf(["default","textarea","small"])};Input$1.defaultProps={variant:"default"};var LabelWrapper$2$1=system({is:"div",p:0,color:"black",m:0},function(props){return{fontFamily:props.theme.fonts.bold,fontWeight:700,display:props.is==="span"?"inline-block":"block",userSelect:"none"};});var Label$1=function(_Component){inherits$1$1(Label,_Component);function Label(){classCallCheck$1$2(this,Label);return possibleConstructorReturn$1$1(this,(Label.__proto__||Object.getPrototypeOf(Label)).apply(this,arguments));}createClass$1$2(Label,[{key:"render",value:function render(){var _props=this.props,color=_props.color,children=_props.children,px=_props.px,pt=_props.pt,pb=_props.pb,is=_props.is;var label=formatTitle$1$1(children);return React.createElement(LabelWrapper$2$1,{color:color,is:is,pt:pt,pb:pb,px:px},label);}}]);return Label;}(Component);Label$1.propTypes={/** The actual text of the label */children:PropTypes.string.isRequired};var _templateObject$11$1=taggedTemplateLiteral$1$1(["\n  user-select: none;\n  font-family: ",";\n  box-sizing: border-box;\n  text-decoration: inherit;\n"],["\n  user-select: none;\n  font-family: ",";\n  box-sizing: border-box;\n  text-decoration: inherit;\n"]);var LinkWrapper$1=system({is:"a",alignSelf:"flex-start",lineHeight:0,borderBottom:2,pb:0,color:"black",fontSize:1,m:0,mr:0,mb:0,focus:{outline:"none"}},function(props){return{borderColor:props.disabled?dist_3$1("colors.disabled")(props):dist_3$1("colors.black")(props),cursor:props.disabled?"default":"pointer","&:hover":{color:props.disabled?dist_3$1("colors.disabled")(props):dist_3$1("colors.black")(props),borderColor:props.disabled?dist_3$1("colors.disabled")(props):dist_3$1("colors.primary")(props)}};}).extend(_templateObject$11$1,function(_ref){var theme$$1=_ref.theme;return theme$$1.fonts.bold;});/**
 * The link component for the Offcourse project
 */var Link$1=function(_Component){inherits$1$1(Link,_Component);function Link(){classCallCheck$1$2(this,Link);return possibleConstructorReturn$1$1(this,(Link.__proto__||Object.getPrototypeOf(Link)).apply(this,arguments));}createClass$1$2(Link,[{key:"color",value:function color(){var _props=this.props,active=_props.active,disabled=_props.disabled;if(disabled){return"disabled";}if(active){return"primary";}return"black";}},{key:"render",value:function render(){var _props2=this.props,active=_props2.active,basic=_props2.basic,href=_props2.href,children=_props2.children,onClick=_props2.onClick,disabled=_props2.disabled;return React.createElement(LinkWrapper$1,{color:this.color(),borderBottom:basic?0:2,onClick:!disabled?onClick:function(){},href:!disabled?href:undefined,disabled:disabled},formatTitle$1$1(children));}}]);return Link;}(Component);Link$1.propTypes={/** determines if the link should only have basic styling*/basic:PropTypes.bool,/** determines if the link is in an active state*/active:PropTypes.bool,/** determines if the link should be disabled */disabled:PropTypes.bool,/** the text that is displayed on the link */children:PropTypes.string,/** code that the link should execute when clicked */onClick:PropTypes.func,/** a url that the link should link to, automatically turns the link into the basic type */href:PropTypes.string};Link$1.defaultProps={disabled:false,type:"link"};var Loading$1=function(_Component){inherits$1$1(Loading,_Component);function Loading(){classCallCheck$1$2(this,Loading);return possibleConstructorReturn$1$1(this,(Loading.__proto__||Object.getPrototypeOf(Loading)).apply(this,arguments));}createClass$1$2(Loading,[{key:"render",value:function render(){var size=this.props.size;return React.createElement(Icon$1,{name:"asterisk",size:size,spin:true});}}]);return Loading;}(Component);Loading$1.propTypes={size:PropTypes.oneOf(["small","medium","large"])};Loading$1.defaultProps={size:"lg"};var LogoWrapper$1=system({is:"div",bg:"black",hover:{backgroundColor:"primary"}},function(props){return{height:props.theme.logo.dimensions.height*props.multiply+"rem",width:props.theme.logo.dimensions.width*props.multiply+"rem",background:"url("+props.theme.logo.svg+") no-repeat top left",backgroundColor:""+props.theme.logo.background,backgroundSize:"contain",boxSizing:"border-box"};});/**
 * The logo component for the Offcourse project
 */var sizes$1={small:2,medium:4,large:6};var Logo$1=function(_Component){inherits$1$1(Logo,_Component);function Logo(){classCallCheck$1$2(this,Logo);return possibleConstructorReturn$1$1(this,(Logo.__proto__||Object.getPrototypeOf(Logo)).apply(this,arguments));}createClass$1$2(Logo,[{key:"render",value:function render(){var _props=this.props,size=_props.size,onClick=_props.onClick;return React.createElement(LogoWrapper$1,{onClick:onClick,multiply:sizes$1[size]});}}]);return Logo;}(Component);Logo$1.defaultProps={size:"small"};Logo$1.propTypes={/** code that the logo should execute when clicked */onClick:PropTypes.func};var _templateObject$12$1=taggedTemplateLiteral$1$1(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  width: 100%;\n"],["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  width: 100%;\n"]);var _templateObject2$1=taggedTemplateLiteral$1$1(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-content: stretch;\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-content: stretch;\n"]);var _templateObject3$1=taggedTemplateLiteral$1$1(["\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n"],["\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n"]);var MasonryWrapper$1=styled.div(_templateObject$12$1);var ColumnWrapper$1=styled.div(_templateObject2$1);var ItemWrapper$2$1=styled.div(_templateObject3$1);var reduceIndexed$1=addIndex$2(reduce$2$1);var Masonry$1=function(_React$Component){inherits$1$1(Masonry,_React$Component);function Masonry(){var _ref;var _temp,_this,_ret;classCallCheck$1$2(this,Masonry);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$1$1(this,(_ref=Masonry.__proto__||Object.getPrototypeOf(Masonry)).call.apply(_ref,[this].concat(args))), _this), _this.state={numberOfColumns:1}, _this.onResize=function(){var numberOfColumns=_this.state.numberOfColumns;var proposal=_this.getColumns(_this.masonry.offsetWidth);if(proposal!==numberOfColumns){_this.setState({numberOfColumns:proposal});}}, _temp), possibleConstructorReturn$1$1(_this,_ret);}createClass$1$2(Masonry,[{key:"componentDidMount",value:function componentDidMount(){this.onResize();window.addEventListener("resize",this.onResize);}},{key:"getColumns",value:function getColumns(containerWidth){var breakpoints=this.props.breakpoints;return reduceWhile$2(function(_,breakpoint){return breakpoint<containerWidth;},inc$2,1,breakpoints);}},{key:"prepareGrid",value:function prepareGrid(){var children=this.props.children;var numberOfColumns=this.state.numberOfColumns;return reduceIndexed$1(function(acc,child,index){return adjust$2(append$2(child),index%numberOfColumns,acc);},repeat$2([],numberOfColumns),children);}},{key:"render",value:function render(){var _this2=this;return React.createElement(MasonryWrapper$1,{innerRef:function innerRef(el){_this2.masonry=el;}},this.prepareGrid().map(function(col,ci){return React.createElement(ColumnWrapper$1,{key:ci},col.map(function(child,i){return React.createElement(ItemWrapper$2$1,{key:i},child);}));}));}}]);return Masonry;}(React.Component);Masonry$1.propTypes={breakpoints:PropTypes.arrayOf(PropTypes.number)};Masonry$1.defaultProps={breakpoints:[]};var _templateObject$13$1=taggedTemplateLiteral$1$1(["\n  span::after {\n    content: \": \";\n    white-space: pre;\n  }\n"],["\n  span::after {\n    content: \": \";\n    white-space: pre;\n  }\n"]);var MessageWrapper$1=system({display:"flex",flex:1,px:0,py:0},"color",function(props){return{fontFamily:props.theme.fonts.base,userSelect:"none"};}).extend(_templateObject$13$1);var background$1$2={default:"grayScale.3",info:"primary",warning:"warning",success:"positive",error:"negative"};var textColor$1$2={default:"white",error:"white",info:"white",warning:"text",success:"text"};var Message$1=function(_Component){inherits$1$1(Message,_Component);function Message(){classCallCheck$1$2(this,Message);return possibleConstructorReturn$1$1(this,(Message.__proto__||Object.getPrototypeOf(Message)).apply(this,arguments));}createClass$1$2(Message,[{key:"render",value:function render(){var _props=this.props,children=_props.children,px=_props.px,basic=_props.basic,variant=_props.variant;return React.createElement(MessageWrapper$1,{px:basic?0:px,py:basic?0:4,bg:basic?null:background$1$2[variant],color:basic?background$1$2[variant]:textColor$1$2[variant]},variant!=="default"&&React.createElement(Label$1,{is:"span"},variant),formatTitle$1$1(children));}}]);return Message;}(Component);Message$1.propTypes={children:PropTypes.string.isRequired,basic:PropTypes.bool,variant:PropTypes.oneOf(["default","error","info","success","warning"])};Message$1.defaultProps={px:6,variant:"default"};var _templateObject$14$1=taggedTemplateLiteral$1$1(["\n  transition: all .5s ease-in-out;\n  > * {\n    opacity: ",";\n    transition: all .5s ease-in-out;\n  }\n"],["\n  transition: all .5s ease-in-out;\n  > * {\n    opacity: ",";\n    transition: all .5s ease-in-out;\n  }\n"]);var OverlayWrapper$1=system({bg:"grayScale.4",display:"flex",position:"fixed",justifyContent:"center",alignItems:"center",zIndex:999,top:0,right:0,bottom:0,left:0}).extend(_templateObject$14$1,function(props){return props.zIndex===999?0.9:0;});var Overlay$1=function(_Component){inherits$1$1(Overlay,_Component);function Overlay(){var _ref;var _temp,_this,_ret;classCallCheck$1$2(this,Overlay);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$1$1(this,(_ref=Overlay.__proto__||Object.getPrototypeOf(Overlay)).call.apply(_ref,[this].concat(args))), _this), _this.handleKeyPress=function(e){var keyCode=e.keyCode;var close=_this.props.close;if(keyCode===27){close();}}, _temp), possibleConstructorReturn$1$1(_this,_ret);}createClass$1$2(Overlay,[{key:"componentDidMount",value:function componentDidMount(){document.addEventListener("keydown",this.handleKeyPress);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("keydown",this.handleKeyPress);}},{key:"render",value:function render(){var _props=this.props,children=_props.children,isOpen=_props.isOpen,close=_props.close;var bg=isOpen?"rgba(61, 61, 61, 0.9)":"rgba(61,61,61,0)";return React.createElement(OverlayWrapper$1,{bg:bg,zIndex:isOpen?999:-1},children);}}]);return Overlay;}(Component);Overlay$1.propTypes={/** flag that decides if the overlay is open or closed */isOpen:PropTypes.bool.isRequired};Overlay$1.defaultProps={isOpen:true,close:function close(){return null;}};var SectionWrapper$1=system({is:"section",px:6,py:6,borderBottom:1,borderColor:"grayScale.1"},"alignItems","justifyContent","flexDirection","display","color");/**
 * Generic Section component for the Offcourse project
 */var Section$1=function(_Component){inherits$1$1(Section,_Component);function Section(){classCallCheck$1$2(this,Section);return possibleConstructorReturn$1$1(this,(Section.__proto__||Object.getPrototypeOf(Section)).apply(this,arguments));}createClass$1$2(Section,[{key:"render",value:function render(){var _props=this.props,children=_props.children,rest=objectWithoutProperties$1$2(_props,["children"]);return React.createElement(SectionWrapper$1,rest,children);}}]);return Section;}(Component);var _templateObject$15$1=taggedTemplateLiteral$1$1(["\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  font-family: ",";\n  text-decoration: inherit;\n"],["\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  font-family: ",";\n  text-decoration: inherit;\n"]);var TagWrapper$1=system({display:"inline-block",color:"black",bg:"grayScale.1",py:0,px:4,hover:{backgroundColor:"primary",color:"white"}}).extend(_templateObject$15$1,function(_ref){var theme=_ref.theme;return theme.fonts.bold;});/**
 * The Tag component for the Offcourse project
 */var Tag$1=function(_Component){inherits$1$1(Tag,_Component);function Tag(){var _ref;var _temp,_this,_ret;classCallCheck$1$2(this,Tag);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$1$1(this,(_ref=Tag.__proto__||Object.getPrototypeOf(Tag)).call.apply(_ref,[this].concat(args))), _this), _this.handleClick=function(event){var _this$props=_this.props,onClick=_this$props.onClick,children=_this$props.children,href=_this$props.href;if(onClick){event.preventDefault();onClick({tag:children});}}, _temp), possibleConstructorReturn$1$1(_this,_ret);}createClass$1$2(Tag,[{key:"render",value:function render(){var _props=this.props,children=_props.children,href=_props.href;return React.createElement(TagWrapper$1,{onClick:this.handleClick,href:href},React.createElement(Text$1,{size:"small"},formatTitle$1$1(children)));}}]);return Tag;}(Component);Tag$1.propTypes={/** the text that is displayed on the tag */children:PropTypes.string.isRequired,/** a url that the tag links to */href:PropTypes.string,/** a on click callback handler */onClick:PropTypes.func};var TextWrapper$1=system({is:"p",m:0,p:0,fontSize:1,lineHeight:1});var Text$1=function(_Component){inherits$1$1(Text,_Component);function Text(){classCallCheck$1$2(this,Text);return possibleConstructorReturn$1$1(this,(Text.__proto__||Object.getPrototypeOf(Text)).apply(this,arguments));}createClass$1$2(Text,[{key:"render",value:function render(){var _props=this.props,size=_props.size,children=_props.children;var textSize=size==="small"?0:1;return React.createElement(TextWrapper$1,{fontSize:textSize,lineHeight:textSize},children);}}]);return Text;}(Component);Text$1.propTypes={/** Field that indicates the size of the text */size:PropTypes.oneOf(["small","regular"])};Text$1.defaultProps={size:"regular"};var _templateObject$1$1$1=taggedTemplateLiteral$2(["\n  flex-wrap: wrap;\n  > button {\n    margin-right: ",";\n\n    &:last-child {\n      margin-right: 0;\n      }\n    }\n  }\n"],["\n  flex-wrap: wrap;\n  > button {\n    margin-right: ",";\n\n    &:last-child {\n      margin-right: 0;\n      }\n    }\n  }\n"]);var ButtonGroupWrapper=Group$1.extend(_templateObject$1$1$1,function(_ref){var theme=_ref.theme;return theme.space[3];});var ButtonGroup=function(_Component){inherits$2(ButtonGroup,_Component);function ButtonGroup(){var _ref;var _temp,_this,_ret;classCallCheck$2(this,ButtonGroup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$2(this,(_ref=ButtonGroup.__proto__||Object.getPrototypeOf(ButtonGroup)).call.apply(_ref,[this].concat(args))), _this), _this.renderButtons=function(){var _this$props=_this.props,buttons=_this$props.buttons,size=_this$props.size;return mapIndexed$1(function(props,index){return React.createElement(Button$1,_extends$1$1({size:size},props,{key:index}),props.title);},buttons);}, _temp), possibleConstructorReturn$2(_this,_ret);}createClass$2(ButtonGroup,[{key:"render",value:function render(){var _props=this.props,buttons=_props.buttons,pt=_props.pt,justifyContent=_props.justifyContent,children=_props.children,direction=_props.direction;return React.createElement(ButtonGroupWrapper,{flexDirection:"row",pt:pt,justifyContent:justifyContent},isEmpty(buttons)?children:this.renderButtons());}}]);return ButtonGroup;}(Component);ButtonGroup.Button=Button$1;ButtonGroup.propTypes={direction:PropTypes.oneOf(["horizontal","vertical"]),size:PropTypes.oneOf(["small","medium","large"]),buttons:PropTypes.arrayOf(PropTypes.shape({title:PropTypes.string.isRequired,variant:PropTypes.string,href:PropTypes.string,onClick:PropTypes.func,type:PropTypes.oneOf(["button","submit"]),disabled:PropTypes.bool})),children:PropTypes.oneOfType([PropTypes.element,PropTypes.arrayOf(PropTypes.element)])};ButtonGroup.defaultProps={buttons:[],direction:"horizontal"};var CheckItem=function(_Component){inherits$2(CheckItem,_Component);function CheckItem(){classCallCheck$2(this,CheckItem);return possibleConstructorReturn$2(this,(CheckItem.__proto__||Object.getPrototypeOf(CheckItem)).apply(this,arguments));}createClass$2(CheckItem,[{key:"renderChildren",value:function renderChildren(){var _props=this.props,href=_props.href,children=_props.children;return href?React.createElement(Item$1.Link,{href:href},children):React.createElement(Item$1.Content,null,children);}},{key:"render",value:function render(){var _props2=this.props,is=_props2.is,href=_props2.href,children=_props2.children,checked=_props2.checked,id=_props2.id,_onToggle=_props2.onToggle;return React.createElement(Item$1,{is:is,gridTemplateColumns:"2rem 1fr"},React.createElement(Checkbox$1,{onToggle:function onToggle(_ref){var checked=_ref.checked;return _onToggle({id:id,checked:checked});},checked:checked}),this.renderChildren());}}]);return CheckItem;}(Component);CheckItem.propTypes={children:PropTypes.oneOfType([PropTypes.string,PropTypes.element]).isRequired,id:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),checked:PropTypes.bool,onToggle:PropTypes.func.isRequired};var _templateObject$2$1$1=taggedTemplateLiteral$2(["\n  .inputs {\n    flex: 50;\n  }\n  .handles {\n    flex: 1;\n  }\n"],["\n  .inputs {\n    flex: 50;\n  }\n  .handles {\n    flex: 1;\n  }\n"]);var CheckpointSectionWrapper=system({display:"flex",bg:"grayScale.1",border:0,mb:3,borderColor:"negative"},function(props){return{fontFamily:props.theme.fonts.bold,boxSizing:"border-box"};}).extend(_templateObject$2$1$1);var CheckpointInput=function(_Component){inherits$2(CheckpointInput,_Component);function CheckpointInput(){classCallCheck$2(this,CheckpointInput);return possibleConstructorReturn$2(this,(CheckpointInput.__proto__||Object.getPrototypeOf(CheckpointInput)).apply(this,arguments));}createClass$2(CheckpointInput,[{key:"render",value:function render(){var _props=this.props,name=_props.name,children=_props.children,value=_props.value,remove=_props.remove,hasErrors=_props.hasErrors,onChange=_props.onChange,onBlur=_props.onBlur;return React.createElement(CheckpointSectionWrapper,{border:hasErrors?2:0},React.createElement(Group$1,{alignItems:"stretch",className:"inputs"},React.createElement(Input$1,{onChange:onChange,onBlur:onBlur,pb:2,mb:0,name:name+".task",value:value.task,placeholder:"Task"}),React.createElement(Input$1,{onChange:onChange,onBlur:onBlur,pt:0,mt:0,name:name+".resourceUrl",variant:"small",value:value.resourceUrl,placeholder:"Resource URL"})),children&&React.createElement(Group$1,{px:6,alignItems:"flex-end"},children));}}]);return CheckpointInput;}(Component);CheckpointInput.propTypes={};var CheckpointItem=function(_Component){inherits$2(CheckpointItem,_Component);function CheckpointItem(){classCallCheck$2(this,CheckpointItem);return possibleConstructorReturn$2(this,(CheckpointItem.__proto__||Object.getPrototypeOf(CheckpointItem)).apply(this,arguments));}createClass$2(CheckpointItem,[{key:"render",value:function render(){var _props=this.props,_onToggle=_props.onToggle,trackable=_props.trackable,checkpointId=_props.checkpointId,completed=_props.completed,task=_props.task,is=_props.is,resourceUrl=_props.resourceUrl;return _onToggle?React.createElement(CheckItem,{is:is,id:checkpointId,href:resourceUrl,checked:completed,onToggle:function onToggle(_ref){var checked=_ref.checked;return _onToggle({checkpointId:checkpointId,checked:checked});}},task):React.createElement(Item$1,{is:is,href:resourceUrl},task);}}]);return CheckpointItem;}(Component);CheckpointItem.propTypes={};var CheckpointList=function(_Component){inherits$2(CheckpointList,_Component);function CheckpointList(){classCallCheck$2(this,CheckpointList);return possibleConstructorReturn$2(this,(CheckpointList.__proto__||Object.getPrototypeOf(CheckpointList)).apply(this,arguments));}createClass$2(CheckpointList,[{key:"renderChildren",value:function renderChildren(){var _props=this.props,checkpoints=_props.checkpoints,onToggle=_props.onToggle;return map$1(function(props){return React.createElement(CheckpointItem,_extends$1$1({onToggle:onToggle,key:props.checkpointId},props));},checkpoints);}},{key:"render",value:function render(){return React.createElement(List,null,this.renderChildren());}}]);return CheckpointList;}(Component);CheckpointList.propTypes={};CheckpointList.defaultProps={checkpoints:[]};var _templateObject$3$1$1=taggedTemplateLiteral$2(["\n  grid-template-columns: 4rem 1fr;\n  p {\n    user-select: none;\n    line-height: 1rem;\n  }\n"],["\n  grid-template-columns: 4rem 1fr;\n  p {\n    user-select: none;\n    line-height: 1rem;\n  }\n"]);var CuratorWrapper=system({display:"grid",color:"black"}).extend(_templateObject$3$1$1);var Curator=function(_Component){inherits$2(Curator,_Component);function Curator(){classCallCheck$2(this,Curator);return possibleConstructorReturn$2(this,(Curator.__proto__||Object.getPrototypeOf(Curator)).apply(this,arguments));}createClass$2(Curator,[{key:"renderHeading",value:function renderHeading(){var _props=this.props,curator=_props.curator,onClick=_props.onClick,profileUrl=_props.profileUrl;return React.createElement(Heading$1,{onClick:onClick&&partial(onClick,[{curator:curator}]),size:"small",href:profileUrl},formatTitle$1(curator));}},{key:"render",value:function render(){var _props2=this.props,curator=_props2.curator,avatarUrl=_props2.avatarUrl;return React.createElement(CuratorWrapper,null,React.createElement(Avatar$1,{url:avatarUrl,name:curator}),React.createElement(Group$1,null,React.createElement(Text$1,{small:true},"Curated by"),this.renderHeading()));}}]);return Curator;}(Component);Curator.propTypes={curator:PropTypes.string.isRequired,avatarUrl:PropTypes.string};var _templateObject$4$1$1=taggedTemplateLiteral$2(["\n"],["\n"]);var DescriptionWrapper=system({pb:0}).extend(_templateObject$4$1$1);var Description=function(_Component){inherits$2(Description,_Component);function Description(){classCallCheck$2(this,Description);return possibleConstructorReturn$2(this,(Description.__proto__||Object.getPrototypeOf(Description)).apply(this,arguments));}createClass$2(Description,[{key:"render",value:function render(){var _props=this.props,pb=_props.pb,children=_props.children,label=_props.label;if(label){return React.createElement(DescriptionWrapper,{pb:pb},React.createElement(Label$1,null,label),React.createElement(Text$1,null,children));}return React.createElement(DescriptionWrapper,{pb:pb},children," ");}}]);return Description;}(Component);Description.Label=Label$1;Description.Text=Text$1;Description.propTypes={children:PropTypes.oneOfType([PropTypes.string,PropTypes.arrayOf(PropTypes.element)]).isRequired,label:PropTypes.string};var _templateObject$5$1$1=taggedTemplateLiteral$2(["\n  > a,\n  button {\n    margin-right: ",";\n    margin-bottom: ",";\n\n    &:last-child {\n      margin-right: 0;\n      margin-bottom: 0;\n    }\n  }\n"],["\n  > a,\n  button {\n    margin-right: ",";\n    margin-bottom: ",";\n\n    &:last-child {\n      margin-right: 0;\n      margin-bottom: 0;\n    }\n  }\n"]);var IconGroupWrapper=Group$1.extend(_templateObject$5$1$1,function(_ref){var theme=_ref.theme,flexDirection=_ref.flexDirection,spacing=_ref.spacing;return flexDirection==="row"?theme.space[4]:0;},function(_ref2){var theme=_ref2.theme,flexDirection=_ref2.flexDirection,spacing=_ref2.spacing;return flexDirection==="column"?theme.space[1]:0;});IconGroupWrapper.styleProps={horizontal:{flexDirection:"row",justifyContent:"flex-start",alignItems:"center"},vertical:{flexDirection:"column",justifyContent:"center",alignItems:"center"}};var IconGroup=function(_Component){inherits$2(IconGroup,_Component);function IconGroup(){var _ref;var _temp,_this,_ret;classCallCheck$2(this,IconGroup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$2(this,(_ref=IconGroup.__proto__||Object.getPrototypeOf(IconGroup)).call.apply(_ref,[this].concat(args))), _this), _this.renderIcons=function(){var _this$props=_this.props,icons=_this$props.icons,groupSize=_this$props.size,groupColor=_this$props.color;return mapIndexed$1(function(_ref2,index){var name=_ref2.name,size=_ref2.size,tabIndex=_ref2.tabIndex,is=_ref2.is,color=_ref2.color,onClick=_ref2.onClick;return React.createElement(Icon$1,{is:is,tabIndex:tabIndex,color:color||groupColor,key:index,size:size||groupSize,name:name,onClick:onClick});},icons);}, _this.renderChildren=function(){var _this$props2=_this.props,children=_this$props2.children,size=_this$props2.size,color=_this$props2.color;return Children.map(children,function(child){return React.cloneElement(child,_extends$1$1({size:size,color:color},child.props));});}, _temp), possibleConstructorReturn$2(_this,_ret);}createClass$2(IconGroup,[{key:"render",value:function render(){var _props=this.props,icons=_props.icons,direction=_props.direction,children=_props.children;return React.createElement(IconGroupWrapper,IconGroupWrapper.styleProps[direction],isEmpty(icons)?this.renderChildren():this.renderIcons());}}]);return IconGroup;}(Component);IconGroup.Icon=Icon$1;IconGroup.propTypes={icons:PropTypes.arrayOf(PropTypes.shape({name:PropTypes.string.isRequired,onClick:PropTypes.func})),children:PropTypes.oneOfType([PropTypes.element,PropTypes.arrayOf(PropTypes.element)]),/** Size of the icons */size:PropTypes.oneOf(["small","medium","large"])};IconGroup.defaultProps={direction:"horizontal",icons:[]};var _templateObject$6$1$1=taggedTemplateLiteral$2(["\n  .handlers {\n    grid-area: input;\n  }\n"],["\n  .handlers {\n    grid-area: input;\n  }\n"]);var InputFieldWrapper=system({p:0}).extend(_templateObject$6$1$1);var InputField=function(_Component){inherits$2(InputField,_Component);function InputField(){classCallCheck$2(this,InputField);return possibleConstructorReturn$2(this,(InputField.__proto__||Object.getPrototypeOf(InputField)).apply(this,arguments));}createClass$2(InputField,[{key:"renderLabel",value:function renderLabel(){var _props=this.props,title=_props.title,name=_props.name;return title?React.createElement(Label$1,{pb:4,px:6,htmlFor:name},title):null;}},{key:"hasErrors",value:function hasErrors(){var errors=this.props.errors;return!isEmpty(compact$1(errors));}},{key:"renderErrors",value:function renderErrors(){var errors=this.props.errors;return this.hasErrors()?React.createElement(MessageGroup,{px:6,pb:6,basic:true,messages:MessageGroup.formatMessages(errors)}):null;}},{key:"renderChildren",value:function renderChildren(){var _props2=this.props,name=_props2.name,placeholder=_props2.placeholder,value=_props2.value,onChange=_props2.onChange,onBlur=_props2.onBlur,children=_props2.children,FieldComponent=_props2.FieldComponent,variant=_props2.variant;return children?children:React.createElement(FieldComponent,{name:name,value:value,placeholder:placeholder,onChange:onChange,onBlur:onBlur,mb:3,hasErrors:this.hasErrors(),variant:variant});}},{key:"render",value:function render(){return React.createElement(InputFieldWrapper,null,this.renderLabel(),this.renderErrors(),this.renderChildren());}}]);return InputField;}(Component);InputField.propTypes={name:PropTypes.string.isRequired,title:PropTypes.string,placeholder:PropTypes.string,value:PropTypes.string,onBlur:PropTypes.func,onChange:PropTypes.func,touched:PropTypes.array,errors:PropTypes.array,variant:PropTypes.oneOf(["default","textarea","small"]),FieldComponent:PropTypes.func};InputField.defaultProps={FieldComponent:Input$1,errors:[],touched:[]};var InputList=function(_Component){inherits$2(InputList,_Component);function InputList(){classCallCheck$2(this,InputList);return possibleConstructorReturn$2(this,(InputList.__proto__||Object.getPrototypeOf(InputList)).apply(this,arguments));}createClass$2(InputList,[{key:"renderHandles",value:function renderHandles(index){var _props=this.props,arrangeable=_props.arrangeable,remove=_props.remove,move$$1=_props.move;var icons=[{is:"button",onClick:function onClick(){return remove(index);},name:"remove",tabIndex:"-1"},{is:"button",name:"sort",tabIndex:"-1"}];return React.createElement(IconGroup,{icons:icons,color:"grayScale.2",direction:"vertical",size:"small"});}},{key:"renderFields",value:function renderFields(){var _this2=this;var _props2=this.props,arrangeable=_props2.arrangeable,items=_props2.items,errors=_props2.errors,placeholder=_props2.placeholder,name=_props2.name,onChange=_props2.onChange,onBlur=_props2.onBlur,FieldComponent=_props2.FieldComponent;return mapIndexed$1(function(item,index){return React.createElement(FieldComponent,{value:item,onChange:onChange,onBlur:onBlur,hasErrors:!!errors[index],mb:3,placeholder:placeholder,key:index,name:name+"."+index},arrangeable&&_this2.renderHandles(index));},items);}},{key:"renderLinks",value:function renderLinks(){var _props3=this.props,arrangeable=_props3.arrangeable,title=_props3.title,add=_props3.add;return arrangeable&&React.createElement(LinkGroup,{pt:6,justifyContent:"flex-end"},React.createElement(LinkGroup.Link,{onClick:add},"Add "+title.slice(0,-1)));}},{key:"render",value:function render(){var move$$1=this.props.move;return React.createElement(Fragment,null,React.createElement(SortableList,{onSort:move$$1},this.renderFields()),this.renderLinks());}}]);return InputList;}(Component);InputList.Input=Input$1;InputList.move=move;InputList.propTypes={/** list of elements that need to be entered */items:PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string,PropTypes.object])).isRequired,/** list of errors corresponding to these items */errors:PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string,PropTypes.object])),/** field that indicates if the form itself is arrangeable (add, remove, move, etc...) */arrangeable:PropTypes.bool,/** title of the field (i.e. label) */title:PropTypes.string.isRequired,/** name of the field */name:PropTypes.string.isRequired,/** placeholder for the value of the field */placeholder:PropTypes.string,/** function that adds a new items to the list */add:PropTypes.func,/** function that removes an item from the list */remove:PropTypes.func,/** function that moves an item to another position */move:PropTypes.func,/** handler for when a list value changes */onChange:PropTypes.func.isRequired,/** handler for when a field loses focus */onBlur:PropTypes.func,/** optional component that can be rendered instead of the default one */FieldComponent:PropTypes.func};InputList.defaultProps={arrangeable:false,placeholder:"edit this",errors:[],items:[],FieldComponent:Input$1};var _templateObject$7$1$1=taggedTemplateLiteral$2(["\n  > a {\n    margin-right: ",";\n    margin-bottom: ",";\n\n    &:last-child {\n      margin-right: 0;\n      margin-bottom: 0;\n    }\n  }\n"],["\n  > a {\n    margin-right: ",";\n    margin-bottom: ",";\n\n    &:last-child {\n      margin-right: 0;\n      margin-bottom: 0;\n    }\n  }\n"]);var LinkGroupWrapper=Group$1.extend(_templateObject$7$1$1,function(_ref){var theme=_ref.theme,flexDirection=_ref.flexDirection,spacing=_ref.spacing;return flexDirection==="row"?theme.space[6]:0;},function(_ref2){var theme=_ref2.theme,flexDirection=_ref2.flexDirection,spacing=_ref2.spacing;return flexDirection==="column"?theme.space[6]:0;});var LinkGroup=function(_Component){inherits$2(LinkGroup,_Component);function LinkGroup(){var _ref;var _temp,_this,_ret;classCallCheck$2(this,LinkGroup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$2(this,(_ref=LinkGroup.__proto__||Object.getPrototypeOf(LinkGroup)).call.apply(_ref,[this].concat(args))), _this), _this.renderLinks=function(){var links=_this.props.links;return mapIndexed$1(function(_ref2,index){var title=_ref2.title,disabled=_ref2.disabled,active=_ref2.active,href=_ref2.href,onClick=_ref2.onClick;return React.createElement(Link$1,{active:active,disabled:disabled,key:index,href:href,onClick:onClick},title);},links);}, _temp), possibleConstructorReturn$2(_this,_ret);}createClass$2(LinkGroup,[{key:"render",value:function render(){var _props=this.props,display=_props.display,links=_props.links,px=_props.px,pt=_props.pt,pb=_props.pb,children=_props.children,direction=_props.direction,justifyContent=_props.justifyContent,alignItems=_props.alignItems;return React.createElement(LinkGroupWrapper,{display:display,px:px,pt:pt,pb:pb,flexDirection:direction==="horizontal"?"row":"column",justifyContent:justifyContent,alignItems:alignItems},isEmpty(links)?children:this.renderLinks());}}]);return LinkGroup;}(Component);LinkGroup.Link=Link$1;LinkGroup.propTypes={direction:PropTypes.oneOf(["horizontal","vertical"]),links:PropTypes.arrayOf(PropTypes.shape({title:PropTypes.string.isRequired,href:PropTypes.string,onClick:PropTypes.func})),children:PropTypes.oneOfType([PropTypes.element,PropTypes.arrayOf(PropTypes.element)])};LinkGroup.defaultProps={links:[],direction:"horizontal",alignItems:"flex-start"};var _templateObject$8$1$1=taggedTemplateLiteral$2(["\n  li {\n    margin-right: ",";\n    margin-bottom: ","\n"],["\n  li {\n    margin-right: ",";\n    margin-bottom: ","\n"]);var itemSpacing=function itemSpacing(spacing,theme){var spaceTable={wide:theme.space[6],normal:theme.space[4],tight:theme.space[3],none:theme.space[0]};return spaceTable[spacing];};var ListWrapper=system({is:"ul",display:"flex",flexDirection:"row",alignContent:"stretch",m:0,p:0},function(props){return{marginBottom:props.direction==="vertical"||props.direction==="both"?"-"+itemSpacing(props.spacing,props.theme):0,marginRight:props.direction==="horizontal"||props.direction==="both"?"-"+itemSpacing(props.spacing,props.theme):0};}).extend(_templateObject$8$1$1,function(_ref){var theme=_ref.theme,direction=_ref.direction,spacing=_ref.spacing;return direction==="horizontal"||direction==="both"?itemSpacing(spacing,theme):0;},function(_ref2){var theme=_ref2.theme,direction=_ref2.direction,spacing=_ref2.spacing;return direction==="vertical"||direction==="both"?itemSpacing(spacing,theme):0;});var List=function(_Component){inherits$2(List,_Component);function List(){classCallCheck$2(this,List);return possibleConstructorReturn$2(this,(List.__proto__||Object.getPrototypeOf(List)).apply(this,arguments));}createClass$2(List,[{key:"renderChildren",value:function renderChildren(){var children=this.props.children;return Children.map(children,function(child){return React.cloneElement(child,{is:"li",flex:1});});}},{key:"render",value:function render(){var _props=this.props,direction=_props.direction,spacing=_props.spacing;return React.createElement(ListWrapper,{flexDirection:direction==="horizontal"?"row":"column",direction:direction||"vertical",spacing:spacing||"normal"},this.renderChildren());}}]);return List;}(Component);List.Item=Item$1;List.propTypes={children:PropTypes.oneOfType([PropTypes.element,PropTypes.arrayOf(PropTypes.element)]).isRequired};var _templateObject$9$1$1=taggedTemplateLiteral$2([""],[""]);var MessageGroupWrapper=Group$1.extend(_templateObject$9$1$1);var MessageGroup=function(_Component){inherits$2(MessageGroup,_Component);function MessageGroup(){var _ref;var _temp,_this,_ret;classCallCheck$2(this,MessageGroup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$2(this,(_ref=MessageGroup.__proto__||Object.getPrototypeOf(MessageGroup)).call.apply(_ref,[this].concat(args))), _this), _this.renderMessages=function(){var _this$props=_this.props,messages=_this$props.messages,basic=_this$props.basic;return mapIndexed$1(function(_ref2,index){var message=_ref2.message,variant=_ref2.variant,px=_ref2.px;return React.createElement(Message$1,{px:px,basic:basic,variant:variant,key:index},message);},messages);}, _temp), possibleConstructorReturn$2(_this,_ret);}createClass$2(MessageGroup,[{key:"render",value:function render(){var _props=this.props,messages=_props.messages,errors=_props.errors,px=_props.px,pb=_props.pb,children=_props.children;return React.createElement(MessageGroupWrapper,{px:px,pb:pb,alignItems:"stretch"},!isEmpty(messages)&&this.renderMessages(),children);}}]);return MessageGroup;}(Component);MessageGroup.Message=Message$1;MessageGroup.formatMessages=function(){var errors=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _ref3=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref3$variant=_ref3.variant,variant=_ref3$variant===undefined?"error":_ref3$variant,px=_ref3.px;return map$1(function(message){return{message:message,variant:variant,px:px};},errors);};MessageGroup.propTypes={messages:PropTypes.arrayOf(PropTypes.shape({message:PropTypes.string.isRequired,variant:PropTypes.oneOf(["default","error","info","success","warning"])})),children:PropTypes.oneOfType([PropTypes.element,PropTypes.arrayOf(PropTypes.element)])};MessageGroup.defaultProps={messages:[],errors:[]};var Menu=function(_Component){inherits$2(Menu,_Component);function Menu(){classCallCheck$2(this,Menu);return possibleConstructorReturn$2(this,(Menu.__proto__||Object.getPrototypeOf(Menu)).apply(this,arguments));}createClass$2(Menu,[{key:"filteredLinks",value:function filteredLinks(){var _props=this.props,links=_props.links,maxLevel=_props.maxLevel;var filterByMaxLevel=filter$1(propSatisfies(gte(maxLevel))("level"));var groupByLevel=groupBy$1(prop$1("level"));return filterByMaxLevel(links);}},{key:"groupedLinks",value:function groupedLinks(){var groupByLevel=groupBy$1(prop$1("level"));return values(groupByLevel(this.filteredLinks()));}},{key:"render",value:function render(){var _props2=this.props,display=_props2.display,direction=_props2.direction,px=_props2.px,pb=_props2.pb,justifyContent=_props2.justifyContent,alignItems=_props2.alignItems;return direction==="horizontal"?React.createElement(LinkGroup,{display:display,px:px,pb:pb,justifyContent:justifyContent,alignItems:"center",links:this.filteredLinks(),direction:direction}):React.createElement(Group$1,{alignItems:alignItems},mapIndexed$1(function(links,index){return React.createElement(Section$1,{key:index},React.createElement(LinkGroup,{key:index,links:links,direction:direction}));},this.groupedLinks()));}}]);return Menu;}(Component);Menu.Button=function(_ref){var onClick=_ref.onClick;return React.createElement(Icon$1,{name:"hamburger",onClick:onClick});};Menu.propTypes={direction:PropTypes.oneOf(["horizontal","vertical"]),links:PropTypes.arrayOf(PropTypes.shape),maxLevel:PropTypes.oneOf([0,1,2,3])};Menu.defaultProps={alignItems:"stretch",direction:"vertical",maxLevel:3};var Modal=function(_Component){inherits$2(Modal,_Component);function Modal(){classCallCheck$2(this,Modal);return possibleConstructorReturn$2(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}createClass$2(Modal,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,px=_props.px,py=_props.py,children=_props.children,close=_props.close;return React.createElement(Overlay$1,{close:close,isOpen:isOpen},React.createElement(Container$1,{px:px,py:py},children));}}]);return Modal;}(Component);Modal.Heading=function(props){return React.createElement(Section$1,{py:6,px:6},React.createElement(Heading$1,props));};Modal.Section=Section$1;Modal.propTypes={isOpen:PropTypes.bool.isRequired,close:PropTypes.func};var NavBar=function(_Component){inherits$2(NavBar,_Component);function NavBar(){classCallCheck$2(this,NavBar);return possibleConstructorReturn$2(this,(NavBar.__proto__||Object.getPrototypeOf(NavBar)).apply(this,arguments));}createClass$2(NavBar,[{key:"render",value:function render(){var _props=this.props,links=_props.links,onLogoClick=_props.onLogoClick,onMenuButtonClick=_props.onMenuButtonClick,position=_props.position;return React.createElement(Bar$1,{position:position},React.createElement(Logo$1,{onClick:onLogoClick}),React.createElement(Menu,{display:["none","flex","flex"],justifyContent:"flex-end",px:6,maxLevel:0,direction:"horizontal",links:links}),React.createElement(Menu.Button,{onClick:onMenuButtonClick}));}}]);return NavBar;}(Component);NavBar.Logo=Logo$1;NavBar.propTypes={/** function that is invoked when the logo is clicked */onLogoClick:PropTypes.func,/** function that is invoked when the menu button is clicked */onMenuButtonClick:PropTypes.func,/** array of objects that define the links in the menu */links:PropTypes.arrayOf(PropTypes.shape({title:PropTypes.string.isRequired,level:PropTypes.number.isRequired,onClick:PropTypes.func,href:PropTypes.string})),/** determines the position of the navbar. This is mainly for debugging...*/position:PropTypes.oneOf(["fixed","absolute"])};NavBar.defaultProps={onLogoClick:function onLogoClick(){},onMenuClick:function onMenuClick(){}};var PasswordInput=function(_Component){inherits$2(PasswordInput,_Component);function PasswordInput(){var _ref;var _temp,_this,_ret;classCallCheck$2(this,PasswordInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$2(this,(_ref=PasswordInput.__proto__||Object.getPrototypeOf(PasswordInput)).call.apply(_ref,[this].concat(args))), _this), _this.state={inputType:"password"}, _this.toggleInputType=function(){_this.setState(function(_ref2){var inputType=_ref2.inputType;return{inputType:inputType==="password"?"text":"password"};});}, _temp), possibleConstructorReturn$2(_this,_ret);}createClass$2(PasswordInput,[{key:"render",value:function render(){var inputType=this.state.inputType;return React.createElement(Input$1,_extends$1$1({type:inputType},this.props),React.createElement(Icon$1,{onClick:this.toggleInputType,color:"grayScale.2",name:"eye"}));}}]);return PasswordInput;}(Component);PasswordInput.propTypes=_extends$1$1({},Input$1.propTypes);var toggleSelection=function toggleSelection(){var selection=document.getSelection();if(!selection.rangeCount){return function(){};}var active=document.activeElement;var ranges=[];for(var i=0;i<selection.rangeCount;i++){ranges.push(selection.getRangeAt(i));}switch(active.tagName.toUpperCase()){// .toUpperCase handles XHTML
case'INPUT':case'TEXTAREA':active.blur();break;default:active=null;break;}selection.removeAllRanges();return function(){selection.type==='Caret'&&selection.removeAllRanges();if(!selection.rangeCount){ranges.forEach(function(range){selection.addRange(range);});}active&&active.focus();};};var defaultMessage='Copy to clipboard: #{key}, Enter';function format(message){var copyKey=(/mac os x/i.test(navigator.userAgent)?'⌘':'Ctrl')+'+C';return message.replace(/#{\s*key\s*}/g,copyKey);}function copy(text,options){var debug,message,reselectPrevious,range,selection,mark,success=false;if(!options){options={};}debug=options.debug||false;try{reselectPrevious=toggleSelection();range=document.createRange();selection=document.getSelection();mark=document.createElement('span');mark.textContent=text;// reset user styles for span element
mark.style.all='unset';// prevents scrolling to the end of the page
mark.style.position='fixed';mark.style.top=0;mark.style.clip='rect(0, 0, 0, 0)';// used to preserve spaces and line breaks
mark.style.whiteSpace='pre';// do not inherit user-select (it may be `none`)
mark.style.webkitUserSelect='text';mark.style.MozUserSelect='text';mark.style.msUserSelect='text';mark.style.userSelect='text';document.body.appendChild(mark);range.selectNode(mark);selection.addRange(range);var successful=document.execCommand('copy');if(!successful){throw new Error('copy command was unsuccessful');}success=true;}catch(err){debug&&console.error('unable to copy using execCommand: ',err);debug&&console.warn('trying IE specific stuff');try{window.clipboardData.setData('text',text);success=true;}catch(err){debug&&console.error('unable to copy using clipboardData: ',err);debug&&console.error('falling back to prompt');message=format('message'in options?options.message:defaultMessage);window.prompt(message,text);}}finally{if(selection){if(typeof selection.removeRange=='function'){selection.removeRange(range);}else{selection.removeAllRanges();}}if(mark){document.body.removeChild(mark);}reselectPrevious();}return success;}var copyToClipboard=copy;var Component$1=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.CopyToClipboard=undefined;var _extends$$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react2=_interopRequireDefault(React);var _copyToClipboard2=_interopRequireDefault(copyToClipboard);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CopyToClipboard=exports.CopyToClipboard=function(_React$PureComponent){_inherits(CopyToClipboard,_React$PureComponent);function CopyToClipboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CopyToClipboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CopyToClipboard.__proto__||Object.getPrototypeOf(CopyToClipboard)).call.apply(_ref,[this].concat(args))), _this), _this.onClick=function(event){var _this$props=_this.props,text=_this$props.text,onCopy=_this$props.onCopy,children=_this$props.children,options=_this$props.options;var elem=_react2.default.Children.only(children);var result=(0, _copyToClipboard2.default)(text,options);if(onCopy){onCopy(text,result);}// Bypass onClick if it was present
if(elem&&elem.props&&typeof elem.props.onClick==='function'){elem.props.onClick(event);}}, _temp), _possibleConstructorReturn(_this,_ret);}_createClass(CopyToClipboard,[{key:'render',value:function render(){var _props=this.props,_text=_props.text,_onCopy=_props.onCopy,_options=_props.options,children=_props.children,props=_objectWithoutProperties(_props,['text','onCopy','options','children']);var elem=_react2.default.Children.only(children);return _react2.default.cloneElement(elem,_extends$$1({},props,{onClick:this.onClick}));}}]);return CopyToClipboard;}(_react2.default.PureComponent);CopyToClipboard.defaultProps={onCopy:undefined,options:undefined};});unwrapExports$1(Component$1);var Component_1=Component$1.CopyToClipboard;var CopyToClipboard=Component$1.CopyToClipboard;CopyToClipboard.CopyToClipboard=CopyToClipboard;var lib=CopyToClipboard;var lib_1=lib.CopyToClipboard;var ShareWrapper=system({display:"flex",justifyContent:"space-between"});var twitter=function twitter(text,url){return window.open("http://twitter.com/share?url="+url+"&text="+text,"tshare","height=260,width=550,resizable=0,toolbar=0,menubar=0,status=0,location=0");};var facebook=function facebook(text,url){return window.open("http://facebook.com/sharer.php?u="+url,"fbshare","height=260,width=550,resizable=0,toolbar=0,menubar=0,status=0,location=0");};var Share=function(_Component){inherits$2(Share,_Component);function Share(){var _ref;var _temp,_this,_ret;classCallCheck$2(this,Share);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$2(this,(_ref=Share.__proto__||Object.getPrototypeOf(Share)).call.apply(_ref,[this].concat(args))), _this), _this.handlers={facebook:facebook,twitter:twitter}, _temp), possibleConstructorReturn$2(_this,_ret);}createClass$2(Share,[{key:"renderIcons",value:function renderIcons(){var _this2=this;var _props=this.props,providers=_props.providers,url=_props.url,text=_props.text;var isProvider=function isProvider(provider){return provider!=="url"&&provider!=="contact";};var socialProviders=filter$1(isProvider,providers);return map$1(function(name){return React.createElement(Icon$1,{onClick:function onClick(){return _this2.handlers[name](text,url);},size:"medium",key:name,name:name});},socialProviders);}},{key:"renderGetUrl",value:function renderGetUrl(){var url=this.props.url;return React.createElement(lib_1,{text:url},React.createElement(Link$1,null,"Get Url"));}},{key:"renderContact",value:function renderContact(){var url=this.props.url;return React.createElement(lib_1,{text:url},React.createElement(Link$1,null,"Contact Us"));}},{key:"render",value:function render(){var _props2=this.props,url=_props2.url,providers=_props2.providers;return React.createElement(ShareWrapper,null,React.createElement(IconGroup,null,this.renderIcons()),contains$1$1("url",providers)&&this.renderGetUrl(),contains$1$1("contact",providers)&&this.renderContact());}}]);return Share;}(Component);Share.propTypes={providers:PropTypes.arrayOf(PropTypes.oneOf(["facebook","twitter","contact","url"])).isRequired,url:PropTypes.string.isRequired,text:PropTypes.string.isRequired};Share.defaultProps={providers:[]};var sidebar=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _extends$$1=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof$$1=typeof Symbol==="function"&&_typeof(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof(obj);};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react2=_interopRequireDefault(React);var _propTypes2=_interopRequireDefault(PropTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&((typeof call==='undefined'?'undefined':_typeof(call))==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+(typeof superClass==='undefined'?'undefined':_typeof(superClass)));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CANCEL_DISTANCE_ON_SCROLL=20;var defaultStyles={root:{position:'absolute',top:0,left:0,right:0,bottom:0,overflow:'hidden'},sidebar:{zIndex:2,position:'absolute',top:0,bottom:0,transition:'transform .3s ease-out',WebkitTransition:'-webkit-transform .3s ease-out',willChange:'transform',overflowY:'auto'},content:{position:'absolute',top:0,left:0,right:0,bottom:0,overflowY:'scroll',WebkitOverflowScrolling:'touch',transition:'left .3s ease-out, right .3s ease-out'},overlay:{zIndex:1,position:'fixed',top:0,left:0,right:0,bottom:0,opacity:0,visibility:'hidden',transition:'opacity .3s ease-out, visibility .3s ease-out',backgroundColor:'rgba(0,0,0,.3)'},dragHandle:{zIndex:1,position:'fixed',top:0,bottom:0}};var Sidebar=function(_Component){_inherits(Sidebar,_Component);function Sidebar(props){_classCallCheck(this,Sidebar);var _this=_possibleConstructorReturn(this,(Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).call(this,props));_this.state={// the detected width of the sidebar in pixels
sidebarWidth:props.defaultSidebarWidth,// keep track of touching params
touchIdentifier:null,touchStartX:null,touchStartY:null,touchCurrentX:null,touchCurrentY:null,// if touch is supported by the browser
dragSupported:false};_this.overlayClicked=_this.overlayClicked.bind(_this);_this.onTouchStart=_this.onTouchStart.bind(_this);_this.onTouchMove=_this.onTouchMove.bind(_this);_this.onTouchEnd=_this.onTouchEnd.bind(_this);_this.onScroll=_this.onScroll.bind(_this);_this.saveSidebarRef=_this.saveSidebarRef.bind(_this);return _this;}_createClass(Sidebar,[{key:'componentDidMount',value:function componentDidMount(){this.setState({dragSupported:(typeof window==='undefined'?'undefined':_typeof$$1(window))==='object'&&'ontouchstart'in window});this.saveSidebarWidth();}},{key:'componentDidUpdate',value:function componentDidUpdate(){// filter out the updates when we're touching
if(!this.isTouching()){this.saveSidebarWidth();}}},{key:'onTouchStart',value:function onTouchStart(ev){// filter out if a user starts swiping with a second finger
if(!this.isTouching()){var touch=ev.targetTouches[0];this.setState({touchIdentifier:touch.identifier,touchStartX:touch.clientX,touchStartY:touch.clientY,touchCurrentX:touch.clientX,touchCurrentY:touch.clientY});}}},{key:'onTouchMove',value:function onTouchMove(ev){if(this.isTouching()){for(var ind=0;ind<ev.targetTouches.length;ind++){// we only care about the finger that we are tracking
if(ev.targetTouches[ind].identifier===this.state.touchIdentifier){this.setState({touchCurrentX:ev.targetTouches[ind].clientX,touchCurrentY:ev.targetTouches[ind].clientY});break;}}}}},{key:'onTouchEnd',value:function onTouchEnd(){if(this.isTouching()){// trigger a change to open if sidebar has been dragged beyond dragToggleDistance
var touchWidth=this.touchSidebarWidth();if(this.props.open&&touchWidth<this.state.sidebarWidth-this.props.dragToggleDistance||!this.props.open&&touchWidth>this.props.dragToggleDistance){this.props.onSetOpen(!this.props.open);}this.setState({touchIdentifier:null,touchStartX:null,touchStartY:null,touchCurrentX:null,touchCurrentY:null});}}// This logic helps us prevents the user from sliding the sidebar horizontally
// while scrolling the sidebar vertically. When a scroll event comes in, we're
// cancelling the ongoing gesture if it did not move horizontally much.
},{key:'onScroll',value:function onScroll(){if(this.isTouching()&&this.inCancelDistanceOnScroll()){this.setState({touchIdentifier:null,touchStartX:null,touchStartY:null,touchCurrentX:null,touchCurrentY:null});}}// True if the on going gesture X distance is less than the cancel distance
},{key:'inCancelDistanceOnScroll',value:function inCancelDistanceOnScroll(){var cancelDistanceOnScroll=void 0;if(this.props.pullRight){cancelDistanceOnScroll=Math.abs(this.state.touchCurrentX-this.state.touchStartX)<CANCEL_DISTANCE_ON_SCROLL;}else{cancelDistanceOnScroll=Math.abs(this.state.touchStartX-this.state.touchCurrentX)<CANCEL_DISTANCE_ON_SCROLL;}return cancelDistanceOnScroll;}},{key:'isTouching',value:function isTouching(){return this.state.touchIdentifier!==null;}},{key:'overlayClicked',value:function overlayClicked(){if(this.props.open){this.props.onSetOpen(false);}}},{key:'saveSidebarWidth',value:function saveSidebarWidth(){var width=this.sidebar.offsetWidth;if(width!==this.state.sidebarWidth){this.setState({sidebarWidth:width});}}},{key:'saveSidebarRef',value:function saveSidebarRef(node){this.sidebar=node;}// calculate the sidebarWidth based on current touch info
},{key:'touchSidebarWidth',value:function touchSidebarWidth(){// if the sidebar is open and start point of drag is inside the sidebar
// we will only drag the distance they moved their finger
// otherwise we will move the sidebar to be below the finger.
if(this.props.pullRight){if(this.props.open&&window.innerWidth-this.state.touchStartX<this.state.sidebarWidth){if(this.state.touchCurrentX>this.state.touchStartX){return this.state.sidebarWidth+this.state.touchStartX-this.state.touchCurrentX;}return this.state.sidebarWidth;}return Math.min(window.innerWidth-this.state.touchCurrentX,this.state.sidebarWidth);}if(this.props.open&&this.state.touchStartX<this.state.sidebarWidth){if(this.state.touchCurrentX>this.state.touchStartX){return this.state.sidebarWidth;}return this.state.sidebarWidth-this.state.touchStartX+this.state.touchCurrentX;}return Math.min(this.state.touchCurrentX,this.state.sidebarWidth);}},{key:'render',value:function render(){var sidebarStyle=_extends$$1({},defaultStyles.sidebar,this.props.styles.sidebar);var contentStyle=_extends$$1({},defaultStyles.content,this.props.styles.content);var overlayStyle=_extends$$1({},defaultStyles.overlay,this.props.styles.overlay);var useTouch=this.state.dragSupported&&this.props.touch;var isTouching=this.isTouching();var rootProps={className:this.props.rootClassName,style:_extends$$1({},defaultStyles.root,this.props.styles.root),role:"navigation"};var dragHandle=void 0;// sidebarStyle right/left
if(this.props.pullRight){sidebarStyle.right=0;sidebarStyle.transform='translateX(100%)';sidebarStyle.WebkitTransform='translateX(100%)';if(this.props.shadow){sidebarStyle.boxShadow='-2px 2px 4px rgba(0, 0, 0, 0.15)';}}else{sidebarStyle.left=0;sidebarStyle.transform='translateX(-100%)';sidebarStyle.WebkitTransform='translateX(-100%)';if(this.props.shadow){sidebarStyle.boxShadow='2px 2px 4px rgba(0, 0, 0, 0.15)';}}if(isTouching){var percentage=this.touchSidebarWidth()/this.state.sidebarWidth;// slide open to what we dragged
if(this.props.pullRight){sidebarStyle.transform='translateX('+(1-percentage)*100+'%)';sidebarStyle.WebkitTransform='translateX('+(1-percentage)*100+'%)';}else{sidebarStyle.transform='translateX(-'+(1-percentage)*100+'%)';sidebarStyle.WebkitTransform='translateX(-'+(1-percentage)*100+'%)';}// fade overlay to match distance of drag
overlayStyle.opacity=percentage;overlayStyle.visibility='visible';}else if(this.props.docked){// show sidebar
if(this.state.sidebarWidth!==0){sidebarStyle.transform='translateX(0%)';sidebarStyle.WebkitTransform='translateX(0%)';}// make space on the left/right side of the content for the sidebar
if(this.props.pullRight){contentStyle.right=this.state.sidebarWidth+'px';}else{contentStyle.left=this.state.sidebarWidth+'px';}}else if(this.props.open){// slide open sidebar
sidebarStyle.transform='translateX(0%)';sidebarStyle.WebkitTransform='translateX(0%)';// show overlay
overlayStyle.opacity=1;overlayStyle.visibility='visible';}if(isTouching||!this.props.transitions){sidebarStyle.transition='none';sidebarStyle.WebkitTransition='none';contentStyle.transition='none';overlayStyle.transition='none';}if(useTouch){if(this.props.open){rootProps.onTouchStart=this.onTouchStart;rootProps.onTouchMove=this.onTouchMove;rootProps.onTouchEnd=this.onTouchEnd;rootProps.onTouchCancel=this.onTouchEnd;rootProps.onScroll=this.onScroll;}else{var dragHandleStyle=_extends$$1({},defaultStyles.dragHandle,this.props.styles.dragHandle);dragHandleStyle.width=this.props.touchHandleWidth;// dragHandleStyle right/left
if(this.props.pullRight){dragHandleStyle.right=0;}else{dragHandleStyle.left=0;}dragHandle=_react2.default.createElement('div',{style:dragHandleStyle,onTouchStart:this.onTouchStart,onTouchMove:this.onTouchMove,onTouchEnd:this.onTouchEnd,onTouchCancel:this.onTouchEnd});}}return _react2.default.createElement('div',rootProps,_react2.default.createElement('div',{className:this.props.sidebarClassName,style:sidebarStyle,ref:this.saveSidebarRef},this.props.sidebar),_react2.default.createElement('div',{className:this.props.overlayClassName,style:overlayStyle,role:'presentation',tabIndex:'0',onClick:this.overlayClicked}),_react2.default.createElement('div',{className:this.props.contentClassName,style:contentStyle},dragHandle,this.props.children));}}]);return Sidebar;}(React.Component);Sidebar.propTypes={// main content to render
children:_propTypes2.default.node.isRequired,// styles
styles:_propTypes2.default.shape({root:_propTypes2.default.object,sidebar:_propTypes2.default.object,content:_propTypes2.default.object,overlay:_propTypes2.default.object,dragHandle:_propTypes2.default.object}),// root component optional class
rootClassName:_propTypes2.default.string,// sidebar optional class
sidebarClassName:_propTypes2.default.string,// content optional class
contentClassName:_propTypes2.default.string,// overlay optional class
overlayClassName:_propTypes2.default.string,// sidebar content to render
sidebar:_propTypes2.default.node.isRequired,// boolean if sidebar should be docked
docked:_propTypes2.default.bool,// boolean if sidebar should slide open
open:_propTypes2.default.bool,// boolean if transitions should be disabled
transitions:_propTypes2.default.bool,// boolean if touch gestures are enabled
touch:_propTypes2.default.bool,// max distance from the edge we can start touching
touchHandleWidth:_propTypes2.default.number,// Place the sidebar on the right
pullRight:_propTypes2.default.bool,// Enable/Disable sidebar shadow
shadow:_propTypes2.default.bool,// distance we have to drag the sidebar to toggle open state
dragToggleDistance:_propTypes2.default.number,// callback called when the overlay is clicked
onSetOpen:_propTypes2.default.func,// Intial sidebar width when page loads
defaultSidebarWidth:_propTypes2.default.number};Sidebar.defaultProps={docked:false,open:false,transitions:true,touch:true,touchHandleWidth:20,pullRight:false,shadow:true,dragToggleDistance:30,onSetOpen:function onSetOpen(){},styles:{},defaultSidebarWidth:0};exports.default=Sidebar;});unwrapExports$1(sidebar);var distModules=createCommonjsModule$1$1(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _sidebar2=_interopRequireDefault(sidebar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_sidebar2.default;});var ReactSidebar=unwrapExports$1(distModules);var styles$1$1$2={root:{position:"absolute",top:0,left:0,right:0,bottom:0,backgroundColor:"#f4f6f4",overflow:"hidden"},sidebar:{zIndex:4,position:"absolute",display:"flex",top:0,bottom:0,backgroundColor:"white",opacity:1,width:"15rem",transition:"transform .3s ease-out",WebkitTransition:"-webkit-transform .3s ease-out",willChange:"transform",overflowY:"auto"},content:{position:"absolute",top:0,left:0,right:0,bottom:0,overflowY:"scroll",WebkitOverflowScrolling:"touch",transition:"left .3s ease-out, right .3s ease-out"},overlay:{zIndex:3,position:"fixed",top:0,left:0,right:0,bottom:0,opacity:0,visibility:"hidden",transition:"all .5s ease-in-out",backgroundColor:"rgba(61,61,61,0.9)"},dragHandle:{zIndex:1,position:"fixed",top:0,bottom:0}};var Sidebar=function(_Component){inherits$2(Sidebar,_Component);function Sidebar(){classCallCheck$2(this,Sidebar);return possibleConstructorReturn$2(this,(Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).apply(this,arguments));}createClass$2(Sidebar,[{key:"render",value:function render(){var _props=this.props,toggle=_props.toggle,content=_props.content,children=_props.children,isOpen=_props.isOpen;return React.createElement(ReactSidebar,{shadow:false,styles:styles$1$1$2,sidebar:content,open:isOpen,onSetOpen:toggle},children);}}]);return Sidebar;}(Component);Sidebar.MenuButton=function(_ref){var onClick=_ref.onClick,isOpen=_ref.isOpen;return React.createElement(Icon$1,{name:"hamburger",onClick:onClick});};Sidebar.CloseButton=function(_ref2){var onClick=_ref2.onClick,isOpen=_ref2.isOpen;return React.createElement(Icon$1,{name:"remove",size:"small",onClick:onClick});};Sidebar.propTypes={toggle:PropTypes.func,content:PropTypes.element.isRequired,isOpen:PropTypes.bool};Sidebar.defaultProps={isOpen:false};var SortableItem=commonjs_6(function(_ref){var children=_ref.children;return children;});var List$1=commonjs_7(List);var SortableList=function(_Component){inherits$2(SortableList,_Component);function SortableList(){classCallCheck$2(this,SortableList);return possibleConstructorReturn$2(this,(SortableList.__proto__||Object.getPrototypeOf(SortableList)).apply(this,arguments));}createClass$2(SortableList,[{key:"renderItems",value:function renderItems(){var children=this.props.children;return Children.map(children,function(child,index){return React.createElement(SortableItem,{index:index},child);});}},{key:"render",value:function render(){var _props=this.props,children=_props.children,direction=_props.direction,onSort=_props.onSort;return React.createElement(List$1,{pressDelay:200,direction:direction,axis:direction==="horizontal"?"x":"y",lockAxis:direction==="horizontal"?"x":"y",onSortEnd:onSort},this.renderItems());}}]);return SortableList;}(Component);SortableList.propTypes={};SortableList.Item=List.Item;SortableList.move=move;var _templateObject$10$1$1=taggedTemplateLiteral$2([""],[""]);var StatWrapper=Group$1.extend(_templateObject$10$1$1);var Stat=function(_Component){inherits$2(Stat,_Component);function Stat(){classCallCheck$2(this,Stat);return possibleConstructorReturn$2(this,(Stat.__proto__||Object.getPrototypeOf(Stat)).apply(this,arguments));}createClass$2(Stat,[{key:"render",value:function render(){var _props=this.props,direction=_props.direction,inverse=_props.inverse,iconName=_props.iconName,label=_props.label;var color=inverse?"white":"black";return React.createElement(StatWrapper,{alignItems:"center",justifyContent:"center",flexDirection:direction==="horizontal"?"row":"column"},React.createElement(Icon$1,{color:color,name:iconName}),React.createElement(Label$1,{color:color,pt:direction==="horizontal"?0:2,px:direction==="horizontal"?4:0},""+label));}}]);return Stat;}(Component);Stat.propTypes={label:PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,iconName:PropTypes.string.isRequired};var StatGroup=function(_Component){inherits$2(StatGroup,_Component);function StatGroup(){classCallCheck$2(this,StatGroup);return possibleConstructorReturn$2(this,(StatGroup.__proto__||Object.getPrototypeOf(StatGroup)).apply(this,arguments));}createClass$2(StatGroup,[{key:"renderStats",value:function renderStats(){var _props=this.props,inverse=_props.inverse,direction=_props.direction,stats=_props.stats;return map$1(function(_ref){var iconName=_ref.iconName,label=_ref.label;return React.createElement(Stat,{key:label,inverse:inverse,direction:direction,iconName:iconName,label:label});},stats);}},{key:"renderChildren",value:function renderChildren(){var _props2=this.props,direction=_props2.direction,inverse=_props2.inverse,children=_props2.children;return Children.map(children,function(child){return React.cloneElement(child,{inverse:inverse,direction:direction});});}},{key:"render",value:function render(){var children=this.props.children;return React.createElement(Group$1,{flexDirection:"row",section:"time"},children?this.renderChildren():this.renderStats());}}]);return StatGroup;}(Component);StatGroup.Stat=Stat;StatGroup.propTypes={inverse:PropTypes.bool,direction:PropTypes.oneOf(["horizontal","vertical"]),stats:PropTypes.arrayOf(PropTypes.shape({iconName:PropTypes.string.isRequired,label:PropTypes.string.isRequired}))};StatGroup.defaultProps={inverse:false,direction:"vertical"};var _templateObject$11$1$1=taggedTemplateLiteral$2(["\n  \n  margin-bottom: ",";\n  div {\n    margin-right: ",";\n    margin-bottom: ",";\n\n\n  &:last-child {\n    margin-right: 0;\n    }\n  }\n"],["\n  \n  margin-bottom: ",";\n  div {\n    margin-right: ",";\n    margin-bottom: ",";\n\n\n  &:last-child {\n    margin-right: 0;\n    }\n  }\n"]);var TagGroupWrapper=system({display:"flex",flex:1,flexWrap:"wrap",flexDirection:"row",px:0,pb:0,pt:0},"justifyContent").extend(_templateObject$11$1$1,function(_ref){var theme=_ref.theme;return"-"+theme.space[3]+"}";},function(_ref2){var theme=_ref2.theme;return theme.space[3];},function(_ref3){var theme=_ref3.theme;return theme.space[3];});var TagGroup=function(_Component){inherits$2(TagGroup,_Component);function TagGroup(){var _ref;var _temp,_this,_ret;classCallCheck$2(this,TagGroup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=possibleConstructorReturn$2(this,(_ref=TagGroup.__proto__||Object.getPrototypeOf(TagGroup)).call.apply(_ref,[this].concat(args))), _this), _this.renderTags=function(){var _this$props=_this.props,tags=_this$props.tags,onClick=_this$props.onClick;return mapIndexed$1(function(text,index){return React.createElement(Tag$1,{onClick:onClick,key:index},text);},tags);}, _temp), possibleConstructorReturn$2(_this,_ret);}createClass$2(TagGroup,[{key:"render",value:function render(){var _props=this.props,tags=_props.tags,pt=_props.pt,pb=_props.pb,children=_props.children;return React.createElement(TagGroupWrapper,{pb:pb,pt:pt},isEmpty(tags)?children:this.renderTags());}}]);return TagGroup;}(Component);TagGroup.Tag=Tag$1;TagGroup.propTypes={tags:PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string),PropTypes.object]).isRequired,children:PropTypes.oneOfType([PropTypes.element,PropTypes.arrayOf(PropTypes.element)])};TagGroup.defaultProps={tags:[]};

var AppShell = function (_Component) {
  inherits(AppShell, _Component);

  function AppShell() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AppShell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AppShell.__proto__ || Object.getPrototypeOf(AppShell)).call.apply(_ref, [this].concat(args))), _this), _this.renderNavBar = function () {
      var _this$props = _this.props,
          links = _this$props.links,
          onLogoClick = _this$props.onLogoClick,
          toggleSidebar = _this$props.toggleSidebar,
          position = _this$props.position;

      return React.createElement(NavBar, {
        onLogoClick: onLogoClick,
        onMenuButtonClick: toggleSidebar,
        links: links,
        position: position
      });
    }, _this.renderSidebar = function () {
      var links = _this.props.links;

      return React.createElement(Menu, { links: links });
    }, _this.renderMain = function () {
      var children = _this.props.children;

      return React.createElement(
        Group,
        { mt: 8 },
        children
      );
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AppShell, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          isSidebarOpen = _props.isSidebarOpen,
          toggleSidebar = _props.toggleSidebar;

      return React.createElement(
        Sidebar,
        {
          content: this.renderSidebar(),
          toggle: toggleSidebar,
          isOpen: isSidebarOpen
        },
        this.renderNavBar(),
        this.renderMain()
      );
    }
  }]);
  return AppShell;
}(Component);

AppShell.propTypes = {
  /** array of objects that define the links in the menu */
  links: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    href: PropTypes.string
  })),
  /** function that triggers the sidebar to open or close */
  toggleSidebar: PropTypes.func,
  /** flag that determines whether the sidebar is open or closed */
  isSidebarOpen: PropTypes.bool,
  /** determines the position of the navbar. This is mainly for debugging...*/
  position: PropTypes.oneOf(["fixed", "absolute"])
};
AppShell.defaultProps = {
  isSidebarOpen: false
};

function _isPlaceholder$2(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry1$2(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder$2(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */
var always$2$1 = /*#__PURE__*/_curry1$2(function always(val) {
  return function () {
    return val;
  };
});

/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */
var F$2$1 = /*#__PURE__*/always$2$1(false);

/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
var T$2$1 = /*#__PURE__*/always$2$1(true);

/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry2$2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder$2(a) ? f2 : _curry1$2(function (_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder$2(a) && _isPlaceholder$2(b) ? f2 : _isPlaceholder$2(a) ? _curry1$2(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder$2(b) ? _curry1$2(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */
var add$2$1 = /*#__PURE__*/_curry2$2(function add(a, b) {
  return Number(a) + Number(b);
});

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat$2(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}

function _arity$2(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}

/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curryN$2(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder$2(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder$2(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity$2(left, _curryN$2(length, combined, fn));
  };
}

/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
var curryN$2$1 = /*#__PURE__*/_curry2$2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1$2(fn);
  }
  return _arity$2(length, _curryN$2(length, [], fn));
});

/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
var addIndex$2$1 = /*#__PURE__*/_curry1$2(function addIndex(fn) {
  return curryN$2$1(fn.length, function () {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function () {
      var result = origFn.apply(this, _concat$2(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry3$2(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder$2(a) ? f3 : _curry2$2(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder$2(a) && _isPlaceholder$2(b) ? f3 : _isPlaceholder$2(a) ? _curry2$2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder$2(b) ? _curry2$2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1$2(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder$2(a) && _isPlaceholder$2(b) && _isPlaceholder$2(c) ? f3 : _isPlaceholder$2(a) && _isPlaceholder$2(b) ? _curry2$2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder$2(a) && _isPlaceholder$2(c) ? _curry2$2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder$2(b) && _isPlaceholder$2(c) ? _curry2$2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder$2(a) ? _curry1$2(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder$2(b) ? _curry1$2(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder$2(c) ? _curry1$2(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
var _isArray$2 = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

function _isTransformer$2(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}

/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
function _dispatchable$2(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray$2(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer$2(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}

var _xfBase$2 = {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};

/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */
var max$2$1 = /*#__PURE__*/_curry2$2(function max(a, b) {
  return b > a ? b : a;
});

function _map$2(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}

function _isString$2(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
var _isArrayLike$2$1 = /*#__PURE__*/_curry1$2(function isArrayLike(x) {
  if (_isArray$2(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (typeof x !== 'object') {
    return false;
  }
  if (_isString$2(x)) {
    return false;
  }
  if (x.nodeType === 1) {
    return !!x.length;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});

var XWrap$2 = /*#__PURE__*/function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap$2(fn) {
  return new XWrap$2(fn);
}

/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
var bind$2$1 = /*#__PURE__*/_curry2$2(function bind(fn, thisObj) {
  return _arity$2(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});

function _arrayReduce$2(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    idx += 1;
  }
  return xf['@@transducer/result'](acc);
}

function _iterableReduce$2(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    step = iter.next();
  }
  return xf['@@transducer/result'](acc);
}

function _methodReduce$2(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](bind$2$1(xf['@@transducer/step'], xf), acc));
}

var symIterator$2 = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

function _reduce$2(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = _xwrap$2(fn);
  }
  if (_isArrayLike$2$1(list)) {
    return _arrayReduce$2(fn, acc, list);
  }
  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce$2(fn, acc, list, 'fantasy-land/reduce');
  }
  if (list[symIterator$2] != null) {
    return _iterableReduce$2(fn, acc, list[symIterator$2]());
  }
  if (typeof list.next === 'function') {
    return _iterableReduce$2(fn, acc, list);
  }
  if (typeof list.reduce === 'function') {
    return _methodReduce$2(fn, acc, list, 'reduce');
  }

  throw new TypeError('reduce: list must be array or iterable');
}

var XMap$2 = /*#__PURE__*/function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase$2.init;
  XMap.prototype['@@transducer/result'] = _xfBase$2.result;
  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap$2$1 = /*#__PURE__*/_curry2$2(function _xmap(f, xf) {
  return new XMap$2(f, xf);
});

function _has$2(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var toString$2 = Object.prototype.toString;
var _isArguments$2$1 = function () {
  return toString$2.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString$2.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has$2('callee', x);
  };
};

// cover IE < 9 keys issues
var hasEnumBug$2 = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
var nonEnumerableProps$2 = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug$2 = /*#__PURE__*/function () {
  return arguments.propertyIsEnumerable('length');
}();

var contains$2 = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var _keys$2 = typeof Object.keys === 'function' && !hasArgsEnumBug$2 ? function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
} : function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug$2 && _isArguments$2$1(obj);
  for (prop in obj) {
    if (_has$2(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug$2) {
    nIdx = nonEnumerableProps$2.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps$2[nIdx];
      if (_has$2(prop, obj) && !contains$2(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
};
var keys$2$1 = /*#__PURE__*/_curry1$2(_keys$2);

/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
var map$2$1 = /*#__PURE__*/_curry2$2( /*#__PURE__*/_dispatchable$2(['fantasy-land/map', 'map'], _xmap$2$1, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN$2$1(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce$2(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys$2$1(functor));
    default:
      return _map$2(fn, functor);
  }
}));

/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */
var path$2$1 = /*#__PURE__*/_curry2$2(function path(paths, obj) {
  var val = obj;
  var idx = 0;
  while (idx < paths.length) {
    if (val == null) {
      return;
    }
    val = val[paths[idx]];
    idx += 1;
  }
  return val;
});

/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */

var prop$2$1 = /*#__PURE__*/_curry2$2(function prop(p, obj) {
  return path$2$1([p], obj);
});

/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */
var pluck$2$1 = /*#__PURE__*/_curry2$2(function pluck(p, list) {
  return map$2$1(prop$2$1(p), list);
});

/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
var reduce$2$2 = /*#__PURE__*/_curry3$2(_reduce$2);

/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */
var ap$2$1 = /*#__PURE__*/_curry2$2(function ap(applyF, applyX) {
  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
    return applyF(x)(applyX(x));
  } :
  // else
  _reduce$2(function (acc, f) {
    return _concat$2(acc, map$2$1(f, applyX));
  }, [], applyF);
});

/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */
var values$1 = /*#__PURE__*/_curry1$2(function values(obj) {
  var props = keys$2$1(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }
  return vals;
});

/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */

/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */
var isNil = /*#__PURE__*/_curry1$2(function isNil(x) {
  return x == null;
});

function _isFunction$2(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}

/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */
var liftN$2$1 = /*#__PURE__*/_curry2$2(function liftN(arity, fn) {
  var lifted = curryN$2$1(arity, fn);
  return curryN$2$1(arity, function () {
    return _reduce$2(ap$2$1, map$2$1(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});

/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */
var lift$2$1 = /*#__PURE__*/_curry1$2(function lift(fn) {
  return liftN$2$1(fn.length, fn);
});

/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
var curry$2$1 = /*#__PURE__*/_curry1$2(function curry(fn) {
  return curryN$2$1(fn.length, fn);
});

/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */
var call$2$1 = /*#__PURE__*/curry$2$1(function call(fn) {
  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});

/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */
function _makeFlat$2(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (_isArrayLike$2$1(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
}

function _forceReduced$2(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

var preservingReduced$2 = function (xf) {
  return {
    '@@transducer/init': _xfBase$2.init,
    '@@transducer/result': function (result) {
      return xf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      var ret = xf['@@transducer/step'](result, input);
      return ret['@@transducer/reduced'] ? _forceReduced$2(ret) : ret;
    }
  };
};

var _flatCat$2$1 = function _xcat(xf) {
  var rxf = preservingReduced$2(xf);
  return {
    '@@transducer/init': _xfBase$2.init,
    '@@transducer/result': function (result) {
      return rxf['@@transducer/result'](result);
    },
    '@@transducer/step': function (result, input) {
      return !_isArrayLike$2$1(input) ? _reduce$2(rxf, result, [input]) : _reduce$2(rxf, result, input);
    }
  };
};

var _xchain$2$1 = /*#__PURE__*/_curry2$2(function _xchain(f, xf) {
  return map$2$1(f, _flatCat$2$1(xf));
});

/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */
var chain$2$1 = /*#__PURE__*/_curry2$2( /*#__PURE__*/_dispatchable$2(['fantasy-land/chain', 'chain'], _xchain$2$1, function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function (x) {
      return fn(monad(x))(x);
    };
  }
  return _makeFlat$2(false)(map$2$1(fn, monad));
}));

function _cloneRegExp(pattern) {
                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */
var type$2$1 = /*#__PURE__*/_curry1$2(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});

/**
 * Copies an object.
 *
 * @private
 * @param {*} value The value to be copied
 * @param {Array} refFrom Array containing the source references
 * @param {Array} refTo Array containing the copied source references
 * @param {Boolean} deep Whether or not to perform deep cloning.
 * @return {*} The copied value.
 */
function _clone(value, refFrom, refTo, deep) {
  var copy = function copy(copiedValue) {
    var len = refFrom.length;
    var idx = 0;
    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }
      idx += 1;
    }
    refFrom[idx + 1] = value;
    refTo[idx + 1] = copiedValue;
    for (var key in value) {
      copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
    }
    return copiedValue;
  };
  switch (type$2$1(value)) {
    case 'Object':
      return copy({});
    case 'Array':
      return copy([]);
    case 'Date':
      return new Date(value.valueOf());
    case 'RegExp':
      return _cloneRegExp(value);
    default:
      return value;
  }
}

/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      var objects = [{}, {}, {}];
 *      var objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */
var clone = /*#__PURE__*/_curry1$2(function clone(value) {
  return value != null && typeof value.clone === 'function' ? value.clone() : _clone(value, [], [], true);
});

/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */
var not$2$1 = /*#__PURE__*/_curry1$2(function not(a) {
  return !a;
});

/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */
var complement$2$1 = /*#__PURE__*/lift$2$1(not$2$1);

function _pipe$2(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
function _checkForMethod$2(methodname, fn) {
  return function () {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return _isArray$2(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}

/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
var slice$2$1 = /*#__PURE__*/_curry3$2( /*#__PURE__*/_checkForMethod$2('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));

/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
var tail$2$1 = /*#__PURE__*/_curry1$2( /*#__PURE__*/_checkForMethod$2('tail', /*#__PURE__*/slice$2$1(1, Infinity)));

/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
function pipe$2() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity$2(arguments[0].length, reduce$2$2(_pipe$2, arguments[0], tail$2$1(arguments)));
}

/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
var reverse$2$1 = /*#__PURE__*/_curry1$2(function reverse(list) {
  return _isString$2(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});

/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
function compose$2() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe$2.apply(this, reverse$2$1(arguments));
}

function _arrayFromIterator$2(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}

function _containsWith$2(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}

function _functionName$2(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */
var identical$2$1 = /*#__PURE__*/_curry2$2(function identical(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
});

/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals$2(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator$2(aIterator);
  var b = _arrayFromIterator$2(bIterator);

  function eq(_a, _b) {
    return _equals$2(_a, _b, stackA.slice(), stackB.slice());
  }

  // if *a* array contains any element that is not included in *b*
  return !_containsWith$2(function (b, aItem) {
    return !_containsWith$2(eq, aItem, b);
  }, b, a);
}

function _equals$2(a, b, stackA, stackB) {
  if (identical$2$1(a, b)) {
    return true;
  }

  var typeA = type$2$1(a);

  if (typeA !== type$2$1(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName$2(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && identical$2$1(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!identical$2$1(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals$2(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals$2(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys$2$1(a);
  if (keysA.length !== keys$2$1(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);

  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has$2(key, b) && _equals$2(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}

/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
var equals$2$1 = /*#__PURE__*/_curry2$2(function equals(a, b) {
  return _equals$2(a, b, [], []);
});

function _indexOf$2(list, a, idx) {
  var inf, item;
  // Array.prototype.indexOf doesn't exist below IE9
  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === 'number' && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        // non-zero numbers can utilise Set
        return list.indexOf(a, idx);

      // all these types can utilise Set
      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }
    }
  }
  // anything else not covered above, defer to R.equals
  while (idx < list.length) {
    if (equals$2$1(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}

function _contains$2(a, list) {
  return _indexOf$2(list, a, 0) >= 0;
}

function _quote$2(s) {
  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');

  return '"' + escaped.replace(/"/g, '\\"') + '"';
}

/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
var pad$2 = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var _toISOString$2$1 = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
  return d.toISOString();
} : function _toISOString(d) {
  return d.getUTCFullYear() + '-' + pad$2(d.getUTCMonth() + 1) + '-' + pad$2(d.getUTCDate()) + 'T' + pad$2(d.getUTCHours()) + ':' + pad$2(d.getUTCMinutes()) + ':' + pad$2(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};

function _complement$2(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}

function _filter$2(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}

function _isObject$2(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

var XFilter$2 = /*#__PURE__*/function () {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = _xfBase$2.init;
  XFilter.prototype['@@transducer/result'] = _xfBase$2.result;
  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

var _xfilter$2$1 = /*#__PURE__*/_curry2$2(function _xfilter(f, xf) {
  return new XFilter$2(f, xf);
});

/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var filter$2$1 = /*#__PURE__*/_curry2$2( /*#__PURE__*/_dispatchable$2(['filter'], _xfilter$2$1, function (pred, filterable) {
  return _isObject$2(filterable) ? _reduce$2(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, keys$2$1(filterable)) :
  // else
  _filter$2(pred, filterable);
}));

/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
var reject$2$1 = /*#__PURE__*/_curry2$2(function reject(pred, filterable) {
  return filter$2$1(_complement$2(pred), filterable);
});

function _toString$2(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _contains$2(y, xs) ? '<Circular>' : _toString$2(y, xs);
  };

  //  mapPairs :: (Object, [String]) -> [String]
  var mapPairs = function (obj, keys) {
    return _map$2(function (k) {
      return _quote$2(k) + ': ' + recur(obj[k]);
    }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map$2(recur, x).join(', ') + '))';
    case '[object Array]':
      return '[' + _map$2(recur, x).concat(mapPairs(x, reject$2$1(function (k) {
        return (/^\d+$/.test(k)
        );
      }, keys$2$1(x)))).join(', ') + ']';
    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote$2(_toISOString$2$1(x))) + ')';
    case '[object Null]':
      return 'null';
    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote$2(x);
    case '[object Undefined]':
      return 'undefined';
    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();
        if (repr !== '[object Object]') {
          return repr;
        }
      }
      return '{' + mapPairs(x, keys$2$1(x)).join(', ') + '}';
  }
}

/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
var toString$3$1 = /*#__PURE__*/_curry1$2(function toString(val) {
  return _toString$2(val, []);
});

/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */
var converge$2$1 = /*#__PURE__*/_curry2$2(function converge(after, fns) {
  return curryN$2$1(reduce$2$2(max$2$1, 0, pluck$2$1('length', fns)), function () {
    var args = arguments;
    var context = this;
    return after.apply(context, _map$2(function (fn) {
      return fn.apply(context, args);
    }, fns));
  });
});

var XReduceBy$2 = /*#__PURE__*/function () {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy.prototype['@@transducer/init'] = _xfBase$2.init;
  XReduceBy.prototype['@@transducer/result'] = function (result) {
    var key;
    for (key in this.inputs) {
      if (_has$2(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);
        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };
  XReduceBy.prototype['@@transducer/step'] = function (result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return XReduceBy;
}();

var _xreduceBy$2$1 = /*#__PURE__*/_curryN$2(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
  return new XReduceBy$2(valueFn, valueAcc, keyFn, xf);
});

/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */
var reduceBy$2$1 = /*#__PURE__*/_curryN$2(4, [], /*#__PURE__*/_dispatchable$2([], _xreduceBy$2$1, function reduceBy(valueFn, valueAcc, keyFn, list) {
  return _reduce$2(function (acc, elt) {
    var key = keyFn(elt);
    acc[key] = valueFn(_has$2(key, acc) ? acc[key] : valueAcc, elt);
    return acc;
  }, {}, list);
}));

/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */
var countBy$2$1 = /*#__PURE__*/reduceBy$2$1(function (acc, elem) {
  return acc + 1;
}, 0);

/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */
var dec$2$1 = /*#__PURE__*/add$2$1(-1);

var XDropRepeatsWith$2 = /*#__PURE__*/function () {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase$2.init;
  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase$2.result;
  XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return XDropRepeatsWith;
}();

var _xdropRepeatsWith$2$1 = /*#__PURE__*/_curry2$2(function _xdropRepeatsWith(pred, xf) {
  return new XDropRepeatsWith$2(pred, xf);
});

/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */
var nth$2$1 = /*#__PURE__*/_curry2$2(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString$2(list) ? list.charAt(idx) : list[idx];
});

/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */
var last$2$1 = /*#__PURE__*/nth$2$1(-1);

/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */
var dropRepeatsWith$2$1 = /*#__PURE__*/_curry2$2( /*#__PURE__*/_dispatchable$2([], _xdropRepeatsWith$2$1, function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;
  if (len !== 0) {
    result[0] = list[0];
    while (idx < len) {
      if (!pred(last$2$1(result), list[idx])) {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
  }
  return result;
}));

/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */
var dropRepeats$2$1 = /*#__PURE__*/_curry1$2( /*#__PURE__*/_dispatchable$2([], /*#__PURE__*/_xdropRepeatsWith$2$1(equals$2$1), /*#__PURE__*/dropRepeatsWith$2$1(equals$2$1)));

/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */
var empty$1 = /*#__PURE__*/_curry1$2(function empty(x) {
  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray$2(x) ? [] : _isString$2(x) ? '' : _isObject$2(x) ? {} : _isArguments$2$1(x) ? function () {
    return arguments;
  }() :
  // else
  void 0;
});

/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */
var flatten = /*#__PURE__*/_curry1$2( /*#__PURE__*/_makeFlat$2(true));

/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */
var flip$2$1 = /*#__PURE__*/_curry1$2(function flip(fn) {
  return curryN$2$1(fn.length, function (a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});

/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */
var groupBy$2$1 = /*#__PURE__*/_curry2$2( /*#__PURE__*/_checkForMethod$2('groupBy', /*#__PURE__*/reduceBy$2$1(function (acc, item) {
  if (acc == null) {
    acc = [];
  }
  acc.push(item);
  return acc;
}, null)));

/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */
var head$2$1 = /*#__PURE__*/nth$2$1(0);

function _identity$2(x) {
  return x;
}

/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */
var identity$2$1 = /*#__PURE__*/_curry1$2(_identity$2);

/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
var inc$2$1 = /*#__PURE__*/add$2$1(1);

/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */
var indexBy$2$1 = /*#__PURE__*/reduceBy$2$1(function (acc, elem) {
  return elem;
}, null);

/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */
var init$2$1 = /*#__PURE__*/slice$2$1(0, -1);

var _Set$2$1 = /*#__PURE__*/function () {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function (item) {
    return !hasOrAdd$2(item, true, this);
  };

  //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //
  _Set.prototype.has = function (item) {
    return hasOrAdd$2(item, false, this);
  };

  //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //
  return _Set;
}();

function hasOrAdd$2(item, shouldAdd, set) {
  var type = typeof item;
  var prevSize, newSize;
  switch (type) {
    case 'string':
    case 'number':
      // distinguish between +0 and -0
      if (item === 0 && 1 / item === -Infinity) {
        if (set._items['-0']) {
          return true;
        } else {
          if (shouldAdd) {
            set._items['-0'] = true;
          }
          return false;
        }
      }
      // these types can all utilise the native Set
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = {};
            set._items[type][item] = true;
          }
          return false;
        } else if (item in set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][item] = true;
          }
          return false;
        }
      }

    case 'boolean':
      // set._items['boolean'] holds a two element array
      // representing [ falseExists, trueExists ]
      if (type in set._items) {
        var bIdx = item ? 1 : 0;
        if (set._items[type][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type][bIdx] = true;
          }
          return false;
        }
      } else {
        if (shouldAdd) {
          set._items[type] = item ? [false, true] : [true, false];
        }
        return false;
      }

    case 'function':
      // compare functions for reference equality
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }
          return false;
        }
        if (!_contains$2(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }
          return false;
        }
        return true;
      }

    case 'undefined':
      if (set._items[type]) {
        return true;
      } else {
        if (shouldAdd) {
          set._items[type] = true;
        }
        return false;
      }

    case 'object':
      if (item === null) {
        if (!set._items['null']) {
          if (shouldAdd) {
            set._items['null'] = true;
          }
          return false;
        }
        return true;
      }
    /* falls through */
    default:
      // reduce the search size of heterogeneous sets by creating buckets
      // for each type.
      type = Object.prototype.toString.call(item);
      if (!(type in set._items)) {
        if (shouldAdd) {
          set._items[type] = [item];
        }
        return false;
      }
      // scan through all previously applied items
      if (!_contains$2(item, set._items[type])) {
        if (shouldAdd) {
          set._items[type].push(item);
        }
        return false;
      }
      return true;
  }
}

/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */
var uniqBy$2$1 = /*#__PURE__*/_curry2$2(function uniqBy(fn, list) {
  var set = new _Set$2$1();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});

/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */
var uniq$2$1 = /*#__PURE__*/uniqBy$2$1(identity$2$1);

/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */
var invoker$2$1 = /*#__PURE__*/_curry2$2(function invoker(arity, method) {
  return curryN$2$1(arity + 1, function () {
    var target = arguments[arity];
    if (target != null && _isFunction$2(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString$3$1(target) + ' does not have a method named "' + method + '"');
  });
});

/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */
var isEmpty$1 = /*#__PURE__*/_curry1$2(function isEmpty(x) {
  return x != null && equals$2$1(x, empty$1(x));
});

/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */
var join$2$1 = /*#__PURE__*/invoker$2$1(1, 'join');

/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */
var juxt$2$1 = /*#__PURE__*/_curry1$2(function juxt(fns) {
  return converge$2$1(function () {
    return Array.prototype.slice.call(arguments, 0);
  }, fns);
});

/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      var values = { x: 1, y: 2, z: 3 };
 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */
var mapObjIndexed = /*#__PURE__*/_curry2$2(function mapObjIndexed(fn, obj) {
  return _reduce$2(function (acc, key) {
    acc[key] = fn(obj[key], key, obj);
    return acc;
  }, {}, keys$2$1(obj));
});

/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */
var sum$2$1 = /*#__PURE__*/reduce$2$2(add$2$1, 0);

/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
var memoizeWith$2$1 = /*#__PURE__*/_curry2$2(function memoizeWith(mFn, fn) {
  var cache = {};
  return _arity$2(fn.length, function () {
    var key = mFn.apply(this, arguments);
    if (!_has$2(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});

/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @deprecated since v0.25.0
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
var memoize$2$1 = /*#__PURE__*/memoizeWith$2$1(function () {
  return toString$3$1(arguments);
});

/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */
var multiply$2$1 = /*#__PURE__*/_curry2$2(function multiply(a, b) {
  return a * b;
});

function _createPartialApplicator$2(concat) {
  return _curry2$2(function (fn, args) {
    return _arity$2(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}

/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */
var partialRight$2$1 = /*#__PURE__*/_createPartialApplicator$2( /*#__PURE__*/flip$2$1(_concat$2));

/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */
var partition$2$1 = /*#__PURE__*/juxt$2$1([filter$2$1, reject$2$1]);

/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */
var pickAll$2$1 = /*#__PURE__*/_curry2$2(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});

/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */
var product$2$1 = /*#__PURE__*/reduce$2$2(multiply$2$1, 1);

/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */
var useWith$2$1 = /*#__PURE__*/_curry2$2(function useWith(fn, transformers) {
  return curryN$2$1(transformers.length, function () {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});

/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */
var project$2$1 = /*#__PURE__*/useWith$2$1(_map$2, [pickAll$2$1, identity$2$1]); // passing `identity` gives correct arity

/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */
var times$1 = /*#__PURE__*/_curry2$2(function times(fn, n) {
  var len = Number(n);
  var idx = 0;
  var list;

  if (len < 0 || isNaN(len)) {
    throw new RangeError('n must be a non-negative number');
  }
  list = new Array(len);
  while (idx < len) {
    list[idx] = fn(idx);
    idx += 1;
  }
  return list;
});

/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */
var split$2$1 = /*#__PURE__*/invoker$2$1(1, 'split');

/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */
var toLower$2$1 = /*#__PURE__*/invoker$2$1(0, 'toLowerCase');

/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
var toUpper$2$1 = /*#__PURE__*/invoker$2$1(0, 'toUpperCase');

/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      var isOdd = (x) => x % 2 === 1;
 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */
var transduce$2$1 = /*#__PURE__*/curryN$2$1(4, function transduce(xf, fn, acc, list) {
  return _reduce$2(xf(typeof fn === 'function' ? _xwrap$2(fn) : fn), acc, list);
});

var ws$2 = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
var zeroWidth$2 = '\u200b';
var hasProtoTrim$2 = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */
var _trim$2 = !hasProtoTrim$2 || /*#__PURE__*/ws$2.trim() || ! /*#__PURE__*/zeroWidth$2.trim() ? function trim(str) {
  var beginRx = new RegExp('^[' + ws$2 + '][' + ws$2 + ']*');
  var endRx = new RegExp('[' + ws$2 + '][' + ws$2 + ']*$');
  return str.replace(beginRx, '').replace(endRx, '');
} : function trim(str) {
  return str.trim();
};

/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */
var union$2$1 = /*#__PURE__*/_curry2$2( /*#__PURE__*/compose$2(uniq$2$1, _concat$2));

/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */
var unnest$2$1 = /*#__PURE__*/chain$2$1(_identity$2);

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};



function unwrapExports$2 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule$2(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var interopRequireDefault$1 = createCommonjsModule$2(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports$2(interopRequireDefault$1);

var _extends_1 = createCommonjsModule$2(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

var _baseHas = baseHas;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$2.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]';
var undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]';
var funcTag = '[object Function]';
var genTag = '[object GeneratorFunction]';
var proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;
var objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$4.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$4(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$4.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$4.Cache = _MapCache;

var memoize_1 = memoize$4;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined;
var symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$5(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString$5;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has$2(object, path) {
  return object != null && _hasPath(object, path, _baseHas);
}

var has_1 = has$2;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty$1$2 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$1$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule$2(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]';
var arrayTag = '[object Array]';
var boolTag = '[object Boolean]';
var dateTag = '[object Date]';
var errorTag = '[object Error]';
var funcTag$1 = '[object Function]';
var mapTag = '[object Map]';
var numberTag = '[object Number]';
var objectTag = '[object Object]';
var regexpTag = '[object RegExp]';
var setTag = '[object Set]';
var stringTag = '[object String]';
var weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]';
var dataViewTag = '[object DataView]';
var float32Tag = '[object Float32Array]';
var float64Tag = '[object Float64Array]';
var int8Tag = '[object Int8Array]';
var int16Tag = '[object Int16Array]';
var int32Tag = '[object Int32Array]';
var uint8Tag = '[object Uint8Array]';
var uint8ClampedTag = '[object Uint8ClampedArray]';
var uint16Tag = '[object Uint16Array]';
var uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule$2(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$9;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$10.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$4(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$4;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$11.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$9.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule$2(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$12 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$12.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set$4 = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap$1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';
var objectTag$1 = '[object Object]';
var promiseTag = '[object Promise]';
var setTag$1 = '[object Set]';
var weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView);
var mapCtorString = _toSource(_Map);
var promiseCtorString = _toSource(_Promise);
var setCtorString = _toSource(_Set$4);
var weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set$4 && getTag(new _Set$4) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$13 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$10 = objectProto$13.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$10.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp$1 = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined;
var symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]';
var dateTag$1 = '[object Date]';
var mapTag$2 = '[object Map]';
var numberTag$1 = '[object Number]';
var regexpTag$1 = '[object RegExp]';
var setTag$2 = '[object Set]';
var stringTag$1 = '[object String]';
var symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]';
var dataViewTag$2 = '[object DataView]';
var float32Tag$1 = '[object Float32Array]';
var float64Tag$1 = '[object Float64Array]';
var int8Tag$1 = '[object Int8Array]';
var int16Tag$1 = '[object Int16Array]';
var int32Tag$1 = '[object Int32Array]';
var uint8Tag$1 = '[object Uint8Array]';
var uint8ClampedTag$1 = '[object Uint8ClampedArray]';
var uint16Tag$1 = '[object Uint16Array]';
var uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp$1(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;
var CLONE_FLAT_FLAG = 2;
var CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';
var arrayTag$1 = '[object Array]';
var boolTag$2 = '[object Boolean]';
var dateTag$2 = '[object Date]';
var errorTag$1 = '[object Error]';
var funcTag$2 = '[object Function]';
var genTag$1 = '[object GeneratorFunction]';
var mapTag$4 = '[object Map]';
var numberTag$2 = '[object Number]';
var objectTag$2 = '[object Object]';
var regexpTag$2 = '[object RegExp]';
var setTag$4 = '[object Set]';
var stringTag$2 = '[object String]';
var symbolTag$2 = '[object Symbol]';
var weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]';
var dataViewTag$3 = '[object DataView]';
var float32Tag$2 = '[object Float32Array]';
var float64Tag$2 = '[object Float64Array]';
var int8Tag$2 = '[object Int8Array]';
var int16Tag$2 = '[object Int16Array]';
var int32Tag$2 = '[object Int32Array]';
var uint8Tag$2 = '[object Uint8Array]';
var uint8ClampedTag$2 = '[object Uint8ClampedArray]';
var uint16Tag$2 = '[object Uint16Array]';
var uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1;
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1, customizer);
}

var cloneDeepWith_1 = cloneDeepWith;

/** `Object#toString` result references. */
var stringTag$3 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$3);
}

var isString_1 = isString;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

var _iteratorToArray = iteratorToArray;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff';
var rsComboMarksRange = '\\u0300-\\u036f';
var reComboHalfMarksRange = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange = '\\u20d0-\\u20ff';
var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
var rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff';
var rsComboMarksRange$1 = '\\u0300-\\u036f';
var reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange$1 = '\\u20d0-\\u20ff';
var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']';
var rsCombo = '[' + rsComboRange$1 + ']';
var rsFitz = '\\ud83c[\\udffb-\\udfff]';
var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
var rsNonAstral = '[^' + rsAstralRange$1 + ']';
var rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
var rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
var rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?';
var rsOptVar = '[' + rsVarRange$1 + ']?';
var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
var rsSeq = rsOptVar + reOptMod + rsOptJoin;
var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

var _stringToArray = stringToArray;

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return _arrayMap(props, function(key) {
    return object[key];
  });
}

var _baseValues = baseValues;

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values$3(object) {
  return object == null ? [] : _baseValues(object, keys_1(object));
}

var values_1 = values$3;

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]';
var setTag$5 = '[object Set]';

/** Built-in value references. */
var symIterator$3 = _Symbol ? _Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray$1$2(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike_1(value)) {
    return isString_1(value) ? _stringToArray(value) : _copyArray(value);
  }
  if (symIterator$3 && value[symIterator$3]) {
    return _iteratorToArray(value[symIterator$3]());
  }
  var tag = _getTag(value),
      func = tag == mapTag$5 ? _mapToArray : (tag == setTag$5 ? _setToArray : values_1);

  return func(value);
}

var toArray_1 = toArray$1$2;

var printValue_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = printValue;
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

module.exports = exports["default"];
});

unwrapExports$2(printValue_1);

var locale = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = void 0;

var _printValue = interopRequireDefault$1(printValue_1);

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + (0, _printValue.default)(value, true) + "`") + (isCast ? " (cast from the value `" + (0, _printValue.default)(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
exports.mixed = mixed;
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
exports.string = string;
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  less: '${path} must be less than ${less}',
  more: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
exports.number = number;
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
exports.date = date;
var boolean = {};
exports.boolean = boolean;
var object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};
exports.object = object;
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
exports.array = array;
var _default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};
exports.default = _default;
});

unwrapExports$2(locale);
var locale_1 = locale.array;
var locale_2 = locale.object;
var locale_3 = locale.date;
var locale_4 = locale.number;
var locale_5 = locale.string;
var locale_6 = locale.mixed;

var isSchema = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;

var _default = function _default(obj) {
  return obj && obj.__isYupSchema__;
};

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports$2(isSchema);

var Condition = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;

var _has = interopRequireDefault$1(has_1);

var _isSchema = interopRequireDefault$1(isSchema);

function callOrConcat(schema) {
  if (typeof schema === 'function') return schema;
  return function (base) {
    return base.concat(schema);
  };
}

var Conditional =
/*#__PURE__*/
function () {
  function Conditional(refs, options) {
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    this.refs = [].concat(refs);
    then = callOrConcat(then);
    otherwise = callOrConcat(otherwise);
    if (typeof options === 'function') this.fn = options;else {
      if (!(0, _has.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
      if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
      var isFn = typeof is === 'function' ? is : function () {
        for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }

        return values.every(function (value) {
          return value === is;
        });
      };

      this.fn = function () {
        for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          values[_key2] = arguments[_key2];
        }

        var currentSchema = values.pop();
        var option = isFn.apply(void 0, values) ? then : otherwise;
        return option(currentSchema);
      };
    }
  }

  var _proto = Conditional.prototype;

  _proto.getValue = function getValue(parent, context) {
    var values = this.refs.map(function (r) {
      return r.getValue(parent, context);
    });
    return values;
  };

  _proto.resolve = function resolve(ctx, values) {
    var schema = this.fn.apply(ctx, values.concat(ctx));
    if (schema !== undefined && !(0, _isSchema.default)(schema)) throw new TypeError('conditions must return a schema object');
    return schema || ctx;
  };

  return Conditional;
}();

var _default = Conditional;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports$2(Condition);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties$2 = _objectWithoutProperties;

function argumentsToArray(args) {
  return Array.prototype.slice.apply(args);
}

function looksLikePromise(thing) {
  return thing &&
    thing.then &&
    typeof (thing.then) === "function" &&
    typeof (thing.catch) === "function";
}

function SynchronousPromise(ctorFunction) {
  this.status = "pending";
  this._paused = false;
  this._next = [];
  this._data = [];
  this._runConstructorFunction(ctorFunction);
}

SynchronousPromise.prototype = {
  then: function (next, fail) {
    this._next.push([next, fail]);

    if (this._isPendingResolutionOrRejection()) {
      return this;
    }

    return this._applyNext();
  },
  catch: function (fn) {
    this._next.push([undefined, fn]);

    if (this._isPendingResolutionOrRejection()) {
      return this;
    }

    return this._applyNext();
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    this._paused = false;
    return this._applyNext();
  },
  _runConstructorFunction: function (ctorFunction) {
    var self = this;

    this._next.push([
      function (r) { return r; },
      function (err) { throw err; }
    ]);

    var isRun = false;
    ctorFunction(function (result) {
      if (isRun) {
        return;
      }

      isRun = true;
      self._setResolved();
      self._data = [result];
      self._applyNext();
    }, function (err) {
      if (isRun) {
        return;
      }

      isRun = true;
      self._setRejected();
      self._data = [err];
      self._applyNext();
    });
  },
  _setRejected: function () {
    this.status = "rejected";
  },
  _setResolved: function () {
    this.status = "resolved";
  },
  _setPending: function () {
    this.status = "pending";
  },
  _applyNext: function () {
    if (this._next.length === 0 || this._paused) {
      return this;
    }

    var next = this._findNext();
    if (!next) {
      return this;
    }
    return this._applyNextHandler(next);
  },
  _applyNextHandler: function (handler) {
    try {
      var data = handler.apply(null, this._data);

      if (looksLikePromise(data)) {
        this._handleNestedPromise(data);
        return this;
      }

      this._setResolved();
      this._data = [data];
      return this._applyNext();
    } catch (e) {
      this._setRejected();
      this._data = [e];
      return this._applyNext();
    }
  },
  _findNext: function () {
    if (this._isPendingResolutionOrRejection()) {
      return undefined;
    }
    var handler = this.status === "resolved"
          ? this._findFirstResolutionHandler
          : this._findFirstRejectionHandler;
    return handler ? handler.apply(this) : undefined;
  },
  _handleNestedPromise: function (promise) {
    this._setPending();
    var self = this;
    promise.then(function (d) {
      self._setResolved();
      self._data = [d];
      self._applyNext();
    }).catch(function (e) {
      self._setRejected();
      self._data = [e];
      self._applyNext();
    });
  },
  _isPendingResolutionOrRejection: function () {
    return this.status === "pending";
  },
  _findFirstResolutionHandler: function () {
    var next;
    while (!next && this._next.length > 0) {
      next = this._next.shift()[0];
    }

    return next;
  },
  _findFirstRejectionHandler: function () {
    var next;
    while (!next && this._next.length > 0) {
      next = this._next.shift()[1];
    }

    return next;
  }
};
SynchronousPromise.resolve = function (data) {
  if (looksLikePromise(data)) {
    return data;
  }

  return new SynchronousPromise(function (resolve) {
    resolve(data);
  });
};
SynchronousPromise.reject = function (error) {
  if (looksLikePromise(error)) {
    return error;
  }

  return new SynchronousPromise(function (resolve, reject) {
    reject(error);
  });
};
SynchronousPromise.all = function () {
  var args = argumentsToArray(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};
SynchronousPromise.unresolved = function () {
  var stash = {};
  var result = new SynchronousPromise(function (resolve, reject) {
    stash.resolve = resolve;
    stash.reject = reject;
  });
  result.resolve = stash.resolve;
  result.reject = stash.reject;
  return result;
};

var synchronousPromise = {
  SynchronousPromise: SynchronousPromise
};

var ValidationError_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = ValidationError;

var _printValue = interopRequireDefault$1(printValue_1);

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return (0, _printValue.default)(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);
    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });
  this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}

ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(params) {
    params.path = params.label || params.path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};

module.exports = exports["default"];
});

unwrapExports$2(ValidationError_1);

var runValidations_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.propagateErrors = propagateErrors;
exports.settled = settled;
exports.collectErrors = collectErrors;
exports.default = runValidations;

var _objectWithoutProperties2 = interopRequireDefault$1(objectWithoutProperties$2);



var _ValidationError = interopRequireDefault$1(ValidationError_1);

var promise = function promise(sync) {
  return sync ? synchronousPromise.SynchronousPromise : Promise;
};

var unwrapError = function unwrapError(errors) {
  if (errors === void 0) {
    errors = [];
  }

  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises); //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  }); //console.log('scopeToValue c', b)

  var c = b.then(function () {
    return value;
  }); //console.log('scopeToValue d', c)

  return c;
}
/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */


function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}

function settled(promises, sync) {
  var settle = function settle(promise) {
    return promise.then(function (value) {
      return {
        fulfilled: true,
        value: value
      };
    }, function (value) {
      return {
        fulfilled: false,
        value: value
      };
    });
  };

  return promise(sync).all(promises.map(settle));
}

function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;
  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!_ValidationError.default.isError(error)) {
        throw error;
      }

      return arr.concat(error);
    }, []);
    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

    errors = nestedErrors.concat(errors);
    if (errors.length) throw new _ValidationError.default(errors, value, path);
    return value;
  });
}

function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = (0, _objectWithoutProperties2.default)(_ref3, ["endEarly"]);
  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
  return collectErrors(options);
}
});

unwrapExports$2(runValidations_1);
var runValidations_2 = runValidations_1.propagateErrors;
var runValidations_3 = runValidations_1.settled;
var runValidations_4 = runValidations_1.collectErrors;

var merge_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = merge;

var _has = interopRequireDefault$1(has_1);

var _isSchema = interopRequireDefault$1(isSchema);

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function merge(target, source) {
  for (var key in source) {
    if ((0, _has.default)(source, key)) {
      var targetVal = target[key],
          sourceVal = source[key];
      if (sourceVal === undefined) continue;

      if ((0, _isSchema.default)(sourceVal)) {
        target[key] = (0, _isSchema.default)(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
      } else if (isObject(sourceVal)) {
        target[key] = isObject(targetVal) ? merge(targetVal, sourceVal) : sourceVal;
      } else if (Array.isArray(sourceVal)) {
        target[key] = Array.isArray(targetVal) ? targetVal.concat(sourceVal) : sourceVal;
      } else target[key] = source[key];
    }
  }

  return target;
}

module.exports = exports["default"];
});

unwrapExports$2(merge_1);

var isAbsent = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value == null;
};

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports$2(isAbsent);

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;
var COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1;
var COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]';
var dateTag$3 = '[object Date]';
var errorTag$2 = '[object Error]';
var mapTag$6 = '[object Map]';
var numberTag$3 = '[object Number]';
var regexpTag$3 = '[object RegExp]';
var setTag$6 = '[object Set]';
var stringTag$4 = '[object String]';
var symbolTag$3 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]';
var dataViewTag$4 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined;
var symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$3:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$2:
      return object.name == other.name && object.message == other.message;

    case regexpTag$3:
    case stringTag$4:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$6:
      var convert = _mapToArray;

    case setTag$6:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$14 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$11 = objectProto$14.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$11.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';
var arrayTag$2 = '[object Array]';
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var objectProto$15 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$12 = objectProto$15.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$2 : _getTag(object),
      othTag = othIsArr ? arrayTag$2 : _getTag(other);

  objTag = objTag == argsTag$3 ? objectTag$3 : objTag;
  othTag = othTag == argsTag$3 ? objectTag$3 : othTag;

  var objIsObj = objTag == objectTag$3,
      othIsObj = othTag == objectTag$3,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$12.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$12.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1;
var COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

var _getMatchData = getMatchData;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn$2;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1;
var COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get_1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn_1(object, path)
      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$4(value) {
  return value;
}

var identity_1 = identity$4;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity_1;
  }
  if (typeof value == 'object') {
    return isArray_1(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return property_1(value);
}

var _baseIteratee = baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g;
var DIGIT_REGEX = /^\d+$/;
var LEAD_DIGIT_REGEX = /^\d/;
var SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g;

var setCache = {};
var getCache = {};

var propertyExpr = {
  expr: expr,

  setter: function(path) {
    return (
      setCache[path] ||
      (setCache[path] = new Function(
        'data, value',
        expr(path, 'data') + ' = value'
      ))
    )
  },

  getter: function(path, safe) {
    var k = path + '_' + safe;
    return (
      getCache[k] ||
      (getCache[k] = new Function('data', 'return ' + expr(path, safe, 'data')))
    )
  },

  split: function(path) {
    return path.match(SPLIT_REGEX)
  },

  join: function(segments) {
    return segments.reduce(function(path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function(path, cb, thisArg) {
    forEach$2(path.match(SPLIT_REGEX), cb, thisArg);
  }
};

function expr(expression, safe, param) {
  expression = expression || '';

  if (typeof safe === 'string') {
    param = safe;
    safe = false;
  }

  param = param || 'data';

  if (expression && expression.charAt(0) !== '[') expression = '.' + expression;

  return safe ? makeSafe(expression, param) : param + expression
}

function forEach$2(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;

  for (idx = 0; idx < len; idx++) {
    part = parts[idx];

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }

      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);

      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function makeSafe(path, param) {
  var result = param,
    parts = path.match(SPLIT_REGEX),
    isLast;

  forEach$2(parts, function(part, isBracket, isArray, idx, parts) {
    isLast = idx === parts.length - 1;

    part = isBracket || isArray ? '[' + part + ']' : '.' + part;

    result += part + (!isLast ? ' || {})' : ')');
  });

  return new Array(parts.length + 1).join('(') + result
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}

var Reference_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;



var validateName = function validateName(d) {
  if (typeof d !== 'string') throw new TypeError("ref's must be strings, got: " + d);
};

var Reference =
/*#__PURE__*/
function () {
  Reference.isRef = function isRef(value) {
    return !!(value && (value.__isYupRef || value instanceof Reference));
  };

  var _proto = Reference.prototype;

  _proto.toString = function toString() {
    return "Ref(" + this.key + ")";
  };

  function Reference(key, mapFn, options) {
    if (options === void 0) {
      options = {};
    }

    validateName(key);
    var prefix = options.contextPrefix || '$';

    if (typeof key === 'function') {
      key = '.';
    }

    this.key = key.trim();
    this.prefix = prefix;
    this.isContext = this.key.indexOf(prefix) === 0;
    this.isSelf = this.key === '.';
    this.path = this.isContext ? this.key.slice(this.prefix.length) : this.key;
    this._get = (0, propertyExpr.getter)(this.path, true);

    this.map = mapFn || function (value) {
      return value;
    };
  }

  _proto.resolve = function resolve() {
    return this;
  };

  _proto.cast = function cast(value, _ref) {
    var parent = _ref.parent,
        context = _ref.context;
    return this.getValue(parent, context);
  };

  _proto.getValue = function getValue(parent, context) {
    var isContext = this.isContext;

    var value = this._get(isContext ? context : parent || context || {});

    return this.map(value);
  };

  return Reference;
}();

exports.default = Reference;
Reference.prototype.__isYupRef = true;
module.exports = exports["default"];
});

unwrapExports$2(Reference_1);

var createValidation_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = createValidation;

var _objectWithoutProperties2 = interopRequireDefault$1(objectWithoutProperties$2);

var _extends2 = interopRequireDefault$1(_extends_1);

var _mapValues = interopRequireDefault$1(mapValues_1);

var _ValidationError = interopRequireDefault$1(ValidationError_1);

var _Reference = interopRequireDefault$1(Reference_1);



var formatError = _ValidationError.default.formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
  }

  return synchronousPromise.SynchronousPromise.resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return (0, _mapValues.default)((0, _extends2.default)({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = (0, _objectWithoutProperties2.default)(_ref, ["value", "label", "resolve", "originalValue"]);
  return function createError(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? opts.name : _ref2$type,
        params = _ref2.params;

    params = (0, _extends2.default)({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));
    return (0, _extends2.default)(new _ValidationError.default(formatError(message, params), value, path, type), {
      params: params
    });
  };
}

function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;

  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = (0, _objectWithoutProperties2.default)(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);
    var parent = options.parent;

    var resolve = function resolve(value) {
      return _Reference.default.isRef(value) ? value.getValue(parent, options.context) : value;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });
    var ctx = (0, _extends2.default)({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);
    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (_ValidationError.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.TEST_NAME = name;
  validate.TEST_FN = test;
  validate.TEST = options;
  return validate;
}

module.exports.createErrorFactory = createErrorFactory;
module.exports = exports["default"];
});

unwrapExports$2(createValidation_1);
var createValidation_2 = createValidation_1.createErrorFactory;

var mixed = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = SchemaType;

var _extends2 = interopRequireDefault$1(_extends_1);

var _has = interopRequireDefault$1(has_1);

var _cloneDeepWith = interopRequireDefault$1(cloneDeepWith_1);

var _toArray2 = interopRequireDefault$1(toArray_1);



var _Condition = interopRequireDefault$1(Condition);

var _runValidations = interopRequireDefault$1(runValidations_1);

var _merge = interopRequireDefault$1(merge_1);

var _isSchema = interopRequireDefault$1(isSchema);

var _isAbsent = interopRequireDefault$1(isAbsent);

var _createValidation = interopRequireDefault$1(createValidation_1);

var _printValue = interopRequireDefault$1(printValue_1);

var _Reference = interopRequireDefault$1(Reference_1);

var notEmpty = function notEmpty(value) {
  return !(0, _isAbsent.default)(value);
};

var RefSet =
/*#__PURE__*/
function () {
  function RefSet() {
    this.list = new Set();
    this.refs = new Map();
  }

  var _proto = RefSet.prototype;

  _proto.toArray = function toArray() {
    return (0, _toArray2.default)(this.list).concat((0, _toArray2.default)(this.refs.values()));
  };

  _proto.add = function add(value) {
    _Reference.default.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  _proto.delete = function _delete(value) {
    _Reference.default.isRef(value) ? this.refs.delete(value.key, value) : this.list.delete(value);
  };

  _proto.has = function has(value, resolve) {
    if (this.list.has(value)) return true;
    var item,
        values = this.refs.values();

    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }

    return false;
  };

  return RefSet;
}();

function SchemaType(options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(this instanceof SchemaType)) return new SchemaType();
  this._deps = [];
  this._conditions = [];
  this._options = {
    abortEarly: true,
    recursive: true
  };
  this._exclusive = Object.create(null);
  this._whitelist = new RefSet();
  this._blacklist = new RefSet();
  this.tests = [];
  this.transforms = [];
  this.withMutation(function () {
    _this.typeError(locale.mixed.notType);
  });
  if ((0, _has.default)(options, 'default')) this._defaultDefault = options.default;
  this._type = options.type || 'mixed';
}

SchemaType.prototype = {
  __isYupSchema__: true,
  constructor: SchemaType,
  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
    // they are already immutable

    return (0, _cloneDeepWith.default)(this, function (value) {
      if ((0, _isSchema.default)(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;
    var next = this.clone();
    next._meta = (0, _extends2.default)(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    this._mutate = true;
    var result = fn(this);
    this._mutate = false;
    return result;
  },
  concat: function concat(schema) {
    if (!schema) return this;
    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
    var cloned = this.clone();
    var next = (0, _merge.default)(this.clone(), schema.clone()); // undefined isn't merged over, but is a valid value for default

    if ((0, _has.default)(schema, '_default')) next._default = schema._default;
    next.tests = cloned.tests;
    next._exclusive = cloned._exclusive; // manually add the new tests to ensure
    // the deduping logic is consistent

    schema.tests.forEach(function (fn) {
      next = next.test(fn.TEST);
    });
    next._type = schema._type;
    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(_ref) {
    var context = _ref.context,
        parent = _ref.parent;

    if (this._conditions.length) {
      return this._conditions.reduce(function (schema, match) {
        return match.resolve(schema, match.getValue(parent, context));
      }, this);
    }

    return this;
  },
  cast: function cast(value, options) {
    if (options === void 0) {
      options = {};
    }

    var resolvedSchema = this.resolve(options);

    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = (0, _printValue.default)(value);
      var formattedResult = (0, _printValue.default)(result);
      throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && (0, _has.default)(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value, options) {
    var _this4 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);

    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, (0, _extends2.default)({
        assert: false
      }, options));
    } // value is cast, we can check if it meets type requirements


    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };
    var initialTests = [];
    if (this._typeError) initialTests.push(this._typeError(validationParams));
    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
    return (0, _runValidations.default)({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return (0, _runValidations.default)({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    var result, err;

    schema._validate(value, (0, _extends2.default)({}, options, {
      sync: true
    })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, (0, _extends2.default)({}, options));
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema.default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = (0, _has.default)(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith.default)(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict() {
    var next = this.clone();
    next._options.strict = true;
    return next;
  },
  required: function required(message) {
    if (message === void 0) {
      message = locale.mixed.required;
    }

    return this.test({
      message: message,
      name: 'required',
      test: notEmpty
    });
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.TEST_NAME !== 'required';
    });
    return next;
  },
  nullable: function nullable(value) {
    var next = this.clone();
    next._nullable = value === false ? false : true;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var opts = args[0];

    if (args.length > 1) {
      var name = args[0],
          message = args[1],
          test = args[2];

      if (test == null) {
        test = message;
        message = locale.mixed.default;
      }

      opts = {
        name: name,
        test: test,
        message: message,
        exclusive: false
      };
    }

    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    var next = this.clone();
    var validate = (0, _createValidation.default)(opts);
    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(function (fn) {
      if (fn.TEST_NAME === opts.name) {
        if (isExclusive) return false;
        if (fn.TEST.test === validate.TEST.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  },
  when: function when(keys, options) {
    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new _Reference.default(key);
    });
    deps.forEach(function (dep) {
      if (!dep.isContext) next._deps.push(dep.key);
    });

    next._conditions.push(new _Condition.default(deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();
    next._typeError = (0, _createValidation.default)({
      message: message,
      name: 'typeError',
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums, message) {
    if (message === void 0) {
      message = locale.mixed.oneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = (0, _createValidation.default)({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });
    return next;
  },
  notOneOf: function notOneOf(enums, message) {
    if (message === void 0) {
      message = locale.mixed.notOneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = (0, _createValidation.default)({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });
    return next;
  },
  strip: function strip(_strip) {
    if (_strip === void 0) {
      _strip = true;
    }

    var next = this.clone();
    next._strip = _strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return (0, _has.default)(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();
    return {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return fn.TEST_NAME;
      }, {}).filter(function (n, idx, list) {
        return list.indexOf(n) === idx;
      })
    };
  }
};
var aliases = {
  oneOf: ['equals', 'is'],
  notOneOf: ['not', 'nope']
};
Object.keys(aliases).forEach(function (method) {
  aliases[method].forEach(function (alias) {
    return SchemaType.prototype[alias] = SchemaType.prototype[method];
  });
});
module.exports = exports["default"];
});

unwrapExports$2(mixed);

var inherits_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = inherits;

var _extends2 = interopRequireDefault$1(_extends_1);

function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  (0, _extends2.default)(ctor.prototype, spec);
}

module.exports = exports["default"];
});

unwrapExports$2(inherits_1);

var boolean_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;

var _inherits = interopRequireDefault$1(inherits_1);

var _mixed = interopRequireDefault$1(mixed);

var _default = BooleanSchema;
exports.default = _default;

function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  _mixed.default.call(this, {
    type: 'boolean'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }

      return value;
    });
  });
}

(0, _inherits.default)(BooleanSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
});
module.exports = exports["default"];
});

unwrapExports$2(boolean_1);

var string = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = StringSchema;

var _inherits = interopRequireDefault$1(inherits_1);

var _mixed = interopRequireDefault$1(mixed);



var _isAbsent = interopRequireDefault$1(isAbsent);

// eslint-disable-next-line
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

var hasLength = function hasLength(value) {
  return (0, _isAbsent.default)(value) || value.length > 0;
};

var isTrimmed = function isTrimmed(value) {
  return (0, _isAbsent.default)(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();

  _mixed.default.call(this, {
    type: 'string'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}

(0, _inherits.default)(StringSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  },
  required: function required(message) {
    if (message === void 0) {
      message = locale.mixed.required;
    }

    var next = _mixed.default.prototype.required.call(this, message);

    return next.test({
      message: message,
      name: 'required',
      test: hasLength
    });
  },
  length: function length(_length, message) {
    if (message === void 0) {
      message = locale.string.length;
    }

    return this.test({
      message: message,
      name: 'length',
      exclusive: true,
      params: {
        length: _length
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = locale.string.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = locale.string.max;
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: message,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex, options) {
    var excludeEmptyString = false;
    var message;

    if (options) {
      if (options.message || options.hasOwnProperty('excludeEmptyString')) {
        excludeEmptyString = options.excludeEmptyString;
        message = options.message;
      } else message = options;
    }

    return this.test({
      message: message || locale.string.matches,
      params: {
        regex: regex
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === '' && excludeEmptyString || regex.test(value);
      }
    });
  },
  email: function email(message) {
    if (message === void 0) {
      message = locale.string.email;
    }

    return this.matches(rEmail, {
      message: message,
      excludeEmptyString: true
    });
  },
  url: function url(message) {
    if (message === void 0) {
      message = locale.string.url;
    }

    return this.matches(rUrl, {
      message: message,
      excludeEmptyString: true
    });
  },
  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(message) {
    if (message === void 0) {
      message = locale.string.trim;
    }

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test({
      message: message,
      name: 'trim',
      test: isTrimmed
    });
  },
  lowercase: function lowercase(message) {
    if (message === void 0) {
      message = locale.string.lowercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toLowerCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(message) {
    if (message === void 0) {
      message = locale.string.uppercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toUpperCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toUpperCase();
      }
    });
  }
});
module.exports = exports["default"];
});

unwrapExports$2(string);

var number = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = NumberSchema;

var _inherits = interopRequireDefault$1(inherits_1);

var _mixed = interopRequireDefault$1(mixed);



var _isAbsent = interopRequireDefault$1(isAbsent);

var isNaN = function isNaN(value) {
  return value != +value;
};

var isInteger = function isInteger(val) {
  return (0, _isAbsent.default)(val) || val === (val | 0);
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();

  _mixed.default.call(this, {
    type: 'number'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      var parsed = parseFloat(value);
      if (this.isType(parsed)) return parsed;
      return NaN;
    });
  });
}

(0, _inherits.default)(NumberSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = locale.number.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = locale.number.max;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, message) {
    if (message === void 0) {
      message = locale.number.less;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        less: less
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, message) {
    if (message === void 0) {
      message = locale.number.more;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        more: more
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    if (msg === void 0) {
      msg = locale.number.positive;
    }

    return this.min(0, msg);
  },
  negative: function negative(msg) {
    if (msg === void 0) {
      msg = locale.number.negative;
    }

    return this.max(0, msg);
  },
  integer: function integer(message) {
    if (message === void 0) {
      message = locale.number.integer;
    }

    return this.test({
      name: 'integer',
      message: message,
      test: isInteger
    });
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? Math[method](value) : value;
    });
  }
});
module.exports = exports["default"];
});

unwrapExports$2(number);

var isodate = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = parseIsoDate;

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

module.exports = exports["default"];
});

unwrapExports$2(isodate);

var date = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;

var _mixed = interopRequireDefault$1(mixed);

var _inherits = interopRequireDefault$1(inherits_1);

var _isodate = interopRequireDefault$1(isodate);



var _isAbsent = interopRequireDefault$1(isAbsent);

var _Reference = interopRequireDefault$1(Reference_1);

var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var _default = DateSchema;
exports.default = _default;

function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();

  _mixed.default.call(this, {
    type: 'date'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return isDate(value) ? new Date(value) : value;
      value = (0, _isodate.default)(value);
      return value ? new Date(value) : invalidDate;
    });
  });
}

(0, _inherits.default)(DateSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = locale.date.min;
    }

    var limit = _min;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = locale.date.max;
    }

    var limit = _max;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(limit);
      }
    });
  }
});
module.exports = exports["default"];
});

unwrapExports$2(date);

var interopRequireWildcard$1 = createCommonjsModule$2(function (module) {
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;
});

unwrapExports$2(interopRequireWildcard$1);

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var taggedTemplateLiteralLoose$1 = _taggedTemplateLiteralLoose;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce$3 = arrayReduce;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$2 = '\\u0300-\\u036f';
var reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange$2 = '\\u20d0-\\u20ff';
var rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;

/** Used to compose unicode capture groups. */
var rsCombo$1 = '[' + rsComboRange$2 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$1, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString_1(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr;

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords;

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord;

/** Used to compose unicode character classes. */
var rsAstralRange$2 = '\\ud800-\\udfff';
var rsComboMarksRange$3 = '\\u0300-\\u036f';
var reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange$3 = '\\u20d0-\\u20ff';
var rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;
var rsDingbatRange = '\\u2700-\\u27bf';
var rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff';
var rsMathOpRange = '\\xac\\xb1\\xd7\\xf7';
var rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf';
var rsPunctuationRange = '\\u2000-\\u206f';
var rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000';
var rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde';
var rsVarRange$2 = '\\ufe0e\\ufe0f';
var rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";
var rsBreak = '[' + rsBreakRange + ']';
var rsCombo$2 = '[' + rsComboRange$3 + ']';
var rsDigits = '\\d+';
var rsDingbat = '[' + rsDingbatRange + ']';
var rsLower = '[' + rsLowerRange + ']';
var rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']';
var rsFitz$1 = '\\ud83c[\\udffb-\\udfff]';
var rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')';
var rsNonAstral$1 = '[^' + rsAstralRange$2 + ']';
var rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}';
var rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]';
var rsUpper = '[' + rsUpperRange + ']';
var rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')';
var rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')';
var rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?';
var rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?';
var reOptMod$1 = rsModifier$1 + '?';
var rsOptVar$1 = '[' + rsVarRange$2 + ']?';
var rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*';
var rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])';
var rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])';
var rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1;
var rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString_1(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return _hasUnicodeWord(string) ? _unicodeWords(string) : _asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos$1, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return _arrayReduce$3(words_1(deburr_1(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder;

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = _createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

var snakeCase_1 = snakeCase;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

var _castSlice = castSlice;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString_1(string);

    var strSymbols = _hasUnicode(string)
      ? _stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? _castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = _createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst_1(toString_1(string).toLowerCase());
}

var capitalize_1$2 = capitalize;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = _createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize_1$2(word) : word);
});

var camelCase_1 = camelCase;

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

var mapKeys_1 = mapKeys;

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

var toposort_1 = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};

var array = toposort;

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true;

    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);

    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }

    sorted[--cursor] = node;
  }
}

function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}

toposort_1.array = array;

var sortFields_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = sortFields;

var _has = interopRequireDefault$1(has_1);

var _toposort = interopRequireDefault$1(toposort_1);



var _Reference = interopRequireDefault$1(Reference_1);

var _isSchema = interopRequireDefault$1(isSchema);

function sortFields(fields, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = (0, propertyExpr.split)(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if ((0, _has.default)(fields, key)) {
      var value = fields[key];
      if (!~nodes.indexOf(key)) nodes.push(key);
      if (_Reference.default.isRef(value) && !value.isContext) addNode(value.path, key);else if ((0, _isSchema.default)(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }

  return _toposort.default.array(nodes, edges).reverse();
}

module.exports = exports["default"];
});

unwrapExports$2(sortFields_1);

var sortByKeyOrder_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = sortByKeyOrder;

function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

module.exports = exports["default"];
});

unwrapExports$2(sortByKeyOrder_1);

var makePath_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = makePath;

function makePath(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });
  return path.replace(/^\./, '');
}

module.exports = exports["default"];
});

unwrapExports$2(makePath_1);

var object = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = ObjectSchema;

var _taggedTemplateLiteralLoose2 = interopRequireDefault$1(taggedTemplateLiteralLoose$1);

var _extends2 = interopRequireDefault$1(_extends_1);

var _has = interopRequireDefault$1(has_1);

var _snakeCase2 = interopRequireDefault$1(snakeCase_1);

var _camelCase2 = interopRequireDefault$1(camelCase_1);

var _mapKeys = interopRequireDefault$1(mapKeys_1);

var _mapValues = interopRequireDefault$1(mapValues_1);



var _mixed = interopRequireDefault$1(mixed);



var _sortFields = interopRequireDefault$1(sortFields_1);

var _sortByKeyOrder = interopRequireDefault$1(sortByKeyOrder_1);

var _inherits = interopRequireDefault$1(inherits_1);

var _makePath = interopRequireDefault$1(makePath_1);

var _runValidations = interopRequireWildcard$1(runValidations_1);

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed.default.call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      if (!this._nodes.length) return undefined;
      var dft = {};

      this._nodes.forEach(function (key) {
        dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      });

      return dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];
  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }

      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits.default)(ObjectSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _mixed.default.prototype._cast.call(this, _value, options); //should ignore nulls here


    if (value === undefined) return this.default();
    if (!this._typeCheck(value)) return value;
    var fields = this.fields;
    var strip = this._option('stripUnknown', options) === true;

    var props = this._nodes.concat(Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }));

    var intermediateValue = {}; // is filled during the transform below

    var innerOptions = (0, _extends2.default)({}, options, {
      parent: intermediateValue,
      __validating: false
    });
    props.forEach(function (prop) {
      var field = fields[prop];
      var exists = (0, _has.default)(value, prop);

      if (field) {
        var fieldValue;
        var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

        innerOptions.path = (0, _makePath.default)(_templateObject(), options.path, prop);
        innerOptions.value = value[prop];
        field = field.resolve(innerOptions);
        if (field._strip === true) return;
        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
      } else if (exists && !strip) intermediateValue[prop] = value[prop];
    });
    return intermediateValue;
  },
  _validate: function _validate(_value, opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {};
    }

    var endEarly, recursive;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);
    opts = (0, _extends2.default)({}, opts, {
      __validating: true,
      originalValue: originalValue
    });
    return _mixed.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = (0, _makePath.default)(_templateObject2(), opts.path, key);
        var field = _this4.fields[key];
        var innerOptions = (0, _extends2.default)({}, opts, {
          path: path,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;
          if (field.validate) return field.validate(value[key], innerOptions);
        }

        return true;
      });

      return (0, _runValidations.default)({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields.default)(next.fields, next._excludedEdges);
    return next;
  },
  shape: function shape(schema, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var next = this.clone(),
        fields = (0, _extends2.default)(next.fields, schema);
    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + "-" + second;
      });
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields.default)(fields, next._excludedEdges);
    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = (0, propertyExpr.getter)(_from, true);
    return this.transform(function (obj) {
      var newObj = obj;
      if (obj == null) return obj;

      if ((0, _has.default)(obj, _from)) {
        newObj = (0, _extends2.default)({}, obj);
        if (!alias) delete obj[_from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown(noAllow, message) {
    if (noAllow === void 0) {
      noAllow = true;
    }

    if (message === void 0) {
      message = locale.object.noUnknown;
    }

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });
    if (noAllow) next._options.stripUnknown = true;
    return next;
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys.default)(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(_camelCase2.default);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(_snakeCase2.default);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return (0, _snakeCase2.default)(key).toUpperCase();
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    base.fields = (0, _mapValues.default)(this.fields, function (value) {
      return value.describe();
    });
    return base;
  }
});
module.exports = exports["default"];
});

unwrapExports$2(object);

var array$1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;

var _extends2 = interopRequireDefault$1(_extends_1);

var _taggedTemplateLiteralLoose2 = interopRequireDefault$1(taggedTemplateLiteralLoose$1);

var _inherits = interopRequireDefault$1(inherits_1);

var _isAbsent = interopRequireDefault$1(isAbsent);

var _isSchema = interopRequireDefault$1(isSchema);

var _makePath = interopRequireDefault$1(makePath_1);

var _printValue = interopRequireDefault$1(printValue_1);

var _mixed = interopRequireDefault$1(mixed);



var _runValidations = interopRequireWildcard$1(runValidations_1);

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", "[", "]"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var hasLength = function hasLength(value) {
  return !(0, _isAbsent.default)(value) && value.length > 0;
};

var _default = ArraySchema;
exports.default = _default;

function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);

  _mixed.default.call(this, {
    type: 'array'
  }); // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"


  this._subType = undefined;
  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }
      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

(0, _inherits.default)(ArraySchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = _mixed.default.prototype._cast.call(this, _value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this._subType) return value;
    return value.map(function (v) {
      return _this2._subType.cast(v, _opts);
    });
  },
  _validate: function _validate(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var subType = this._subType;

    var endEarly = this._option('abortEarly', options);

    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;
    return _mixed.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !subType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;
      var validations = value.map(function (item, idx) {
        var path = (0, _makePath.default)(_templateObject(), options.path, idx); // object._validate note for isStrict explanation

        var innerOptions = (0, _extends2.default)({}, options, {
          path: path,
          strict: true,
          parent: value,
          originalValue: originalValue[idx]
        });
        if (subType.validate) return subType.validate(item, innerOptions);
        return true;
      });
      return (0, _runValidations.default)({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  of: function of(schema) {
    var next = this.clone();
    if (schema !== false && !(0, _isSchema.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _printValue.default)(schema));
    next._subType = schema;
    return next;
  },
  required: function required(message) {
    if (message === void 0) {
      message = locale.mixed.required;
    }

    var next = _mixed.default.prototype.required.call(this, message);

    return next.test({
      message: message,
      name: 'required',
      test: hasLength
    });
  },
  min: function min(_min, message) {
    message = message || locale.array.min;
    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || locale.array.max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    return this.default(function () {
      return [];
    }).transform(function (val) {
      return val === null ? [] : [].concat(val);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };
    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    if (this._subType) base.innerType = this._subType.describe();
    return base;
  }
});
module.exports = exports["default"];
});

unwrapExports$2(array$1);

var Lazy_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = void 0;

var _objectWithoutProperties2 = interopRequireDefault$1(objectWithoutProperties$2);

var _isSchema = interopRequireDefault$1(isSchema);

var Lazy =
/*#__PURE__*/
function () {
  function Lazy(mapFn) {
    this._resolve = function () {
      var schema = mapFn.apply(void 0, arguments);
      if (!(0, _isSchema.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema;
    };
  }

  var _proto = Lazy.prototype;

  _proto.resolve = function resolve(_ref) {
    var value = _ref.value,
        rest = (0, _objectWithoutProperties2.default)(_ref, ["value"]);
    return this._resolve(value, rest);
  };

  _proto.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  _proto.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;
var _default = Lazy;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports$2(Lazy_1);

var reach_1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.default = reach;



var _has = interopRequireDefault$1(has_1);

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function reach(obj, path, value, context) {
  var parent, lastPart; // if only one "value" arg then use it for both

  context = context || value;
  (0, propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;

    if (isArray || (0, _has.default)(obj, '_subType')) {
      // we skipped an array: foo[].bar
      var idx = isArray ? parseInt(part, 10) : 0;
      obj = obj.resolve({
        context: context,
        parent: parent,
        value: value
      })._subType;

      if (value) {
        if (isArray && idx >= value.length) {
          throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
        }

        value = value[idx];
      }
    }

    if (!isArray) {
      obj = obj.resolve({
        context: context,
        parent: parent,
        value: value
      });
      if (!(0, _has.default)(obj, 'fields') || !(0, _has.default)(obj.fields, part)) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPart + " which is a type: \"" + obj._type + "\") "));
      obj = obj.fields[part];
      parent = value;
      value = value && value[part];
      lastPart = isBracket ? '[' + _part + ']' : '.' + _part;
    }
  });

  if (obj) {
    obj = obj.resolve({
      context: context,
      parent: parent,
      value: value
    });
  }

  return obj;
}

module.exports = exports["default"];
});

unwrapExports$2(reach_1);

var lib$1 = createCommonjsModule$2(function (module, exports) {
exports.__esModule = true;
exports.addMethod = addMethod;
exports.lazy = exports.ref = exports.boolean = void 0;

var _mixed = interopRequireDefault$1(mixed);

exports.mixed = _mixed.default;

var _boolean = interopRequireDefault$1(boolean_1);

exports.bool = _boolean.default;

var _string = interopRequireDefault$1(string);

exports.string = _string.default;

var _number = interopRequireDefault$1(number);

exports.number = _number.default;

var _date = interopRequireDefault$1(date);

exports.date = _date.default;

var _object = interopRequireDefault$1(object);

exports.object = _object.default;

var _array = interopRequireDefault$1(array$1);

exports.array = _array.default;

var _Reference = interopRequireDefault$1(Reference_1);

var _Lazy = interopRequireDefault$1(Lazy_1);

var _ValidationError = interopRequireDefault$1(ValidationError_1);

exports.ValidationError = _ValidationError.default;

var _reach = interopRequireDefault$1(reach_1);

exports.reach = _reach.default;

var _isSchema = interopRequireDefault$1(isSchema);

exports.isSchema = _isSchema.default;
var boolean = _boolean.default;
exports.boolean = boolean;

var ref = function ref(key, options) {
  return new _Reference.default(key, options);
};

exports.ref = ref;

var lazy = function lazy(fn) {
  return new _Lazy.default(fn);
};

exports.lazy = lazy;

function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}
});

var yup = unwrapExports$2(lib$1);
var lib_1$1 = lib$1.addMethod;
var lib_2 = lib$1.lazy;
var lib_3 = lib$1.ref;
var lib_4 = lib$1.mixed;
var lib_5 = lib$1.bool;
var lib_6 = lib$1.string;
var lib_7 = lib$1.number;
var lib_8 = lib$1.date;
var lib_9 = lib$1.object;
var lib_10 = lib$1.array;
var lib_11 = lib$1.ValidationError;
var lib_12 = lib$1.reach;
var lib_13 = lib$1.isSchema;

var userName = yup.string().min(4).required();

var password = yup.string().min(4).required();

var normal = yup.object().shape({ userName: userName, password: password });

var schemata = { normal: normal };

var SignInModel = function SignInModel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$userName = _ref.userName,
      userName = _ref$userName === undefined ? "" : _ref$userName;

  classCallCheck(this, SignInModel);

  this.userName = userName;
  this.password = "";
};

SignInModel.schemata = schemata;

var SignInForm = function (_Component) {
  inherits(SignInForm, _Component);

  function SignInForm() {
    classCallCheck(this, SignInForm);
    return possibleConstructorReturn(this, (SignInForm.__proto__ || Object.getPrototypeOf(SignInForm)).apply(this, arguments));
  }

  createClass(SignInForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          onSubmit = _props.onSubmit,
          links = _props.links,
          errors = _props.errors,
          userName = _props.userName,
          onCancel = _props.onCancel;

      return React.createElement(
        Form$1,
        {
          Model: SignInModel,
          values: new SignInModel({ userName: userName }),
          errors: errors,
          title: "Sign In",
          links: links,
          onSubmit: onSubmit,
          onCancel: onCancel
        },
        React.createElement(Form$1.Field, { title: "User Name", name: "userName", placeholder: "User Name" }),
        React.createElement(Form$1.Field, {
          title: "Password",
          FieldComponent: PasswordInput,
          name: "password",
          placeholder: "Password"
        })
      );
    }
  }]);
  return SignInForm;
}(Component);

SignInForm.propTypes = {
  /** callback that triggers when the form is submitted */
  onSubmit: PropTypes.func.isRequired,
  /** callback that triggers when the form is cancelled */
  onCancel: PropTypes.func,
  /** optional initial username */
  userName: PropTypes.string,
  /** object with external errors */
  errors: PropTypes.shape({
    general: PropTypes.string,
    userName: PropTypes.string,
    password: PropTypes.string
  }),
  /** object that defines the links to other forms */
  links: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  }))
};

var userName$1 = yup.string().min(4).matches(/^[a-z]+$/, "user name cannot have spaces or special characters").strict().required();

var password$1 = yup.string().min(8).matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]/, "password must have at least one uppercase letter, one lowercase letter, one number and one special character").required();

var confirmationCode = yup.string().min(6).max(12).matches(/^\d+$/, "confirmation code can only contain numbers").required();

var normal$1 = yup.object().shape({ userName: userName$1 });
var confirm = yup.object().shape({ userName: userName$1, password: password$1, confirmationCode: confirmationCode });

var schemata$1 = {
  normal: normal$1,
  confirm: confirm
};

var PasswordRetrievalModel = function PasswordRetrievalModel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$userName = _ref.userName,
      userName = _ref$userName === undefined ? "" : _ref$userName;

  classCallCheck(this, PasswordRetrievalModel);

  this.userName = userName;
  this.confirmationCode = "";
  this.password = "";
};

PasswordRetrievalModel.schemata = schemata$1;

var PasswordRetrievalForm = function (_Component) {
  inherits(PasswordRetrievalForm, _Component);

  function PasswordRetrievalForm() {
    classCallCheck(this, PasswordRetrievalForm);
    return possibleConstructorReturn(this, (PasswordRetrievalForm.__proto__ || Object.getPrototypeOf(PasswordRetrievalForm)).apply(this, arguments));
  }

  createClass(PasswordRetrievalForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          mode = _props.mode,
          userName = _props.userName,
          onSubmit = _props.onSubmit,
          onCancel = _props.onCancel,
          links = _props.links,
          errors = _props.errors;

      return React.createElement(
        Form$1,
        {
          Model: PasswordRetrievalModel,
          values: new PasswordRetrievalModel({ userName: userName }),
          errors: errors,
          mode: mode,
          links: links,
          onSubmit: onSubmit,
          onCancel: onCancel,
          title: "Retrieve Password"
        },
        React.createElement(Form$1.Field, { title: "User Name", name: "userName", placeholder: "User Name" }),
        mode === "confirm" && React.createElement(
          Fragment,
          null,
          React.createElement(Form$1.Field, {
            title: "Confirmation Code",
            name: "confirmationCode",
            placeholder: "Confirmation Code"
          }),
          React.createElement(Form$1.Field, {
            title: "New Password",
            type: "password",
            FieldComponent: PasswordInput,
            name: "password",
            placeholder: "Password"
          })
        )
      );
    }
  }]);
  return PasswordRetrievalForm;
}(Component);

PasswordRetrievalForm.propTypes = {
  /** callback that triggers when the form is submitted */
  onSubmit: PropTypes.func.isRequired,
  /** callback that triggers when the form is cancelled */
  onCancel: PropTypes.func,
  /** optional initial username */
  userName: PropTypes.string,
  /** object with external errors */
  errors: PropTypes.shape({
    userName: PropTypes.string,
    confirmationCode: PropTypes.string,
    password: PropTypes.string
  }),
  /** flag that indicates confirmMode */
  mode: PropTypes.oneOf(["confirm", "normal"]),
  /** object that defines the links to other forms */
  links: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  }))
};

var userName$2 = yup.string().min(4).matches(/^[a-z]+$/, "user name cannot have spaces or special characters").strict().required();

var email = yup.string().email().required();

var password$2 = yup.string().min(8).matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]/, "password must have at least one uppercase letter, one lowercase letter, one number and one special character").required();

var confirmationCode$1 = yup.string().min(6).max(12).matches(/^\d+$/, "confirmation code can only contain numbers").required();

var normal$2 = yup.object().shape({ userName: userName$2, email: email, password: password$2 });
var confirm$1 = yup.object().shape({ userName: userName$2, email: email, password: password$2, confirmationCode: confirmationCode$1 });

var schemata$2 = {
  normal: normal$2,
  confirm: confirm$1
};

var SignUpModel = function SignUpModel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$userName = _ref.userName,
      userName = _ref$userName === undefined ? "" : _ref$userName;

  classCallCheck(this, SignUpModel);

  this.userName = userName;
  this.email = "";
  this.password = "";
  this.confirmationCode = "";
};

SignUpModel.schemata = schemata$2;

var SignUpForm = function (_Component) {
  inherits(SignUpForm, _Component);

  function SignUpForm() {
    classCallCheck(this, SignUpForm);
    return possibleConstructorReturn(this, (SignUpForm.__proto__ || Object.getPrototypeOf(SignUpForm)).apply(this, arguments));
  }

  createClass(SignUpForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          mode = _props.mode,
          userName = _props.userName,
          onSubmit = _props.onSubmit,
          links = _props.links,
          errors = _props.errors,
          onCancel = _props.onCancel;


      return React.createElement(
        Form$1,
        {
          Model: SignUpModel,
          values: new SignUpModel({ userName: userName }),
          links: links,
          mode: mode,
          errors: errors,
          title: "Sign Up",
          onSubmit: onSubmit,
          onCancel: onCancel,
          setSubmitting: mode !== "confirm"
        },
        React.createElement(Form$1.Field, { title: "User Name", name: "userName", placeholder: "User Name" }),
        React.createElement(Form$1.Field, {
          title: "Email",
          type: "email",
          name: "email",
          placeholder: "Email Address"
        }),
        React.createElement(Form$1.Field, {
          title: "Password",
          FieldComponent: PasswordInput,
          name: "password",
          placeholder: "Password"
        }),
        mode === "confirm" && React.createElement(Form$1.Field, {
          title: "Confirmation Code",
          name: "confirmationCode",
          placeholder: "Confirmation Code"
        })
      );
    }
  }]);
  return SignUpForm;
}(Component);

SignUpForm.propTypes = {
  /** callback that triggers when the form is submitted */
  onSubmit: PropTypes.func.isRequired,
  /** callback that triggers when the form is cancelled */
  onCancel: PropTypes.func,
  /** optional initial username */
  userName: PropTypes.string,
  /** object with external errors */
  errors: PropTypes.shape({
    userName: PropTypes.string,
    email: PropTypes.string,
    confirmationCode: PropTypes.string,
    password: PropTypes.string
  }),
  /** flag that indicates confirmMode */
  mode: PropTypes.oneOf(["confirm", "normal"]),
  /** object that defines the links to other forms */
  links: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  }))
};

var SIGNING_IN = "SIGNING_IN";
var SIGNING_UP = "SIGNING_UP";
var RETRIEVING_PASSWORD = "RETRIEVING_PASSWORD";

var formComponents = {
  RETRIEVING_PASSWORD: PasswordRetrievalForm,
  SIGNING_IN: SignInForm,
  SIGNING_UP: SignUpForm
};

var Auth = function (_Component) {
  inherits(Auth, _Component);

  function Auth() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Auth);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Auth.__proto__ || Object.getPrototypeOf(Auth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mode: _this.props.defaultMode,
      userName: ""
    }, _this.switchTo = function (newMode, _ref2) {
      var userName = _ref2.userName;

      _this.setState({
        mode: newMode,
        userName: newMode === SIGNING_IN ? "" : userName
      });
    }, _this.reset = function () {
      var _this$props = _this.props,
          onCancel = _this$props.onCancel,
          defaultMode = _this$props.defaultMode;

      _this.switchTo(defaultMode, { userName: "" });
      onCancel();
    }, _this.linkData = function () {
      var mode = _this.state.mode;

      var switchTo = curry$2$1(_this.switchTo);

      var SignIn = {
        onClick: switchTo(SIGNING_IN),
        title: "Sign In"
      };
      var SignUp = {
        onClick: switchTo(SIGNING_UP),
        title: "Sign Up"
      };
      var RetrievePassword = {
        onClick: switchTo(RETRIEVING_PASSWORD),
        title: "Password Lost"
      };

      var modes = {
        SIGNING_IN: [SignUp, RetrievePassword],
        SIGNING_UP: [SignIn],
        RETRIEVING_PASSWORD: [SignIn]
      };

      return modes[mode];
    }, _this.submitHandler = function () {
      var mode = _this.state.mode;
      var _this$props2 = _this.props,
          resetPassword = _this$props2.resetPassword,
          signUp = _this$props2.signUp,
          signIn = _this$props2.signIn;

      var modes = {
        SIGNING_IN: signIn,
        SIGNING_UP: signUp,
        RETRIEVING_PASSWORD: resetPassword
      };

      return modes[mode];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Auth, [{
    key: "render",
    value: function render() {
      var _state = this.state,
          userName = _state.userName,
          mode = _state.mode;
      var _props = this.props,
          needsConfirmation = _props.needsConfirmation,
          errors = _props.errors;

      var FormComponent = formComponents[mode];

      return React.createElement(FormComponent, {
        errors: errors,
        mode: needsConfirmation ? "confirm" : "normal",
        userName: userName,
        links: this.linkData(),
        onCancel: this.reset,
        onSubmit: this.submitHandler()
      });
    }
  }]);
  return Auth;
}(Component);

Auth.propTypes = {
  defaultMode: PropTypes.oneOf([SIGNING_IN, SIGNING_UP, RETRIEVING_PASSWORD]),
  needsConfirmation: PropTypes.bool,
  errors: PropTypes.object,
  signUp: PropTypes.func.isRequired,
  signIn: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired
};
Auth.defaultProps = {
  defaultMode: SIGNING_IN,
  needsConfirmation: false,
  onCancel: function onCancel() {
    return null;
  }
};

/**
 * The course card component for the Offcourse project
 */

var CourseCard = function (_Component) {
  inherits(CourseCard, _Component);

  function CourseCard() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, CourseCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = CourseCard.__proto__ || Object.getPrototypeOf(CourseCard)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckpointToggle = function (_ref2) {
      var checkpointId = _ref2.checkpointId,
          checked = _ref2.checked;
      var _this$props = _this.props,
          course = _this$props.course,
          onCheckpointToggle = _this$props.onCheckpointToggle;

      onCheckpointToggle({
        courseId: course.courseId,
        checkpointId: checkpointId,
        checked: checked
      });
    }, _this.hasTags = function (tags) {
      return !isEmpty$1(tags) && !isNil(tags);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(CourseCard, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          course = _props.course,
          onCheckpointToggle = _props.onCheckpointToggle,
          onGoalClick = _props.onGoalClick,
          onTagClick = _props.onTagClick,
          onCuratorClick = _props.onCuratorClick,
          shareMessage = _props.shareMessage;
      var courseId = course.courseId,
          goal = course.goal,
          curator = course.curator,
          courseUrl = course.courseUrl,
          avatarUrl = course.avatarUrl,
          profileUrl = course.profileUrl,
          checkpoints = course.checkpoints,
          description = course.description,
          tags = course.tags;

      return React.createElement(
        Card,
        null,
        React.createElement(
          Heading,
          {
            onClick: function onClick() {
              return onGoalClick({ goal: goal, curator: curator, courseId: courseId });
            },
            section: "header"
          },
          goal
        ),
        React.createElement(Curator, {
          section: "meta",
          curator: curator,
          onClick: onCuratorClick,
          profileUrl: profileUrl,
          avatarUrl: avatarUrl
        }),
        description && React.createElement(
          Description,
          { label: "Course Description", section: "description" },
          description
        ),
        React.createElement(CheckpointList, {
          section: "heckpoints",
          onToggle: onCheckpointToggle && this.handleCheckpointToggle,
          checkpoints: checkpoints
        }),
        this.hasTags(tags) && React.createElement(TagGroup, {
          onClick: onTagClick,
          flex: 1,
          direction: "both",
          section: "tags",
          tags: tags
        }),
        React.createElement(Share, {
          section: "social",
          url: courseUrl || "loading...",
          text: shareMessage,
          providers: ["twitter", "facebook", "url"]
        })
      );
    }
  }]);
  return CourseCard;
}(Component);

CourseCard.propTypes = {
  onCheckpointToggle: PropTypes.func,
  onCuratorClick: PropTypes.func,
  onGoalClick: PropTypes.func,
  onTagClick: PropTypes.func,
  shareMessage: PropTypes.string,
  course: PropTypes.shape({
    courseId: PropTypes.string.isRequired,
    goal: PropTypes.string.isRequired,
    curator: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    courseUrl: PropTypes.string
  })
};
CourseCard.defaultProps = {
  shareMessage: "Checkout This Course",
  onCuratorClick: identity$2$1,
  onGoalClick: identity$2$1,
  onTagClick: identity$2$1
};

var _templateObject$2$2 = taggedTemplateLiteral(["\n  box-sizing: border-box\n"], ["\n  box-sizing: border-box\n"]);

var CourseCardLayoutWrapper = system({
  p: 6,
  pr: 0,
  bg: "grayScale.1",
  width: "100%",
  flexDirection: "column",
  overflow: "auto",
  display: "flex"
}).extend(_templateObject$2$2);

var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}

var constants$2 = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};

function debugLog() {
  if (process.env.NODE_ENV !== 'production') {
    console.log(arguments); // eslint-disable-line no-console
  }
}

var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      React.Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component$$1) {
  return typeof Component$$1.type === 'string';
}

var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage$1);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return constants$2.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return constants$2.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return constants$2.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return constants$2.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return constants$2.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return constants$2.above;
  }

  return constants$2.invisible;
}

var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function () {
    function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      var index = timeoutQueue.indexOf(cb);
      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }

    return unsubscribe;
  }();
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function () {
    function onEnter() {}

    return onEnter;
  }(),
  onLeave: function () {
    function onLeave() {}

    return onLeave;
  }(),
  onPositionChange: function () {
    function onPositionChange() {}

    return onPositionChange;
  }(),

  fireOnRapidScroll: true
};

/**
 * Calls a function when you scroll to the element.
 */

var Waypoint = function (_React$Component) {
  _inherits(Waypoint, _React$Component);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        ensureChildrenIsValid(this.props.children);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        // this._ref may occasionally not be set at this time. To help ensure that
        // this works smoothly, we want to delay the initial execution until the
        // next tick.
        this.cancelInitialTimeout = onNextTick(function () {
          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

          _this2._handleScroll = _this2._handleScroll.bind(_this2);
          _this2.scrollableAncestor = _this2._findScrollableAncestor();

          if (process.env.NODE_ENV !== 'production' && _this2.props.debug) {
            debugLog('scrollableAncestor', _this2.scrollableAncestor);
          }

          _this2.scrollEventListenerUnsubscribe = addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

          _this2.resizeEventListenerUnsubscribe = addEventListener(window, 'resize', _this2._handleScroll, { passive: true });

          _this2._handleScroll(null);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        ensureChildrenIsValid(newProps.children);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (!this.scrollableAncestor) {
          // The Waypoint has not yet initialized.
          return;
        }

        // The element may have moved.
        this._handleScroll(null);
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (this.scrollEventListenerUnsubscribe) {
          this.scrollEventListenerUnsubscribe();
        }
        if (this.resizeEventListenerUnsubscribe) {
          this.resizeEventListenerUnsubscribe();
        }

        if (this.cancelInitialTimeout) {
          this.cancelInitialTimeout();
        }
      }

      return componentWillUnmount;
    }()

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function () {
      function _findScrollableAncestor() {
        var _props = this.props,
            horizontal = _props.horizontal,
            scrollableAncestor = _props.scrollableAncestor;


        if (scrollableAncestor) {
          return resolveScrollableAncestorProp(scrollableAncestor);
        }

        var node = this._ref;

        while (node.parentNode) {
          node = node.parentNode;

          if (node === document.body) {
            // We've reached all the way to the root node.
            return window;
          }

          var style = window.getComputedStyle(node);
          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
          var overflow = overflowDirec || style.getPropertyValue('overflow');

          if (overflow === 'auto' || overflow === 'scroll') {
            return node;
          }
        }

        // A scrollable ancestor element was not found, which means that we need to
        // do stuff on window.
        return window;
      }

      return _findScrollableAncestor;
    }()

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function () {
      function _handleScroll(event) {
        if (!this._ref) {
          // There's a chance we end up here after the component has been unmounted.
          return;
        }

        var bounds = this._getBounds();
        var currentPosition = getCurrentPosition(bounds);
        var previousPosition = this._previousPosition;

        if (process.env.NODE_ENV !== 'production' && this.props.debug) {
          debugLog('currentPosition', currentPosition);
          debugLog('previousPosition', previousPosition);
        }

        // Save previous position as early as possible to prevent cycles
        this._previousPosition = currentPosition;

        if (previousPosition === currentPosition) {
          // No change since last trigger
          return;
        }

        var callbackArg = {
          currentPosition: currentPosition,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        };
        this.props.onPositionChange.call(this, callbackArg);

        if (currentPosition === constants$2.inside) {
          this.props.onEnter.call(this, callbackArg);
        } else if (previousPosition === constants$2.inside) {
          this.props.onLeave.call(this, callbackArg);
        }

        var isRapidScrollDown = previousPosition === constants$2.below && currentPosition === constants$2.above;
        var isRapidScrollUp = previousPosition === constants$2.above && currentPosition === constants$2.below;

        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
          // If the scroll event isn't fired often enough to occur while the
          // waypoint was visible, we trigger both callbacks anyway.
          this.props.onEnter.call(this, {
            currentPosition: constants$2.inside,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
          this.props.onLeave.call(this, {
            currentPosition: currentPosition,
            previousPosition: constants$2.inside,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
        }
      }

      return _handleScroll;
    }()
  }, {
    key: '_getBounds',
    value: function () {
      function _getBounds() {
        var horizontal = this.props.horizontal;

        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
            left = _ref$getBoundingClien.left,
            top = _ref$getBoundingClien.top,
            right = _ref$getBoundingClien.right,
            bottom = _ref$getBoundingClien.bottom;

        var waypointTop = horizontal ? left : top;
        var waypointBottom = horizontal ? right : bottom;

        var contextHeight = void 0;
        var contextScrollTop = void 0;
        if (this.scrollableAncestor === window) {
          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
          contextScrollTop = 0;
        } else {
          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
        }

        if (process.env.NODE_ENV !== 'production' && this.props.debug) {
          debugLog('waypoint top', waypointTop);
          debugLog('waypoint bottom', waypointBottom);
          debugLog('scrollableAncestor height', contextHeight);
          debugLog('scrollableAncestor scrollTop', contextScrollTop);
        }

        var _props2 = this.props,
            bottomOffset = _props2.bottomOffset,
            topOffset = _props2.topOffset;

        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
        var contextBottom = contextScrollTop + contextHeight;

        return {
          waypointTop: waypointTop,
          waypointBottom: waypointBottom,
          viewportTop: contextScrollTop + topOffsetPx,
          viewportBottom: contextBottom - bottomOffsetPx
        };
      }

      return _getBounds;
    }()

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var children = this.props.children;


        if (!children) {
          // We need an element that we can locate in the DOM to determine where it is
          // rendered relative to the top of its context.
          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
        }

        if (isDOMElement(children)) {
          var ref = function () {
            function ref(node) {
              _this3.refElement(node);
              if (children.ref) {
                children.ref(node);
              }
            }

            return ref;
          }();

          return React.cloneElement(children, { ref: ref });
        }

        return React.cloneElement(children, { innerRef: this.refElement });
      }

      return render;
    }()
  }]);

  return Waypoint;
}(React.Component);


process.env.NODE_ENV !== "production" ? Waypoint.propTypes = {
  children: PropTypes.node,
  debug: PropTypes.bool,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onPositionChange: PropTypes.func,
  fireOnRapidScroll: PropTypes.bool,
  scrollableAncestor: PropTypes.any,
  horizontal: PropTypes.bool,

  // `topOffset` can either be a number, in which case its a distance from the
  // top of the container in pixels, or a string value. Valid string values are
  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
  // as a percentage of the height of the containing element.
  // For instance, if you pass "-20%", and the containing element is 100px tall,
  // then the waypoint will be triggered when it has been scrolled 20px beyond
  // the top of the containing element.
  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : void 0;

Waypoint.above = constants$2.above;
Waypoint.below = constants$2.below;
Waypoint.inside = constants$2.inside;
Waypoint.invisible = constants$2.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';

var CourseCardLayout = function (_Component) {
  inherits(CourseCardLayout, _Component);

  function CourseCardLayout() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, CourseCardLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = CourseCardLayout.__proto__ || Object.getPrototypeOf(CourseCardLayout)).call.apply(_ref, [this].concat(args))), _this), _this.handlePositionChange = function (_ref2) {
      var currentPosition = _ref2.currentPosition,
          rest = objectWithoutProperties(_ref2, ["currentPosition"]);
      var loadMore = _this.props.loadMore;

      currentPosition === "inside" ? loadMore() : null;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(CourseCardLayout, [{
    key: "calculateBreakpoints",
    value: function calculateBreakpoints() {
      return times$1(identity$2$1, 100).map(function (columns) {
        var gutter = 16;
        var columnWidth = 288;
        var offset = columnWidth + gutter;
        var colSpace = (columns + 1) * columnWidth;
        var gutterSpace = columns * gutter;
        return colSpace + offset + gutterSpace;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          courses = _props.courses,
          goToCollection = _props.goToCollection,
          goToCourse = _props.goToCourse,
          hasMore = _props.hasMore;

      return React.createElement(
        CourseCardLayoutWrapper,
        null,
        React.createElement(
          Masonry,
          { breakpoints: this.calculateBreakpoints() },
          map$2$1(function (course) {
            return React.createElement(CourseCard, {
              onCuratorClick: goToCollection,
              onGoalClick: goToCourse,
              onTagClick: goToCollection,
              key: course.courseId,
              course: course
            });
          }, courses)
        ),
        React.createElement(
          Waypoint,
          {
            key: courses.length,
            onPositionChange: this.handlePositionChange,
            onEnter: this.handlePositionChange
          },
          React.createElement(
            Group,
            { alignItems: "center" },
            hasMore && React.createElement(Loading, { size: "large" })
          )
        )
      );
    }
  }]);
  return CourseCardLayout;
}(Component);

CourseCardLayout.propTypes = {
  goToCollection: PropTypes.func,
  goToCourse: PropTypes.func,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func,
  courses: PropTypes.arrayOf(PropTypes.shape({
    courseId: PropTypes.string.isRequired,
    goal: PropTypes.string.isRequired,
    curator: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    courseUrl: PropTypes.string
  }))
};
CourseCardLayout.defaultProps = {
  hasMore: false,
  goToCollection: function goToCollection() {},
  goToCourse: function goToCourse() {},
  loadMore: function loadMore() {}
};

var checkpoint = yup.object().shape({
  task: yup.string().min(5).max(55).required(),
  resourceUrl: yup.string().url().required()
});

var course = yup.object().shape({
  goal: yup.string().min(5).max(55).required(),
  checkpoints: yup.array().of(checkpoint).min(1).max(7).required(),
  description: yup.string().min(10).max(210)
});

var schemata$3 = {
  create: course,
  edit: course
};

var CheckpointModel = function CheckpointModel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$task = _ref.task,
      task = _ref$task === undefined ? "" : _ref$task,
      _ref$resourceUrl = _ref.resourceUrl,
      resourceUrl = _ref$resourceUrl === undefined ? "" : _ref$resourceUrl;

  classCallCheck(this, CheckpointModel);

  this.task = task;
  this.resourceUrl = resourceUrl;
};

var CourseModel = function CourseModel() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$goal = _ref2.goal,
      goal = _ref2$goal === undefined ? "" : _ref2$goal,
      _ref2$checkpoints = _ref2.checkpoints,
      checkpoints = _ref2$checkpoints === undefined ? [new CheckpointModel()] : _ref2$checkpoints,
      _ref2$description = _ref2.description,
      description = _ref2$description === undefined ? "" : _ref2$description;

  classCallCheck(this, CourseModel);

  this.goal = goal;
  this.checkpoints = map$2$1(function (cp) {
    return new CheckpointModel(cp);
  }, checkpoints);
  this.description = description;
};

CourseModel.Checkpoint = CheckpointModel;
CourseModel.schemata = schemata$3;

var CourseForm = function (_Component) {
  inherits(CourseForm, _Component);

  function CourseForm() {
    classCallCheck(this, CourseForm);
    return possibleConstructorReturn(this, (CourseForm.__proto__ || Object.getPrototypeOf(CourseForm)).apply(this, arguments));
  }

  createClass(CourseForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          mode = _props.mode,
          errors = _props.errors,
          course = _props.course,
          onCancel = _props.onCancel,
          onSubmit = _props.onSubmit;

      var title = mode + " Course";
      return React.createElement(
        Form$1,
        {
          Model: CourseModel,
          values: new CourseModel(course),
          errors: errors,
          mode: mode,
          title: title,
          onSubmit: onSubmit,
          onCancel: onCancel
        },
        React.createElement(Form$1.Field, { title: "Goal", name: "goal", placeholder: "Goal" }),
        React.createElement(Form$1.FieldList, {
          title: "Checkpoints",
          emptyItem: new CourseModel.Checkpoint(),
          name: "checkpoints",
          FieldComponent: CheckpointInput
        }),
        React.createElement(Form$1.Field, {
          variant: "textarea",
          title: "Description",
          name: "description",
          placeholder: "Course Description"
        })
      );
    }
  }]);
  return CourseForm;
}(Component);

CourseForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  mode: PropTypes.oneOf(["create", "edit"]),
  course: PropTypes.shape({
    goal: PropTypes.string.isRequired,
    checkpoints: PropTypes.array,
    description: PropTypes.string
  })
};
CourseForm.defaultProps = {
  mode: "create"
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var commonjsGlobal$1$2 = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule$3(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant$1(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1$1 = invariant$1;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$13 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var index = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$13.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (process.env.NODE_ENV !== 'production') {
  var invariant$2 = invariant_1$1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$2(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1$1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = index({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1$1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var index$2 = createCommonjsModule$3(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var index_1 = index$2.object;
var index_2 = index$2.oneOfType;
var index_3 = index$2.string;
var index_4 = index$2.node;
var index_5 = index$2.func;
var index_6 = index$2.bool;
var index_7 = index$2.element;

var index$4 = createCommonjsModule$3(function (module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal$1$2 == 'object' && commonjsGlobal$1$2 && commonjsGlobal$1$2.Object === Object && commonjsGlobal$1$2;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;
});

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$2 = function() {};

if (__DEV__) {
  warning$2 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

var warning_1$2 = warning$2;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** `Object#toString` result references. */
var funcTag$3 = '[object Function]';
var genTag$2 = '[object GeneratorFunction]';
var symbolTag$4 = '[object Symbol]';

/** Used to match property names within property paths. */
var reLeadingDot = /^\./;
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof commonjsGlobal$1$2 == 'object' && commonjsGlobal$1$2 && commonjsGlobal$1$2.Object === Object && commonjsGlobal$1$2;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$2 || freeSelf$1 || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;
var funcProto$2 = Function.prototype;
var objectProto$16 = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$2['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1$1 = objectProto$16.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$16.toString;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$2.call(hasOwnProperty$1$1).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol$1$1 = root$2.Symbol;
var splice$1 = arrayProto$1.splice;

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$2(root$2, 'Map');
var nativeCreate$2 = getNative$2(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$1$1 ? Symbol$1$1.prototype : undefined;
var symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$2(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$2() {
  this.__data__ = nativeCreate$2 ? nativeCreate$2(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$2(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$3 ? undefined : result;
  }
  return hasOwnProperty$1$1.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$2 ? data[key] !== undefined : hasOwnProperty$1$1.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$2(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate$2 && value === undefined) ? HASH_UNDEFINED$3 : value;
  return this;
}

// Add methods to `Hash`.
Hash$2.prototype.clear = hashClear$2;
Hash$2.prototype['delete'] = hashDelete$2;
Hash$2.prototype.get = hashGet$2;
Hash$2.prototype.has = hashHas$2;
Hash$2.prototype.set = hashSet$2;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$2(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$2() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache$2.prototype.clear = listCacheClear$2;
ListCache$2.prototype['delete'] = listCacheDelete$2;
ListCache$2.prototype.get = listCacheGet$2;
ListCache$2.prototype.has = listCacheHas$2;
ListCache$2.prototype.set = listCacheSet$2;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$2(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$2() {
  this.__data__ = {
    'hash': new Hash$2,
    'map': new (Map$3 || ListCache$2),
    'string': new Hash$2
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$2(key) {
  return getMapData$2(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$2(key) {
  return getMapData$2(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$2(key, value) {
  getMapData$2(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache$2.prototype.clear = mapCacheClear$2;
MapCache$2.prototype['delete'] = mapCacheDelete$2;
MapCache$2.prototype.get = mapCacheGet$2;
MapCache$2.prototype.has = mapCacheHas$2;
MapCache$2.prototype.set = mapCacheSet$2;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$2(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$2(value) {
  if (!isObject$2(value) || isMasked$2(value)) {
    return false;
  }
  var pattern = (isFunction$2(value) || isHostObject(value)) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$2(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray$2(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$2(map, key) {
  var data = map.__data__;
  return isKeyable$2(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$2(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative$2(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$2(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$2(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoize$6(function(string) {
  string = toString$7(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$2(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$6(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize$6.Cache || MapCache$2);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize$6.Cache = MapCache$2;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$2(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$2 = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$2(value) ? objectToString$2.call(value) : '';
  return tag == funcTag$3 || tag == genTag$2;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$2(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$2(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$2(value) && objectToString$2.call(value) == symbolTag$4);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$7(value) {
  return value == null ? '' : baseToString$2(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray$2(value)) {
    return arrayMap$2(value, toKey$2);
  }
  return isSymbol$2(value) ? [value] : copyArray$2(stringToPath$2(value));
}

var index$5 = toPath;

var index$6 = createCommonjsModule$3(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal$1$2 == 'object' && commonjsGlobal$1$2 && commonjsGlobal$1$2.Object === Object && commonjsGlobal$1$2;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;
});

function getIn(obj, key, def, p) {
    if (p === void 0) { p = 0; }
    var path = index$5(key);
    while (obj && p < path.length) {
        obj = obj[path[p++]];
    }
    return obj === undefined ? def : obj;
}
function setIn(obj, path, value) {
    var res = {};
    var resVal = res;
    var i = 0;
    var pathArray = index$5(path);
    for (; i < pathArray.length - 1; i++) {
        var currentPath = pathArray[i];
        var currentObj = obj[currentPath];
        if (resVal[currentPath]) {
            resVal = resVal[currentPath];
        }
        else if (currentObj) {
            resVal = resVal[currentPath] = index$6(currentObj);
        }
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] =
                isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    }
    resVal[pathArray[i]] = value;
    return __assign({}, obj, res);
}
function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) { visited = new WeakMap(); }
    if (response === void 0) { response = {}; }
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var k = _a[_i];
        var val = object[k];
        if (isObject$1$1(val)) {
            if (!visited.get(val)) {
                visited.set(val, true);
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        }
        else {
            response[k] = value;
        }
    }
    return response;
}
var isReactNative = typeof window !== 'undefined' &&
    window.navigator &&
    window.navigator.product &&
    window.navigator.product === 'ReactNative';
var isFunction$1$1 = function (obj) { return 'function' === typeof obj; };
var isObject$1$1 = function (obj) { return obj !== null && typeof obj === 'object'; };
var isInteger = function (obj) { return String(Math.floor(Number(obj))) === obj; };
var isEmptyChildren = function (children) {
    return Children.count(children) === 0;
};
function isPromise(value) {
    if (value !== null && typeof value === 'object') {
        return value && typeof value.then === 'function';
    }
    return false;
}

var Field = (function (_super) {
    __extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            var _a = _this.context.formik, handleChange = _a.handleChange, validateOnChange = _a.validateOnChange;
            handleChange(e);
            if (!!validateOnChange && !!_this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.handleBlur = function (e) {
            var _a = _this.context.formik, handleBlur = _a.handleBlur, validateOnBlur = _a.validateOnBlur;
            handleBlur(e);
            if (validateOnBlur && _this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.runFieldValidations = function (value) {
            var setFieldError = _this.context.formik.setFieldError;
            var _a = _this.props, name = _a.name, validate = _a.validate;
            var maybePromise = validate(value);
            if (isPromise(maybePromise)) {
                maybePromise.then(function () { return setFieldError(name, undefined); }, function (error) { return setFieldError(name, error); });
            }
            else {
                setFieldError(name, maybePromise);
            }
        };
        return _this;
    }
    Field.prototype.componentWillMount = function () {
        var _a = this.props, render = _a.render, children = _a.children, component = _a.component;
        warning_1$2(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored');
        warning_1$2(!(this.props.component && children && isFunction$1$1(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.');
        warning_1$2(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored');
    };
    Field.prototype.render = function () {
        var _a = this.props, validate = _a.validate, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, props = __rest(_a, ["validate", "name", "render", "children", "component"]);
        var formik = this.context.formik;
        var field = {
            value: props.type === 'radio' || props.type === 'checkbox'
                ? props.value
                : getIn(formik.values, name),
            name: name,
            onChange: validate ? this.handleChange : formik.handleChange,
            onBlur: validate ? this.handleBlur : formik.handleBlur,
        };
        var bag = { field: field, form: formik };
        if (render) {
            return render(bag);
        }
        if (isFunction$1$1(children)) {
            return children(bag);
        }
        if (typeof component === 'string') {
            return createElement(component, __assign({}, field, props, { children: children }));
        }
        return createElement(component, __assign({}, bag, props, { children: children }));
    };
    Field.contextTypes = {
        formik: index_1,
    };
    Field.propTypes = {
        name: index_3.isRequired,
        component: index_2([index_3, index_5]),
        render: index_5,
        children: index_2([index_5, index_4]),
        validate: index_5,
    };
    return Field;
}(Component));

var move$1 = function (array, from, to) {
    var copy = (array || []).slice();
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function (array, indexA, indexB) {
    var copy = (array || []).slice();
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert$2 = function (array, index, value) {
    var copy = (array || []).slice();
    copy.splice(index, 0, value);
    return copy;
};
var FieldArray = (function (_super) {
    __extends(FieldArray, _super);
    function FieldArray(props) {
        var _this = _super.call(this, props) || this;
        _this.updateArrayField = function (fn, alterTouched, alterErrors) {
            var _a = _this.context.formik, setFormikState = _a.setFormikState, validateForm = _a.validateForm, values = _a.values, touched = _a.touched, errors = _a.errors;
            var _b = _this.props, name = _b.name, validateOnChange = _b.validateOnChange;
            setFormikState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, name, fn(getIn(values, name))), errors: alterErrors
                    ? setIn(prevState.errors, name, fn(getIn(errors, name)))
                    : prevState.errors, touched: alterTouched
                    ? setIn(prevState.touched, name, fn(getIn(touched, name)))
                    : prevState.touched })); }, function () {
                if (validateOnChange) {
                    validateForm();
                }
            });
        };
        _this.push = function (value) {
            return _this.updateArrayField(function (array) { return (array || []).concat([value]); }, false, false);
        };
        _this.swap = function (indexA, indexB) {
            return _this.updateArrayField(function (array) { return swap(array, indexA, indexB); }, false, false);
        };
        _this.move = function (from, to) {
            return _this.updateArrayField(function (array) { return move$1(array, from, to); }, false, false);
        };
        _this.insert = function (index, value) {
            return _this.updateArrayField(function (array) { return insert$2(array, index, value); }, false, false);
        };
        _this.unshift = function (value) {
            var arr = [];
            _this.updateArrayField(function (array) {
                arr = array ? [value].concat(array) : [value];
                return arr;
            }, false, false);
            return arr.length;
        };
        _this.remove = _this.remove.bind(_this);
        _this.pop = _this.pop.bind(_this);
        return _this;
    }
    FieldArray.prototype.remove = function (index) {
        var result;
        this.updateArrayField(function (array) {
            var copy = array ? array.slice() : [];
            if (!result) {
                result = copy[index];
            }
            if (isFunction$1$1(copy.splice)) {
                copy.splice(index, 1);
            }
            return copy;
        }, true, true);
        return result;
    };
    FieldArray.prototype.pop = function () {
        var result;
        this.updateArrayField(function (array) {
            var tmp = array;
            if (!result) {
                result = tmp && tmp.pop && tmp.pop();
            }
            return tmp;
        }, true, true);
        return result;
    };
    FieldArray.prototype.render = function () {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            unshift: this.unshift,
            remove: this.remove,
        };
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children, name = _a.name;
        var props = __assign({}, arrayHelpers, { form: this.context.formik, name: name });
        return component
            ? createElement(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children) ? Children.only(children) : null
                    : null;
    };
    FieldArray.defaultProps = {
        validateOnChange: true,
    };
    FieldArray.contextTypes = {
        formik: index_1,
    };
    return FieldArray;
}(Component));

var Formik = (function (_super) {
    __extends(Formik, _super);
    function Formik(props) {
        var _this = _super.call(this, props) || this;
        _this.setErrors = function (errors) {
            _this.setState({ errors: errors });
        };
        _this.setTouched = function (touched) {
            _this.setState({ touched: touched }, function () {
                if (_this.props.validateOnBlur) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setValues = function (values) {
            _this.setState({ values: values }, function () {
                if (_this.props.validateOnChange) {
                    _this.runValidations(values);
                }
            });
        };
        _this.setStatus = function (status) {
            _this.setState({ status: status });
        };
        _this.setError = function (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
            }
            _this.setState({ error: error });
        };
        _this.setSubmitting = function (isSubmitting) {
            _this.setState({ isSubmitting: isSubmitting });
        };
        _this.runValidationSchema = function (values, onSuccess) {
            var validationSchema = _this.props.validationSchema;
            var schema = isFunction$1$1(validationSchema)
                ? validationSchema()
                : validationSchema;
            validateYupSchema(values, schema).then(function () {
                _this.setState({ errors: {} });
                if (onSuccess) {
                    onSuccess();
                }
            }, function (err) {
                return _this.setState({ errors: yupToFormErrors(err), isSubmitting: false });
            });
        };
        _this.runValidations = function (values) {
            if (values === void 0) { values = _this.state.values; }
            if (_this.props.validationSchema) {
                _this.runValidationSchema(values);
            }
            if (_this.props.validate) {
                var maybePromisedErrors = _this.props.validate(values);
                if (isPromise(maybePromisedErrors)) {
                    maybePromisedErrors.then(function () {
                        _this.setState({ errors: {} });
                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
                }
                else {
                    _this.setErrors(maybePromisedErrors);
                }
            }
        };
        _this.handleChange = function (e) {
            if (isReactNative) {
                if (process.env.NODE_ENV !== 'production') {
                    console.error("Warning: Formik's handleChange does not work with React Native. Use setFieldValue and within a callback instead. For more info see https://github.com/jaredpalmer/formik#react-native");
                }
                return;
            }
            e.persist();
            var _a = e.target, type = _a.type, name = _a.name, id = _a.id, value = _a.value, checked = _a.checked, outerHTML = _a.outerHTML;
            var field = name ? name : id;
            var parsed;
            var val = /number|range/.test(type)
                ? (parsed = parseFloat(value), Number.isNaN(parsed) ? '' : parsed)
                : /checkbox/.test(type) ? checked : value;
            if (!field && process.env.NODE_ENV !== 'production') {
                warnAboutMissingIdentifier({
                    htmlContent: outerHTML,
                    documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
                    handlerName: 'handleChange',
                });
            }
            _this.setState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, field, val) })); });
            if (_this.props.validateOnChange) {
                _this.runValidations(setIn(_this.state.values, field, val));
            }
        };
        _this.setFieldValue = function (field, value, shouldValidate) {
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, field, value) })); }, function () {
                if (_this.props.validateOnChange && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.submitForm();
        };
        _this.submitForm = function () {
            _this.setState({
                touched: setNestedObjectValues(_this.state.values, true),
                isSubmitting: true,
            });
            if (_this.props.validate) {
                var maybePromisedErrors = _this.props.validate(_this.state.values) || {};
                if (isPromise(maybePromisedErrors)) {
                    maybePromisedErrors.then(function () {
                        _this.setState({ errors: {} });
                        _this.executeSubmit();
                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
                    return;
                }
                else {
                    var isValid = Object.keys(maybePromisedErrors).length === 0;
                    _this.setState({
                        errors: maybePromisedErrors,
                        isSubmitting: isValid,
                    });
                    if (isValid) {
                        _this.executeSubmit();
                    }
                }
            }
            else if (_this.props.validationSchema) {
                _this.runValidationSchema(_this.state.values, _this.executeSubmit);
            }
            else {
                _this.executeSubmit();
            }
        };
        _this.executeSubmit = function () {
            _this.props.onSubmit(_this.state.values, _this.getFormikActions());
        };
        _this.handleBlur = function (e) {
            if (isReactNative) {
                if (process.env.NODE_ENV !== 'production') {
                    console.error("Warning: Formik's handleBlur does not work with React Native. Use setFieldTouched(field, isTouched) within a callback instead. For more info see https://github.com/jaredpalmer/formik#setfieldtouched-field-string-istouched-boolean--void");
                }
                return;
            }
            e.persist();
            var _a = e.target, name = _a.name, id = _a.id, outerHTML = _a.outerHTML;
            var field = name ? name : id;
            if (!field && process.env.NODE_ENV !== 'production') {
                warnAboutMissingIdentifier({
                    htmlContent: outerHTML,
                    documentationAnchorLink: 'handleblur-e-any--void',
                    handlerName: 'handleBlur',
                });
            }
            _this.setState(function (prevState) { return ({
                touched: setIn(prevState.touched, field, true),
            }); });
            if (_this.props.validateOnBlur) {
                _this.runValidations(_this.state.values);
            }
        };
        _this.setFieldTouched = function (field, touched, shouldValidate) {
            if (touched === void 0) { touched = true; }
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (__assign({}, prevState, { touched: setIn(prevState.touched, field, touched) })); }, function () {
                if (_this.props.validateOnBlur && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setFieldError = function (field, message) {
            _this.setState(function (prevState) { return (__assign({}, prevState, { errors: setIn(prevState.errors, field, message) })); });
        };
        _this.resetForm = function (nextValues) {
            var values = nextValues ? nextValues : _this.props.initialValues;
            _this.initialValues = values;
            _this.setState({
                isSubmitting: false,
                errors: {},
                touched: {},
                error: undefined,
                status: undefined,
                values: values,
            });
        };
        _this.handleReset = function () {
            if (_this.props.onReset) {
                var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());
                if (isPromise(maybePromisedOnReset)) {
                    maybePromisedOnReset.then(_this.resetForm);
                }
                else {
                    _this.resetForm();
                }
            }
            else {
                _this.resetForm();
            }
        };
        _this.setFormikState = function (s, callback) {
            return _this.setState(s, callback);
        };
        _this.getFormikActions = function () {
            return {
                resetForm: _this.resetForm,
                submitForm: _this.submitForm,
                validateForm: _this.runValidations,
                setError: _this.setError,
                setErrors: _this.setErrors,
                setFieldError: _this.setFieldError,
                setFieldTouched: _this.setFieldTouched,
                setFieldValue: _this.setFieldValue,
                setStatus: _this.setStatus,
                setSubmitting: _this.setSubmitting,
                setTouched: _this.setTouched,
                setValues: _this.setValues,
                setFormikState: _this.setFormikState,
            };
        };
        _this.getFormikComputedProps = function () {
            var isInitialValid = _this.props.isInitialValid;
            var dirty = !index$4(_this.initialValues, _this.state.values);
            return {
                dirty: dirty,
                isValid: dirty
                    ? _this.state.errors && Object.keys(_this.state.errors).length === 0
                    : isInitialValid !== false && isFunction$1$1(isInitialValid)
                        ? isInitialValid(_this.props)
                        : isInitialValid,
                initialValues: _this.initialValues,
            };
        };
        _this.getFormikBag = function () {
            return __assign({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), { handleBlur: _this.handleBlur, handleChange: _this.handleChange, handleReset: _this.handleReset, handleSubmit: _this.handleSubmit, validateOnChange: _this.props.validateOnChange, validateOnBlur: _this.props.validateOnBlur });
        };
        _this.state = {
            values: props.initialValues || {},
            errors: {},
            touched: {},
            isSubmitting: false,
        };
        _this.initialValues = props.initialValues || {};
        return _this;
    }
    Formik.prototype.getChildContext = function () {
        return {
            formik: this.getFormikBag(),
        };
    };
    Formik.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.enableReinitialize &&
            !index$4(nextProps.initialValues, this.props.initialValues)) {
            this.initialValues = nextProps.initialValues;
            this.resetForm(nextProps.initialValues);
        }
    };
    Formik.prototype.componentWillMount = function () {
        warning_1$2(!(this.props.component && this.props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored');
        warning_1$2(!(this.props.component &&
            this.props.children &&
            !isEmptyChildren(this.props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
        warning_1$2(!(this.props.render &&
            this.props.children &&
            !isEmptyChildren(this.props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
    };
    Formik.prototype.render = function () {
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children;
        var props = this.getFormikBag();
        return component
            ? createElement(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children) ? Children.only(children) : null
                    : null;
    };
    Formik.defaultProps = {
        validateOnChange: true,
        validateOnBlur: true,
        isInitialValid: false,
        enableReinitialize: false,
    };
    Formik.propTypes = {
        validateOnChange: index_6,
        validateOnBlur: index_6,
        isInitialValid: index_2([index_5, index_6]),
        initialValues: index_1,
        onReset: index_5,
        onSubmit: index_5.isRequired,
        validationSchema: index_2([index_5, index_1]),
        validate: index_5,
        component: index_5,
        render: index_5,
        children: index_2([index_5, index_4]),
        enableReinitialize: index_6,
    };
    Formik.childContextTypes = {
        formik: index_1,
    };
    return Formik;
}(Component));
function warnAboutMissingIdentifier(_a) {
    var htmlContent = _a.htmlContent, documentationAnchorLink = _a.documentationAnchorLink, handlerName = _a.handlerName;
    console.error("Warning: `" + handlerName + "` has triggered and you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
    var errors = {};
    for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
        var err = _a[_i];
        if (!errors[err.path]) {
            errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
function validateYupSchema(data, schema, context) {
    if (context === void 0) { context = {}; }
    var validateData = {};
    for (var k in data) {
        if (data.hasOwnProperty(k)) {
            var key = String(k);
            validateData[key] =
                data[key] !== '' ? data[key] : undefined;
        }
    }
    return schema.validate(validateData, { abortEarly: false, context: context });
}

var FormWrapper = system({
  is: "form",
  bg: "white"
});

var formatMessages = MessageGroup.formatMessages;

var Shell = function (_Component) {
  inherits(Shell, _Component);

  function Shell() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Shell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Shell.__proto__ || Object.getPrototypeOf(Shell)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleCancel = function () {
      var _this$props = _this.props,
          resetForm = _this$props.resetForm,
          onCancel = _this$props.onCancel;

      resetForm();
      onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Shell, [{
    key: "buttonData",
    value: function buttonData() {
      var _props = this.props,
          dirty = _props.dirty,
          isSubmitting = _props.isSubmitting,
          isValid = _props.isValid,
          buttons = _props.buttons;
      var cancel = buttons.cancel,
          submit = buttons.submit,
          rest = objectWithoutProperties(buttons, ["cancel", "submit"]);


      var others = mapObjIndexed(function (obj, key) {
        return _extends({}, obj, {
          disabled: isSubmitting
        });
      }, rest);

      return values$1(_extends({
        cancel: _extends({
          title: "Cancel",
          onClick: this.handleCancel,
          disabled: isSubmitting
        }, cancel),
        submit: _extends({
          title: "Submit",
          variant: "positive",
          type: "submit",
          disabled: !isValid || isSubmitting
        }, submit)
      }, others));
    }
  }, {
    key: "linkData",
    value: function linkData() {
      var _props2 = this.props,
          links = _props2.links,
          values = _props2.values;

      return map$2$1(function (_ref2) {
        var _onClick = _ref2.onClick,
            title = _ref2.title;

        return { onClick: function onClick() {
            return _onClick(values);
          }, title: title };
      }, links);
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.props.errors;

      var messages = errors.general && formatMessages([errors.general], { px: 8 });
      return React.createElement(MessageGroup, { messages: messages });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var title = this.props.title;

      return React.createElement(
        Section,
        { py: 6, px: 8 },
        React.createElement(
          Heading,
          null,
          title
        )
      );
    }
  }, {
    key: "renderLinks",
    value: function renderLinks() {
      return React.createElement(LinkGroup, { px: 8, pt: 6, direction: "vertical", links: this.linkData() });
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      return React.createElement(
        Section,
        {
          py: 7,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end"
        },
        React.createElement(ButtonGroup, { buttons: this.buttonData() })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          links = _props3.links,
          handleSubmit = _props3.handleSubmit;

      return React.createElement(
        FormWrapper,
        { onSubmit: handleSubmit },
        this.renderErrors(),
        this.renderHeader(),
        children,
        links && this.renderLinks(),
        this.renderButtons()
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, _ref4) {
      var setErrors = _ref3.setErrors,
          mode = _ref3.mode,
          setSubmitting = _ref3.setSubmitting,
          errors = _ref3.errors,
          externalErrors = _ref3.externalErrors;
      var previousErrors = _ref4.previousErrors,
          previousMode = _ref4.previousMode;

      if (externalErrors !== previousErrors) {
        setErrors(externalErrors);
        setSubmitting(false);
      }

      if (mode !== previousMode) {
        setSubmitting(false);
      }

      return {
        previousErrors: externalErrors,
        previousMode: mode
      };
    }
  }]);
  return Shell;
}(Component);

Shell.defaultProps = {
  onCancel: function onCancel() {
    return null;
  },
  mode: "normal",
  buttons: {}
};

var FormField = function (_Component) {
  inherits(FormField, _Component);

  function FormField() {
    classCallCheck(this, FormField);
    return possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).apply(this, arguments));
  }

  createClass(FormField, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          name = _props.name,
          FieldComponent = _props.FieldComponent,
          variant = _props.variant,
          title = _props.title,
          placeholder = _props.placeholder;

      return React.createElement(
        Section,
        null,
        React.createElement(Field, {
          name: name,
          render: function render(_ref) {
            var field = _ref.field,
                form = _ref.form;
            var errors = form.errors,
                touched = form.touched;

            return React.createElement(InputField, _extends({}, field, {
              FieldComponent: FieldComponent,
              variant: variant,
              title: title,
              errors: touched[name] && errors[name] && [errors[name]],
              placeholder: placeholder
            }));
          }
        })
      );
    }
  }]);
  return FormField;
}(Component);

FormField.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
};

var _const$2 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A regular expression string matching digits
 *
 * @type {string}
 * @ignore
 */
var digit = exports.digit = '\\d';

/**
 * A regular expression string matching whitespace
 *
 * @type {string}
 * @ignore
 */
var whitespace = exports.whitespace = '\\s\\uFEFF\\xA0';

/**
 * A regular expression string matching high surrogate
 *
 * @type {string}
 * @ignore
 */
var highSurrogate = exports.highSurrogate = '\\uD800-\\uDBFF';

/**
 * A regular expression string matching low surrogate
 *
 * @type {string}
 * @ignore
 */
var lowSurrogate = exports.lowSurrogate = '\\uDC00-\\uDFFF';

/**
 * A regular expression string matching diacritical mark
 *
 * @type {string}
 * @ignore
 */
var diacriticalMark = exports.diacriticalMark = '\\u0300-\\u036F\\u1AB0-\\u1AFF\\u1DC0-\\u1DFF\\u20D0-\\u20FF\\uFE20-\\uFE2F';

/**
 * A regular expression to match the base character for a combining mark
 *
 * @type {string}
 * @ignore
 */
var base = exports.base = '\\0-\\u02FF\\u0370-\\u1AAF\\u1B00-\\u1DBF\\u1E00-\\u20CF\\u2100-\\uD7FF\\uE000-\\uFE1F\\uFE30-\\uFFFF';

/**
 * Regular expression to match combining marks
 *
 * @see http://unicode.org/faq/char_combmark.html
 * @type {RegExp}
 * @ignore
 */
var REGEXP_COMBINING_MARKS = exports.REGEXP_COMBINING_MARKS = new RegExp('([' + base + ']|[' + highSurrogate + '][' + lowSurrogate + ']|[' + highSurrogate + '](?![' + lowSurrogate + '])|(?:[^' + highSurrogate + ']|^)[' + lowSurrogate + '])([' + diacriticalMark + ']+)', 'g');

/**
 * Regular expression to match surrogate pairs
 *
 * @see http://www.unicode.org/faq/utf_bom.html#utf16-2
 * @type {RegExp}
 * @ignore
 */
var REGEXP_SURROGATE_PAIRS = exports.REGEXP_SURROGATE_PAIRS = new RegExp('([' + highSurrogate + '])([' + lowSurrogate + '])', 'g');

/**
 * Regular expression to match a unicode character
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_UNICODE_CHARACTER = exports.REGEXP_UNICODE_CHARACTER = new RegExp('((?:[' + base + ']|[' + highSurrogate + '][' + lowSurrogate + ']|[' + highSurrogate + '](?![' + lowSurrogate + '])|(?:[^' + highSurrogate + ']|^)[' + lowSurrogate + '])(?:[' + diacriticalMark + ']+))|\
([' + highSurrogate + '][' + lowSurrogate + '])|\
([\\n\\r\\u2028\\u2029])|\
(.)', 'g');

/**
 * Regular expression to match whitespaces
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_WHITESPACE = exports.REGEXP_WHITESPACE = new RegExp('[' + whitespace + ']');

/**
 * Regular expression to match whitespaces from the left side
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_TRIM_LEFT = exports.REGEXP_TRIM_LEFT = new RegExp('^[' + whitespace + ']+');

/**
 * Regular expression to match whitespaces from the right side
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_TRIM_RIGHT = exports.REGEXP_TRIM_RIGHT = new RegExp('[' + whitespace + ']+$');

/**
 * Regular expression to match digit characters
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_DIGIT = exports.REGEXP_DIGIT = new RegExp('^' + digit + '+$');

/**
 * Regular expression to match regular expression special characters
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_SPECIAL_CHARACTERS = exports.REGEXP_SPECIAL_CHARACTERS = /[-[\]{}()*+!<=:?./\\^$|#,]/g;

/**
 * Regular expression to match not latin characters
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_NON_LATIN = exports.REGEXP_NON_LATIN = /[^A-Za-z0-9]/g;

/**
 * Regular expression to match HTML special characters.
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_HTML_SPECIAL_CHARACTERS = exports.REGEXP_HTML_SPECIAL_CHARACTERS = /[<>&"'`]/g;

/**
 * Regular expression to match sprintf format string
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_CONVERSION_SPECIFICATION = exports.REGEXP_CONVERSION_SPECIFICATION = /(%{1,2})(?:(\d+)\$)?(\+)?([ 0]|'.{1})?(-)?(\d+)?(?:\.(\d+))?([bcdiouxXeEfgGs])?/g;

/**
 * Regular expression to match trailing zeros in a number
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_TRAILING_ZEROS = exports.REGEXP_TRAILING_ZEROS = /\.?0+$/g;

/**
 * Regular expression to match flags from a regular expression.
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_FLAGS = exports.REGEXP_FLAGS = /[gimuy]*$/;

/**
 * Regular expression to match a list of tags.
 *
 * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-name
 * @type {RegExp}
 * @ignore
 */

var REGEXP_TAG_LIST = exports.REGEXP_TAG_LIST = /<([A-Za-z0-9]+)>/g;
});

unwrapExports$2(_const$2);
var _const_1$2 = _const$2.digit;
var _const_2$2 = _const$2.whitespace;
var _const_3$2 = _const$2.highSurrogate;
var _const_4$2 = _const$2.lowSurrogate;
var _const_5$2 = _const$2.diacriticalMark;
var _const_6$2 = _const$2.base;
var _const_7$2 = _const$2.REGEXP_COMBINING_MARKS;
var _const_8$2 = _const$2.REGEXP_SURROGATE_PAIRS;
var _const_9$2 = _const$2.REGEXP_UNICODE_CHARACTER;
var _const_10$2 = _const$2.REGEXP_WHITESPACE;
var _const_11$2 = _const$2.REGEXP_TRIM_LEFT;
var _const_12$2 = _const$2.REGEXP_TRIM_RIGHT;
var _const_13$2 = _const$2.REGEXP_DIGIT;
var _const_14$2 = _const$2.REGEXP_SPECIAL_CHARACTERS;
var _const_15$2 = _const$2.REGEXP_NON_LATIN;
var _const_16$2 = _const$2.REGEXP_HTML_SPECIAL_CHARACTERS;
var _const_17$2 = _const$2.REGEXP_CONVERSION_SPECIFICATION;
var _const_18$2 = _const$2.REGEXP_TRAILING_ZEROS;
var _const_19$2 = _const$2.REGEXP_FLAGS;
var _const_20$2 = _const$2.REGEXP_TAG_LIST;

var const_extended$2$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGEXP_EXTENDED_ASCII = exports.REGEXP_ALPHA_DIGIT = exports.REGEXP_ALPHA = exports.REGEXP_LATIN_WORD = exports.REGEXP_WORD = undefined;



/**
 * A regular expression to match the General Punctuation Unicode block
 *
 * @type {string}
 * @ignore
 */
var generalPunctuationBlock = '\\u2000-\\u206F';

/**
 * A regular expression to match non characters from from Basic Latin and Latin-1 Supplement Unicode blocks
 *
 * @type {string}
 * @ignore
 */
var nonCharacter = '\\x00-\\x2F\\x3A-\\x40\\x5B-\\x60\\x7b-\\xBF\\xD7\\xF7';

/**
 * A regular expression to match the dingbat Unicode block
 *
 * @type {string}
 * @ignore
 */
var dingbatBlock = '\\u2700-\\u27BF';

/**
 * A regular expression string that matches lower case letters: LATIN
 *
 * @type {string}
 * @ignore
 */
var lowerCaseLetter = 'a-z\\xB5\\xDF-\\xF6\\xF8-\\xFF\\u0101\\u0103\\u0105\\u0107\\u0109\\u010B\\u010D\\u010F\\u0111\\u0113\\u0115\\u0117\\u0119\\u011B\\u011D\\u011F\\u0121\\u0123\\u0125\\u0127\\u0129\\u012B\\u012D\\u012F\\u0131\\u0133\\u0135\\u0137\\u0138\\u013A\\u013C\\u013E\\u0140\\u0142\\u0144\\u0146\\u0148\\u0149\\u014B\\u014D\\u014F\\u0151\\u0153\\u0155\\u0157\\u0159\\u015B\\u015D\\u015F\\u0161\\u0163\\u0165\\u0167\\u0169\\u016B\\u016D\\u016F\\u0171\\u0173\\u0175\\u0177\\u017A\\u017C\\u017E-\\u0180\\u0183\\u0185\\u0188\\u018C\\u018D\\u0192\\u0195\\u0199-\\u019B\\u019E\\u01A1\\u01A3\\u01A5\\u01A8\\u01AA\\u01AB\\u01AD\\u01B0\\u01B4\\u01B6\\u01B9\\u01BA\\u01BD-\\u01BF\\u01C6\\u01C9\\u01CC\\u01CE\\u01D0\\u01D2\\u01D4\\u01D6\\u01D8\\u01DA\\u01DC\\u01DD\\u01DF\\u01E1\\u01E3\\u01E5\\u01E7\\u01E9\\u01EB\\u01ED\\u01EF\\u01F0\\u01F3\\u01F5\\u01F9\\u01FB\\u01FD\\u01FF\\u0201\\u0203\\u0205\\u0207\\u0209\\u020B\\u020D\\u020F\\u0211\\u0213\\u0215\\u0217\\u0219\\u021B\\u021D\\u021F\\u0221\\u0223\\u0225\\u0227\\u0229\\u022B\\u022D\\u022F\\u0231\\u0233-\\u0239\\u023C\\u023F\\u0240\\u0242\\u0247\\u0249\\u024B\\u024D\\u024F';

/**
 * A regular expression string that matches upper case letters: LATIN
 *
 * @type {string}
 * @ignore
 */
var upperCaseLetter = '\\x41-\\x5a\\xc0-\\xd6\\xd8-\\xde\\u0100\\u0102\\u0104\\u0106\\u0108\\u010a\\u010c\\u010e\\u0110\\u0112\\u0114\\u0116\\u0118\\u011a\\u011c\\u011e\\u0120\\u0122\\u0124\\u0126\\u0128\\u012a\\u012c\\u012e\\u0130\\u0132\\u0134\\u0136\\u0139\\u013b\\u013d\\u013f\\u0141\\u0143\\u0145\\u0147\\u014a\\u014c\\u014e\\u0150\\u0152\\u0154\\u0156\\u0158\\u015a\\u015c\\u015e\\u0160\\u0162\\u0164\\u0166\\u0168\\u016a\\u016c\\u016e\\u0170\\u0172\\u0174\\u0176\\u0178\\u0179\\u017b\\u017d\\u0181\\u0182\\u0184\\u0186\\u0187\\u0189-\\u018b\\u018e-\\u0191\\u0193\\u0194\\u0196-\\u0198\\u019c\\u019d\\u019f\\u01a0\\u01a2\\u01a4\\u01a6\\u01a7\\u01a9\\u01ac\\u01ae\\u01af\\u01b1-\\u01b3\\u01b5\\u01b7\\u01b8\\u01bc\\u01c4\\u01c5\\u01c7\\u01c8\\u01ca\\u01cb\\u01cd\\u01cf\\u01d1\\u01d3\\u01d5\\u01d7\\u01d9\\u01db\\u01de\\u01e0\\u01e2\\u01e4\\u01e6\\u01e8\\u01ea\\u01ec\\u01ee\\u01f1\\u01f2\\u01f4\\u01f6-\\u01f8\\u01fa\\u01fc\\u01fe\\u0200\\u0202\\u0204\\u0206\\u0208\\u020a\\u020c\\u020e\\u0210\\u0212\\u0214\\u0216\\u0218\\u021a\\u021c\\u021e\\u0220\\u0222\\u0224\\u0226\\u0228\\u022a\\u022c\\u022e\\u0230\\u0232\\u023a\\u023b\\u023d\\u023e\\u0241\\u0243-\\u0246\\u0248\\u024a\\u024c\\u024e';

/**
 * Regular expression to match Unicode words
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_WORD = exports.REGEXP_WORD = new RegExp('(?:[' + upperCaseLetter + '][' + _const$2.diacriticalMark + ']*)?(?:[' + lowerCaseLetter + '][' + _const$2.diacriticalMark + ']*)+|\
(?:[' + upperCaseLetter + '][' + _const$2.diacriticalMark + ']*)+(?![' + lowerCaseLetter + '])|\
[' + _const$2.digit + ']+|\
[' + dingbatBlock + ']|\
[^' + nonCharacter + generalPunctuationBlock + _const$2.whitespace + ']+', 'g');

/**
 * Regular expression to match words from Basic Latin and Latin-1 Supplement blocks
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_LATIN_WORD = exports.REGEXP_LATIN_WORD = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

/**
 * Regular expression to match alpha characters
 *
 * @see http://stackoverflow.com/a/22075070/1894471
 * @type {RegExp}
 * @ignore
 */
var REGEXP_ALPHA = exports.REGEXP_ALPHA = new RegExp('^(?:[' + lowerCaseLetter + upperCaseLetter + '][' + _const$2.diacriticalMark + ']*)+$');

/**
 * Regular expression to match alpha and digit characters
 *
 * @see http://stackoverflow.com/a/22075070/1894471
 * @type {RegExp}
 * @ignore
 */
var REGEXP_ALPHA_DIGIT = exports.REGEXP_ALPHA_DIGIT = new RegExp('^((?:[' + lowerCaseLetter + upperCaseLetter + '][' + _const$2.diacriticalMark + ']*)|[' + _const$2.digit + '])+$');

/**
 * Regular expression to match Extended ASCII characters, i.e. the first 255
 *
 * @type {RegExp}
 * @ignore
 */
var REGEXP_EXTENDED_ASCII = exports.REGEXP_EXTENDED_ASCII = /^[\x01-\xFF]*$/;
});

unwrapExports$2(const_extended$2$1);
var const_extended_1$2 = const_extended$2$1.REGEXP_EXTENDED_ASCII;
var const_extended_2$2 = const_extended$2$1.REGEXP_ALPHA_DIGIT;
var const_extended_3$2 = const_extended$2$1.REGEXP_ALPHA;
var const_extended_4$2 = const_extended$2$1.REGEXP_LATIN_WORD;
var const_extended_5$2 = const_extended$2$1.REGEXP_WORD;

var is_nil$2$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNil;
/**
 * Checks if `value` is `null` or `undefined`
 *
 * @ignore
 * @function isNil
 * @param {*} value The object to check
 * @return {boolean} Returns `true` is `value` is `undefined` or `null`, `false` otherwise
 */
function isNil(value) {
  return value === undefined || value === null;
}
module.exports = exports["default"];
});

unwrapExports$2(is_nil$2$1);

var coerce_to_boolean$2$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = coerceToBoolean;



var _is_nil2 = _interopRequireDefault(is_nil$2$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts the `value` to a boolean. If `value` is `undefined` or `null`, returns `defaultValue`.
 *
 * @ignore
 * @function toBoolean
 * @param {*} value The value to convert.
 * @param {boolean} [defaultValue=false] The default value.
 * @return {boolean} Returns the coercion to boolean.
 */
function coerceToBoolean(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if ((0, _is_nil2.default)(value)) {
    return defaultValue;
  }
  return Boolean(value);
}
module.exports = exports['default'];
});

unwrapExports$2(coerce_to_boolean$2$1);

var is_string$2$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isString;
/**
 * Checks whether `subject` is a string primitive type.
 *
 * @function isString
 * @static
 * @since 1.0.0
 * @memberOf Query
 * @param {string} subject The value to verify.
 * @return {boolean} Returns `true` if `subject` is string primitive type or `false` otherwise.
 * @example
 * v.isString('vacation');
 * // => true
 *
 * v.isString(560);
 * // => false
 */
function isString(subject) {
  return typeof subject === 'string';
}
module.exports = exports['default'];
});

unwrapExports$2(is_string$2$1);

var coerce_to_string$2$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = coerceToString;



var _is_nil2 = _interopRequireDefault(is_nil$2$1);



var _is_string2 = _interopRequireDefault(is_string$2$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the string representation of the `value`.
 * Converts the `value` to string.
 * If `value` is `null` or `undefined`, return `defaultValue`.
 *
 * @ignore
 * @function toString
 * @param {*} value             The value to convert.
 * @param {*} [defaultValue=''] The default value to return.
 * @return {string|null}        Returns the string representation of `value`. Returns `defaultValue` if `value` is
 *                              `null` or `undefined`.
 */
function coerceToString(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if ((0, _is_nil2.default)(value)) {
    return defaultValue;
  }
  if ((0, _is_string2.default)(value)) {
    return value;
  }
  return String(value);
}
module.exports = exports['default'];
});

unwrapExports$2(coerce_to_string$2$1);

var capitalize_1$4 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalize;



var _coerce_to_boolean2 = _interopRequireDefault(coerce_to_boolean$2$1);



var _coerce_to_string2 = _interopRequireDefault(coerce_to_string$2$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts the first character of `subject` to upper case. If `restToLower` is `true`, convert the rest of
 * `subject` to lower case.
 *
 * @function capitalize
 * @static
 * @since 1.0.0
 * @memberOf Case
 * @param  {string}  [subject='']        The string to capitalize.
 * @param  {boolean} [restToLower=false] Convert the rest of `subject` to lower case.
 * @return {string}                      Returns the capitalized string.
 * @example
 * v.capitalize('apple');
 * // => 'Apple'
 *
 * v.capitalize('aPPle', true);
 * // => 'Apple'
 */
function capitalize(subject, restToLower) {
  var subjectString = (0, _coerce_to_string2.default)(subject);
  var restToLowerCaseBoolean = (0, _coerce_to_boolean2.default)(restToLower);
  if (subjectString === '') {
    return '';
  }
  if (restToLowerCaseBoolean) {
    subjectString = subjectString.toLowerCase();
  }
  return subjectString.substr(0, 1).toUpperCase() + subjectString.substr(1);
}
module.exports = exports['default'];
});

unwrapExports$2(capitalize_1$4);

var title_case$2 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = titleCase;





var _capitalize2 = _interopRequireDefault(capitalize_1$4);



var _coerce_to_string2 = _interopRequireDefault(coerce_to_string$2$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts the subject to title case.
 *
 * @function titleCase
 * @static
 * @since 1.4.0
 * @memberOf Case
 * @param  {string} [subject=''] The string to convert to title case.
 * @param  {Array}  [noSplit]    Do not split words at the specified characters.
 * @return {string}              Returns the title case string.
 * @example
 * v.titleCase('learning to fly');
 * // => 'Learning To Fly'
 *
 * v.titleCase('jean-luc is good-looking', ['-']);
 * // => 'Jean-luc Is Good-looking'
 */
function titleCase(subject, noSplit) {
  var subjectString = (0, _coerce_to_string2.default)(subject);
  var noSplitArray = Array.isArray(noSplit) ? noSplit : [];
  var wordsRegExp = const_extended$2$1.REGEXP_EXTENDED_ASCII.test(subjectString) ? const_extended$2$1.REGEXP_LATIN_WORD : const_extended$2$1.REGEXP_WORD;
  return subjectString.replace(wordsRegExp, function (word, index) {
    var isNoSplit = index > 0 && noSplitArray.indexOf(subjectString[index - 1]) >= 0;
    return isNoSplit ? word.toLowerCase() : (0, _capitalize2.default)(word, true);
  });
}
module.exports = exports['default'];
});

var titleCase$2 = unwrapExports$2(title_case$2);

var lower_case$2 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lowerCase;



var _coerce_to_string2 = _interopRequireDefault(coerce_to_string$2$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts the `subject` to lower case.
 *
 * @function lowerCase
 * @static
 * @since 1.0.0
 * @memberOf Case
 * @param  {string} [subject=''] The string to convert to lower case.
 * @return {string}              Returns the lower case string.
 * @example
 * v.lowerCase('Green');
 * // => 'green'
 *
 * v.lowerCase('BLUE');
 * // => 'blue'
 */
function lowerCase(subject) {
  var subjectString = (0, _coerce_to_string2.default)(subject, '');
  return subjectString.toLowerCase();
}
module.exports = exports['default'];
});

var lowerCase$2 = unwrapExports$2(lower_case$2);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV$1 = process.env.NODE_ENV;

var invariant$2$1 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV$1 !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1$2 = invariant$2$1;

var utils$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorPrefix = exports.events = undefined;
exports.arrayMove = arrayMove;
exports.omit = omit;
exports.closest = closest;
exports.limit = limit;
exports.getElementMargin = getElementMargin;
exports.provideDisplayName = provideDisplayName;
exports.getPosition = getPosition;
exports.isTouchEvent = isTouchEvent;
exports.getEdgeOffset = getEdgeOffset;
exports.getLockPixelOffset = getLockPixelOffset;



var _invariant2 = _interopRequireDefault(invariant_1$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
    return acc;
  }, {});
}

var events = exports.events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = exports.vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

function provideDisplayName(prefix, Component$$1) {
  var componentName = Component$$1.displayName || Component$$1.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}

function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}

function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { top: 0, left: 0 };

  // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
  if (node) {
    var nodeOffset = {
      top: offset.top + node.offsetTop,
      left: offset.left + node.offsetLeft
    };

    if (node.parentNode !== parent) {
      return getEdgeOffset(node.parentNode, parent, nodeOffset);
    } else {
      return nodeOffset;
    }
  }
}

function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;

  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

    (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);

    offsetX = offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}
});

unwrapExports$2(utils$1);
var utils_1$1 = utils$1.vendorPrefix;
var utils_2$1 = utils$1.events;
var utils_3$1 = utils$1.arrayMove;
var utils_4$1 = utils$1.omit;
var utils_5$1 = utils$1.closest;
var utils_6$1 = utils$1.limit;
var utils_7$1 = utils$1.getElementMargin;
var utils_8$1 = utils$1.provideDisplayName;
var utils_9$1 = utils$1.getPosition;
var utils_10$1 = utils$1.isTouchEvent;
var utils_11$1 = utils$1.getEdgeOffset;
var utils_12$1 = utils$1.getLockPixelOffset;

var Manager_1$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    this.refs = {};
  }

  _createClass(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(
      // eslint-disable-next-line eqeqeq
      function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

exports.default = Manager;


function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;

  return index1 - index2;
}
});

unwrapExports$2(Manager_1$1);

var SortableContainer$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableContainer;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);





var _invariant2 = _interopRequireDefault(invariant_1$2);



var _Manager2 = _interopRequireDefault(Manager_1$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Container Component
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.handleStart = function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;


        if (event.button === 2 || shouldCancelStart(event)) {
          return false;
        }

        _this._touched = true;
        _this._pos = (0, utils$1.getPosition)(event);

        var node = (0, utils$1.closest)(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection;


          if (useDragHandle && !(0, utils$1.closest)(event.target, function (el) {
            return el.sortableHandle != null;
          })) return;

          _this.manager.active = { index: index, collection: collection };

          /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */
          if (!(0, utils$1.isTouchEvent)(event) && event.target.tagName.toLowerCase() === 'a') {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      };

      _this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === _this.manager;
      };

      _this.handleMove = function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;


        if (!_this.state.sorting && _this._touched) {
          var position = (0, utils$1.getPosition)(event);
          var delta = _this._delta = {
            x: _this._pos.x - position.x,
            y: _this._pos.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);

          if (!distance && (!pressThreshold || pressThreshold && combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      };

      _this.handleEnd = function () {
        var distance = _this.props.distance;


        _this._touched = false;

        if (!distance) {
          _this.cancel();
        }
      };

      _this.cancel = function () {
        if (!_this.state.sorting) {
          clearTimeout(_this.pressTimer);
          _this.manager.active = null;
        }
      };

      _this.handlePress = function (event) {
        var active = _this.manager.getActive();

        if (active) {
          var _this$props3 = _this.props,
              axis = _this$props3.axis,
              getHelperDimensions = _this$props3.getHelperDimensions,
              helperClass = _this$props3.helperClass,
              hideSortableGhost = _this$props3.hideSortableGhost,
              onSortStart = _this$props3.onSortStart,
              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
          var node = active.node,
              collection = active.collection;
          var index = node.sortableInfo.index;

          var margin = (0, utils$1.getElementMargin)(node);

          var containerBoundingRect = _this.container.getBoundingClientRect();
          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

          _this.node = node;
          _this.margin = margin;
          _this.width = dimensions.width;
          _this.height = dimensions.height;
          _this.marginOffset = {
            x: _this.margin.left + _this.margin.right,
            y: Math.max(_this.margin.top, _this.margin.bottom)
          };
          _this.boundingClientRect = node.getBoundingClientRect();
          _this.containerBoundingRect = containerBoundingRect;
          _this.index = index;
          _this.newIndex = index;

          _this.axis = {
            x: axis.indexOf('x') >= 0,
            y: axis.indexOf('y') >= 0
          };
          _this.offsetEdge = (0, utils$1.getEdgeOffset)(node, _this.container);
          _this.initialOffset = (0, utils$1.getPosition)(event);
          _this.initialScroll = {
            top: _this.container.scrollTop,
            left: _this.container.scrollLeft
          };

          _this.initialWindowScroll = {
            top: window.pageYOffset,
            left: window.pageXOffset
          };

          var fields = node.querySelectorAll('input, textarea, select');
          var clonedNode = node.cloneNode(true);
          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

          clonedFields.forEach(function (field, index) {
            if (field.type !== 'file' && fields[index]) {
              field.value = fields[index].value;
            }
          });

          _this.helper = _this.document.body.appendChild(clonedNode);

          _this.helper.style.position = 'fixed';
          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
          _this.helper.style.width = _this.width + 'px';
          _this.helper.style.height = _this.height + 'px';
          _this.helper.style.boxSizing = 'border-box';
          _this.helper.style.pointerEvents = 'none';

          if (hideSortableGhost) {
            _this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          _this.minTranslate = {};
          _this.maxTranslate = {};
          if (_this.axis.x) {
            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
          }
          if (_this.axis.y) {
            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
          }

          if (helperClass) {
            var _this$helper$classLis;

            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
          }

          _this.listenerNode = event.touches ? node : _this.contentWindow;
          utils$1.events.move.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
          });
          utils$1.events.end.forEach(function (eventName) {
            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
          });

          _this.setState({
            sorting: true,
            sortingIndex: index
          });

          if (onSortStart) {
            onSortStart({ node: node, index: index, collection: collection }, event);
          }
        }
      };

      _this.handleSortMove = function (event) {
        var onSortMove = _this.props.onSortMove;

        event.preventDefault(); // Prevent scrolling on mobile

        _this.updatePosition(event);
        _this.animateNodes();
        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      };

      _this.handleSortEnd = function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var collection = _this.manager.active.collection;

        // Remove the event listeners if the node is still in the DOM

        if (_this.listenerNode) {
          utils$1.events.move.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
          });
          utils$1.events.end.forEach(function (eventName) {
            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
          });
        }

        // Remove the helper from the DOM
        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          _this.sortableGhost.style.visibility = '';
          _this.sortableGhost.style.opacity = '';
        }

        var nodes = _this.manager.refs[collection];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[utils$1.vendorPrefix + 'Transform'] = '';
          el.style[utils$1.vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this.autoscrollInterval);
        _this.autoscrollInterval = null;

        // Update state
        _this.manager.active = null;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: _this.index,
            newIndex: _this.newIndex,
            collection: collection
          }, event);
        }

        _this._touched = false;
      };

      _this.autoscroll = function () {
        var translate = _this.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
          direction.y = 1; // Scroll Down
          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
          direction.x = 1; // Scroll Right
          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
          direction.y = -1; // Scroll Up
          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
          direction.x = -1; // Scroll Left
          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
        }

        if (_this.autoscrollInterval) {
          clearInterval(_this.autoscrollInterval);
          _this.autoscrollInterval = null;
          _this.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          _this.autoscrollInterval = setInterval(function () {
            _this.isAutoScrolling = true;
            var offset = {
              left: 1 * speed.x * direction.x,
              top: 1 * speed.y * direction.y
            };
            _this.scrollContainer.scrollTop += offset.top;
            _this.scrollContainer.scrollLeft += offset.left;
            _this.translate.x += offset.left;
            _this.translate.y += offset.top;
            _this.animateNodes();
          }, 5);
        }
      };

      _this.manager = new _Manager2.default();
      _this.events = {
        start: _this.handleStart,
        move: _this.handleMove,
        end: _this.handleEnd
      };

      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');

      _this.state = {};
      return _this;
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */

        var container = this.getContainer();

        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;

          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;

          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : _this2.container;

          var _loop = function _loop(key) {
            if (_this2.events.hasOwnProperty(key)) {
              utils$1.events[key].forEach(function (eventName) {
                return _this2.container.addEventListener(eventName, _this2.events[key], false);
              });
            }
          };

          for (var key in _this2.events) {
            _loop(key);
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.container) {
          var _loop2 = function _loop2(key) {
            if (_this3.events.hasOwnProperty(key)) {
              utils$1.events[key].forEach(function (eventName) {
                return _this3.container.removeEventListener(eventName, _this3.events[key]);
              });
            }
          };

          for (var key in this.events) {
            _loop2(key);
          }
        }
      }
    }, {
      key: 'getLockPixelOffsets',
      value: function getLockPixelOffsets() {
        var width = this.width,
            height = this.height;
        var lockOffset = this.props.lockOffset;

        var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];

        (0, _invariant2.default)(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

        var _offsets = _slicedToArray(offsets, 2),
            minLockOffset = _offsets[0],
            maxLockOffset = _offsets[1];

        return [(0, utils$1.getLockPixelOffset)({ lockOffset: minLockOffset, width: width, height: height }), (0, utils$1.getLockPixelOffset)({ lockOffset: maxLockOffset, width: width, height: height })];
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition(event) {
        var _props = this.props,
            lockAxis = _props.lockAxis,
            lockToContainerEdges = _props.lockToContainerEdges;


        var offset = (0, utils$1.getPosition)(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };

        // Adjust for window scroll
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;

        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = this.getLockPixelOffsets(),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };

          translate.x = (0, utils$1.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = (0, utils$1.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        this.helper.style[utils$1.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
      }
    }, {
      key: 'animateNodes',
      value: function animateNodes() {
        var _props2 = this.props,
            transitionDuration = _props2.transitionDuration,
            hideSortableGhost = _props2.hideSortableGhost,
            onSortOver = _props2.onSortOver;

        var nodes = this.manager.getOrderedRefs();
        var containerScrollDelta = {
          left: this.container.scrollLeft - this.initialScroll.left,
          top: this.container.scrollTop - this.initialScroll.top
        };
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var windowScrollDelta = {
          top: window.pageYOffset - this.initialWindowScroll.top,
          left: window.pageXOffset - this.initialWindowScroll.left
        };
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i].node;

          var index = node.sortableInfo.index;
          var width = node.offsetWidth;
          var height = node.offsetHeight;
          var offset = {
            width: this.width > width ? width / 2 : this.width / 2,
            height: this.height > height ? height / 2 : this.height / 2
          };

          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          // If we haven't cached the node's offsetTop / offsetLeft value

          if (!edgeOffset) {
            nodes[i].edgeOffset = edgeOffset = (0, utils$1.getEdgeOffset)(node, this.container);
          }

          // Get a reference to the next and previous node
          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          // Also cache the next node's edge offset if needed.
          // We need this for calculating the animation in a grid setup
          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = (0, utils$1.getEdgeOffset)(nextNode.node, this.container);
          }

          // If the node is the one we're currently animating, skip it
          if (index === this.index) {
            if (hideSortableGhost) {
              /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */
              this.sortableGhost = node;
              node.style.visibility = 'hidden';
              node.style.opacity = 0;
            }
            continue;
          }

          if (transitionDuration) {
            node.style[utils$1.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
          }

          if (this.axis.x) {
            if (this.axis.y) {
              // Calculations for a grid setup
              if (index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                // If the current node is to the left on the same row, or above the node that's being dragged
                // then move it to the right
                translate.x = this.width + this.marginOffset.x;
                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  // If it moves passed the right bounds, then animate it to the first position of the next row.
                  // We just use the offset of the next node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                }
                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                // If the current node is to the right on the same row, or below the node that's being dragged
                // then move it to the left
                translate.x = -(this.width + this.marginOffset.x);
                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
                  // We just use the offset of the previous node to calculate where to move, because that node's original position
                  // is exactly where we want to go
                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                }
                this.newIndex = index;
              }
            } else {
              if (index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;
                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
          node.style[utils$1.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (onSortOver && this.newIndex !== prevIndex) {
          onSortOver({
            newIndex: this.newIndex,
            oldIndex: prevIndex,
            index: this.index,
            collection: this.manager.active.collection
          });
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'getContainer',
      value: function getContainer() {
        var getContainer = this.props.getContainer;


        if (typeof getContainer !== 'function') {
          return (0, _reactDom.findDOMNode)(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, utils$1.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
      }
    }]);

    return _class;
  }(React.Component), _class.displayName = (0, utils$1.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,
    shouldCancelStart: function shouldCancelStart(e) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
        return true; // Return true to cancel sorting
      }
    },
    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function getHelperDimensions(_ref) {
      var node = _ref.node;
      return {
        width: node.offsetWidth,
        height: node.offsetHeight
      };
    }
  }, _class.propTypes = {
    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
    distance: _propTypes2.default.number,
    lockAxis: _propTypes2.default.string,
    helperClass: _propTypes2.default.string,
    transitionDuration: _propTypes2.default.number,
    contentWindow: _propTypes2.default.any,
    onSortStart: _propTypes2.default.func,
    onSortMove: _propTypes2.default.func,
    onSortOver: _propTypes2.default.func,
    onSortEnd: _propTypes2.default.func,
    shouldCancelStart: _propTypes2.default.func,
    pressDelay: _propTypes2.default.number,
    useDragHandle: _propTypes2.default.bool,
    useWindowAsScrollContainer: _propTypes2.default.bool,
    hideSortableGhost: _propTypes2.default.bool,
    lockToContainerEdges: _propTypes2.default.bool,
    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
    getContainer: _propTypes2.default.func,
    getHelperDimensions: _propTypes2.default.func
  }, _class.childContextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _temp;
}
});

unwrapExports$2(SortableContainer$1);

var SortableElement$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableElement;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);





var _invariant2 = _interopRequireDefault(invariant_1$2);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            collection = _props.collection,
            disabled = _props.disabled,
            index = _props.index;


        if (!disabled) {
          this.setDraggable(collection, index);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index && this.node) {
          this.node.sortableInfo.index = nextProps.index;
        }
        if (this.props.disabled !== nextProps.disabled) {
          var collection = nextProps.collection,
              disabled = nextProps.disabled,
              index = nextProps.index;

          if (disabled) {
            this.removeDraggable(collection);
          } else {
            this.setDraggable(collection, index);
          }
        } else if (this.props.collection !== nextProps.collection) {
          this.removeDraggable(this.props.collection);
          this.setDraggable(nextProps.collection, nextProps.index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _props2 = this.props,
            collection = _props2.collection,
            disabled = _props2.disabled;


        if (!disabled) this.removeDraggable(collection);
      }
    }, {
      key: 'setDraggable',
      value: function setDraggable(collection, index) {
        var node = this.node = (0, _reactDom.findDOMNode)(this);

        node.sortableInfo = {
          index: index,
          collection: collection,
          manager: this.context.manager
        };

        this.ref = { node: node };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: 'removeDraggable',
      value: function removeDraggable(collection) {
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({
          ref: ref
        }, (0, utils$1.omit)(this.props, 'collection', 'disabled', 'index')));
      }
    }]);

    return _class;
  }(React.Component), _class.displayName = (0, utils$1.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: _propTypes2.default.object.isRequired
  }, _class.propTypes = {
    index: _propTypes2.default.number.isRequired,
    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    disabled: _propTypes2.default.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}
});

unwrapExports$2(SortableElement$1);

var SortableHandle$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = sortableHandle;



var _react2 = _interopRequireDefault(React);





var _invariant2 = _interopRequireDefault(invariant_1$2);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Export Higher Order Sortable Element Component
function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var node = (0, _reactDom.findDOMNode)(this);
        node.sortableHandle = true;
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;

        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
      }
    }]);

    return _class;
  }(React.Component), _class.displayName = (0, utils$1.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}
});

unwrapExports$2(SortableHandle$1);

var commonjs$1 = createCommonjsModule$2(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;



Object.defineProperty(exports, 'arrayMove', {
  enumerable: true,
  get: function get() {
    return utils$1.arrayMove;
  }
});



var _SortableContainer3 = _interopRequireDefault(SortableContainer$1);



var _SortableElement3 = _interopRequireDefault(SortableElement$1);



var _SortableHandle3 = _interopRequireDefault(SortableHandle$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer3.default;
exports.SortableElement = _SortableElement3.default;
exports.SortableHandle = _SortableHandle3.default;
exports.sortableContainer = _SortableContainer3.default;
exports.sortableElement = _SortableElement3.default;
exports.sortableHandle = _SortableHandle3.default;
});

unwrapExports$2(commonjs$1);
var commonjs_1$1 = commonjs$1.arrayMove;
var commonjs_2$1 = commonjs$1.sortableHandle;
var commonjs_3$1 = commonjs$1.sortableElement;
var commonjs_4$1 = commonjs$1.sortableContainer;
var commonjs_5$1 = commonjs$1.SortableHandle;
var commonjs_6$1 = commonjs$1.SortableElement;
var commonjs_7$1 = commonjs$1.SortableContainer;

var formatTitle$2 = compose$2(titleCase$2, lowerCase$2);
var mapIndexed$2 = addIndex$2$1(map$2$1);
var compact$2 = filter$2$1(identity$2$1);

var FieldList = function (_Component) {
  inherits(FieldList, _Component);

  function FieldList() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, FieldList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = FieldList.__proto__ || Object.getPrototypeOf(FieldList)).call.apply(_ref, [this].concat(args))), _this), _this.formatFieldError = function (error) {
      return yup.object().isType(error) ? map$2$1(function (error) {
        return error.split(".")[1];
      }, values$1(error)) : error;
    }, _this.formatFieldErrors = function (errors) {
      var filteredErrors = compose$2(compact$2, flatten)(errors);
      var formattedErrors = map$2$1(_this.formatFieldError, filteredErrors);
      return compose$2(uniq$2$1, flatten)(formattedErrors);
    }, _this.fieldErrors = function (errors) {
      if (!errors) {
        return [];
      }

      return yup.string().isType(errors) ? [errors] : _this.formatFieldErrors(errors);
    }, _this.listErrors = function (errors) {
      return yup.array().isType(errors) ? errors : [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(FieldList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          name = _props.name,
          emptyItem = _props.emptyItem,
          placeholder = _props.placeholder,
          FieldComponent = _props.FieldComponent,
          children = _props.children;


      return React.createElement(
        Section,
        null,
        React.createElement(
          FieldArray,
          { name: name },
          function (_ref2) {
            var form = _ref2.form,
                push = _ref2.push,
                remove = _ref2.remove,
                _move = _ref2.move;
            var dirty = form.dirty,
                handleChange = form.handleChange,
                values = form.values,
                touched = form.touched,
                errors = form.errors;

            var items = values[name];
            var fieldErrors = _this2.fieldErrors(errors[name]);
            var listErrors = _this2.listErrors(errors[name]);
            return React.createElement(
              InputField,
              { errors: fieldErrors, name: name, title: title },
              React.createElement(InputList, {
                arrangeable: true,
                title: title,
                name: name,
                placeholder: placeholder,
                items: items,
                add: function add() {
                  return push(clone(emptyItem));
                },
                move: function move(_ref3) {
                  var oldIndex = _ref3.oldIndex,
                      newIndex = _ref3.newIndex;
                  return _move(oldIndex, newIndex);
                },
                remove: remove,
                errors: listErrors,
                onChange: handleChange,
                FieldComponent: FieldComponent,
                onBlur: function onBlur() {}
              })
            );
          }
        )
      );
    }
  }]);
  return FieldList;
}(Component);

FieldList.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};
FieldList.defaultProps = {
  emptyItem: ""
};

var Form$1 = function (_Component) {
  inherits(Form$$1, _Component);

  function Form$$1() {
    classCallCheck(this, Form$$1);
    return possibleConstructorReturn(this, (Form$$1.__proto__ || Object.getPrototypeOf(Form$$1)).apply(this, arguments));
  }

  createClass(Form$$1, [{
    key: "renderElements",
    value: function renderElements(props) {
      var _props = this.props,
          children = _props.children,
          title = _props.title,
          rest = objectWithoutProperties(_props, ["children", "title"]);

      return Children.map(children, function (child) {
        return child && React.cloneElement(child, _extends({}, rest, props));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          values = _props2.values,
          Model = _props2.Model,
          title = _props2.title,
          errors = _props2.errors,
          links = _props2.links,
          mode = _props2.mode,
          buttons = _props2.buttons,
          onCancel = _props2.onCancel,
          onSubmit = _props2.onSubmit;


      return React.createElement(
        Formik,
        {
          validationSchema: Model.schemata[mode],
          initialValues: new Model(values),
          onSubmit: onSubmit
        },
        function (props) {
          return React.createElement(
            Shell,
            _extends({
              externalErrors: errors,
              links: links,
              mode: mode,
              onCancel: onCancel,
              buttons: buttons,
              title: title
            }, props),
            _this2.renderElements(props)
          );
        }
      );
    }
  }]);
  return Form$$1;
}(Component);

Form$1.Field = FormField;
Form$1.FieldList = FieldList;
Form$1.yup = yup;
Form$1.propTypes = {
  /** model for the form */
  Model: PropTypes.func,
  /** predefined values for the form */
  values: PropTypes.object,
  /** title of the form */
  title: PropTypes.string.isRequired,
  /** object with external errors */
  errors: PropTypes.object,
  /** object that defines the links to other forms */
  links: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  })),
  buttons: PropTypes.objectOf(PropTypes.shape({
    href: PropTypes.string,
    type: PropTypes.string,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    onClick: PropTypes.func,
    title: PropTypes.string,
    variant: PropTypes.oneOf(["default", "primary", "positive", "warning", "negative"])
  })),
  mode: PropTypes.string,
  cancelTitle: PropTypes.string,
  submitTitle: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};
Form$1.defaultProps = {
  mode: "normal",
  values: {}
};

var SignOutDialog = function (_Component) {
  inherits(SignOutDialog, _Component);

  function SignOutDialog() {
    classCallCheck(this, SignOutDialog);
    return possibleConstructorReturn(this, (SignOutDialog.__proto__ || Object.getPrototypeOf(SignOutDialog)).apply(this, arguments));
  }

  createClass(SignOutDialog, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          onConfirm = _props.onConfirm,
          onCancel = _props.onCancel;

      return React.createElement(
        Group,
        { justifyContent: "center", alignItems: "center" },
        React.createElement(
          Modal.Heading,
          null,
          "Are You Sure You Want to Sign Out?"
        ),
        React.createElement(
          Modal.Section,
          null,
          React.createElement(
            ButtonGroup,
            null,
            React.createElement(
              ButtonGroup.Button,
              { onClick: onCancel },
              "Wait..."
            ),
            React.createElement(
              ButtonGroup.Button,
              { onClick: onConfirm, variant: "warning" },
              "Yes!"
            )
          )
        )
      );
    }
  }]);
  return SignOutDialog;
}(Component);

SignOutDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export { AppShell, Auth, CourseCard, CourseCardLayout, CourseForm, Form$1 as Form, SignInForm, SignUpForm, SignOutDialog, PasswordRetrievalForm };



//////////////////
// WEBPACK FOOTER
// ../organisms/dist/index.es.js
// module id = 512
// module chunks = 0